webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/16wuzN9/%3F1725275627237&title=Roger%20Ebert%27s%20Movie%20Yearbook%202013&summary=Roger%20Ebert%26rsquo%3Bs%26%23160%3B%26ldquo%3Bcriticism%20shows%20a%20nearly%20unequaled%20grasp%20of%20film%20history%20and%20technique%2C%20and%20formidable%20intellectual%20range.%20.%20.%20.%26rdquo%3B%26%23160%3B%26mdash%3BNew%20York%20TimesPulitzer%20Prize%26ndash%3Bwinning%20film%20critic%20Roger%20Ebert%20prese&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/16wuzN9/%3F1725275627237",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=Roger%20Ebert%26rsquo%3Bs%26%23160%3B%26ldquo%3Bcriticism%20shows%20a%20nearly%20unequaled%20grasp%20of%20film%20history%20and%20technique%2C%20and%20formidable%20intellectual%20range.%20.%20.%20.%0Dhttps://textcafe.co/books/16wuzN9/%3F1725275627237&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/16wuzN9/%3F1725275627237&posttype=link&caption=Roger%20Ebert%26rsquo%3Bs%26%23160%3B%26ldquo%3Bcriticism%20shows%20a%20nearly%20unequaled%20grasp%20of%20film%20history%20and%20technique%2C%20and%20formidable%20intellectual%20range.%20.%20.%20.%26rdquo%3B%26%23160%3B%26mdash%3BNew%20York%20TimesPulitzer%20Prize%26ndash%3Bwinning%20film%20critic%20Roger%20Ebert%20prese",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/16wuzN9/%3F1725275627237&description=Roger%20Ebert%26rsquo%3Bs%26%23160%3B%26ldquo%3Bcriticism%20shows%20a%20nearly%20unequaled%20grasp%20of%20film%20history%20and%20technique%2C%20and%20formidable%20intellectual%20range.%20.%20.%20.%26rdquo%3B%26%23160%3B%26mdash%3BNew%20York%20TimesPulitzer%20Prize%26ndash%3Bwinning%20film%20critic%20Roger%20Ebert%20prese&media=https://textcafe.co/books/16wuzN9/tc-custom/9781449423117.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon US',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.com/s?k=9781449423117&i=stripbooks&linkCode=qs&tag=mobilebookcom-20',
        alt: 'None'
      }, {
        title: 'Google Play',
        img: 'https://textcafe.co/global-css/img/Google_Play_symbol.svg',
        url: 'https://play.google.com/store/books/details?id=yDaRdJbXDpQC&amp;rdid=book-yDaRdJbXDpQC&amp;rdot=1&amp;source=gbs_atb&amp;pcampaignid=books_booksearch_atb&gl=us',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9781449423117').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/16wuzN9/tc-custom/9781449423117.jpg?1725275627237',
        alt: 'Roger Ebert&#x27;s Movie Yearbook 2013'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "cover", "love_1", "title", "Dedication", "content", "Introduction", "Acknowledgments", "key", "chapter1", "chapter2", "chapter3", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/16wuzN9/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cover__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_love_1__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_love_1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_love_1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_title__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Dedication__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Dedication___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Dedication__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_content__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_content___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_content__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Introduction__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Introduction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Introduction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Acknowledgments__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Acknowledgments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Acknowledgments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_key__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_key___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_key__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_chapter1__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_chapter1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_chapter1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_chapter2__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_chapter2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_chapter2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_chapter3__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_chapter3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_chapter3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_chapter4__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_chapter4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_chapter4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_chapter5__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_chapter5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_chapter5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_chapter6__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_chapter6___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_chapter6__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_chapter7__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_chapter7___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_chapter7__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_chapter8__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_chapter8___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_chapter8__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_chapter9__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_chapter9___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_chapter9__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_chapter10__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_chapter10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_chapter10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_chapter11__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_chapter11___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_chapter11__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_chapter12__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_chapter12___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_chapter12__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_chapter13__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_chapter13___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_chapter13__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_chapter14__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_chapter14___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_chapter14__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_chapter15__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_chapter15___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_chapter15__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_chapter16__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_chapter16___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_chapter16__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_chapter17__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_chapter17___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_chapter17__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_chapter18__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_chapter18___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_chapter18__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_chapter19__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_chapter19___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_chapter19__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_chapter19_2__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_chapter19_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_chapter19_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_chapter20__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_chapter20___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_chapter20__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_chapter21__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_chapter21___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_chapter21__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_chapter22__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_chapter22___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_chapter22__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_chapter23__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_chapter23___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_chapter23__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_chapter24__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_chapter24___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_chapter24__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_chapter25__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_chapter25___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_chapter25__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_chapter26__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_chapter26___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__components_chapter26__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_chapter27__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_chapter27___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__components_chapter27__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_chapter28__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_chapter28___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__components_chapter28__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_chapter29__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_chapter29___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__components_chapter29__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_chapter30__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_chapter30___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__components_chapter30__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_chapter31__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_chapter31___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__components_chapter31__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_chapter32__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_chapter32___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__components_chapter32__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_love_2__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_love_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__components_love_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_index__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__components_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_index1__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_index1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__components_index1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_index2__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_index2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__components_index2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_page2__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_page2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__components_page2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_copyright__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_copyright___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__components_copyright__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_author__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_author___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__components_author__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_last__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__components_last__);
/*jshint esversion: 6 */























































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/cover",
    "name": "cover",
    "component": __WEBPACK_IMPORTED_MODULE_4__components_cover___default.a
  }, {
    "path": "/love_1",
    "name": "love_1",
    "component": __WEBPACK_IMPORTED_MODULE_5__components_love_1___default.a
  }, {
    "path": "/title",
    "name": "title",
    "component": __WEBPACK_IMPORTED_MODULE_6__components_title___default.a
  }, {
    "path": "/Dedication",
    "name": "Dedication",
    "component": __WEBPACK_IMPORTED_MODULE_7__components_Dedication___default.a
  }, {
    "path": "/content",
    "name": "content",
    "component": __WEBPACK_IMPORTED_MODULE_8__components_content___default.a
  }, {
    "path": "/Introduction",
    "name": "Introduction",
    "component": __WEBPACK_IMPORTED_MODULE_9__components_Introduction___default.a
  }, {
    "path": "/Acknowledgments",
    "name": "Acknowledgments",
    "component": __WEBPACK_IMPORTED_MODULE_10__components_Acknowledgments___default.a
  }, {
    "path": "/key",
    "name": "key",
    "component": __WEBPACK_IMPORTED_MODULE_11__components_key___default.a
  }, {
    "path": "/chapter1",
    "name": "chapter1",
    "component": __WEBPACK_IMPORTED_MODULE_12__components_chapter1___default.a
  }, {
    "path": "/chapter2",
    "name": "chapter2",
    "component": __WEBPACK_IMPORTED_MODULE_13__components_chapter2___default.a
  }, {
    "path": "/chapter3",
    "name": "chapter3",
    "component": __WEBPACK_IMPORTED_MODULE_14__components_chapter3___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_52__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/16wuzN9/tc-custom/9781449423117.jpg?1725275627237",
      "alt": "This image is the cover for the book Roger Ebert's Movie Yearbook 2013"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Roger Ebert's Movie Yearbook 2013\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Roger Ebert’s “criticism shows a nearly unequaled grasp of film history and technique, and formidable intellectual range. . . .” —"), _c('i', [_vm._v("New York Times")]), _c('br'), _c('br'), _vm._v("Pulitzer Prize–winning film critic Roger Ebert presents more than 600 full-length critical movie reviews, along with interviews, tributes, and journal entries inside "), _c('i', [_vm._v("Roger Ebert")]), _c('i', [_vm._v("’")]), _c('i', [_vm._v("s Movie Yearbook 2013.")]), _c('br'), _c('br'), _vm._v("It includes every movie review Ebert has written from January 2010 to July 2012."), _c('br'), _c('br'), _vm._v("Also included in the Yearbook:In-depth interviews with newsmakers and celebritiesTributes to those in the film industry who have passed away recentlyEssays on the Oscars, reports from the Toronto Film Festival, and entries into Ebert's Little Movie Glossary")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Roger Ebert\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Andrews McMeel Publishing\n   ")])])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "centre"
  }, [_c('img', {
    attrs: {
      "alt": "cover",
      "src": "images/cover.jpg"
    }
  })])])])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-inside": "avoid",
      "text-align": "center",
      "margin": "0"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://earlybirdbooks.com/freebook/index.html?q=6572068d00d3b3f6d67a7698&utm_campaign=front",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "love.jpg"
    }
  })])])])])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "centre"
  }, [_c('img', {
    attrs: {
      "alt": "cover",
      "src": "images/title.jpg"
    }
  })])])])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p-in1"
  }, [_vm._v("This book is dedicated to Robert Zonka, 1928–1985. God love ya. ")])])])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(66),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "Minion-Bold"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }, [_c('a', {
    attrs: {
      "href": "#/Introduction"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }, [_c('a', {
    attrs: {
      "href": "#/Acknowledgments"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }, [_c('a', {
    attrs: {
      "href": "#/key"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Key to Symbols")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Reviews")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("The Best Films of 2011")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter27#b1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("The Best Documentaries of 2011")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Interviews")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter28#b2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Asghar Farhadi "), _c('em', [_vm._v("(A Separation)")])])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter28#b3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Tilda Swinton "), _c('em', [_vm._v("(We Need to Talk About Kevin)")])])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter28#b4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Quvenzhane Wallis "), _c('em', [_vm._v("(Beasts of the Southern Wild)")])])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Ebert’s Journal")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#b5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Sarah Palin Documentary")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#b6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("The Enigma of Political Prayer")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#b7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("A   Shimmering Mirage")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#b8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Knocked Up At the Movies")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#b9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("The Sudden Death of Film")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#b10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Heteronormative Vampires")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#b11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Dissecting Declining Box Office Revenue")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#b12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Think of Me as the Butler, Carson")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#b13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("The Oscar Losers: They Wuz Robbed")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#b14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Indie Spirit Awards Joined "), _c('em', [_vm._v("The Artist")]), _vm._v(" Bandwagon")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#b15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Hey, Kids! Anybody Here Not Heard the F-Word?")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#b16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_c('em', [_vm._v("The Raid")]), _vm._v(" and Why I Hated It")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#b17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("I Remember You")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#b18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("The Perfect Audience")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#b19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Movies Don’t Stream Themselves")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#b20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("A Few Calm Words About The List")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("In Memoriam")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter30#b21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Andrew Sarris")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Film Festival")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter31#b22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Toronto International Film Festival")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Ebert’s Little Movie Glossary")])])]), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }), _vm._v(" "), _c('p', {
    staticClass: "con-in1"
  }, [_c('span', {
    attrs: {
      "href": "#/index",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Index")])])])])])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', [_vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The massacre at a premiere of "), _c('em', [_vm._v("The Dark Knight Rises")]), _vm._v(" in Aurora, Colorado, brought a wave of speculation about whether movie violence inspires violent behavior in moviegoers. I’d written a blog about our need for better gun control, and it drew a lot of messages along those lines, suggesting I should put my own house in order. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("This yearbook is not the right place to go into gun control, but violence in the movies is fair game. Does it inspire violence in society? The honest answer is, I don’t know. But there I times I believe it has a sort of deadening effect on young viewers who are exposed to a lot of it. I go to see virtually every new release, and sometimes I despair. Many new films are nonstop violent action, with mechanical dialogue and shallow characters. Essentially they offer only kinetic action and bright colors. What thinking person can possibly care about the plot of a Transformers movie? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("In my years of professional movie going I’ve seen a relentless erosion of story-telling standards in mainstream commercial movies. The idea of a well-structured story is no longer a goal. Many successful movies consist essentially of a perfunctory set-up and 80 or 90 minutes of spectacular special effects. Well-made feature films used to embed the idea that causes had effects; that characters should expect to reap the results of their decisions. Now we usually see invulnerable heroes who destroy one threat after another in ways that make no sense. They can jump from heights and not be injured. They can miraculously avoid being struck by countless rounds from automatic weapons. They can drive through city streets, leave carnage behind, and pay no consequences. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("This can often be entertaining escapism, as in the "), _c('em', [_vm._v("Dark Knight")]), _vm._v(" movies, "), _c('em', [_vm._v("Spider-Man II")]), _vm._v(", and a Bond picture. More often, it is simply routine. Please forgive me for employing one of the most over-used lines in Shakespeare: Viewers are subjected to sound and fury, signifying nothing. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I don’t know if an exclusive diet of such movies can influence human behavior. I do believe, however, that seeing good films are, at the end of the day, likely to make you a more thoughtful and interesting person. I think there is such a thing as “dumbing down,” and I think our mass media contribute to it. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("One of the reasons for this may be that movie choices are often shaped by the myopic and skewed MPAA Rating System. It’s obvious that the MPAA takes a sterner look at sexuality than violence. Incredible violence can get a "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PG-13")]), _vm._v(" seal of approval, but films, however thoughtful, that deal with human relationships are more likely to be rated "), _c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(". Children’s films, which are now usually animated 3-D cartoons, often consist of little more than distracting fast action. The loving craftsmanship of Disney classics or such more recent films as "), _c('em', [_vm._v("Little Mermaid")]), _vm._v(" and "), _c('em', [_vm._v("The Lion King")]), _vm._v(" is much harder to find than inane adventures like "), _c('em', [_vm._v("Kung Fu Panda")]), _vm._v(" and the "), _c('em', [_vm._v("Ice Age")]), _vm._v(" movies. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I believe there is such thing as a movie appropriate for adults, and that it should be rated "), _c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(" or "), _c('span', {
    staticClass: "small"
  }, [_vm._v("NC-17")]), _vm._v(". During 2012, we had the rare experience of seeing a film by an established director, with major stars in the leads, released with the "), _c('span', {
    staticClass: "small"
  }, [_vm._v("NC-17")]), _vm._v(" rating. This was William Friedkin’s Killer Joe, starring Matthew McConaughey. You can read my review of it in this book. I think "), _c('span', {
    staticClass: "small"
  }, [_vm._v("NC-17")]), _vm._v(" was the correct rating and that a good many more "), _c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v("-rated movies deserve it. There are also "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PG-13")]), _vm._v(" movies that probably should be rated "), _c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(". ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I think, perhaps foolishly, that such a shift in the MPAA’s standards might place more emphasis on storytelling and character and make a smaller opening for movies that depend entirely on violence. I believe that younger viewers, those in the "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PG-13")]), _vm._v(" category, might benefit from less mindless action in their formative years. The decay of standards in movies may be related to the decay of standards in our society. I can’t prove it. But I fear it. ")]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("My sincere thanks to Dorothy O’Brien, who has been the book’s valued editor at Andrews McMeel for many years. Also to Sue Roush, my editor at Universal Uclick, and to Laura Emerick, Amanda Barrett, Linda Bergstrom, Miriam Di Nunzio, Darel Jevens, Teresa Budasi, Thomas Conner, and all the other heroes at the "), _c('em', [_vm._v("Chicago Sun-Times")]), _vm._v(", and Jim Emerson and the Web staff at "), _c('a', {
    attrs: {
      "href": "http://rogerebert.com",
      "target": "_blank"
    }
  }, [_vm._v("rogerebert.com")]), _vm._v(". Many others are thanked in the Acknowledgments. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }), _vm._v(" "), _c('p', {
    staticClass: "text-right"
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OGER")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BERT")])])])])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "initial"
  }), _vm._v(" "), _c('p', {
    staticClass: "initial"
  }), _vm._v(" "), _c('p', {
    staticClass: "initial"
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("My editor is Dorothy O’Brien, tireless, cheerful, all-noticing. My friend and longtime editor Donna Martin suggested the yearbook approach to the annual volume. The design is by Cameron Poulter, the typographical genius of Hyde Park. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-in"
  }, [_vm._v("My thanks to production editor Christi Clemons Hoffman, who renders Cameron’s design into reality. John Yuelkenbeck at Alias Creative Group is the compositor who has worked diligently on the series for years. I have been blessed with the expert and discriminating editing of Laura Emerick, Miriam Di Nunzio, Darel Jevins, Jeff Johnson, and Teresa Budasi at the "), _c('em', [_vm._v("Chicago Sun-Times")]), _vm._v("; Sue Roush at Universal Uclick; and Michelle Daniel and David Shaw at Andrews McMeel Publishing. For much advice and counsel, thanks to Jim Emerson and John Barry of "), _c('a', {
    attrs: {
      "href": "http://www.rogerebert.com",
      "target": "_blank"
    }
  }, [_vm._v("www.rogerebert.com")]), _vm._v(". ")]), _vm._v(" "), _c('p', {
    staticClass: "p-in"
  }, [_vm._v("Many thanks are also due to Marsha Jordan at WLS-TV. My gratitude goes to Carol Iwata, my expert personal assistant, and to Gregory Isaac, who is a computer whiz and invaluable aide-de-camp. I must also thank those who have given me countless observations and corrections, including Peter Debruge, Jana J. Monji, and Troylene Ladner. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-in"
  }, [_vm._v("And special thanks and love to my wife, Chaz, who was always at my side during a difficult illness, helped see three books through the press during that time, and was a cheerleader for this one. I am so grateful to her as we once again, relieved, enter a period of good health.")]), _vm._v(" "), _c('p', {
    staticClass: "initial"
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OGER")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BERT")])])])])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', [_vm._v("Key to Symbols\t")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p'), _vm._v(" "), _c('p'), _vm._v(" "), _c('table', {
    staticClass: "key",
    attrs: {
      "border": "0",
      "cellpadding": "1px",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "small",
    staticStyle: {
      "padding-top": "1px"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("A great film")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "small",
    staticStyle: {
      "padding-top": "1px"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("A good film")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "small",
    staticStyle: {
      "padding-top": "1px"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Fair")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "small",
    staticStyle: {
      "padding-top": "1px"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Poor")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "small"
  }, [_vm._v("G, PG, PG-13, R, NC-17: ")]), _vm._v("Ratings of the Motion Picture Association of America")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "small",
    staticStyle: {
      "padding-top": "2px"
    }
  }, [_vm._v("G")]), _vm._v(" "), _c('td', [_vm._v("Indicates that the movie is suitable for general audiences")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "small",
    staticStyle: {
      "padding-top": "2px"
    }
  }, [_vm._v("PG")]), _vm._v(" "), _c('td', [_vm._v("Suitable for general audiences but parental guidance is suggested")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "small",
    staticStyle: {
      "padding-top": "2px"
    }
  }, [_vm._v("PG-13")]), _vm._v(" "), _c('td', [_vm._v("Recommended for viewers "), _c('span', {
    staticClass: "small"
  }, [_vm._v("13")]), _vm._v(" years or above; may contain material inappropriate for younger children")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "small",
    staticStyle: {
      "padding-top": "2px"
    }
  }, [_vm._v("R")]), _vm._v(" "), _c('td', [_vm._v("Recommended for viewers "), _c('span', {
    staticClass: "small"
  }, [_vm._v("17")]), _vm._v(" or older")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "small",
    staticStyle: {
      "padding-top": "2px"
    }
  }, [_vm._v("NC-17")]), _vm._v(" "), _c('td', [_vm._v("Intended for adults only")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "small",
    staticStyle: {
      "padding-top": "2px"
    }
  }, [_vm._v("141 m.")]), _vm._v(" "), _c('td', [_vm._v("Running time")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "small",
    staticStyle: {
      "padding-top": "2px"
    }
  }, [_vm._v("2010              ")]), _vm._v(" "), _c('td', [_vm._v("Year of theatrical release")])])])])])])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "margin-bottom"
  }, [_vm._v("Reviews")]), _vm._v(" "), _c('h2', {
    staticClass: "margin-bottom"
  }, [_vm._v("A")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a8"
    }
  }, [_vm._v("Abraham Lincoln: Vampire Hunter "), _c('span', {
    staticClass: "key"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 105 m., 2012")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Benjamin Walker (Abraham Lincoln), Dominic Cooper (Henry Sturgess), Anthony Mackie (Will Johnson), Mary Elizabeth Winstead (Mary Todd Lincoln), Rufus Sewell (Adam), Marton Csokas (Jack Barts), Jimmi Simpson (Joshua Speed), Erin Wasson (Vadoma). Directed by Timur Bekmambetov and produced by Bekmambetov, Tim Burton, and Jim Lemley. Screenplay by Seth Grahame-Smith, based on his novel.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_c('em', [_vm._v("Abraham Lincoln: Vampire Hunter")]), _vm._v(" is without a doubt the best picture we are ever likely to see on the subject—unless there is a sequel, which is unlikely, because at the end the Lincolns are on their way to the theater. It’s also a more entertaining movie than I remotely expected. Yes, dear readers, I went expecting to sneer.")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The story opens with young Abe witnessing the murder of his mother by a vampire. He swears an oath of vengeance, and some years later is lucky to be getting drunk while standing at a bar next to Henry Sturgess (Dominic Cooper), who coaches him on vampire killing and explains that it is a high calling, requiring great dedication and no distractions like marriage.")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("There’s an early scene in which Lincoln tries to shoot a vampire, but that won’t work because they’re already dead. Then whatever can he do? “Well,” he tells Henry, “I used to be pretty good at rail-splitting.” This line drew only a few chuckles from the audience because the movie cautiously avoids any attempt to seem funny.")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Lincoln’s weapon of choice becomes an ax with a silver blade, which he learns to spin like a baton twirler. That he carries this ax with him much of the time may strike some as peculiar. I was reminded uncannily of Buford Pusser, walking tall and carrying a big stick.")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Against advice, Lincoln (Benjamin Walker) marries Mary Todd (Mary Elizabeth Winstead), and the story moves quickly to his days in the White House, where he discovers that the vampires are fighting on the side of the South. This seems odd, since they should be equal opportunity bloodsuckers, but there you have it. Still with him is childhood friend Will Johnson (Anthony Mackie), a free black man whose mistreatment helped form Lincoln’s hatred of slavery. Also still at his side is Joshua Speed (Jimmi Simpson), who hired Lincoln in his Springfield general store; Johnson and Speed join Lincoln in Civil War strategy sessions and are his principal advisers, roles overlooked by history.")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The movie, directed by Timur Bekmambetov and written by Seth Grahame-Smith, based on his novel, handles all these matters with an admirable seriousness, which may be the only way they could possibly work. The performances are earnest and sincere, and even villains like Adam (Rufus Sewell), the American leader of the Vampire Nation, doesn’t spit or snarl overmuch. The movie regrettably introduces but does not explain Vadoma (Erin Wasson), a statuesque woman who is several decades ahead of her time in her taste for leather fetish wear. Are vampires kinky? I didn’t know.")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Although we do not attend "), _c('em', [_vm._v("Abraham Lincoln: Vampire Hunter")]), _vm._v(" in search of a history lesson, there’s one glitch I cannot overlook. In the first day of fighting at Gettysburg, the Union sustains a defeat so crushing that Lincoln is tempted to surrender. This is because the Confederate troops, all vampires, are invulnerable to lead bullets, cannon fire, and steel blades, and have an alarming way of disappearing and rematerializing. Over breakfast, Lincoln confides his despair to his wife, and says conventional weapons are of no more use against them than—why—than this fork! As he stares at it, he realizes it is a silver fork, and vampires can be killed by silver weapons, as he has proved with his ax twirling.")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Now try not to focus too much on the timeline. After his realization, Lincoln mobilizes all resources to gather wagonloads of silver in Washington, smelts it, and manufactures silver bayonets, bullets, and cannonballs. Then we see him, Johnson, and Speed on board a weapons train en route to Gettysburg. It is night again, so apparently all of this took less than a day.")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Never mind. What comes now is a genuinely thrilling action sequence in which the vampires battle with Lincoln and his friends on top of the speeding train, which hurtles toward a high wooden bridge that has been set alight by the sinister Vadoma (pronounced "), _c('em', [_vm._v("Vadooma")]), _vm._v(", I think). This sequence is preposterous and yet exciting, using skillful editing and special effects. Somehow Benjamin Walker and his costars here are even convincing—well, as convincing as such goofiness could possibly be.")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Abraham Lincoln: Vampire Hunter")]), _vm._v(" has nothing useful to observe about Abraham Lincoln, slavery, the Civil War, or much of anything else. Blink and you may miss the detail that Harriet Tubman’s Underground Railroad essentially won the war for the North. But the movie doesn’t promise insights on such subjects. What it achieves is a surprisingly good job of doing justice to its title, and treating Lincoln with as much gravity as we can expect, under the circumstances.")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a11"
    }
  }, [_vm._v("Accomplices "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NO MPAA RATING")]), _vm._v(", 93 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Gilbert Melki (Herve Cagan), Emmanuelle Devos (Karine Mangin), Cyril Descours (Vincent Bouvier), Nina Meurisse (Rebecca Legendre), Joana Preiss (Esther). Directed by Frederic Mermoud and produced by Damien Couvreur and Tonie Marshall. Screenplay by Mermoud and Pascal Arnold. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_c('em', [_vm._v("Accomplices ")]), _vm._v("coils through two stories, cutting between them as they converge, as we know they will, because the film has opened with a corpse ﬂoating in the river Seine. This body, as a ﬂashback establishes, belongs to a boy about nineteen, and the film will watch as he meets a cute girl in a cyber café and leads her into his dangerous world. The other story involves two police inspectors, who begin with the corpse. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Sometimes when a movie cuts between parallel stories it’s tiresome. Not this one. The director, Frederic Mermoud, does an interesting thing with time: As the cops are working their way back from the dead body, the other story works its way forward to the point that the body became dead. Then the stories join up and conclude in a surprising and particularly satisfying way. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Vincent (Cyril Descours) is a hustler who meets his male clients in hotel rooms. He meets Rebecca (Nina Meurisse), likes her, gets her phone number, and they start seeing each other. He says he works in real estate—unlikely, given his scruffy appearance and the shabby mobile home he lives in. She is bourgeois but ready for the wild side, and they fall truly in love, like Bonnie and Clyde and other couples where crime is in the mix. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Vincent eventually tells Rebecca what he really does, and the way the movie charts her reaction is touchingly realistic. She learns of his world and stirs the jealousy of his pimp—or "), _c('em', [_vm._v("friend, ")]), _vm._v("as he considers him. It’s thrilling for her to glimpse his outlaw life, and fun when they use prostitution income to pay cash for sneakers. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Herve (Gilbert Melki) and Karine (Emmanuelle Devos) are like a long-established couple, skilled in police work, functioning expertly together, sharing personal feelings. We think it’s a possibility they might hook up, but the plot isn’t that obvious. The film is a police procedural explaining how they begin with a nameless body and find their way back to Vincent’s associates and clients. One interview, with a businesswoman who shared Vincent with her husband, is startling: The woman is forthcoming, matter-of-fact, defiant. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Without making a big deal out of it, "), _c('em', [_vm._v("Accomplices ")]), _vm._v("puts several plausible murder suspects onstage, including Rebecca, who disappeared the day of Vincent’s murder. It’s like an Agatha Christie in which lots of people have the opportunity and the motive. But Mermoud works so close to the characters, sees them in such detail, that only later do we pull back and observe the workings of the plot. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The original English title of the film was "), _c('em', [_vm._v("Partners, ")]), _vm._v("and that would have been accurate. It’s about two partnerships. The one is the sad, doomed story of Vincent and Rebecca, incapable of dealing with the risks they run. The other is about how Herve and Karine shy away from risks in their lonely personal lives; how police routine creates a way for them to spend most of their waking hours together without having to deal with the sleeping hours. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I appreciate the way French films, in particular, often approach their characters at eye level. There’s no artificial heightening. No music pounding out emotional instruction. They’re cool, curious, looking for performances with the tone of plausible life. All four of these actors are completely natural in front of the camera. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("You may have seen Emmanuelle Devos in films such as "), _c('em', [_vm._v("Read My Lips ")]), _vm._v("(2001) or "), _c('em', [_vm._v("The Beat That My Heart Skipped ")]), _vm._v("(2005); she’s in the wonderful "), _c('em', [_vm._v("L’Origin, ")]), _vm._v("still unreleased, about a small-town mayor and a desperate con man. She’s always attractive, never distractingly so, and comes equipped with intelligence and hidden motives. I like actors who make me want to figure them out. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Accomplices ")]), _vm._v("is technically a murder mystery. But the murder is only what happens. A lot of other things could have happened, and the story plays fair with the fateful role that chance takes. You would even argue that no one is actually murdered in this movie, and that when they die it is simply the result of bad decisions. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a16"
    }
  }, [_vm._v("Act of Valor "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½ ")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 101 m., 2012 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Chief Dave (Himself), Lieutenant Rorke (Himself), Roselyn Sanchez (Lisa Morales), Marc Margulies (U.S. Ambassador), Dimiter Marinov (Karimov), Ailsa Marshall (Jackie Engel), Gonzalo Menendez (Commander Pedros), Timothy Gibbs (J. C. Palmer). Directed and produced by Mike McCoy and Scott Waugh. Screenplay by Kurt Johnstad. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_c('em', [_vm._v("Act of Valor ")]), _vm._v("contains hard-hitting combat footage, relentless and effective. There is a story behind the film that is no less engrossing. In an introduction at the beginning, its codirectors, Mike McCoy and Scott Waugh, speak directly to the audience, describing how they got involved in a film about the Navy SEALs, how they were embedded with an actual SEAL unit—and how, when that project grew into a fiction film, they determined to use real SEALs and not professional actors. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The early version of the film, according to reporting by Rebecca Keegan of the "), _c('em', [_vm._v("Los Angeles Times")]), _vm._v(", was variously intended as a training film or recruitment film, and was made outside the usual Department of Defense guidelines for motion pictures. It now emerges as a thriller involving two (nonfactual) scenarios, one about a SEAL mission to free a kidnapped CIA operative (Roselyn Sanchez), the other about a plot to smuggle terrorists into the United States through tunnels from Mexico constructed by drug cartels. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The details in both of these scenarios seem realistic—although how would I know? The codirectors and their team have produced an accomplished, riveting action movie. I am reminded of the initial impact of films such as Oliver Stone’s "), _c('em', [_vm._v("Platoon ")]), _vm._v("and Kathryn Bigelow’s "), _c('em', [_vm._v("The Hurt Locker")]), _vm._v(", which both told convincing and authentic stories. "), _c('em', [_vm._v("Act of Valor")]), _vm._v(", however, centers more on action and much less on the human elements involved. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The central characters are played by actual Navy SEALs, who were apparently on active duty at the time and still are. This makes it difficult to write the ordinary kind of review, because none of their real names are revealed, and indeed some of the characters seem to have no names at all. I learn from Rebecca Keegan’s article that the characters named Chief Dave and Lieutenant Rorke are played by SEALs whose real first names are Dave and Rorke. Thanks a lot. The official cast listing is a baffling mixture of characters without names and names with “uncredited” roles, and doesn’t include either Chief Dave or Lieutenant Rorke, so I am reduced to describing the experience and not the performances. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Much of the movie consists of pure action, punctuated by terse dialogue and few subtleties. We don’t get to know the characters as individuals, they don’t have personality traits, they have no backstories, they don’t use colorful dialogue, and after the movie you find yourself describing events but not people. Assuming that the characters described as SEALs were being played by real SEALs, all I can say is that they were convincing and weren’t asked to do any dramatic stretching they weren’t capable of. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Yet the movie can be discussed on another level. In the same week I saw "), _c('em', [_vm._v("Act of Valor")]), _vm._v(", I also saw an extraordinary film named "), _c('em', [_vm._v("Hell and Back Again")]), _vm._v(". It is about a real man, marine sergeant Nathan Harris, and his real wife, Ashley. Harris led men in combat in Afghanistan. Shortly before the scheduled end of his six-month tour, a sniper’s bullet entered his right buttock, shattered his hip socket, and bounced back to destroy leg bones. He’s quite willing to show people the entry scar and describe how he has two rods filling in for bones. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("When Nathan Harris was a teenager, he says, “what I wanted to do was kill people.” He enlisted in the marines. He doesn’t actually say if he has killed anyone or not, but the director, Danfung Dennis, who was embedded with Harris’s Echo Company, followed him in action and we see that he has grown into a natural leader of men. Some of the film’s most involving scenes show him debating village elders (through an interpreter) about the role of America in Afghanistan—he sincerely believes he is helping to bring them freedom, and finds it hard to answer their statements that they want to be left alone by both the Americans and the Taliban. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The film follows Harris home, through an agonizing period of rehab, and shows that his life will never be the same. Memories of battle haunt him, and "), _c('em', [_vm._v("Hell and Back Again ")]), _vm._v("intercuts actual sights and scenes from Afghanistan with scenes back home in North Carolina. He doesn’t have post-traumatic stress syndrome. He dreams of returning to action, and it is hard for him to accept that it may not happen. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Act of Valor ")]), _vm._v("is gift-wrapped in patriotism. Once intended as a recruitment film, that’s how it plays. The action scenes are harrowing but exciting. Lots of explosions and special effects. At the end there is a full-dress military funeral, honoring three generations of warriors. The real action scenes in "), _c('em', [_vm._v("Hell and Back Again ")]), _vm._v("don’t play like an action movie. I don’t recall seeing a single Taliban fighter. One of Sergeant Harris’s men is killed on the first day in the field. Harris is wounded late in his tour. Nobody saw either one of the snipers. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I have a feeling that the teenage Nathan Harris, who wanted to kill people, would have loved "), _c('em', [_vm._v("Act of Valor")]), _vm._v(". But "), _c('em', [_vm._v("Hell and Back Again")]), _vm._v(", in describing his life today, doesn’t play like a recruitment film. A great deal is made by the directors McCoy and Waugh that actual live ammunition was used in the making of their film. Actual live ammunition was also used in "), _c('em', [_vm._v("Hell and Back Again")]), _vm._v(". If you asked Sergeant Nathan Harris what he thought about using live ammo in a Hollywood action movie, what do you suppose he would say? My best guess is, he would say they were damned fools. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a19"
    }
  }, [_vm._v("Addiction Incorporated "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v(", 100 m., 2012 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("A documentary featuring Victor DeNoble, Paul Mele, Russ Herman, David A. Kessler, Michael C. Moore, Keith Summa, Henry Waxman, and Steven C. Parrish. Directed and produced by Charles Evans Jr. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("The "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v(" rating of "), _c('em', [_vm._v("Addiction Incorporated ")]), _vm._v("is explained in part because it “contains thematic material involving smoking and addiction.” When the MPAA first adopted its code, everyone in the movies smoked except Snow White. Smoking was identified with romance and heroism, Bette Davis was applauded for lighting up on the "), _c('em', [_vm._v("Tonight ")]), _vm._v("show, and you could often see the smoke from Johnny’s own cigarette curling up from the ashtray under his desk. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("These days, a character who smokes is self-destructive, a villain, or a troubled high school student. "), _c('em', [_vm._v("Addiction Incorporated ")]), _vm._v("follows tobacco’s journey downhill from respectability. After his long night’s work, Santa used to relax with a Lucky on a back-cover ad in "), _c('em', [_vm._v("Life ")]), _vm._v("magazine, and Ronald Reagan liked to puff on Chesterfields. Now we learn of proposed new government health warnings that are more likely to make you spew than smoke your first cigarette. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The key player in this process was a man named Victor DeNoble, a scientist for Philip Morris who began with the generally known fact that nicotine was addictive, and discovered that a chemical named acetaldehyde made it more addictive. DeNoble was originally hired by Philip Morris to find a "), _c('em', [_vm._v("substitute ")]), _vm._v("for nicotine, in the attempt to develop a less addictive cigarette. (The tobacco industry’s reasoning was: Dead smokers don’t buy cigarettes.) When DeNoble reported his findings, Philip Morris switched signals and realized it could outsell their competitors by adding more acetaldehyde. At this time the Tobacco Institute was making phony claims that there was no evidence cigarettes were addictive at all. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("You may be assuming DeNoble is the same whistleblower played by Russell Crowe in "), _c('em', [_vm._v("The Insider ")]), _vm._v("(1999). No, that was Jeffrey Wigand, a scientist employed by Brown and Williamson. DeNoble’s research was obtained by ABC News, whose corporate bosses vetoed its use. Wigand was leaking to "), _c('em', [_vm._v("60 Minutes ")]), _vm._v("on CBS, where network executives also were shy. There were a lot of cigarette ads on TV in those days—but more to the point, Big Tobacco had a reputation of suing for millions and never losing a case. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The first half of this doc covers familiar territory; although everyone, even my parents, who both died from smoking cigarettes, knew they were addictive, Big Tobacco had always denied it. Now DeNoble’s research with laboratory rats proved it beyond a doubt. Rats who pushed a button got a rat-sized dose of nicotine. The first dose made them puke, but soon they were pushing the button ninety times a day. DeNoble was the most harmful witness imaginable to the industry because he could testify that Philip Morris knew it, and hoped to increase sales with its knowledge. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The second half of the film begins with a historic series of congressional hearings chaired by Representative Henry Waxman of California. Having thoroughly established that the industry knew nicotine was an addictive drug, Waxman summoned the heads of the seven major tobacco companies to testify. In the past they’d always refused to appear. This time they showed up. Waxman dropped a surprise: He placed them under oath. They can either agree it is addictive, or perjure themselves. All seven raise their right hands and swear it isn’t addictive. Then DeNoble delivers his historic testimony. In the months to come, all seven resigned from their corporations. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("DeNoble, from a working-class family, was its first member to attend college. That came after he discovered he was dyslexic and “I wasn’t stupid like I thought.” Publication of his Philip Morris findings in a journal would have established his reputation. Instead, learning what the paper contained, his bosses ordered him to withdraw it and kill his rats. Then they fired him. Today he speaks against cigarettes on national tours paid for by funds that were part of Big Tobacco’s settlement with the government. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Addiction Incorporated")]), _vm._v(", directed by Charles Evans Jr., doesn’t tell a new story, although it closes very recently with President Obama signing the legislation that DeNoble’s research put into motion. It’s an effective film, enlivened with animated rats, never boring, and entertaining when it shows Rush Limbaugh, the cigar enthusiast, fulminating against the Waxman hearings. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a20"
    }
  }, [_vm._v("The Adjustment Bureau "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v("-13, 105 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Matt Damon (David Norris), Emily Blunt (Elise Sellas), Anthony Mackie (Harry Mitchell), John Slattery (Richardson), Michael Kelly (Charlie Traynor), Terence Stamp (Thompson). Directed by George Nolfi and produced by Nolfi, Bill Carraro, Michael Hackett, and Chris Moore. Screenplay by Nolfi, based on the short story “Adjustment Team” by Philip K. Dick. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Here I go again. I’ll be helpless to stop myself. "), _c('em', [_vm._v("The Adjustment Bureau ")]), _vm._v("is about the conﬂict between free will and predestination, and right there you have the whole dilemma of life, don’t you? Either it makes a difference what you choose to do, or the book has already been written and all you can do is turn the pages. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("That these questions are raised in a science-fiction thriller with a romance at its core should not be surprising. Sci-fi offers storytellers the freedom of tinkering with realism, and few writers did that with more complexity than Philip K. Dick. This movie, written and directed by George Nolfi, is based on a Dick story about a legion of “adjusters” who move a strange thing there and a known thing here, just to be sure everything proceeds according to plan. Whose plan? The adjusters aren’t big on explanations. They’re like undercover agents for the higher power of your choice. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("But the best-laid plans of mice and men sometimes stray. Random chance barges in, and its interference must be corrected. In "), _c('em', [_vm._v("The Adjustment Bureau")]), _vm._v(", Matt Damon plays a congressional candidate named David Norris, who walks into a men’s room he has every reason to believe is empty, and who should emerge from one of the stalls but Elise Sellas (Emily Blunt). What was she doing there? You don’t cross-examine a Meet Cute. The important thing is, these two people, who were never intended to meet, have that particular chemistry that means they’re a perfect romantic match. They know it, we know it, and when their eyes and lips meet, their stories become entangled. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Philip Dick was intrigued by devices that allowed him to examine the mechanisms by which life unfolds. I think he voted for free will in the short run (the span of intelligent life on Earth, say), evolution for the middle distance (things develop according to underlying principles), and predestination in the long run (the universe will entropy and cease). A man and a woman whose eyes Meet Cute need only be concerned about the very short run. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("In the movie, David Norris becomes aware of certain men wearing suits and fedoras who strangely appear in his life. He meets two of these: Mitchell and Richardson (Anthony Mackie and John Slattery). They explain that they work for a bureau that makes corrections when things go slightly wrong. For example, David and Elise were not intended to meet. What was she doing in the men’s room, anyway? For her sake and his, David must not see her again. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("OK, so this is where it gets intriguing. They do meet again, once again by pure chance. But "), _c('em', [_vm._v("this ")]), _vm._v("time, they recognize each other, you see, because they had met earlier. It is possible the second time they see each other was intended to be the first time, in which case (if you follow me) they would not necessarily even notice each other. Seeing a woman on the bus isn’t the same thing as getting into a conversation with her in a men’s room. So answer me this: When the adjusters urge David to forget about Elise and never see her again, aren’t they asking him to exercise his free will? Aren’t they implying he has a choice? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("So you might think, but "), _c('em', [_vm._v("The Adjustment Bureau")]), _vm._v(" reveals a hidden level of reality by which players can be yanked out of the game. David is confronted in a cavernous industrial space and warned that if he doesn’t straighten up, his memory will be erased. This space is reached through a doorway to a place that has no logical possibility of existence; it must be like the bedroom beyond Jupiter in "), _c('em', [_vm._v("2001")]), _vm._v(", which was summoned by a greater intelligence to provide the illusion of a familiar space for an unwitting subject. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The plot develops into a cat-and-mouse game of the mind, in which David and Elise, in love and feeling as if they’re destined for each other, try to outsmart or elude the men in the suits and hats. This is fun, and because Matt Damon and Emily Blunt have an easy rapport, it doesn’t seem as preposterous as it is. Beneath its apparent sci-fi levels, a romantic comedy lurks here. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("If you’re like me, you’re thinking the universe in this movie is run by a singularly inefficient designer. There is no room for chance in predestination. If there is a plan, you can’t allow tinkering. There’s a well-known sci-fi precept that warns if you travel back far enough in time and step on the wrong insect, you could wipe out the future. By the time we meet a very, very serious senior adviser named Thompson (Terence Stamp), we begin to suspect that his employer has delusions of grandeur. Thompson gives the appearance of being firmly in control and knowing all the right buttons to push, but his problem is David and Elise have seen behind the curtain and realize they need not be instruments of a plan. There’s even the intriguing possibility that the adjusters themselves have some freedom of choice. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("The Adjustment Bureau ")]), _vm._v("is a smart and good movie that could have been a great one if it had been a little more daring. I suspect the filmmakers were reluctant to follow its implications too far. What David and Elise signify by their adventures, I think, is that we’re all in this together, and we’re all on our own. If you follow that through, the implications are treacherous to some, not all, religions. In the short term, however, the movie is a sorta heartwarming entertainment. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a21"
    }
  }, [_vm._v("The Adventures of Tintin "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v(", 107 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Jamie Bell (Tintin), Andy Serkis (Captain Archibald Haddock), Daniel Craig (Ivan Ivanovitch Sakharine), Nick Frost (Thomson), Simon Pegg (Thompson), Toby Jones (Silk), Mackenzie Crook (Tom), Daniel Mays (Allan), Gad Elmaleh (Ben Salaad), Joe Starr (Barnaby). Directed by Steven Spielberg and produced by Spielberg, Peter Jackson, and Kathleen Kennedy. Screenplay by Steven Moffat, Edgar Wright, and Joe Cornish, based on the comic book series "), _c('em', [_vm._v("The Adventures of Tintin ")]), _vm._v("by Herge. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("In gearing up to make "), _c('em', [_vm._v("The Adventures of Tintin")]), _vm._v(", I suspect Steven Spielberg reached down into that place inside that fueled "), _c('em', [_vm._v("Raiders of the Lost Ark. ")]), _vm._v("Here again is an intrepid hero involved in a nonstop series of exploits involving exotic locations, grandiose villains, planes, trains, automobiles, motorcycles, helicopters, and ships at sea. It evokes Saturday afternoon serials in an age when most of the audience will never have seen one. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I was surprised by how much I enjoyed myself. Spielberg not only uses 3-D but bases his story on one of Europe’s most beloved comic characters. The 3-D, he pulls off, just as Scorsese did in "), _c('em', [_vm._v("Hugo")]), _vm._v(", because he employs it as an enhancement to 2-D instead of an attention-grabbing gimmick. The beloved character . . . can we ﬂash back? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("It is a morning in May at the Cannes Film Festival, and I am drinking my coffee in the sunlight and reading "), _c('em', [_vm._v("Nice-Matin")]), _vm._v(", the regional paper. A back page in full color is given over to comics, and half the page is devoted to Tintin. I ask a French friend about him. “You don’t know Tintin?” She is amazed. “"), _c('em', [_vm._v("Zut!")]), _vm._v("” So loved is he, I learn, that papers rerun his old exploits even after the death of his creator, Herge. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("This Tintin (voiced by Jamie Bell in the film) is a piece of work. He is a newspaperman who rarely seems to go to the office but can usually be found globe-trotting on an unimaginable expense account, always accompanied by his gifted dog, Snowy. Two maladroit Interpol inspectors named Thompson and Thomson (Nick Frost and Simon Pegg) are often on the same cases. A rum-soaked old sea salt named Captain Haddock (Andy Serkis) is often found nearby. Tintin looks like a prepubescent to me, but is treated by everyone as sort of an honorary grown-up. His yellow hair comes up to a quiff in the front. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Tintin’s adventures come in book length, their pages the size of old "), _c('em', [_vm._v("Life ")]), _vm._v("magazines. They are drawn by the Belgian artist Herge with elegant clarity (the “clean line” approach). Sometimes a situation will require an entire page. Starting that year at Cannes I read every single Tintin book, and even bought a Tintin and Snowy T-shirt. My little French-English dictionary was a great help. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("It was reported that Spielberg would use motion-capture technology on his characters. This seemed wrong, wrong, wrong. Not only did Tintin inhabit an adamantly 2-D universe, but he was manifestly not real. Anyone could draw him; his face has two dots for eyes, little curves for eyebrows and a mouth, and a nose that is like a sideways U"), _c('em', [_vm._v(". ")]), _vm._v("To make him seem more real would be to lose Tintin. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("My worries became irrelevant during the movie’s opening scene. It was going to be all right. Tintin looked human, if extremely streamlined. His face, as described by an eyewitness to a police artist, would produce a sketch of . . . Tintin. The other characters are permitted more detail; Thomson and Thompson in particular are given noses that would make W. C. Fields weep with envy. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Spielberg and a team of artists and animators have copied not the literal look of the Tintin strips, but the feel. A more traditional 2-D approach was done for a TV series, which you can check out on YouTube; I like it, but Spielberg is more ambitious and his characters seem more believable, to the extent that anyone created by Herge is real. The movie involves the same headlong hurtle through perilous adventures, with dire endangerment by explosives and so on. The chase is on to find a lost treasure with ancient connections to Captain Haddock’s family. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("There’s one change I didn’t appreciate. Spielberg too closely imitates a traditional action movie. There’s gunfire in Herge, but the amount that goes on here is distracting. Herge devoted more time to local color, character eccentricities, and explosive dialogue, and I learned to mystify my friends with such Haddockisms as “"), _c('em', [_vm._v("Tonnerre de Brest!")]), _vm._v("” and “"), _c('em', [_vm._v("Mille sabords!")]), _vm._v("” (“"), _c('em', [_vm._v("Thunder of Brest!")]), _vm._v("” and “"), _c('em', [_vm._v("A thousand portholes!")]), _vm._v("”). ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("One of the benefits of animation is what it allows Spielberg to do with Snowy. The little dog has always been dubious about his master’s daring schemes; Tintin will propose an expedition and Snowy will think in a thought balloon, “Not by foot, I hope!” Some of the funniest moments in the movie involve Snowy’s determination to convey urgent information to dunderheaded humans. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("The Adventures of Tintin ")]), _vm._v("is an ambitious and lively caper, miles smarter than your average 3-D family film (how can any thinking person want to see one Chipmunks movie, let alone two or now even three?). Spielberg’s film plays fair with the plucky young reporter; the director received Herge’s blessing before his death in 1983. I give it 875 portholes. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a22"
    }
  }, [_vm._v("After.Life "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½ ")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 97 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Liam Neeson (Eliot Deacon), Christina Ricci (Anna Taylor), Justin Long (Paul Conran), Chandler Canterbury (Jack), Josh Charles (Tom Peterson), Celia Weston (Beatrice Taylor). Directed by Agnieszka Wojtowicz-Vosloo and produced by Brad Michael Gilbert, Bill Perkins, and Celine Rattray. Screenplay by Wojtowicz-Vosloo, Paul Vosloo, and Jakub Korolczuk. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("“You people!” says Eliot Deacon sadly, and with a touch of frustration. He is referring to the dead. They are whiners. They’re not ready to die, they’ve got unfinished business, there are things they still desire, the death certificate is mistaken, and on and on and on. Deacon, as a mortician, has to put up with this. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Take Anna as an example. She drove away from a disastrous dinner with her boyfriend, was speeding on a rainy night, and was killed in a crash. Now here she is on a porcelain slab in his prep room, telling him there’s been some mistake. Deacon tries to reason with her. He even shows her the coroner’s signature on the death certificate. But no. She’s alive, as he can clearly see. Besides, if he’s so sure she’s dead, why does he carefully lock the door from the outside whenever he leaves the room? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("After.Life")]), _vm._v(" is a strange movie that never clearly declares whether Anna (Christina Ricci) is dead or alive. Well, not alive in the traditional sense, but alive in a sort of middle state between life and death. Her body is presumably dead. She has no pulse, and we assume her blood has been replaced by embalming ﬂuid. Yet she protests, argues, can sit up and move around. Is Deacon (Liam Nee-son) the only one who can see this? Maybe he’s fantasizing? No, the little boy Jack (Chandler Canterbury) sees her, too, through a window. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Jack tells her boyfriend, Paul (Justin Long). He believes it. He’s had a great deal of difficulty accepting her death. He still has the engagement ring he planned to offer her on that fateful night. He tries to break into the funeral home. He causes a scene at the police station. He sounds like a madman to them. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("After.Life ")]), _vm._v("is a horror film involving the familiar theme of being alive when the world thinks you’re dead. It couples that with a possibility that has chilled me ever since the day when, at far too young an age, I pulled down Poe from my dad’s bookshelf, looked at the table of contents, and turned straight to “The Premature Burial.” From Anna’s point of view, she’s still alive when the earth starts thudding on the coffin. From Deacon’s point of view? Yes, I think from his POV, too. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("From ours? The director, Agnieszka Wojtowicz-Vosloo, says audiences split about half and half. That’s how I split. Half of me seizes on evidence that she’s still alive, and the other half notices how the film diabolically undercuts all that evidence. I think the correct solution is: Anna is a character in a horror film that leaves her state deliberately ambiguous. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Neeson’s performance as Deacon is ambiguous but sincere. He has been working with these people for years. He explains he has the “gift” of speaking with them. And little Jack, the eyewitness? Oh, but Deacon thinks he has the gift, too. So once again, you don’t know what to believe. Perhaps the gift is supernatural, or perhaps it’s madness or a delusion. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The film has many of the classic scenes of horror movies set in mortuaries. The chilling stainless steel paraphernalia. The work late at night. The moonlit graveyard. The burial. The opened grave. Even her desperate nails shredding the lining inside the coffin—although we see that from Anna’s POV and no one else’s. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I think, in a way, the film shortchanges itself by not coming down on one side or the other. As it stands, it’s a framework for horror situations, but cannot be anything deeper. Yes, we can debate it endlessly—but pointlessly, because there is no solution. We can enjoy the suspense of the opening scenes and some of the drama. The performances are in keeping with the material. But toward the end, when we realize that the entire reality of the film is problematical, there is a certain impatience. It’s as if our chain is being yanked. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a23"
    }
  }, [_vm._v("Agora "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NO MPAA RATING")]), _vm._v(", 141 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Rachel Weisz (Hypatia), Max Minghella (Davus), Oscar Isaac (Orestes), Ashraf Barhom (Ammonius), Michael Lonsdale (Theon), Rupert Evans (Synesius), Homayoun Ershadi (Aspasius), Sammy Samir (Cyril), Richard Durden (Olympius), Omar Mostafa (Isidorus), Oshri Cohen (Medorus). Directed by Alejandro Amenabar and produced by Alvaro Augustin and Fernando Bovaira. Screenplay by Amenabar and Mateo Gil. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("I went to see "), _c('em', [_vm._v("Agora ")]), _vm._v("expecting an epic with swords, sandals, and sex. I found swords and sandals, some unexpected opinions about sex, and a great deal more. This is a movie about ideas, a drama based on the ancient war between science and superstition. At its center is a woman who in the fourth century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.D.")]), _vm._v(" was a scientist, mathematician, philosopher, astronomer, and teacher, respected in Egypt although women were not expected to be any of those things. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Hypatia (Rachel Weisz) was born into the family business. Her father, Theon (Michael Lonsdale), was the curator of the Library of Alexandria, which had as its mission “collecting all the world’s knowledge.” Scholars traveled there from across the ancient world, doing research and donating manuscripts. It was destroyed by Christians in "), _c('span', {
    staticClass: "small"
  }, [_vm._v("391 A.D.")]), _vm._v(", and "), _c('em', [_vm._v("Agora ")]), _vm._v("takes place in the years surrounding that incalculable loss. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The film’s title refers to the name for the public assembly places in ancient Greek city-states. The library was such an agora, and we see Hypatia teaching a class of young men, who listen to her with open admiration. There’s an early indication that this won’t be a routine "), _c('em', [_vm._v("Troy")]), _vm._v("-like exercise in CGI action scenes: Hypatia actually "), _c('em', [_vm._v("does ")]), _vm._v("teach something, using the first scale model of planetary motion to deduce, centuries before Galileo, that the earth cannot be the center of the universe. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Hypatia has three students completely under her spell: Davus (Max Minghella), Synesius (Rupert Evans), and Orestes (Oscar Isaac). All make the error of feeling lust, Orestes least subtly. Hypatia seems devoid of sexual feeling; perhaps she believes her vocation prohibits it. Her method of rejecting Orestes is brutally direct. Although Rachel Weisz may be beautiful, in the performance she makes no effort to exploit that, and is single-minded in her dedication to knowledge. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The director, Alejandro Amenabar, re-creates the Alexandria of Hypatia’s time with a mixture of sets and effects, showing it at the tipping point between Greek and Roman paganism and the new religion of Christianity. As she studies with and under her father, drawing from countless parchment scrolls in the library, outside in the city the Christians burn with a fearful intensity. Hypatia herself is not interested in religion; she feels passion only for her ideas. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Neither pagans nor Christians are pacifists. Both sides possess that peculiar certainty that their opponents must by definition be evil. Blood is shed. Foolishly believing they hold the upper hand, the pagans led by Orestes sponsor a bloodletting, only to learn in a savage lesson that there are now more Christians than they imagined. This warfare culminates in the destruction of the library. Hypatia races with her students to rescue armloads of scrolls, a few of which may literally have been responsible for our surviving texts from Aristotle and other Greeks. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("In sword-and-sandal epics, the Christians are without fail the good guys. Not here. Christians and pagans are equally blinded by the conviction that those who disagree deserve death. After the rise of the Christians, they grow even more militant; one group wears black robes and searches the streets for dissenters, heretics, and Jews. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("There is historical truth here. The actual teachings of Jesus are often imperfectly observed by his followers. The film also has unmistakable parallels to militant Islam and to the sectarian conﬂicts in the Middle East and elsewhere. The movie doesn’t make as much as you might expect about Hypatia’s gender; possibly the subjugation of women was so unconsciously and universally accepted that, in some sense, she was seen less as a woman than as a daughter teaching the lessons of her father. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("That Hypatia was a genius seems beyond question. Her invention, the hydrometer, is being used in the Gulf of Mexico at this moment to distinguish oil from water by their specific densities. Although "), _c('em', [_vm._v("Agora ")]), _vm._v("avoids the temptation to sneak in a romantic subplot, it gets mileage out of her character as a focus of emotional intrigue for her male students, who would have never seen a woman anything like her. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Alejandro Amenabar seems drawn to stories about the determination of the intellect to work in the real world. His "), _c('em', [_vm._v("The Sea Inside ")]), _vm._v("(2004) starred Javier Bardem as a paralyzed man who fought for the right to die. In "), _c('em', [_vm._v("Open Your Eyes ")]), _vm._v("(1997), a disfigured man struggles to express his love for a woman. The underrated "), _c('em', [_vm._v("The Others ")]), _vm._v("(2001) starred Nicole Kidman as a woman compelled to prove her ideas of ghosts have objective reality. Here a woman finds the earth circles the sun, but moves in indifference to her ideas. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a24"
    }
  }, [_vm._v("Ajami "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NO MPAA RATING")]), _vm._v(", 120 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Shahir Kabaha (Omar), Ibrahim Frege (Malek), Fouad Habash (Nasri), Youssef Sahwani (Abu Elias), Ranin Karim (Hadir), Eran Naim (Dando), Scandar Copti (Binj). Directed by Scandar Copti and Yaron Shani and produced by Moshe Danon, Thanassis Karathanos, and Talia Kleinhendler. Screenplay by Copti and Shani. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Americans didn’t know we had the right idea, but we did. We welcomed those from foreign lands (or, in some cases, forced them to come here). Then we shook them up together and left them to sort things out. We have every race, ethnicity, and religion, and that helps. Unhappy are those who live in a land with only a few. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Consider Israel, where Jews, Arabs, Muslims, and Christians by and large think it is extremely important that they are Jews, Arabs, Muslims, and Christians. There is a growing minority that says, hey, here we all are together, and since nobody is budging, let’s get along. Most people apparently think someone should budge and it’s not them. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Ajami ")]), _vm._v("is the latest and one of the most harrowing films set along the religious divides in Israel. It was cowritten and codirected by an Israeli and a Palestinian, and set in Jaffa, technically a part of Tel-Aviv, which has high crime and unemployment rates. The focus is on mean streets that Scorsese might understand. Gangsters, cops, and drug dealers are tossed in with religious conﬂicts and the ancient Romeo and Juliet dilemma. God help anyone who marries outside their tribe. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I have never seen a film from either Israeli or Palestinian filmmakers that makes a case for anything other than coexistence. There are probably such films. But the dominant theme is the tragedy of the social divides, the waste, the loss, the violence that often claims innocent victims. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Why, in an area where tension and indeed hatred runs so high, aren’t there more partisan or sectarian films? Beginning with the advantage of ignorance, I’ll speculate that those Palestinians and Israelis who are inclined to make feature films are drawn from the elites of their societies. They see more widely and clearly. They may be better educated. They are more instinctively liberal. They’ve grown beyond the group mentality. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Ah, but there is still family. No matter how advanced your views, blood ties run deep, especially when reinforced by religion. A young couple may fall in love outside their tribe, but their fathers and uncles and cousins to remote degrees will feel threatened by their love, and God will be invoked on both sides. It is the same when a relative is murdered. Instincts demand revenge. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Ajami ")]), _vm._v("is about an interlocking series of such situations, starting in the first place when a man is shot dead. Then another man is mistakenly killed in revenge. Was he mistaken for the original killer? No, he was mistaken for a member of the original killer’s family—which he was, although not the correct member. Now two people are dead, more vengeance is required, nothing has been proven, and everyone involved is convinced they are in the right. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Calm heads try to prevail and stop the killing. The actual original killer (are you following?) is levied with a fine. To pay it, he finds he must sell drugs. That means we are now headed into gang territory. The source of the drugs is a Palestinian in love with a Jewish girl. An Israeli cop becomes involved in the case. I won’t describe more. I’m not sure I can. It’s clear enough in the film who is who, but I suspect even the characters lose track of the actual origins of their vendetta. What happens is that hatred continues to claim lives in a sort of domino effect. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The film doesn’t reduce itself to a series of Mafia-style killings, in which death is a way of doing business. There are situations in which characters kill as a means of self-defense. And the filmmakers, Scandar Copti and Yaron Shani, by and large show characters on all sides who essentially would like simply to be left alone to get on with their lives. Few of them possess the "), _c('em', [_vm._v("personal ")]), _vm._v("hatred necessary to fuel murder. But the sectarian divide acts as an artery to carry murder to everyone downstream. Was that a mixed metaphor, or what? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The specifics of the plot in "), _c('em', [_vm._v("Ajami ")]), _vm._v("aren’t as important as the impact of many sad moments built up one after another. Hatred is like the weather. You don’t agree with the rain but still you get wet. What justifies this isthe“honor” of your family, your religion, your tribe. The film deplores this. So do we all, when we stand back. The film has no solution. Nor is there one, until people find the strength to place more value upon an individual than upon his group. Sometimes I fear we’re all genetically programmed not to do that. One solution is the mixing of gene pools so that groups are differently perceived. I’m not holding my breath. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a25"
    }
  }, [_vm._v("Albert Nobbs "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 113 m., 2012 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Glenn Close (Albert Nobbs), Mia Wasikowska (Helen), Aaron Johnson (Joe), Janet McTeer (Hubert Page), Pauline Collins (Mrs. Baker), Brenda Fricker (Polly), Jonathan Rhys Meyers (Viscount Yarrell), Brendan Gleeson (Dr. Holloran), Bronagh Gallagher (Cathleen). Directed by Rodrigo Garcia and produced by Close, Bonnie Curtis, Julie Lynn, and Alan Moloney. Screenplay by Close, John Banville, and Gabriella Prekop, from a novella by George Moore. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("I know a novel that begins: “This is the saddest story I’ve ever heard.” Now here is one of the saddest movies I have ever seen. It is sad because a woman has chosen to lead her life in a way that is fearful and unnatural to her, and she must live every moment in dread. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("As you must know by now, Albert Nobbs is not a man. She works as a butler and waiter in a nineteenth-century Dublin hotel, where she dresses and passes as a man because a woman would not be hired for the job, and she needs the economic security. We can sympathize. But the pain she lives in isn’t worth the money. Many people pass as members of the other sex for many reasons, but my impression is that for most of them it answers a genuine emotional need. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Albert Nobbs isn’t happy being a man. I don’t believe she’s ever happy at all. There is something stiff and genderless about her, and we suspect she has no sexual experience and desires none. Her entire life is narrowly focused on economic security, and she lives in terror of being exposed. Regard her body language: shy, repressed, reclusive, trying to fade in and become invisible. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The hotel is a Dublin crossroads for people of some means but no great distinction. It’s run by the ebullient Mrs. Baker (Pauline Collins), who sails a jolly ship but as an employer is no paragon. Employees come and go, and although Albert is considered by everyone an odd fellow, she’s still there. Homosexuality is not unknown in this establishment; Viscount Yarrell (Jonathan Rhys Meyers) checks in with a free-drinking crew and specifies an adjoining room for his friend. But Albert Nobbs isn’t a homosexual of any description; life would be simpler if she were. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("One day, Hubert Page (Janet McTeer) arrives to do some house painting. Hubert is tall, lanky, smokes a lot, kids around, and is obviously (to our eyes) a woman. She gets by on personality and nerve. She quickly reads Albert, and in what must be the most astonishing moment of Albert’s life to date, exposes her breasts and shares her secret. I wonder if that was the first time Albert realized she wasn’t the only person who has ever passed for another sex. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("That opens the film’s only scenes that give us some reason to hope for Albert. The two women spend a liberating day on the beach, and Hubert takes Albert home to her wife, Cathleen (played by Bronagh Gallagher with quiet calm and tact). It becomes clear, if it wasn’t already, that Albert has only a sketchy idea of what men and women do with one another, what sex is, what marriage is. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("But she has a dream. She has her eye on a storefront that she believes would make a nice little tobacco shop. There would be a room in the back where tea would be served. And a room upstairs to, well, to share with a “wife.” In an exercise of dismaying naïveté, she imagines Helen (Mia Wasikowska), a young housemaid at the hotel, in this role. For Albert, it involves a business partnership, not a romance. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("This is such a brave performance by Glenn Close, who in making Albert so real makes the character as pathetic and unlikable as she must have been in life. The film is based on a story by George Moore (1852–1933), an Irish realist writer who may have known some real-life parallels in Dublin. Close starred in an off-Broadway production of a play based on it in 1982, and tried ever after to make it a film. The Hungarian director Istvan Szabo was attached to it circa 2001, but now the film has been made with Rodrigo Garcia, whose sure touch with women characters can be seen in his "), _c('em', [_vm._v("Nine Lives ")]), _vm._v("and "), _c('em', [_vm._v("Mother and Child. ")])]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Close never steps wrong, never breaks reality. My heart went out to Albert Nobbs, the depth of whose fears are unimaginable. But it is Janet McTeer who brings the film such happiness and life as it has, because the tragedy of the life of Albert Nobbs is that there can be no happiness in it. The conditions she has chosen make it impossible. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a26"
    }
  }, [_vm._v("Alice in Wonderland "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v(", 108 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Johnny Depp (Mad Hatter), Mia Wasikowska (Alice), Anne Hathaway (Mirana, the White Queen), Helena Bonham Carter (Iracebeth, the Red Queen), Crispin Glover (Stayne, the Knave of Hearts), Matt Lucas (Tweedledee/Tweedledum). And the voices of: Stephen Fry (Cheshire Cat), Michael Sheen (White Rabbit), Alan Rickman (Absolem), Timothy Spall (Bayard), Barbara Windsor (Dormouse), Christopher Lee (Jabberwocky). Directed by Tim Burton and produced by Burton, Joe Roth, Jennifer Todd, Suzanne Todd, and Richard D. Zanuck. Screenplay by Linda Woolverton, based on the books "), _c('em', [_vm._v("Alice’s Adventures in Wonderland and Through the Looking-Glass")]), _vm._v(" by Lewis Carroll. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("As a young reader, I found "), _c('em', [_vm._v("Alice in Wonderland ")]), _vm._v("creepy and rather distasteful. Alice’s adventures played like a series of encounters with characters whose purpose was to tease, puzzle, and torment her. Few children would want to go to Wonderland, and none would want to stay. The problem may be that I encountered the book too young and was put off by the alarming John Tenniel illustrations. Why did Alice have such deep, dark eye sockets? Why couldn’t Wonderland be cozy like the world of Pooh? Watching the 1951 film, I feared the Cheshire Cat was about to tell me something I didn’t want to know. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Tim Burton’s new 3-D version of "), _c('em', [_vm._v("Alice in Wonderland ")]), _vm._v("answers my childish questions. This has never been a children’s story. There’s even a little sadism embedded in Carroll’s fantasy. I think of uncles who tickle their nieces until they scream. "), _c('em', [_vm._v("Alice ")]), _vm._v("plays better as an adult hallucination, which is how Burton rather brilliantly interprets it until a pointless third act ﬂies off the rails. It was a wise idea by Burton and his screenwriter, Linda Woolverton, to devise a reason why Alice (Mia Wasikowska) is now a grown girl in her late teens, revisiting a Wonderland that remains much the same, as fantasy worlds must always do. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Burton is above all a brilliant visual artist, and his film is a pleasure to regard; I look forward to admiring it in 2-D, where it will look brighter and more colorful. No artist who can create these images is enhancing them in any way by adding the annoying third dimension. But never mind that. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("He brings to Carroll’s characters an appearance as distinctive and original as Tenniel’s classic illustrations. These are not retreads of familiar cartoon images. They’re grotesques, as they should be, from the hydrocephalic forehead of the Red Queen (Helena Bonham Carter) to Tweedledee and Tweedledum (Matt Lucas), who seem to have been stepped on. Wonderland itself is not limited to necessary props, such as a tree limb for the Cheshire Cat and a hookah for the caterpillar, but extends indefinitely as an alarming undergrowth beneath a lowering sky. Why you can see the sky from beneath the Earth is not a fair question. (The landscape was designed by Robert Stromberg of "), _c('em', [_vm._v("Avatar.")]), _vm._v(") ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("When we meet her again, Alice has decidedly mixed feelings about her original trip down the rabbit hole, but begins to recall Wonderland more favorably as she’s threatened with an arranged marriage with Hamish Ascot (Leo Bill), a conceited snot-nose twit. At the moment of truth in the wedding ceremony, she impulsively scampers away to follow another rabbit down another rabbit hole, and finds below that she is actually remembered from her previous visit. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Burton shows us Wonderland as a perturbing place where the inhabitants exist for little apparent reason other than to be peculiar and obnoxious. Do they reproduce? Most species seem to have only one member, as if Nature quit while she was ahead. The ringleader is the Mad Hatter, played by Johnny Depp, that rare actor who can treat the most bizarre characters with perfect gravity. Whomever he plays (Edward Scissorhands, Sweeney Todd, Jack Sparrow, Willy Wonka, Ichabod Crane), he is that character through and through. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("This is a Wonderland that holds perils for Alice, played by Mia Wasikowska with beauty and pluck. The Red Queen wishes her ill and the White Queen (Anne Hathaway) wishes her well, perhaps because both are formed according to the rules of Wonderland queens. To be sure, the insecure White Queen doesn’t exhaust herself in making Alice welcome. The Queens, the Mad Hatter, Alice, the Knave of Hearts (Crispin Glover), and presumably Tweedledee and Tweedledum are versions of humans; the others are animated, voiced with great zest by such as Stephen Fry (Cheshire), Alan Rickman (Absolem the Caterpillar), Michael Sheen (White Rabbit), and Timothy Spall, Barbara Windsor, and Christopher Lee. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The film is enchanting in its mordant way until, unfortunately, it arrives at its third act. Here I must apologize to faithful readers for repeating myself. Time after time I complain when a film develops an intriguing story and then dissolves it in routine and boring action. We’ve "), _c('em', [_vm._v("seen ")]), _vm._v("every conceivable battle sequence, every duel, all carnage, countless showdowns, and all-too-long fights to the finish. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Why does "), _c('em', [_vm._v("Alice in Wonderland ")]), _vm._v("have to end with an action sequence? Characters not rich enough? Story run out? Little minds, jazzed by sugar from the candy counter, might get too worked up without it? Or is it that executives, not trusting their artists and timid in the face of real stories, demand an action climax as insurance? Insurance of what? That the story will have a beginning and a middle but nothing so tedious as an ending? ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a27"
    }
  }, [_vm._v("All Good Things "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 101 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Ryan Gosling (David Marks), Kirsten Dunst (Katie Marks), Frank Langella (Sanford Marks), Lily Rabe (Deborah Lehrman), Philip Baker Hall (Malvern Bump), Michael Esper (Daniel Marks), Diane Venora (Janice Rizzo). Directed by Andrew Jarecki and produced by Jarecki, Michael London, Bruna Papandrea, and Marc Smerling. Screenplay by Smerling and Marcus Hinchey. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_c('em', [_vm._v("All Good Things")]), _vm._v(" is based on one of those true stories like Dominick Dunne used to tell so intriguingly in "), _c('em', [_vm._v("Vanity Fair")]), _vm._v(". Let me begin with a brief summary, based on the film because I know nothing about the reality. It involves David Marks, the son of a New York family that owned valuable Forty-second Street real estate in the 1970s. The property at that time was rented to strip clubs, porno shops, massage parlors, and so on. The family, wealthy and private, moved in the best circles, and the nature of its holdings was not widely known. The patriarch, Sanford Marks (Frank Langella), is a commanding man who is hands-on. He often collects the rent in cash. He expects his son to enter the family business. David (Ryan Gosling) wants nothing to do with it. A free spirit of the Woodstock era, he meets Katie (Kirsten Dunst), and together they escape from New York and open a twee Vermont health foods and organic products store named, yes, All Good Things. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Sanford ratchets up the pressure. David caves in and returns to Manhattan, where his wife enjoys a luxurious but unhappy existence. She eventually discovers the nature of the family business. David, meanwhile, begins to change from the loving hippie she fell in love with. Their marriage comes apart. Katie disappears. She is never found again. David is suspected of being involved but never charged, because he appears to have an unquestionable alibi. And I will not reveal more. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The film is the work of Andrew Jarecki, who in 2003 made the remarkable Sundance-winning documentary "), _c('em', [_vm._v("Capturing the Friedmans")]), _vm._v(", about a family and its secrets; the father and one son were charged with child molestation. It’s easy to see why this story appealed to him. The key to the film is in the character of David. One can imagine a scenario in which an overbearing father drives the son to rebellion, but what happens here is more complex and sinister. David seemingly adapts to the lifestyle forced upon him. He plays a role like his father played among Manhattan power brokers and establishment members. He and Katie live in an expensive condo, attend charity events, and so on. Perhaps it is self-hatred that drives him to insist they have an abortion. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Kirsten Dunst is so good here as a woman at a loss to understand who her husband really is and what the true nature of his family involves. The man she married and trusted has undergone the transformation of a Mr. Hyde. What happens is the sort of thing that develops only in fantastical horror stories, but this story apparently did happen in one form or another, and the most incredible details of David’s transformation are specifically based on facts revealed during two murder investigations. I choose not to reveal how or where David meets the wonderfully named Malvern Bump (Philip Baker Hall). ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The nature of their relationship goes along with where they meet—the place both their lives have bottomed. Hall is one of those actors who seem to have inhabited their characters for years. He needs no explanation because he "), _c('em', [_vm._v("exists")]), _vm._v(". Jarecki offers a possible solution for the enigma of Katie’s disappearance and David’s alibi. It involves his enigmatic friendship with Janice Rizzo (Diane Venora), and that’s enough about that. This film reminded me of Barbet Schroeder’s "), _c('em', [_vm._v("Reversal of ")]), _vm._v("Fortun"), _c('em', [_vm._v("e ")]), _vm._v("(1990), based on the Dominick Dunne-able Klaus von Bulow case. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("In both stories, there is every reason to focus on the obvious suspect, except the impossibility of explaining how he could have committed the crime—indeed, if there even "), _c('em', [_vm._v("was ")]), _vm._v("a crime. I don’t understand David Marks after seeing this film, and I don’t know if Andrew Jarecki does. It occurs to me that on my first visits to New York of course I was drawn to Forty-second Street, the port of entry for many a young man from the provinces, and I might have even laid eyes on Sanford or David Marks. Little would I have known. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a28"
    }
  }, [_vm._v("Amador "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NO MPAA RATING")]), _vm._v(", 112 m., 2012 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Magaly Solier (Marcela), Celso Bugallo (Amador), Pietro Sibille (Nelson), Sonia Almarcha (Yolanda), Fanny de Castro (Puri). Directed by Fernando Leon de Aranoa and produced by Aranoa and Juame Roures. Screenplay by Aranoa. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Here is a lovely idea for a film, sidetracked by a central performance that is too maddeningly passive. "), _c('em', [_vm._v("Amador ")]), _vm._v("introduces us to Marcela, a Bolivian woman now living in Madrid with Nelson, a man who runs an ingenious business: He hires scavengers to swarm down on a garbage dump and pick up discarded ﬂowers that still look halfway presentable. They wash them, store them in a refrigerator, spray them with ﬂowery scent, wrap them in paper, and send their team out to peddle them on the street and in cafés. I have a feeling I may have purchased a few roses with that lineage from the ﬂower girls in Cannes. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Their refrigerator breaks down. There is a crisis in making the payments on a replacement, and Marcela (Magaly Solier) takes a job as a daytime companion for Amador (Celso Bugallo), an old man who rarely leaves his bed and passes his days assembling big jigsaw puzzles. He loves scenes of sea and sky because the whites and blues blend together and make them trickier. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Marcela is a warm, soulful woman who is unhappy with her life. When Nelson talked her into moving with him to Madrid, he painted a future where they’d have their own ﬂower shop. Now she hardly has a home; the business is run out of their apartment, and when Nelson mounts letters on the refrigerator door saying “Marcela’s Flowers,” somehow that doesn’t seem what he promised. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Amador is quiet and pleasant, suspecting his time has about run out. Marcela met Yolanda (Sonia Almarcha), his daughter, when she and her husband hired Marcela, but they have never visited. Marcela cooks Amador’s meals, helps him sit on the pot, and makes desultory conversation. Much of the film involves close-ups of her face, thoughtful and pensive, as she ponders her life. Too much of the film. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("It is not Magaly Solier’s fault that her character seems so passive. We see a personality in the film, but not enough of it. Her long days pass as she discusses romance, mermaids, and her own life with Amador, who notices immediately that she’s pregnant. That’s something she hasn’t told Nelson, and, of course, he hasn’t noticed. Amador observes that the world has too many people: “But don’t worry. I’m on my way out, to make a space for him.” ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Once a week, on Thursdays, Amador receives a visit from Puri (Fanny de Castro), a plumpish middle-aged prostitute who has been visiting him for years. She’s a wise, friendly woman, and helps Marcela pass the time. The peace is also interrupted by a nosy neighbor who keeps trying to push his way in. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("It wouldn’t be fair to describe more of what happens. We’ve been rather expecting it, and the way the writer-director, Fernando Leon de Aranoa, handles it is effective and holds a series of surprises. Simply on the story level, this could have been a better film. But his pacing is off. Time and again, we get languid close-ups of Marcela as the cogs turn in her mind and she arrives belatedly at fairly obvious conclusions. It might have been possible to produce a much better film just by tighter editing. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The symbolism, mostly involving ﬂowers (which we prize for their beauty even when they’re dead), is pretty obvious. So also the sea and sky, and speculation about mermaids. A late disclosure from the unloving daughter Yolanda provides an ending that is heartless, ironic, and “happy,” all at the same time. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a30"
    }
  }, [_vm._v("The Amazing Spider-Man "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v("-13, 136 m., 2012 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Andrew Garfield (Spider-Man/Peter Parker), Emma Stone (Gwen Stacy), Rhys Ifans (Lizard/Dr. Curt Connors), Denis Leary (Captain Stacy), Campbell Scott (Richard Parker), Irrfan Khan (Dr. Ratha), Martin Sheen (Uncle Ben), Sally Field (Aunt May). Directed by Marc Webb and produced by Avi Arad, Matthew Tolmach, and Laura Ziskin. Screenplay by James Vanderbilt, Alvin Sargent, and Steve Kloves, based on the comic book by Stan Lee and Steve Ditko. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("We live in a speeded-up age, which may explain why the Spider-Man franchise feels the need for a reboot only ten years after its first picture, and five years after the most recent one. In its broad strokes, "), _c('em', [_vm._v("The Amazing Spider-Man ")]), _vm._v("is a remake of Sam Raimi’s "), _c('em', [_vm._v("Spider-Man ")]), _vm._v("(2002), but it’s not the broad strokes we care about. This is a more thoughtful film, and its action scenes are easier to follow in space and time. If we didn’t really need to be told Spidey’s origin story again, at least it’s done with more detail and provides better reasons for why Peter Parker throws himself into his superhero role. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Parker is played by Andrew Garfield ("), _c('em', [_vm._v("Never Let Me Go")]), _vm._v("), who at twenty-eight looks too old to be in high school, but then movie teenagers usually do. His key quality is likability, which he shares with his predecessor Tobey Maguire. As his classmate and girlfriend, Emma Stone ("), _c('em', [_vm._v("The Help")]), _vm._v(") plays a well-grounded girl who needs some persuasion to bond with Peter. That’s partly because Garfield’s take on Spidey is sometimes a few strands short of a web. He’s not above show-off stunts in high school, and takes chances with his newfound superpowers. This is the first Spider-Man who can leap off a skyscraper and make us wonder if he has a plan in mind. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The origin story takes at least an hour to tell, and I enjoyed that, because it seems to me that CGI superhero films often go on autopilot during their big action climaxes. We learn how Peter lost his parents and came into the care of Aunt May (Sally Field) and Uncle Ben (Martin Sheen). Finding his dad’s old-fashioned briefcase in the attic, he comes across brilliant scientific work about cross-species interbreeding, and that leads him to the Manhattan skyscraper of Oscorp, your typical comic book mega-corporation with a madman at the top. The screwball scientist is his dad’s old partner Dr. Curt Connors (Rhys Ifans). He has lost his right arm and obsesses about regenerating it by injecting himself with the genes of lizards, which can replace lost limbs (almost instantly, it appears). ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Connors overdoses himself on lizard juice and expands into the hyper-violent Lizard, who goes on rampages and knocks cars off bridges with its tail. Meanwhile, of course, the cops blame a midtown trail of destruction on Spider-Man, and wouldn’t you know that Gwen’s father is police captain Stacy (Denis Leary). This sets up various close calls and reconciliations, and the movie’s single best action scene, when Spidey rescues a young boy from a burning car dangling from a bridge. The kid is able to assist in his own rescue after putting on Spidey’s face mask; I doubt the mask has magical powers, but simply provides a psychological boost. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("That may also help explain why Peter/Spi-der-Man spends so much time not wearing the mask. That, and the fact that Andrew Garfield is very good-looking and the mask reminds me of Hellboy wearing a screen door. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The best of all the "), _c('em', [_vm._v("Spider-Man ")]), _vm._v("movies remains Raimi’s "), _c('em', [_vm._v("Spider-Man II ")]), _vm._v("(2004), with the best of the series villains, Doc Ock. This one is probably the second best. The Lizard is not especially inspired, and seems limited to the dramatic range of a Godzilla. Luckily, the climactic battle atop the Oscorp Tower is intercut with parallel action involving the plucky Gwen, who risks her life in an attempt to immunize all New Yorkers from becoming lizards. Director Marc Webb is aware that effective CGI action must be slow enough to be comprehensible, and although the Lizard sometimes thrashes about in a rage, Spidey’s action makes sense. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("A technological footnote. Peter/Spidey depends on cell phones, which save the day when Spidey urges Gwen to—quick!—find the blue serum! Peter Parker is still a photographer (and still using rolls of film), but although we see a front page proving the "), _c('em', [_vm._v("Daily ")]), _vm._v("Bugl"), _c('em', [_vm._v("e ")]), _vm._v("is still being published, Peter doesn’t seem to freelance for it anymore; no doubt he’s been downsized. The credit cookies promise a sequel, and I suppose by the time they make it, Peter will have switched over to making videos for YouTube. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a31"
    }
  }, [_vm._v("The American "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 105 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("George Clooney (Jack/Edward), Violante Placido (Clara), Thekla Reuten (Mathilde), Paolo Bonacelli (Father Benedetto), Johan Leysen (Pavel). Directed by Anton Corbijn and produced by Clooney, Anne Carey, Jill Green, Grant Heslov, and Ann Wingate. Screenplay by Rowan Joffe, based on the novel "), _c('em', [_vm._v("A Very Private Gentleman ")]), _vm._v("by Martin Booth. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_c('em', [_vm._v("The American ")]), _vm._v("allows George Clooney to play a man as starkly defined as a samurai. His fatal ﬂaw, as it must be for any samurai, is love. Other than that, the American is perfect: sealed, impervious, and expert, with a focus so narrow it is defined only by his skills and his master. Here is a gripping film with the focus of a Japanese drama, an impenetrable character to equal Alain Delon’s in "), _c('em', [_vm._v("Le Samourai, ")]), _vm._v("by Jean-Pierre Melville. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Clooney plays a character named Jack, or perhaps Edward. He is one of those people who can assemble mechanical parts by feel and instinct, so inborn is his skill. His job is creating specialized weapons for specialized murders. He works for Pavel (Johan Leysen, who looks like Scott Glenn left to dry in the sun). Actually, we might say he “serves” Pavel, because he accepts his commands without question, giving him a samurai’s loyalty. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Pavel assigns him a job. It involves meeting a woman named Mathilde (Thekla Reuten) in Italy. They meet in a public place, where she carries a paper folded under her arm—the classic tell in spy movies. Their conversation begins with one word: “Range?” It involves only the specifications of the desired weapon. No discussion of purpose, cost, anything. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("He thinks to find a room in a small Italian hilltop village, but it doesn’t feel right. He finds another. We know from the film’s shocking opening scene that people want to kill him. In the second village, he meets the ﬂeshy local priest, Father Benedetto (Paolo Bonacelli). Through him he meets the local mechanic, walks into his shop, and finds all the parts he needs to build a custom silencer. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("In the village he also finds a whore, Clara (Violante Placido), who works in a bordello we are surprised to find such a village can support. Jack or Edward lives alone, does push-ups, drinks coffee in cafés, assembles the weapon. And so on. His telephone conversations with Pavel are terse. He finds people beginning to follow him and trying to kill him. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The entire drama of this film rests on two words, “Mr. Butterﬂy.” We must be vigilant to realize that once, and only once, they are spoken by the wrong person. They cause the entire film and all of its relationships to rotate. I felt exaltation at this detail. It is so rare to see a film this carefully crafted, this patiently assembled like a weapon, that when the word comes it strikes like a clap of thunder. A lesser film would have underscored it with a shock chord, punctuated it with a sudden zoom, or cut to a shocked close-up. "), _c('em', [_vm._v("The American ")]), _vm._v("is too cool to do that. Too Zen, if you will. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The director is a Dutchman named Anton Corbijn, known to me for "), _c('em', [_vm._v("Control ")]), _vm._v("(2007), the story of Ian Curtis, lead singer of Joy Division, a suicide at twenty-three. Corbijn has otherwise made mostly music videos (and is a famous photographer of the bands U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("2")]), _vm._v(" and Depeche Mode). Here he paints an idyllic Italian countryside as lyrical as his dialogue is taciturn. There is not a wrong shot. Every performance is tightly controlled. Clooney is in complete command of his effect. He sometimes seems to be chewing a very small piece of gum, or perhaps his tongue. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("His weakness is love. Clara, the prostitute, should not be trusted. We sense he uses prostitutes because he made a mistake in the relationship that opens the film. In his business, he cannot trust anybody. But perhaps Clara is different. Do not assume from what I’ve written that she isn’t different. It is very possible. The film ends like a clockwork mechanism arriving at its final, clarifying tick. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a32"
    }
  }, [_vm._v("American Reunion "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 112 m., 2012 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Jason Biggs (Jim Levenstein), Alyson Hannigan (Michelle), Chris Klein (Oz), Thomas Ian Nicholas (Kevin), Tara Reid (Vicky), Seann William Scott (Steve Stifler), Mena Suvari (Heather), Eddie Kaye Thomas (Finch), Jennifer Coolidge (Stifler’s Mom), Eugene Levy (Jim’s Dad). Directed by Jon Hurwitz and Hayden Schlossberg and produced by Chris Moore, Craig Perry, Chris Weitz, and Warren Zide. Screenplay by Hurwitz and Schlossberg, based on characters created by Adam Herz. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Has Stiﬂer’s mom spent the last thirteen years upstairs in her room, reclining on her chaise lounge, occasionally touching up her pink lipstick and waiting for one of her son’s young friends to wander into her lair? I’m growing concerned for America’s most iconic mother. When she made her first appearance in the "), _c('em', [_vm._v("American Pie ")]), _vm._v("movies, she landed like a blond bombshell. This time, when her son throws a party downstairs and she "), _c('em', [_vm._v("still ")]), _vm._v("looks and behaves exactly the same, we get a sense of tragedy. I fear she has been sitting up there year after year, plumping up her cleavage and sexily brushing a lock of hair back from her eyes. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Stiﬂer’s mom (Jennifer Coolidge) and Stiﬂer himself (Seann William Scott) seem to be trapped by a warp in time. The other members of the old high school gang, now in their early thirties, have moved on in one way or another. So much have they matured, indeed, that when three of the guys plan to get together a few days early in the old hometown for a head start on the class reunion, they don’t even let Stiﬂer know their plans. They still like the Stifmeister, but they keenly recall the trouble he got them into in their previous meetings. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("American Pie")]), _vm._v(" (1999), "), _c('em', [_vm._v("American Pie 2")]), _vm._v(" (2001), and "), _c('em', [_vm._v("American Wedding")]), _vm._v(" (2003) have made the cast so familiar that this movie actually feels sort of like our reunion with them. We get an update. Chris Ostreicher (Chris Klein) has become a sports expert at an ESPN-like channel. Jim and Michelle Levenstein (Jason Biggs and Alyson Hannigan) are still married, and have a baby boy as consolation for the fact that their sex life has ground to a halt. Finch (Eddie Kaye Thomas) has apparently morphed into an adventurer who scales mountains and roars through exotic nightclubs. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("And another familiar face is back: Jim’s dad (Eugene Levy), who you may recall was all too willing to provide his son tips on masturbation and other topics Jim recoiled from. In a film that seems to have been constructed by typing in cross-references to the earlier films, this one breaks new ground in a way by dealing fearlessly with the famous Levy eyebrows; when a girl offers to thin them a little for a makeover, he gets defensive (“They’re sort of a trademark”), but she is able to pluck enough hairs to stuff a pillow while making little visible difference. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The charm of "), _c('em', [_vm._v("American Pie ")]), _vm._v("was the relative youth and naïveté of the characters. It was all happening for the first time, and they had the single-minded obsession with sex typical of many teenagers. "), _c('em', [_vm._v("American Reunion ")]), _vm._v("has a sense of déjà vu, but it still delivers a lot of nice laughs. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Most of them, for me, came thanks to Stiﬂer. Seann William Scott, who has a respectable career otherwise, has made the role of Stiﬂer his own, and seems able to morph his face into an entirely different person: narrowed eyes, broad maniacal grin, frightening focus, still with all the zeal for seduction and adventure he had in high school. The ingenuity with which he destroys the Jet Skis of two jerks can only be admired. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("American Pie ")]), _vm._v("became infamous for one of the ingredients in its titular pie. That recipe is reprised in the dialogue this time, too. In fact, "), _c('em', [_vm._v("American Reunion ")]), _vm._v("seems to depend so much on nostalgia that I wonder if a first-timer to the series would feel a little out to sea. If you liked the earlier films, I suppose you gotta see this one. Otherwise, I dunno. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a33"
    }
  }, [_vm._v("America the Beautiful 2: The Thin Commandments "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½ ")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NO MPAA RATING")]), _vm._v(", 104 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("A documentary featuring Deepak Chopra, Evelyn Tribole, Howard Shapiro, Linda Bacon, Kathleen Sebelius, Timothy Dolan, Paul Campos, Jon Robinson, Beverly Johnson, Carolyn Costin, Christian Lander, and David Satcher. Directed by Daryl Roberts and produced by Harley Decease, Jeff Scheftel, and Eddie Williams III. Screenplay by Roberts. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("If you’re trying to lose weight, this movie will probably not help you. But it reﬂects the stories of a lot of our lives. "), _c('em', [_vm._v("America the Beautiful 2: The Thin Commandments ")]), _vm._v("follows its director, Daryl Roberts, as he peers at his scale reading (272 pounds) and gets the bad news from his doctor about his blood pressure. Then he meets a variety of weight-loss advisers, who recommend raw foods, purging, and more charming cures. He also works his way through a list of famous diet programs that he tried, and reports that they all worked for him—until he put the lost weight back on, plus a little more. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Oh, did I know how that felt. I eventually lost a good chunk of one hundred pounds through the Pritikin Program, but that meant starting over again several times because all these programs have a catch: You actually have to work them. I’m no expert, but I will share a winning formula: regular exercise and a diet heavy on whole foods, especially vegetables, fruits, and grains. And cut down on the fat. And way down on the salt. Not a lot of meat. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I’m now in the unique situation of never again having to worry about my weight because after my medical adventures I can’t eat, drink, taste, or smell. I get all of my nutrition via G-tube out of a can, supplemented by fresh juices. You know the theory that some people just “naturally” put on weight? It’s recommended that I have six cans of liquid nutrition a day. At that level, I gain weight. Go figure. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("What does this have to do with Daryl Roberts and his film? Not very much, but I like talking about my food and diets, and Roberts likes talking about his. At one point in the film, he looks quite a bit slimmer, but he makes no big claims. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Roberts is a tall man with a reliable tummy. He is friendly, confiding, and very likable, and I think he would make a good talk show host, the kind people would confide in. Here he talks to a beautiful dancer who never thinks she’s thin enough, authorities who insist on rigid obedience to their theories, and Secretary of Health and Human Services Kathleen Sebelius, who has a Rick Perry moment when she’s stuck for an answer to this excellent question: Does our emphasis on BMI numbers in childhood lead to eating disorders in maturity? Roberts thinks so. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("BMI, or body mass index, is your body weight divided by the square of your height. Who came up with that? A Belgian named Adolphe Quetelet, between 1830 and 1850. How meaningful is it? Not very, if among those who have "), _c('em', [_vm._v("bad ")]), _vm._v("BMIs are Tom Cruise, George W. Bush, and Arnold Schwarzenegger in his prime. Yet schools measure it and inform parents, and some kids get traumatized. Schools might more profitably emphasize realistic exercise programs—not expensive, challenging sports but, you know, stuff like walking. The only exercise program that ever consistently worked for me was the ten thousand steps a day program. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("This film is a sequel to Roberts’s original "), _c('em', [_vm._v("America the Beautiful")]), _vm._v(", which largely centered on a beautiful young model who endangered her life with bulimia. The second film is all over the map, lacking much of a focus and without a concrete list of recommendations. Still, it contains a great deal of information and is much more entertaining than a film about weight loss has any right to be. And here’s another thing: Daryl Roberts has an infectious charm. He may not get much of anywhere specific, but it’s a pleasure going along on his journey. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a34"
    }
  }, [_vm._v("Anonymous "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v("-13, 130 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Rhys Ifans (Edward de Vere, Earl of Oxford), Vanessa Redgrave (Queen Elizabeth I), Joely Richardson (Young Queen Elizabeth I), David Thewlis (William Cecil), Xavier Samuel (Earl of Southampton), Sebastian Armesto (Ben Jonson), Rafe Spall (William Shakespeare), Edward Hogg (Robert Cecil), Jamie Campbell Bower (Young Earl of Oxford), Sam Reid (Earl of Essex). Directed by Roland Emmerich and produced by Emmerich, Larry J. Franco, and Robert Leger. Screenplay by John Orloff. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Very few commoners of his time are as well documented as William Shakespeare. There seems little good reason to doubt he wrote the plays performed under his name. If he had been an ordinary playwright, there would be no controversy over their authorship. But he was the greatest of all writers in English, in some ways the engine for its spread around the world, and one of the supreme artists of the human race. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("There have long been those not contented with his breeding. He was the son of an illiterate provincial glover, an itinerant actor in a disreputable profession with no connections with royalty. Surely such an ordinary man could not have written the masterpieces. There is a restlessness to reassign them, and over the years theories have grown up claiming the real author of the plays was the Earl of Oxford, Sir Francis Bacon, the sixth Earl of Derby, or Christopher Marlowe. "), _c('em', [_vm._v("Anonymous ")]), _vm._v("argues the case for Edward de Vere, the seventeenth Earl of Oxford. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("You perhaps know little enough about Shakespeare and next to nothing about the other candidates. That’s no reason to avoid this marvelous historical film, which I believe to be profoundly mistaken. Because of the ingenious screenplay by John Orloff, precise direction by Roland Emmerich, and the casting of memorable British actors, you can walk into the theater as a blank slate, follow and enjoy the story, and leave convinced—if of nothing else—that Shakespeare was a figure of compelling interest. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("This movie cruelly stacks the deck against him. The character of Shakespeare himself (Rafe Spall) is drawn a notch or two above the village idiot. Witless and graceless, there is no whiff of brilliance about him, and indeed the wonder is not that this man could have written the plays, but that he could articulate clearly enough to even act in some of them (about which there seems to be no doubt). ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Edward de Vere, the Earl of Oxford (Rhys Ifans), on the other hand, seems the very template of genius. His manner, his bearing, his authority, his ease in the court of Elizabeth all conspire to make him a qualified candidate. He was so well connected with the crown, in fact, that the movie speculates he may have been the lover of the young Elizabeth (Joely Richardson) or the son of the older Elizabeth (Vanessa Redgrave). Not both, I pray ye. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The film also plunges us into the rich intrigue of the first Elizabethan age, including the activities of the Earl of Essex (Sam Reid), whose plot to overthrow the queen led to the inconvenience of beheading. Incredibly, for a film shot mostly on German soundstages, "), _c('em', [_vm._v("Anonymous ")]), _vm._v("richly evokes the London of its time, when the splendor of the court lived in a metropolis of appalling poverty and the streets were ankle-deep in mud. It creates a realistic, convincing Globe theater, which establishes how intimate it really was. The groundlings could almost reach out and touch the players, and in the box seats such as Oxford himself could witness the power of his work, which was credited to the nonentity Shakespeare. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("All of that makes "), _c('em', [_vm._v("Anonymous ")]), _vm._v("a splendid experience: the dialogue, the acting, the depiction of London, the lust, jealousy, and intrigue. But I must tiresomely insist that Edward de Vere did not write Shakespeare’s plays. Apparently, Roland Emmerich sincerely believes he did. Well, when he directed "), _c('em', [_vm._v("2012")]), _vm._v(", Emmerich thought there might be something to the Mayan calendar. The Shakespeare scholar James Shapiro has cited a few technicalities in the "), _c('em', [_vm._v("New York Times")]), _vm._v(": (a) de Vere writes and stars in "), _c('em', [_vm._v("A Midsummer Night’s Dream ")]), _vm._v("when he was nine years old, and (b) "), _c('em', [_vm._v("he died in 1604, before ten or so of Shakespeare’s plays were written. ")])]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I have a personal theory. The most detailed and valuable record of life in London at that time is the diary of Samuel Pepys, who attended plays in court and in town, and as secretary of the navy was an inveterate gossip, well wired for information. He wrote his diary in a cipher, not intending it to be read. If he had knowledge of the true authorship of the plays, I don’t believe he could have suppressed it. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a35"
    }
  }, [_vm._v("Another Earth "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v("-13, 92 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Brit Marling (Rhoda Williams), William Mapother (John Burroughs). Directed by Mike Cahill and produced by Cahill, Hunter Gray, Brit Marling, and Nicholas Shumaker. Screenplay by Cahill and Marling. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_c('em', [_vm._v("Another Earth")]), _vm._v(" is a film animated by one stunning image: A new planet four times the size of the moon appears in the sky of Earth. This startling apparition gives a deeper meaning to everything in the story, especially when it is discovered that the planet is indeed, as the title promises, another Earth. Perhaps not a second Earth, however, but the very same Earth, in another universe that has now become visible. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("That would explain the curious lack of physical effects on two planets so close together. In some sense the two Earths don’t share the same physical reality. In another sense, Earth 2 is right up there in the sky—so close that a corporation sponsors an essay contest and the winner gets to be the first person to visit it. I confess the essay contest was harder for me to believe than the second Earth itself. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("But this intriguing film isn’t concerned with plausibility. It has deeper questions to explore. It involves a bright young woman named Rhoda Williams (Brit Marling), who in the opening scene has been accepted into the astrophysics program at MIT. To celebrate, she parties too hearty, and when she’s driving home she hears the news about Earth 2. Peering out her car window to search the sky, she crashes into another car, killing a mother and child and sending the father into a coma. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("A few years pass. She’s released from prison and learns that the father, a composer named John Burroughs (William Mapother), has emerged from his coma. Rhoda is emotionally devastated by the deaths she caused and wants to apologize or make amends or . . . what? She doesn’t know. She presents herself at the shabby rural house where Burroughs lives as a depressed recluse and makes up a story about doing housecleaning. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Now we have a situation not unfamiliar in the movies, where two people slowly grow close while only one of them is aware of their deep connection. The strength of "), _c('em', [_vm._v("Another Earth ")]), _vm._v("is that it employs that story to a larger purpose; this is no less than a meditation on the infinite variations possible in a human life. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("If she had not had too many beers. If she had been listening to a different radio station. If he had not been on the road in the wrong place at the wrong time. The fatal crash was the sum of an infinite series of "), _c('em', [_vm._v("ifs")]), _vm._v(", tracing back to if life had never evolved on Earth in the first place. In our lives we surf the wave of chance. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("What’s impressive is how well this film joins its parts into a whole. The other Earth idea is left as a fantastical hook and wisely not considered scientifically, except of course in its role as the film’s master image. The relationship between Rhoda and John is seen as fraught with danger. The actors occupy their characters convincingly. They make us care more than the plot really requires. Earth 2, always looming in the sky, encourages us to reﬂect on how arbitrary our destinies are. In one sense, nothing in our lives is necessary. In another sense, everything is inevitable. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("There’s a nice story behind this movie, involving the actress and cowriter Brit Marling. She worked in investment banking on Wall Street before becoming the writer and codirector of "), _c('em', [_vm._v("Boxers and Ballerinas")]), _vm._v(", a Cuban documentary that Mike Cahill made in 2004. They worked together on this film. It arrived unheralded at Sundance 2011 and won the Alfred P. Sloan Feature Film Prize, also taking the Special Jury Prize. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("It was made on a low budget, and Cahill shot and edited it himself. I think it would have benefited from more tripod work and less hand-held; a more classical approach would have suited this thoughtful material. But it’s strong as it is, and Marling emerges as a gifted new talent. The movie is as thought-provoking, in a less profound way, as Tarkovsky’s "), _c('em', [_vm._v("Solaris")]), _vm._v(", another film about a sort of parallel Earth. In this one, when a scientist makes a call to Earth 2 and discovers she is speaking with herself, what do you suppose that can mean? ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a36"
    }
  }, [_vm._v("Another Year "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v("-13, 129 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Jim Broadbent (Tom), Ruth Sheen (Gerri), Lesley Manville (Mary), Oliver Maltman (Joe), Peter Wight (Ken), David Bradley (Ronnie), Karina Fernandez (Katie). Directed by Mike Leigh and produced by Georgina Lowe. Screenplay by Leigh. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Not quite every year brings a new Mike Leigh film, but the years that do are blessed with his sympathy and penetrating observation, and with his instinct for human comedy. By that I don’t mean “comedy” as in easy laughter. I mean that comedy that wells up from movies allowing us to recognize ourselves in characters both lovable and wretched. Leigh’s "), _c('em', [_vm._v("Another Year ")]), _vm._v("is like a long, purifying soak in empathy. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("He begins with Tom and Gerri, a North London couple who have been happily married for years. Immediately you can see the risks Leigh is prepared to take. A happy married couple? Two wise and lovable people? Who are intelligent and alert to the real world? Not caricatures, not comforting, not clichés, but simply two people I wish I knew? I’d look forward to them every time I visited their house, and be slow to leave. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("That’s also how Mary (Lesley Manville) feels. She has worked for years in the office of Gerri, a behavioral counselor. Many people have a friend like Mary. Many people are a friend like Mary: unmarried, not getting any younger, drinking too much, looking for the perfect spouse as a way of holding any real-world relationship at arm’s length. Mary drops in on Tom (Jim Broadbent) and Gerri (Ruth Sheen) a lot. Every time she visits, we’re reminded of Robert Frost: “Home is where, when you have to go there, they have to take you in.” ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Mary needs healing. She badly requires sobriety. She wears an invisible sign around her neck: “Needy.” Tom and Gerri don’t lecture. Sometimes they drop gentle hints. “It’s a shame,” Tom observes to Gerri after Mary has ended yet another sad visit, and that’s all he has to say. No criticisms, no anger, just a factual statement. In their own lives, they’re in complete accord. They garden, they work, they feed their friends dinners, they hope their son will find the right girl, they are in love. Remarkably, in this age, their thirty-year-old son, Joe (Oliver Maltman), loves them and is happy. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Leigh has a gift for scenes involving embarrassment in social situations. We squirm, not because the characters are uneasy, but because we would be, too. In "), _c('em', [_vm._v("Another Year")]), _vm._v(", Tom and Gerri and their son attend the funeral of Tom’s sister-in-law. We have never been to a funeral quite like it, yet it is like many funerals. The uninvolved clergyman, the efficient undertakers, the remote father, the angry son, the handful of neighbors who didn’t know the deceased all that well, the family skeletons. He sees the ways people display their anguish without meaning to. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The movie doesn’t require this scene. It has no obligatory scenes. Like life, it happens once you plug in the people. Mary lives in a very small world, where it’s unlikely she’ll find happiness. She buys a car to give her more “freedom,” but no one who drinks like she does will find freedom that way. She fantastically begins to think of the son, Joe, as a possible partner. Joe brings home Katie (Karina Fernandez) to meet his parents, and they love her. When Mary meets Katie and understands who she is, it is devastating. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("All the actors are pitch perfect. Lesley Manville is virtuoso in making Mary pathetic and yet never a caricature. Listen to the way her cadences vary with drink. Notice the way Tom and Gerri’s responses to her modulate during the course of a visit. Even, for that matter, observe Ken (Peter Wight), Tom’s friend. Ken is no prize, but might be happy to date Mary and maybe marry her; and after all, could Mary do any better? She persists in the delusion that she could. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Now we come to the matter of the chins, and here we touch on something central to the appeal of Mike Leigh. He is not afraid to star imperfect people. Jim Broadbent has a little too much chin, and Ruth Sheen not quite enough. In most movies everybody has about the right chinnage. At the risk of offending many of his many actor-collaborators, I’ll say that not once in forty years has Mike Leigh ever starred a conventionally handsome or beautiful movie-star type. Instead, he has enriched the British cinema by his use of unconventional types, also including Imelda Staunton, Sally Hawkins, Timothy Spall, Marianne Jean-Baptiste, Brenda Blethyn, and David Thewlis. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Another Year ")]), _vm._v("gave me characters I could love, feel uneasy about, identify with, or be appalled by. I see a lot of movies where the characters have no personalities, only attributes. I like James Bond, but I ask you: In what way is he human? Every single character in "), _c('em', [_vm._v("Another Year ")]), _vm._v("is human, and some of them all too human. I saw it and was enriched. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a37"
    }
  }, [_vm._v("Answers to Nothing "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 124 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Miranda Bailey (Drew), Julie Benz (Frankie), Dane Cook (Ryan), Zach Gilford (Evan), Kali Hawk (Allegra), Mark Kelly (Carter), Elizabeth Mitchell (Kate), Erik Palladino (Jerry), Vincent Ventresca (Erik), Aja Volkman (Tara), Barbara Hershey (Marilyn), Greg Germann (Beckworth). Directed by Matthew Leutwyler and produced by Amanda Marshall and Sim Sarna. Screenplay by Leutwyler and Gillian Vigman. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_c('em', [_vm._v("Answers to Nothing ")]), _vm._v("tells the story of several lives in Los Angeles that seem connected through the disappearance of a child. This is the technique of "), _c('em', [_vm._v("Crash ")]), _vm._v("and "), _c('em', [_vm._v("Magnolia")]), _vm._v(", in which we’re involved in many individual lives in addition to the central thread, and some associations surprise us. After the child’s kidnapping, the city follows developments in the case on TV, and so do we, through the eyes of Frankie (Julie Benz), a police detective who is a shade less suspicious than she should be. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("There is a suspect: Beckworth (Greg Germann), a neighbor, who is questioned and released after one of the girl’s hairs is found in his car. Among the many curious is Carter (Mark Kelly), a schoolteacher we follow home. He provides a vignette of a video game addict who essentially spends his entire weekend playing a game, while sometimes removing his headphones to follow the story on the TV news. Since the city knows about Beckworth, but only we know about Carter, are we getting a hint here? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Many other stories interlock. To explain their connections would be complicated, but let me describe them. Erik Palladino plays Jerry, a rookie cop whose own child has died. Dane Cook plays a therapist whose marriage is in trouble and who is having an affair with a musician (Aja Volkman). He spends a good deal of time forlornly trying to watch the clock and produce sperm samples for his wife, Kate (Elizabeth Mitchell). ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("We meet Allegra (Kali Hawk), the African-American writer on a sitcom, whose secret is “I hate black people.” This isn’t much of a secret because she has a pattern of confiding it to pretty much everyone she meets. Hating other black people is her biggest problem, but she seems to have a related problem: She gets a twisted pleasure out of telling that to people. Her problem is resolved, sort of, in a scene where she makes a friendly gesture to two black men she had been cool toward. This is supposed to be cheerful, part of an uplifting conclusion, but it struck me as contrived and awkward. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("One of the most poignant characters is Drew (Miranda Bailey), who cares for her brother Erik (Vincent Ventresca). He is paralyzed and apparently brain-dead. In a ﬂashback, we learn she was driving drunk when this happened to him. Late in the film she straps him into a racing chair and pushes him in the So Cal Marathon, a race he once ran able-bodied. Her determination that they must finish the race becomes a crucial theme. My problem, and I know this sounds heartless: What meaning would it have to him if they finish? For her, it may be penance, and indeed she may deserve it. But how does it work as an amends when he has no idea what’s  happening? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("How, you may ask, are Drew and Erik important to the story of the kidnapped girl? They aren’t really, although we can trace a remote plot connection. That’s a problem with this genre. The interlocking stories are theoretically about people whose lives are associated; that worked in "), _c('em', [_vm._v("Crash. ")]), _vm._v("Here the connections seem less immediate and significant, and so the movie sometimes seems based on a group of separate short stories. That was the approach that worked for Robert Altman with Raymond Carver’s stories in "), _c('em', [_vm._v("Short Cuts. ")])]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("At the end, there’s a scene that draws together three of the major characters, but this scene depends entirely on action that could fit in many movies, and works on its own terms. It’s convenient but not especially revealing about those people. So the film, while well made and acted, lacks the gathering power of the others I’ve mentioned. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a38"
    }
  }, [_vm._v("Anton Chekhov’s The Duel "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NO MPAA RATING")]), _vm._v(", 95 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Andrew Scott (Laevsky), Fiona Glascott (Nadia), Tobias Menzies (Von Koren), Niall Buggy (Samoylenko). Directed by Dover Koshashvili and produced by Mary Bing and Donald Rosenfeld. Screenplay by Bing, based on the novella by Anton Chekhov. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("What strikes you immediately about "), _c('em', [_vm._v("Anton Chekhov’s The Duel ")]), _vm._v("are the visuals. The cinematography of Paul Sarossy composes shots as soft impressionist romance, the colors tastefully softened, the elements arranged in classical symmetry. Unfortunately, this combined with the unwavering progress of the story results in much of a muchness, and we wouldn’t object to the occasional taste of vulgarity. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The film, as you have guessed, is based on a story by Chekhov. That accounts for the textbook quality of the title. I suppose it was out of the question to use "), _c('em', [_vm._v("Steven Spielberg’s The Duel—Not! ")]), _vm._v("The story involves two indolent lovers and a fierce Darwinian zoologist creating a love triangle of theory, not practice, on the beautiful coast of the Black Sea. Maybe after the rigors of the Russian winter they are all driven a little mad by the good weather. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Laevsky (Andrew Scott) is one of those civil servants of nineteenth-century Russian literature who seems high up on an insignificant ladder. He’s shacked up in this seaside resort with his married mistress, Nadia (Fiona Glascott), who has lost her appeal now freed of her husband. I’ve been reading a lot of Balzac lately, and am struck that absent husbands in European classics seem to play much like noises off. Laevsky expresses his discontents to the local physician; Chekhov often provides such learned listeners to sit gravely through anguished monologues. Dr. Samoylenko is required not for his diagnosis but for his ears. Also for his money: Laevsky is a gambler and drunk who desperately hopes for a loan. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Into this powder keg comes the zoologist Von Koren (Tobias Menzies), inﬂamed with the revolutionary principles of Darwinism that were then being embraced by the intelligentsia in all the wrong ways. Rare is the man not convinced that all evolution points like an arrow to his door. Von Koren is too refined to enter a horse of his own in the race, but he observes with scientific precision the willingness of the locals to respond to Nadia’s underemployed sexuality. All comes to a head at a party one night when the overserved Laevsky temporarily goes barking mad, and Von Koren determines he isn’t fit to survive. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The zoologist then faces one of the two choices open to him, given his rudimentary grasp of Darwin’s theory. If he wants little Von Korens to prevail over little Laevskys, he can either seduce the female or kill the man. "), _c('em', [_vm._v("Anton Chekhov’s The Duel ")]), _vm._v("is by no means shy about portraying sex in a forthright manner, and director Dover Koshashvili has gratifying taste in nudity, which has grown sadly rare as Friday night audiences lose their interest in it. But Von Koren is too much of a lardass to seduce Nadia and he knows it, so he challenges Laevsky to a duel. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("One of two men will die over this woman: Man Number One, who no longer desires her, or Man Number Two, who knows what he would do if only he were in Man Number One’s shoes. For Nadia, this must not be quite as exciting as Rhett Butler calling out Ashley Wilkes. The doctor saw it all coming, but then doctors are always seeing it all coming. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Koshashvili is a good filmmaker. His "), _c('em', [_vm._v("Late Marriage ")]), _vm._v("(2002) involved some of the more practical difficulties of an arranged marriage in Israel among immigrants from Soviet Georgia. Its characters had the advantage of caring strongly about who they did or didn’t sleep with. In "), _c('em', [_vm._v("The Duel ")]), _vm._v("and much of Chekhov, lust seems to be a matter best approached by the introspection of the world-weary. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Anton Chekhov’s The Duel ")]), _vm._v("isn’t exactly a bad film. It’s very well made and acted in English by a mostly Irish cast in a polished Chekhovian tone. But it somehow isn’t as exciting as a duel over a woman should be. If you’re not well rested before entering the theater, it could put you under. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a39"
    }
  }, [_vm._v("Araya "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NO MPAA RATING")]), _vm._v(", 90 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Featuring the Pereda, Salazar, and Ortiz families. A documentary directed by Margot Benacerraf and produced by Henry Nadler. Screenplay by Benacerraf. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("To be born here is to be born into hell. That must have happened for more than three hundred years, because no one would ever want to come to live here. "), _c('em', [_vm._v("Araya ")]), _vm._v("tells the story of life on the remote, barren Araya peninsula of Venezuela, where Spanish conquistadors found salt about 1550. Salt was treasure in Europe, to the misfortune of those whose lives were devoted to it. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("This astonishing documentary, so beautiful, so horrifying, was filmed in the late 1950s, when an old way of life had not yet ended. It was the belief of the filmmaker, Margot Benacerraf, that the motions of the salt workers became ritualized over the decades, passed down through the generations, and that here we could see the outcome of the endless repeating of arduous tasks that would destroy others. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The salt cake is taken up from the ﬂoor of a shallow marsh, loaded into ﬂat-bottomed wooden boats, broken up, carted onto land in wheelbarrows, and loaded into 120-pound baskets to be balanced on the heads of workers who trudge up the side of an ever-growing pyramid to deposit it. At the top, a man with a rake forms each mound into a towering, geometrically perfect shape. Now it is ready to be hauled away in trucks. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The workers, bronzed by the sun, all muscle and sinew, work in a blazing sun in a land where nothing grows. Food comes from the sea and from corn meal that is carted in. They live in small rude shacks. They get their water from a tank truck. Some work all day. Some work all night. Such is their life. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("And just such a phrase, "), _c('em', [_vm._v("such is their life, ")]), _vm._v("is used in the doc’s narration, which seems to hover in detachment above the sweat on the ground. I imagine Benacerraf’s purpose was to make the toilers of Araya seem heroic in a “land where nothing lives.” Where the sun is hot and pitiless so often it becomes a mantra. The effect is odd at first, but then we grow accustomed: The idea is to see these not as individuals but almost as a species evolved to take salt from the sea, build it into pyramids, watch it hauled away, and start again. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("We learn something about salt along the way. It was so prized that the Spanish built their largest overseas fortress on the peninsula to guard it. The men who died building it were the first of many who paid for salt with their lives. The working conditions of the salt workers were brutal; their feet and legs were ulcerated by the salt, and if they faltered, they had no income. Their existence is agonizing, and we feel no regret that their way of life is ending. They have been reduced to robots. Small wonder the film contains so little dialogue. Yet these people lived and died, and we had salt in our shakers. It would be too sad if they were not remembered. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("This black-and-white doc, so realistic in its photography, so formal in its words, played at Cannes in 1959 and shared the critics’ prize with Alain Resnais’s "), _c('em', [_vm._v("Hiroshima, Mon Amour. ")]), _vm._v("Benacerraf, a Venezuelan director born in 1926, it still alive and much honored. Her work was almost lost in the years since it was made. Now it has been restored to pristine beauty by Milestone Films, and is on a national tour of art venues. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a40"
    }
  }, [_vm._v("Around a Small Mountain "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NO MPAA RATING")]), _vm._v(", 85 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Jane Birkin (Kate), Sergio Castellitto (Vittorio), Andre Marcon (Alexandre), Jacques Bonnaffe (Marlo), Julie-Marie Parmentier (Clemence), Helene de Vallombreuse (Margot). Directed by Jacques Rivette and produced by Martine Marignac and Maurice Tinchant. Screenplay by Rivette, Pascal Bonitzer, Christine Laurent, and Shirel Amitay. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Sometimes a film is simply a story we might have found interesting to live. Its message may be no more than that we all have to weather hard times. To ordinary life may be added some style and artifice, allowing the filmmaker to tweak reality into a more pleasing form. Maybe that’s what Jacques Rivette has in mind with "), _c('em', [_vm._v("Around a Small Mountain. ")]), _vm._v("One of the founders of the French New Wave, Rivette is still very much active at eighty-two. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("At the center of his film is a shabby little circus, playing to sparse crowds in villages. It becomes the stage on which his two characters live, and they meet on their way to it. Kate (Jane Birkin) is driving down a road when her car stalls. Vittorio (Sergio Castellitto) happens along and fixes it for her: a Meet Cute as old as time. He doesn’t even speak. He drives on, slows, and turns back. Something about Kate has struck him. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("We learn that she is returning to the little circus after fifteen years. It was her father’s. Her lover was killed in a performance. Vittorio sizes up the situation and books the room above a local café on the spur of the moment. At the performance that has never worked, he breaks the silence by suddenly laughing. Even the clowns are startled. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("When the circus caravan leaves town, he follows. It’s not that he and Kate begin a love affair. It’s that they’ve both run off to join the circus. He apparently has nowhere to go and nothing else to do, and the same might be said of her. We learn of the buried past of the circus and the buried careers of its performers. Little one-ring circuses like this set up in town squares in rural districts. They still exist. On the Lido in Venice one night we attended one smaller than this—so small that after the show the clown came over to our granddaughter Raven and gave her a ride on his mule. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Jane Birkin has a sculpted, intelligent face that might not get her far on a U.S. soap opera, but I think she’s sexy. She’s a woman who looks like she’s up to something. She’s had quite a life. She’s sixty-four, looks nowhere near that, was actually one of the two “birds” who frolicked nude in David Hemmings’s photo studio in "), _c('em', [_vm._v("Blow-Up. ")]), _vm._v("What else? She was a famous model during the Swinging London days. Hermes named its Birkin bag after her, she once played Brigitte Bardot’s lover in a film, was once married to John Barry, was the longtime lover of Serge Gainsbourg, and is the mother of Charlotte Gainsbourg, who underwent such rigors in Lars von Trier’s "), _c('em', [_vm._v("Antichrist. ")]), _vm._v("It has been quite a life for anybody who seems so open and vulnerable. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Here she exudes the loss of her father, her lover, the circus. I doubt if she’s experienced love since her lover died. Vittorio becomes a sort of passive counselor, coaxing her to face her wounds and let go of them. Their relationship is ever so much more interesting than if Rivette had reduced it to romance. This man and woman, strangers, actually find themselves talking to each other. How often do you see that? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The movie is the shortest one Rivette has ever made. His "), _c('em', [_vm._v("La Belle Noiseuse ")]), _vm._v("(1991), also with Birkin and one of my Great Movies, runs 236 minutes, and not a second too long. This one clocks in at 85 minutes, again the right length. Some men when they grow old feel a need to be profound. Rivette embodies the New Wave in that he needs to be playful. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a41"
    }
  }, [_vm._v("Arthur "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v("-13, 110 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Russell Brand (Arthur), Helen Mirren (Hobson), Greta Gerwig (Naomi), Jennifer Garner (Susan), Geraldine James (Vivienne), Luis Guzman (Bitterman), Nick Nolte (Burt Johnson). Directed by Jason Winer and produced by Chris Bender, Russell Brand, Larry Brezner, Kevin McCormick, J. C. Spink, and Michael Tadross. Screenplay by Peter Baynham. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_c('em', [_vm._v("Arthur ")]), _vm._v("is a fairly close remake of the great 1981 Dudley Moore movie, with pleasures of its own. It shares some of the same strengths and virtues, and if it lacks Dudley Moore as Arthur and John Gielgud playing his butler, Hobson, well, it has Russell Brand and Helen Mirren playing his nanny, Hobson. That’s not a tradeoff, but it’s a good try. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The thing about Moore, whom people persisted in calling “Cuddly Dudley,” although he hated it, is that he was just plain lovable. The thing about Russell Brand is that he isn’t, not much, and he should get credit here for at least being a good deal more likable than he usually chooses to seem. He plays the alcoholic zillionaire Arthur Bach as a man who wants to party with the world and pick up the check. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Helen Mirren has the presence and authority of John Gielgud, but not the same aloof dignity. Gielgud’s Hobson was a man so reserved you sometimes wanted to knock and see if anyone answered. Then again, they’ve made Hobson into a nanny still loyal from Arthur’s childhood, so she should be expected to love him in a more tender way. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The main plot beats are roughly the same: Arthur is drunk more or less all the time, and steadfast in his irresponsibility. He inadvertently falls in love with a sweet young woman named Naomi (Greta Gerwig), just as his controlling mother, Vivienne (Geraldine James), is arranging his marriage with a very rich woman named Susan (Jennifer Garner). Susan wants him for his name; she may be rich, but she’s not welcomed into the upper crust because her daddy (Nick Nolte) worked his way up in construction. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Naomi cares little about such matters, and supports herself as an unlicensed guide, giving bootleg tours of Grand Central Terminal. She’s remarkably forgiving of Arthur’s irregularities, considering he has the self-discipline and tact of a Charlie Sheen. But then, neither "), _c('em', [_vm._v("Arthur ")]), _vm._v("deals with alcoholism as other than a colorful character trait. No one could possibly drink like Arthur and not be dead at the end of twenty-four hours. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The casting of Greta Gerwig works nicely. Did you see her as the assistant to Ben Stiller’s brother in "), _c('em', [_vm._v("Greenberg ")]), _vm._v("(2010)? The thing about her is that she is indeed cuddly. We sometimes talk about personal chemistry as something that happens in casting. It probably begins at birth. She’s a woman you instinctively feel good about, like Amy Adams in "), _c('em', [_vm._v("Junebug. ")]), _vm._v("This quality goes a long way toward filling in the psychological gaps in her relationship with Arthur. Nice people can get away with more, and take bigger chances. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Russell Brand isn’t doing a Dudley Moore imitation, but you can tell he’s studied the movie, and carefully resists any temptation to go over the top. Just as well, since the whole role resides over the top. I confess I haven’t regarded him as a particularly subtle actor, but here he has a lot of smile moments when he quickly and quietly reacts. I’ll mention an almost invisible one. In the scene in the library at the end, when the kiddies are saying rude things, note how he hushes and dismisses them without much seeming to even notice them. That’s good acting. Bad acting would be to respond directly and lose the focus of the scene, which must be on the woman he loves. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("This "), _c('em', [_vm._v("Arthur ")]), _vm._v("is not as laugh-out-loud funny as the earlier one; its scene of a dinner in a staid hotel dining room isn’t as successful, and it doesn’t have as much fun with the father of the Naomi character. But the dialogue is well written—witty and quick, and not clunky. The visuals in the Grand Central Terminal scene may be overdone, but they are impressive (when did architecture lose its faith in grandeur?). And Russell Brand takes on a thankless task and earns at least some thanks. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a42"
    }
  }, [_vm._v("The Artist "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v("-13, 100 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Jean Dujardin (George Valentin), Berenice Bejo (Peppy Miller), James Cromwell (Clifton), Penelope Ann Miller (Doris), Malcolm McDowell (The Butler), Missi Pyle (Constance), Beth Grant (Peppy’s Maid), Ed Lauter (Peppy’s Butler), John Goodman (Al Zimmer). Directed by Michel Hazanavicius and produced by Thomas Langmann and Emmanuel Montamat. Screenplay by Hazanavicius. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Is it possible to forget that "), _c('em', [_vm._v("The Artist ")]), _vm._v("is a silent film in black and white and simply focus on it as a movie? No? That’s what people seem to zero in on. They cannot imagine themselves seeing such a thing. At a sneak preview screening in Chicago, a few audience members actually walked out, saying they didn’t like silent films. I was reminded of the time a reader called me to ask about an Ingmar Bergman film. “I think it’s the best film of the year,” I said. “Oh,” she said, “that doesn’t sound like anything "), _c('em', [_vm._v("we’d ")]), _vm._v("like to see.” ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Here is one of the most entertaining films in many a moon, a film that charms because of its story, its performances, and because of the sly way it plays with being silent and black-and-white. "), _c('em', [_vm._v("The Artist ")]), _vm._v("knows you’re aware it’s silent, and kids you about it. Not that it’s entirely silent, of course; like all silent films were, it’s accompanied by music. You know—like in a regular movie when nobody’s talking? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("One of its inspirations was probably "), _c('em', [_vm._v("Singin’ in the Rain")]), _vm._v(", a classic about a silent actress whose squeaky voice didn’t work in talkies, and about the perky little unknown actress who made it big because hers did. The heroine (Debbie Reynolds) fell in love with an egomaniacal silent star—but a nice one, you know? Played by Gene Kelly in 1952 and by Jean Dujardin now, he has one of those dazzling smiles you suspect dazzles no one more than himself. Dujardin, who won best actor for this role at Cannes 2011, looks like a cross between Kelly and Sean Connery, and has such a command of comic timing and body language that he might have been—well, a silent star. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Dujardin plays George Valentin, who has a French accent that sounds just right in Hollywood silent films, if you see what I mean. The industry brushes him aside when the pictures start to speak, and he’s left alone and forlorn in a shabby apartment with only his faithful dog, Uggie, for company. At a crucial moment he’s loyally befriended by Peppy Miller (Berenice Bejo), who when they first met was a hopeful dancer and has now found great fame. The fans love her little beauty mark, which Valentin penciled in with love when she was a nobody. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("As was often the case in those days, the cast of "), _c('em', [_vm._v("The Artist ")]), _vm._v("includes actors with many different native tongues, because what difference did it make? John Goodman makes a bombastic studio head, and such familiar faces as James Cromwell, Penelope Ann Miller, Missi Pyle, and Ed Lauter turn up. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("At thirty-nine, Jean Dujardin is well-known in France. I’ve seen him in a successful series of spoofs about OSS 117, a Gallic secret agent who mixes elements of 007 and Inspector Clouseau. He would indeed have made a great silent star. His face is almost too open and expressive for sound, except comedy. As Norma Desmond, the proud silent star in "), _c('em', [_vm._v("Sunset Boulevard")]), _vm._v(", hisses: “We didn’t need dialogue. We had faces!” Dujardin’s face serves perfectly for the purposes here. More than some silent actors, he can play subtle as well as broad, and that allows him to negotiate the hazards of some unbridled melodrama at the end. I felt a great affection for him. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I’ve seen "), _c('em', [_vm._v("The Artist ")]), _vm._v("three times, and each time it was applauded, perhaps because the audience was surprised at itself for liking it so much. Silent films can weave a unique enchantment. During a good one, I fall into a reverie state, an encompassing absorption that drops me out of time. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I also love black-and-white, which some people assume they don’t like. For me, it’s more stylized and less realistic than color, more dreamlike, more concerned with essences than details. Giving a speech once, I was asked by parents what to do about their kids who wouldn’t watch black-and-white. “Do what Bergman’s father did to punish him,” I advised. “Put them in a dark closet and say you hope the mice don’t run up their legs.” ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a43"
    }
  }, [_vm._v("The Art of Getting By "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v("-13, 84 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Freddie Highmore (George Zinavoy), Emma Roberts (Sally Howe), Michael Angarano (Dustin), Elizabeth Reaser (Charlotte Howe), Rita Wilson (Vivian Sargent), Blair Underwood (Principal Martinson), Alicia Silverstone (Ms. Herman), Sam Robards (Jack Sargent), Jarlath Conroy (Harris McElroy). Directed by Gavin Wiesen and produced by Kara Baker, P. Jennifer Dana, Darren Goldberg, and Gia Walsh. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("George, the hero of "), _c('em', [_vm._v("The Art of Getting By")]), _vm._v(", is a high school senior who has decided to stop doing homework and paying any attention to tests. He isn’t tortured, depressed, addicted, or anything like that. It has occurred to him that he will die, and therefore, what use is homework? This is more sophisticated than my theory, which was that homework would kill me. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("George is played by Freddie Highmore, who only yesterday was the kid in "), _c('em', [_vm._v("August Rush. ")]), _vm._v("He could make a durable leading man because he looks good, and by that I don’t mean handsome, I mean kind and likable. He’s nice even when he explains to his parents and teachers that he doesn’t see the point in graduating from school. He’s the spiritual kin of Melville’s Bartleby the scrivener, who patiently informed people, “I would prefer not to.” ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("By not assigning a fixable reason for George’s behavior, the movie sidesteps some of the clichés of the teen problem picture. Not all of them. There’s always romance. George, for example, is attracted by Sally (Emma Roberts), a classmate who he assumes is somehow beyond his reach. In this he isn’t being defeatist but, he thinks, simply realistic. If he were a little more perceptive, he’d realize Sally likes him a whole lot. His life seems stuck on Pause. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("His passivity is both interesting and frustrating because George possesses the answers to all of his problems, and freely chooses to be unhappy. As a result, most of the tension generated by the movie is in ourselves and not in the plot. We want George to succeed, we want him together with Sally, and we even like Dustin (Michael Angarano), an older artist who likes Sally and likes George, too. Dustin is so nice he would step aside from Sally if he thought George was ever going to make a move. Not likely in romance, but there you have it. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("George’s parents (Rita Wilson and Sam Robards) are concerned, but curiously distant. The family is obviously affluent, but isn’t obsessed with George graduating or getting into a good school. He is spared counseling or diagnosis, and we later learn about their distractions. But his school is very engaged, especially his principal (Blair Underwood), his English teacher (Alicia Silverstone), and his bearded and irascible art teacher (Jarlath Conroy). They come up with a deadline that would provide more tension if it were not so clear that a film like this requires George to meet it. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("That leads to a rather sadistic scene in which George must actually attend his school graduation ceremony to find out if he’s graduating. This last-instant verdict has been brought about by the principal, who until this point in the film has been unfailingly kind and understanding. I fear the scene exists for the single purpose of concocting an ending for the screenplay. It shouldn’t be so obvious. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Another problem involves certain details of the relationship between Sally and Dustin that I don’t want to spoil for you. Let me use evasive language. With what is implied by her apparent decision, we must assume emotional decisions on her part that aren’t consistent with her eventual choices. You’ll see what I mean. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("The Art of Getting By ")]), _vm._v("is pleasant and well acted, and easy to watch. I wouldn’t advise against seeing it because it showcases Freddie Highmore and Emma Roberts (Julia’s niece), and they are likely to do greater things, but at the end I was wondering, what is the point? Nice people lead enviable lives, the hero can solve most of his own problems, and the villain is a sweetheart. It’s custard without the lemon. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a44"
    }
  }, [_vm._v("The Art of the Steal "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NO MPAA RATING")]), _vm._v(", 101 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Featuring John Anderson, Colin B. Bailey, Julian Bond, Carolyn T. Carluccio, David D’Arcy, Richard Feigen, D. Michael Fisher, Tom L. Freudenheim, Jim Gerlach, Richard H. Glanton, Nancy Herman, Walter Herman, Christopher Knight, Meryl Levitz, Bruce H. Mann, Robert Marmon, Toby Marmon, Ross Mitchell, Barry Munitz, Irvin Nahan, Marcelle Pick, David W. Rawson, Jay Raymond, Edward G. Rendell, Mark D. Schwartz, Harry Sefarbi, Richard Segal, Nick Tinari, Robert Zaller. A documentary directed by Don Argott. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Dr. Albert C. Barnes accomplished two things for which we must be grateful: He invented a treatment for VD, and he founded the Barnes Foundation in the Philadelphia suburb of Lower Merion. The first paid for the second, so the wages of sin were invested wisely. In his imposing private structure, far from the power brokers of the city, Barnes created an oasis for serious students, who could learn from his collection without rubbing elbows with crowds of art tourists. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("How important was the Barnes Collection? I learn from the press notes of "), _c('em', [_vm._v("The Art of the Steal ")]), _vm._v("that it included 181 Renoirs, 69 Cezannes, 59 Matisses, 46 Picassos, 16 Modiglianis, and 7 Van Goghs. Barnes collected these during many trips to Paris at a time when establishment museums, such as the Philadelphia Museum of Art, considered these artists beneath their attention. Some of the paintings are today literally priceless; one estimate of the worth of the collection is $25 billion. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("That was a lot of art to be sitting in Merion. Barnes knew it was. He designed every detail of his collection with personal care, grouping paintings to reﬂect and comment on one another, placing period furniture and wall ornaments near them, and filling walls with a richness of paintings close, but not too close, together. He loved his collection, and he hated the Philadelphia Main Line establishment—most particularly, the Museum of Art, which had scorned his collection in its early days. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Barnes was a rich man. He hired himself some Philadelphia lawyers and drew up an iron-clad will, endowing the foundation with funds enabling it to be maintained indefinitely where it was and how it was. It was his specific requirement that the collection not go anywhere near the Philadelphia Museum of Art. And that is exactly where it is today. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("He hated the museum. He hated its benefactors, the Annenberg family, founded by a gangster, enriched by "), _c('em', [_vm._v("TV Guide, ")]), _vm._v("chummy with the Nixon administration. The Annenbergs published the "), _c('em', [_vm._v("Philadelphia Inquirer, ")]), _vm._v("which consistently and as a matter of policy covered this story with slanted articles and editorials. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Don Argott’s "), _c('em', [_vm._v("The Art of the Steal")]), _vm._v(" is a documentary that reports the hijacking of the Barnes Collection with outrage, as the Theft of the Century. It was carried out in broad daylight by elected officials and Barnes trustees, all of whom justified it by placing the needs of the vast public above the whims of a dead millionaire. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The film explains in great detail the chain of events that began after the death of Barnes at the wheel of his own car in 1951. It involves Lincoln University, the small African-American college to which he entrusted control of the foundation, no doubt to piss off the establishment. It involves how the president of Lincoln, Richard H. Glanton, sidestepped the wishes of Barnes by taking many of the treasures on tour, bringing honor to himself for such a benefaction. But Glanton is not the final villain. As he perhaps overspent and depleted Barnes’s endowment, the vultures from Philadelphia were hovering, ready to pounce and ﬂy off with their masterpieces to their nest in the museum—yes, at the top of the same great stairs Rocky Balboa ran up in "), _c('em', [_vm._v("Rocky. ")]), _vm._v("It is not difficult to imagine them at the top, their hands in triumph above their heads. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Well, was this such a bad thing? The Renoirs and Picassos can now be seen by anyone visiting the museum, instead of by a limited number of art students. That is good, I suppose, although I’ve seen tourists jogging past the "), _c('em', [_vm._v("Mona Lisa ")]), _vm._v("in Paris just to check it off their itinerary. The film could do a better job of allowing the public access issue to be defended. But what it does is tell a cautionary tale. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("It is perfectly clear exactly what Barnes specified in his will. It was drawn up by the best legal minds. It is clear that what happened to his collection was against his wishes. It is clear that the city fathers acted in obviation of those wishes, and were upheld in a court of appeals. What is finally clear is this: It doesn’t matter a damn what your will says if you have $25 billion and politicians and the establishment want it. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a45"
    }
  }, [_vm._v("The A-Team "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v("-13, 121 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Liam Neeson (Hannibal), Jessica Biel (Charisa), Bradley Cooper (Face), Sharlto Copley (Murdock), Quinton “Rampage” Jackson (B.A.), Patrick Wilson (Lynch). Directed by Joe Carnahan and produced by Stephen J. Cannell, Jules Daly, Tony Scott, Spike Seldin, Iain Smith, and Alex Young. Screenplay by Joe Carnahan, Brian Bloom, and Skip Woods, based on the TV series by Cannell and Frank Lupo. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_c('em', [_vm._v("The A-Team ")]), _vm._v("is an incomprehensible mess with the 1980s TV show embedded inside. The characters have the same names, they play the same types, they have the same traits, and they’re easily as shallow. That was OK for a TV sitcom, which is what the show really was, but at over two hours of queasy-cam anarchy it’s punishment. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The movie uses the new style of violent action, which fragments sequences into so many bits and pieces that it’s impossible to form any sense of what’s happening, or where, or to whom. The actors appear in flash-frames, intercut with shards of CGI and accompanied by loud noises, urgent music, and many explosions. This continues for the required length, and then there’s some dialogue. Not a lot. A few words, a sentence, sometimes a statement that crosses the finish line at paragraph length. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The plot: Wrongly framed for counterfeiting, the team members, all Iraq veterans, bust out of various prisons and go after the engraving plates, which would be pretty much worn out while printing enough $100 bills to pay for the millions in property damage they cause in the process. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Bored out of my mind during this spectacle, I found my attention wandering to the subject of physics. "), _c('em', [_vm._v("The A-Team ")]), _vm._v("has an action scene that admirably demonstrates Newton’s Third Law, which instructs us that for every action there is always an equal and opposite reaction. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The movie illustrates this as the heroes fall from an exploding airplane while inside an armored tank. As the tank hurtles to the ground (cf. Newton’s Law of Gravity), the team leader, Hannibal Smith (Liam Neeson), looks out an opening and barks out commands for the tank’s gun. I am paraphrasing: “Turn forty-five degrees to the left! Fire! Twenty-five degrees to the right! Fire!” etc. In this way he is able to direct the fall of the tank and save their lives. This is very funny. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The action scenes also benefit from everyone having had a glance at the choreography beforehand. Consider a scene when a team member is confronted by a Talking Killer. This is, of course, a killer who only has to pull the trigger but pauses to sneer and boast. He and his target are standing in the middle of a jumble of dozens of freight shipping containers that have been spilled onto a dock. He talks just a little too long, and B. A. Baracus (“Rampage” Jackson) comes roaring to the rescue through the air on his motorcycle and wipes him out. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I know there are Harley lovers among my devoted readers. Am I right in assuming that it is difficult to get enough speed for a good aerial jump while biking across a crooked heap of freight containers? I ask because, as I hinted above, no action in this movie necessarily has any relationship to the actions surrounding it. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The characters here have that annoying ability to precisely predict what will happen and coordinate their response to it. An example. A slimy double-dealer is about to kill another team member, never mind who, when suddenly behind him a container is lifted into the air, and behind it are revealed all of the other team members lined up in a row, with choice words and brief phrases to say. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I don’t want to be tiresome, but (1) how did they know the two guys were behind precisely that container; (2) how did they line up a crane and hook up the container without being heard or noticed; (3) how were they able to gather the members so quickly after the chaos of the preceding action; and (4) was someone eavesdropping to give the cue at the right moment to lift the container? Ten seconds later, and it might have been too late. Ten seconds earlier, and dialogue would have been stepped on. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Are my objections ridiculous? Why? How is it interesting to watch a movie in which the “action” is essentially colorful abstractions? Isn’t it more satisfying if you know where everyone is and what they’re doing and how they’re doing it in real time? In other words, isn’t "), _c('em', [_vm._v("The Hurt Locker ")]), _vm._v("more interesting than "), _c('em', [_vm._v("The A-Team")]), _vm._v("? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("To give it credit, the movie knows it is childish. The "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v("-13 is appropriate. There’s little actual gore, no sex beyond a chaste kiss, no "), _c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v("-rated language, but—ohmigod—there’s smoking! Alert to preteens: Try one of those fat cigars Hannibal smokes and you won’t feel like dinner. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a46"
    }
  }, [_vm._v("Atlas Shrugged: Part 1 "), _c('span', {
    staticClass: "key"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v("-13, 97 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Taylor Schilling (Dagny Taggart), Grant Bowler (Henry Rearden), Matthew Marsden (James Taggart), Graham Beckel (Ellis Wyatt), Edi Gathegi (Eddie Willers), Jsu Garcia (Francisco D’Anconia), Michael Lerner (Wesley Mouch). Directed by Paul Johansson and produced by John Aglialoro and Harmon Kaslow. Screenplay by Aglialoro and Brian Patrick O’Toole, adapted from the novel by Ayn Rand. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("I feel like my arm is all warmed up and I don’t have a game to pitch. I was primed to review "), _c('em', [_vm._v("Atlas Shrugged. ")]), _vm._v("I figured it might provide a parable of Ayn Rand’s philosophy that I could discuss. For me, that philosophy reduces itself to: “I’m on board; pull up the lifeline.” There are, however, people who take Ayn Rand even more seriously than comic book fans take "), _c('em', [_vm._v("Watchmen. ")]), _vm._v("I expected to receive learned and sarcastic lectures on the pathetic failings of my review. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("And now I am faced with this movie, the most anticlimactic nonevent since Geraldo Rivera broke into Al Capone’s vault. I suspect only someone very familiar with Rand’s 1957 novel could understand the film at all, and I doubt they will be happy with it. For the rest of us, it involves a series of business meetings in luxurious retro leather-and-brass boardrooms and offices, and restaurants and bedrooms that look borrowed from a hotel no doubt known as the Robber Baron Arms. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("During these meetings, everybody drinks. More wine is poured and sipped in this film than at a convention of oenophiles. There are conversations in the English language after which I sometimes found myself asking, “What did they just say?” The dialogue seems to have been ripped throbbing with passion from the pages of "), _c('em', [_vm._v("Investor’s Business Daily. ")]), _vm._v("Much of the excitement centers on the tensile strength of steel. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The story involves Dagny Taggart (Taylor Schilling), a young woman who controls a railroad company named Taggart Transcontinental (its motto: “Ocean to Ocean”). She is a fearless and visionary entrepreneur, who is determined to use a revolutionary new steel to repair her train tracks. Vast forces seem to conspire against her. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("It’s a few years in the future. America has become a state in which mediocrity is the goal and high-achieving individuals the enemy. Laws have been passed prohibiting companies from owning other companies. Dagny’s new steel, which is produced by her sometimes lover Hank Rearden (Grant Bowler), has been legislated against because it’s better than other steels. The Union of Railroad Engineers has decided it will not operate Dagny’s trains. Just to show you how bad things have become, a government minister announces “a tax will be applied to the state of Colorado in order to equalize our national economy.” So you see how governments and unions are the enemy of visionary entrepreneurs. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("But you’re thinking, railroads? Yes, although airplanes exist in this future, trains are where it’s at. When I was six, my Aunt Martha brought me to Chicago to attend the great Railroad Fair of 1948, at which the nation’s rail companies celebrated the wonders that were on the way. They didn’t quite foresee mass air transportation. "), _c('em', [_vm._v("Atlas Shrugged ")]), _vm._v("seems to buy into the fair’s glowing vision of the future of trains. Rarely, perhaps never, has television news covered the laying of new railroad track with the breathless urgency of the news channels shown in this movie. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("So OK. Let’s say you know the novel, you agree with Ayn Rand, you’re an objectivist or a libertarian, and you’ve been waiting eagerly for this movie. Man, are you going to get a letdown. It’s not enough that a movie agree with you, in however an incoherent and murky fashion. It would help if it were, like, you know, entertaining? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The movie is constructed of a few kinds of scenes. (1) People sipping their drinks in clubby surroundings and exchanging dialogue that sounds like assorted corporate lingo; (2) railroads, and lots of ’em; (3) limousines driving through cities in ruin and arriving in front of vast, ornate buildings; (4) city skylines; (5) the beauties of Colorado. There is also a love scene, which is shown not merely from the waist up but from the ears up. The man keeps his shirt on. This may be disappointing for libertarians, who I believe enjoy rumpy-pumpy as much as anyone. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Oh, and there is Wisconsin. Dagny and Hank ride blissfully in Taggart’s new high-speed train, and then Hank suggests they take a trip to Wisconsin, where the state’s policies caused the suppression of an engine that runs on the ozone in the air, or something (the film’s detailed explanation won’t clear this up). They decide to drive there. That’s when you’ll enjoy the beautiful landscape photography of the deserts of Wisconsin. My free advice to the filmmakers: If you want to use a desert, why not just refer to Wisconsin as “New Mexico”? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Atlas Shrugged ")]), _vm._v("closes with a title card saying, “End of Part One.” Frequently throughout the film, characters repeat the phrase, “Who is John Galt?” Well they might ask. A man in black, always shot in shadow, is apparently John Galt. If you want to get a good look at him and find out why everybody is asking, I hope you can find out in Part Two. I don’t think you can hold out for Part Three. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a47"
    }
  }, [_vm._v("Attack the Block "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 88 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("John Boyega (Moses), Alex Esmail (Pest), Leeon Jones (Jerome), Simon Howard (Biggz), Franz Drameh (Dennis), Nick Frost (Ron), Jodie Whittaker (Sam), Luke Treadaway (Brewis), Jumayn Hunter (Hi-Hatz). Directed by Joe Cornish and produced by Nira Park and James Wilson. Screenplay by Cornish. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Fireworks fill the sky over London, creating such a distraction that an alien crashes to earth unnoticed. Meanwhile, in a dark bypass, a young nurse is being mugged by a gang of teenage street thugs, their faces buried within fearsome hooded sweatshirts. Their straightforward situation grows complicated when the alien attacks them, and the nurse decides she’d be safer staying with the thieves. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("That’s the setup for "), _c('em', [_vm._v("Attack the Block")]), _vm._v(", an entertaining thriller in the tradition of 1970s B action films, with an unknown cast, energetic special effects, and great energy. That it takes place almost entirely around a low-cost London housing estate (that is, project) adds to its interest, because as the junior thugs band together to fight the aliens, they stop being faceless and emerge as sympathetic individuals who discover their resources. This alien attack may have been a learning experience dropped from the heavens. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The movie, which should have been titled "), _c('em', [_vm._v("Defend the Block")]), _vm._v(", illustrates once again that zombie, horror, and monster movies are a port of entry for new filmmakers. The genre is the star. Unknown actors are almost an advantage. Darkness and quick cutting make up for a great deal in the area of special effects. What is needed is imagination. When John Carpenter made "), _c('em', [_vm._v("Assault on Precinct 13 ")]), _vm._v("(1976), he demonstrated an invaluable formula to later low-budget generations. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("This is an impressive first feature written and directed by Joe Cornish, a British comic actor who also authored the "), _c('em', [_vm._v("Tintin ")]), _vm._v("movie by Spielberg. Here he shows a strong sense for characters as the personalities of the gang members, their neighbors, and friends emerge sharply. He’s made a fortunate discovery in John Boyega as Moses, the de facto leader of the pack and the quickest to figure out the greater dimensions of the alien invasion. Moses’s knowledge of the Block and its residents and his ability to deal with people turn out to be crucial. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Cornish creates a mixed bag. We meet the local crime lord, the Block’s drug dealer, and, revealingly, the family members of the gang. We see how the police leap to conclusions and unerringly arrest the wrong people for the wrong reasons. And Sam (Jodie Whittaker), the nurse, emerges from stereotyped victim-hood and becomes a valuable part of the defense team. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Then there are the aliens. Does it much matter what they look like? They have luminescent fangs and are very fast and are great climbers, always in savage attack mode. Their design is wise; larger and more grotesque alien monsters have a way of looking goofy, as the Japanese demonstrated in the 1950s. These creatures are as efficient and low-maintenance as werewolves. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The question arises about the level of their civilization. Presumably this alien race has mastered space travel and journeyed through the void, almost necessarily at a speed faster than light, and yet they appear to lack opposable thumbs, speech, and other conveniences. Of course they may not be the real aliens. They may merely be the aliens’ attack animals. But no, apparently not. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Such questions are beside the point. The genre calls for a mixed bag of characters to defend the fort/stagecoach/police station/pub/outpost, etc., against savage marauders, meanwhile developing their own personalities and abilities. This is a formula we’ve seen time and again, and in the right hands it’s foolproof. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The movie has been much praised in Britain, whose writers wonder if Americans will understand the jargon of the locals. For that matter, would the queen? It matters not. Context is all, and the language here is no more difficult than the coinages in "), _c('em', [_vm._v("A Clockwork Orange ")]), _vm._v("and "), _c('em', [_vm._v("The Warriors. ")]), _vm._v("The question is, do the action and the characters work well together? The answer is yes. And sometimes it gets a little funny, too. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a48"
    }
  }, [_vm._v("The Avengers "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v("-13, 142 m., 2012 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Robert Downey Jr. (Tony Stark/Iron Man), Chris Evans (Steve Rogers/Captain America), Mark Ruffalo (Bruce Banner/Hulk), Chris Hemsworth (Thor), Scarlett Johansson (Natasha Romanoff/Black Widow), Jeremy Renner (Clint Barton/Hawkeye), Tom Hiddleston (Loki), Clark Gregg (Agent Phil Coulson), Cobie Smulders (Agent Maria Hill), Stellan Skarsgard (Selvig), Samuel L. Jackson (Nick Fury), Gwyneth Paltrow (Pepper Potts). Directed by Joss Whedon and produced by Kevin Feige. Screenplay by Zak Penn and Whedon. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("One of the weapons Marvel used in its climb to comic book dominance was a willingness to invent new characters at a dizzying speed. There are so many Marvel universes, indeed, that some superheroes do not even exist in one another’s worlds, preventing gridlock. The Avengers, however, do share the same time and space continuum, although in recent years they’ve been treated in separate single-superhero movies. One assumes the idle Avengers follow the exploits of the employed ones on the news. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("The Avengers")]), _vm._v(", much awaited by Marvel Comics fans, assembles all of the Avengers in one film—Iron Man, Captain America, Thor, the Hulk, Black Widow, and Hawkeye. This is like an all-star game, or the chef’s sampling menu at a fancy restaurant. What always strikes me is how different their superpowers are. Iron Man (Robert Downey Jr.) is just an ordinary guy until he’s wearing his super-suit. Thor (Chris Hemsworth) swings a mighty hammer. Hawkeye (Jeremy Renner) wields a bow with arrows so powerful they can bring down alien spacecraft. The Hulk (Mark Ruffalo) is a mild-mannered guy until he gets angry, and then he expands into a leaping, bounding green muscleman who can rip apart pretty much anything. Captain America (Chris Evans) has a powerful and versatile shield. Then there’s Natasha Romanoff (Scarlett Johansson), aka Black Widow. After seeing the film, I discussed her with movie critics from Brazil and India, and we were unable to come up with a satisfactory explanation for her superpowers; it seems she is merely a martial artist with good aim with weapons. We decided maybe she and Hawkeye aren’t technically superheroes, but just hang out in the same crowd. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("When I see these six together, I can’t help thinking of the champions at the Westminster Kennel Club Dog Show. You have breeds that seem completely different from one another (Labradors, poodles, boxers, dalmatians), and yet they’re all champions. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The reason they’re brought together in "), _c('em', [_vm._v("The Avengers ")]), _vm._v("is that Earth is under threat by the smirking Loki (Tom Hiddleston), Thor’s adopted brother, who controls the Tesseract, a pulsing cube of energy that opens a gateway to the universe, and through it he plans to attack Earth with his ﬂeet of reptile-looking monster machines. It goes completely unexplained where Loki now lives, how these dragon machines are manufactured, and so on. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Both Loki and Thor are obscurely related to the gods of Norse mythology, as we know from last year’s "), _c('em', [_vm._v("Thor")]), _vm._v(", but let’s not drift into theology. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Nick Fury (Samuel L. Jackson) sends out a call to the Avengers to team up and meet this threat. He runs S.H.I.E.L.D., the Strategic Homeland Intervention, Enforcement, and Logistics Division, which is all I know about it. He’s headquartered on a gigantic aircraft carrier that is also a hovercraft and can become invisible. By bringing the Avengers together, he, of course, reopens ancient rivalries (for example, my hammer can beat your shield), until they learn the benefits of Teamwork, which is discussed in speeches of noble banality. So you see, this is sort of an educational film, teaching the Avengers to do what was so highly valued on my first-grade report card: Working Well with Others. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("These films are all more or less similar, and "), _c('em', [_vm._v("The Avengers ")]), _vm._v("gives us much, much more of the same. There must be a threat. The heroes must be enlisted. The villain must be dramatized. Some personality defects are probed. And then the last hour or so consists of special effects in which large mechanical objects engage in combat that results in deafening crashes and explosions and great balls of fire. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Much of this battle takes place in midtown Manhattan, where the neatest sequences involve Loki’s ginormous, slithering, undulating snake-lizard-dragon machine, which seems almost to have a mind of its own, and is backed up by countless snakelings. At one point, an Avenger ﬂies into the mouth of this leviathan and penetrates its entire length, emerging at the business end. You won’t see that in "), _c('em', [_vm._v("The Human Centipede. ")])]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("“Comic-Con nerds will have multiple orgasms,” predicts David Edelstein in "), _c('em', [_vm._v("New York ")]), _vm._v("magazine, confirming something I had vaguely suspected about them. If he is correct, it’s time for desperately needed movies to reeducate nerds in the joys of sex. "), _c('em', [_vm._v("The Avengers ")]), _vm._v("is done well by Joss Whedon, with style and energy. It provides its fans with exactly what they desire. Whether it is exactly what they deserve is arguable. ")])])])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "margin-bottom"
  }, [_vm._v("B")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a328"
    }
  }, [_vm._v("Babies "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v(", 79 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Featuring Ponijao, Bayar, Mari, and Hattie. A documentary directed by Thomas Balmes and produced by Amandine Billot, Alain Chabat, and Christine Rouxel. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_c('em', [_vm._v("Babies ")]), _vm._v("is the perfect film for anyone who has never had the opportunity to interact with humans at an early age. You may never have had one, held one, or babysat one, yet remained curious about the infants you see in a park, on the beach, or in baby carriers at the mall. Now a French documentarian has traveled to Africa, Asia, and America to bring back charming footage of babies in their natural habitats. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("If, however, you’ve raised children and/or grandchildren, or had little brothers and sisters, the movie may resemble seventy-nine minutes of unpaid babysitting. When Baby Mari starts screaming, you’re wishing you could turn on the TV and use something bright and noisy as a distraction. But no, you’re at a movie. On the other hand, "), _c('em', [_vm._v("Babies ")]), _vm._v("may be fascinating viewing for babies, just as many dogs and cats have their favorite programs. At last, programming for the Mommy & Me screenings. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The babies are cute. Well, all babies are cute. That’s just as well, because how could filmmakers audition a baby and wait six months to give it a callback? It’s not a baby anymore. The director, Thomas Balmes, has found exemplary babies in Namibia, Mongolia, Tokyo, and San Francisco, and observes them lovingly as they nurse, play, doze, poke kittens, and happily hit one another. The movie is really about the babies, not their parents, and in most cases we see only those parts of the parents ranking highest on the infant’s interest scale: nipples, hands, arms, and male and female chests. Not all of the nipples are real, but the babies don’t discriminate as long as they work. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Two of the babies come from poor parts of the world, and two from rich. They seem equally happy and healthy. The Japanese and American babies are subjected to an awesome array of baby training strategies so they can begin climbing the success ladder as early as possible. I have no argument against baby yoga classes, but I have never known a baby that wasn’t naturally able to contort itself into alarming positions and get lost in meditation on the spur of the moment. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The African baby, Ponijao, lives in a forest hut with an earth ﬂoor, but this is Home and here is Mother and there are sticks to play with that may not be made of plastic and ornamented with Disney creatures but are excellent sticks nonetheless, and satisfying. Bayar, whose family lives in a yurt in Mongolia, passes time by becoming expert in sibling rivalry. Mari, from Japan, and Hattie, from America, are surrounded by a baffling array of devices to entertain them, serve them, shelter them, protect them, and help them grow up big and strong. Can the epidemic of attention deficit disorder be explained by the First World’s lack of opportunities for babies to be bored? How can babies concentrate when things are forever being jingled and dangled at them? Is there too much incoming? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I dunno. What I do know is that babies are miraculous. From a sprawling, bawling start, they learn to walk, talk, plan, scheme, play, and figure stuff out. Generations of scientists have hurled themselves at the question of exactly how babies learn to talk. They must be getting so frustrated by the fact that the babies just go ahead and do it with no training. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Did I like the movie? Aw, yeah, I did. How could I not? Did I feel I needed to see it? Not really. I appreciated the fact that there was no narrator to explain what I was seeing; no voice-overs like “little Bayar learns early to appreciate the mystery of yogurt.” No parents asking, “Are you a good little boy?” and answering, “Yes, he’s good little boy.” Just babies. Wonderful. I was once in that state myself. I remember being ﬂat on my stomach with my eyes an inch away from ants all crawling in a line on the front sidewalk. I’ve never been so entertained in my life. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a329"
    }
  }, [_vm._v("The Back-up Plan "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v("-13, 104 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Jennifer Lopez (Zoe), Alex O’Loughlin (Stan). Directed by Alan Poul and produced by Todd ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Black, Jason Blumenthal, and Steve Tisch. Screenplay by Kate Angelo. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Some movies are no better than secondrate sitcoms. Other movies are no better than thirdrate sitcoms. "), _c('em', [_vm._v("The Back-up Plan ")]), _vm._v("doesn’t deserve comparison with sitcoms. It plays like an unendurable TV commercial about beautiful people with great lifestyles and not a thought in their empty little heads. So timid is this film that when it finally arrives at its inevitable childbirth scene, it bails out after two “pushes”! ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Jennifer Lopez has never looked better. That’s about all she does here, is look better. She is talented and deserves more than this birdbrained plot about characters who have no relationship to life as it is lived by, you know, actual people. The movie deals with artificial insemination, romance, sex, and organic goat cheese, which are promising areas for investigation, but it’s so watered down it approaches homeopathy. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Lopez plays Zoe, a Manhattan pet shop owner who despairs of finding the perfect inseminator and decides to become artificially impregnated. Leaving the doctor’s office, she is so happy she finds herself singin’ in the rain. Then she hails a cab and a strange man pops into the backseat the same moment she does. As a Meet Cute, this ranks right down there with two characters bending over to pick up the same thing and bumping heads, which is what Tony Randall is always doing whenever I think of Meet Cutes. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("This stranger is Stan (Alex O’Loughlin). We know, according to the Law of Conservation of Dramatic Resources, that (a) Zoe will become pregnant, and (b) she and Stan will fall in love. Consider the alternatives: (a1) she doesn’t become pregnant, and (b2) they never see each other again. Anyway, fate brings them together, and then again, and soon they’re falling for each other. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("This Stan is a prime catch. Not only does he personally sell organic goat cheese in a ridiculously upscale farmers’ market, but he produces it himself, on his own upstate farm. I am at a loss to explain why the movie squandered an opportunity to show Lopez milking a goat. Or having a goat eat her shoes, or whatever goats usually do in movies of this sort. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Obviously, the only way to make this feature-length is for Zoe and Stan to break up and get back together again, which they do, I think, three times. Their breakups tend toward communications difficulties, as one or the other idiotically misunderstands dialogue that is crystal clear to everyone in the audience. In Little Movie Glossary lore this is Damon Knight’s famous Idiot Plot, in which all difficulties could be resolved by the uttering of one or two words. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I don’t believe "), _c('em', [_vm._v("The Back-up Plan ")]), _vm._v("is intended to be set in the real Manhattan. Take a close look at the farmers’ market. It’s more of a Farmer’s Faire at a church benefit in a rich suburb. Farmer Stan and his goats, indeed. But consider the scene where Zoe is a bridesmaid at a wedding, and her water breaks. What does she do? Rush to the hospital? No, she commandeers the wedding’s rented white Bentley and is driven to the market, where the auto shoulders its way right down the middle of the street and halts before the organic goat cheese stall, where Zoe can leap out and make up with Stan right there in public, while onlookers all smile and listen like benevolent insiders, instead of New Yorkers wondering who the hell these jerks are. Does Stan happen to have one of those little boxes with a ring in it handy? What does a goat do in the woods? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I have neglected poor little Nuts, Zoe’s Boston terrier. Nuts follows her everywhere, and whenever he gets a close-up, he barks appropriately, as if he understands what is said. When was the last time in a movie where somebody said something, and there was a cut to a dog who barked, and you thought, “That’s so funny!” Nuts is paralyzed from the waist down and pulls himself everywhere on his little cart, without the benefit of much loving and cooing from his mistress, who relates to him as exactly what he is, a prop. But the little tyke can really wheel around and is always there when he’s needed on camera. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("This movie is desperately boring. No one says much of anything interesting. They have extremely limited ranges of interest. There are older characters: Zoe’s Nana (Linda Lavin) and grandpa (Tom Bosley) and gynecologist (Robert Klein). They seem human, so the camera cuts away lest they get started on something. At the playground where Stan hangs out (allegedly fascinated by the prospect of fatherhood), there’s “Playground Dad” (Anthony Anderson), a proud black father who gives Stan pep talks on the joys of parenting. African-Americans are so wise in movies like this, always playing proud dads and wise advisers and God and so forth, it’s a wonder the movies are about anyone else. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a330"
    }
  }, [_vm._v("Bad Teacher "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 92 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Cameron Diaz (Elizabeth Halsey), Justin Timberlake (Scott Delacorte), Lucy Punch (Amy Squirrel), John Michael Higgins (Principal Wally Snur), Jason Segel (Russell Gettis), Phyllis Smith (Lynn Davies), Dave “Gruber” Allen (Sandy Pinkus), Jillian Armenante (Ms. Pavicic). Directed by Jake Kasdan and produced by Jimmy Miller. Screenplay by Gene Stupnitsky and Lee Eisenberg. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Jake Kasdan’s "), _c('em', [_vm._v("Bad Teacher ")]), _vm._v("immediately brings "), _c('em', [_vm._v("Bad Santa ")]), _vm._v("to mind, and suffers by the comparison. Its bad teacher is neither bad enough nor likable enough. The transgressions of Elizabeth Halsey (Cameron Diaz) are more or less what you’d expect, but what’s surprising is that she’s so nasty and unpleasant. Billy Bob Thornton, as the bad Santa, was more outrageously offensive and yet more redeemed by his desperation. He was bad for urgent reasons. Elizabeth seems bad merely as a greedy lifestyle choice. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("As the film opens, the Diaz character is engaged to a rich guy she leeches on but doesn’t love. She’s dumped and has to return to middle school teaching, an occupation she has no talent for or interest in, and passes the time showing DVDs to her students and napping, drinking, and doing drugs at her desk. This creates astonishment and indignation in the charmingly named Amy Squirrel (Lucy Punch), whose classroom is right across the hall. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The school characters also include the Back-up teacher Scott Delacorte (Justin Timberlake), amiable but juiceless; the veteran teacher Ms. Pavicic (Jillian Armenante), a sweet dumpling; the hunky gym teacher Russell Gettis (Jason Segel); and the dolphinobsessed Principal Wally Snur (John Michael Higgins). ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Of these characters, the rival played by Lucy Punch is the most colorful because she’s the most driven and obsessed. The others seem curiously inconsequential, content to materialize in a scene, perform a necessary function, and vaporize. There’s no urgency, and that was the one quality "), _c('em', [_vm._v("Bad Santa ")]), _vm._v("dripped with. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("None of the film’s major characters is a student, which seems odd. Yes, there’s a kid who writes bad poetry and has a crush on the class sexpot, but his desperation seems well within comic bounds. There are no vindictive students, none with aggressive behavior, no little Omens in training. The casting of the children seems lacking in imagination, but then what does the screenplay give them to do? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Cameron Diaz has proven that she is gifted with comedy. But here her Elizabeth is a mean, antagonistic moneygrubber on autopilot. Where did she come from? Why did she get into teaching in the first place? Has she no heart? There are times in "), _c('em', [_vm._v("Bad Santa ")]), _vm._v("when we feel sorry for the poor SOB, but nothing in "), _c('em', [_vm._v("Bad Teacher ")]), _vm._v("inspires more than distaste for the character. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Other problems: There is no chemistry, or indeed even much mutual awareness, between Diaz and Timberlake. You know those annual Bad Sex Awards for the worst sex scene in a movie? Their dryhumping scene deserves an award for the decade. The scene itself is pathetic. The shot it ends on—the wet spot on Timberlake’s blue jeans—had the audience recoiling. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Whole chunks of the plot seem to have gone missing. And how, oh how, can we possibly understand the eventual development between Elizabeth and Russell the gym teacher? You know what that feels like? It feels like they called Diaz and Jason Segel in for one additional day of shooting to provide a preposterous happy ending. Jolly music keeps elbowing its way onto the sound track in an unconvincing attempt to cue us that we’ve seen a good comedy. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a331"
    }
  }, [_vm._v("The Bang Bang Club "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NO MPAA RATING")]), _vm._v(", 109 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Ryan Phillippe (Greg Marinovich), Malin Akerman (Robin Comley), Taylor Kitsch (Kevin Carter), Frank Rautenbach (Ken Oosterbroek), Neels Van Jaarsveld (Joao Silva). Directed by Steven Silver and produced by Adam Friedlander, Daniel Iron, and Lance Samuels. Screenplay by Silver, based on the book "), _c('em', [_vm._v("The Bang-Bang Club: Snapshots from a Hidden War")]), _vm._v(" by Greg Marinovich and Joao Silva. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Many of the photos of the bloody final months of apartheid were taken by four photographers who became famous as “The Bang Bang Club,” because of their willingness to risk death for great pictures. Two of them won Pulitzers. One of them was killed, one committed suicide, one was shot four times before retiring. The word often used about them was “courageous,” but another word that occurs is “foolhardy.” ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("In the opening scene, we meet Greg Marinovich (Ryan Phillippe), who pulls his car to the side of a highway and clambers down an embankment to follow an angry mob into a riot in Soweto, the African township outside Johannesburg. He joins three other photographers, all of them white, as they run, crouch low, and shoot photos in the middle of mob violence. They seem almost reckless. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Why do the blacks largely ignore these whites in their midst? Why is their attention so focused on their enemies of the same color? This question, which will instinctively occur to many viewers, is never quite dealt with in the film. The photographers sometimes drive into the middle of violent situations, hold up a camera, and say “Press!”—as if that will solve everything. Sometimes it does. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("We know with the benefit of history that South Africa’s president F.W. de Klerk was even then in talks with Nelson Mandela of the African National Congress that would lead to free elections, Mandela as president, and today’s South Africa. In 1994, the white minority was still involved in forcibly fighting black demonstrations, but almost all of the fighting filmed by the Bang Bang Club was black against black. The movie explains in a cursory way that the ANC was being opposed by the Inkatha Freedom Party, made of Zulus who opposed Mandela’s mostly Xhosa membership. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Inkatha fighters did more actual violence against the ANC than the whites did. I’m not referring to the overarching, crushing daily violence of apartheid itself, but to specific murders. The Zulus introduced the practice of “necklacing,” in which a tire would be tied around a victim’s head and set on fire. This war between two tribes was doubly ironic in a nation ruled by a white tribe. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("The Bang Bang Club ")]), _vm._v("will not leave its viewers with much of an insight into that. Some audience members may come out of the movie wondering why they didn’t see much apartheid, except implicitly. The focus is on the four photographers, Marinovich (Phillippe), Kevin Carter (Taylor Kitsch), Ken Oosterbroek (Frank Rautenbach), and Joao Silva (Neels Van Jaarsveld). Young, fit, hip, they compete for photos but run as a pack, sometimes sharing the same VW van. At nights in Jo’berg they hang out in bars and seem to attract a generous share of good-looking women. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("One of these is Robin Comley (Malin Akerman), the photo editor of the "), _c('em', [_vm._v("Johannesburg Star, ")]), _vm._v("who buys Marinovich’s photos and then buys into a relationship. Ryan Phillippe is effective in the lead—the newcomer to the club, protected by an indifference to personal danger that seems naive if not suicidal. But they all act like immortals: Consider a scene where one sprints across a street during a fierce gun battle to bring back a couple of liters of Coke. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Did these four men ever have extended discussions among themselves about the South African situation and apartheid itself? I’m sure they did, but there’s little of that here. Were their photos intended to strengthen or weaken the government? I can’t tell if they care. They like the money and the glory, they thrive on adrenaline, they buy into their Bang Bang legend. For them, in a sense, the reality of apartheid is only a photo op. Later, most of them will shoot films under fire in Sudan, the Middle East, and Bosnia. They live only to take pictures. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Well, that’s their job, their craft, and their passion. But it evades a question: What is their investment as human beings? Kevin Carter takes a photo of a little girl, bent over with hunger and dehydration, as she is eyed by a nearby vulture. The picture won the Pulitzer Prize. At a press conference, he’s asked what happened to the girl. He doesn’t know. Didn’t he do anything to help her? No. This is a universal dilemma for journalists in the face of tragedy. How many of them would frighten away the vulture and help the child? How many would take the photograph? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The film poses the question raised by the photo, but offers no answer. Perhaps there is none, or it is depressingly obvious. "), _c('em', [_vm._v("The Bang Bang Club ")]), _vm._v("seems curiously oblivious to South Africa as a whole. If this were your only film about that nation, you would leave with meager information. You would recall four good-looking guys who took a lot of chances and had some good times and some bad ones. But the big story wasn’t about them. Bang Bang. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a332"
    }
  }, [_vm._v("Barney’s Version "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½ ")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 132 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Paul Giamatti (Barney), Rosamund Pike (Miriam), Minnie Driver (Second Mrs. P.), Rachelle Lefevre (Clara), Scott Speedman (Boogie), Dustin Hoffman (Izzy), Bruce Greenwood (Blair), Macha Grenon (Solange). Directed by Richard J. Lewis and produced by Robert Lantos. Screenplay by Michael Konyves, based on the novel by Mordecai Richler. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_c('em', [_vm._v("Barney’s Version ")]), _vm._v("tells the story of a man distinguished largely by his ﬂaws and the beautiful woman who loves him in spite of them. What she sees in him I am not quite sure. He is a precariously functioning alcoholic and chainsmoker of cigars, a man balding and with a paunch, a producer of spectacularly bad television shows, and a fanatic hockey fan. Since he lives in Montreal, many good women might forgive the hockey, but he is also hostile toward her friends, rude at dinner parties, and has bad taste in ties. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Barney Panofsky is played by Paul Giamatti, who just won a Golden Globe for his performance. It is a successful performance not simply because of his acting but because of his exuding. He exudes a sweet quality that just barely allows us to understand why three women, the last of them a saint, would want to marry him. It’s not money: He’s broke when he marries the first, the second is rich in her own right, and the third is so desirable that Barney actually walks out of his own wedding reception to chase her to the train station and declare his love at first sight. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Barney’s Version ")]), _vm._v("is based on a 1997 novel by Mordecai Richler, whose "), _c('em', [_vm._v("The Apprenticeship of Duddy Kravitz ")]), _vm._v("(1959) is also the life story of a ﬂawed but lovable Jewish character from Montreal. Barney’s story is told in retrospect, in the form of a response to a book written by a cop who is convinced Barney murdered his best friend. How the friend probably did die is suggested in a nicely handled late scene that Barney himself, by the time he experiences it, is not able to understand. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Having once in middle age forgotten where he parked his car, Barney progresses rather rapidly into Alzheimer’s, although most of the film involves scenes before that happens. Since this isn’t a movie about the disease, we might ask why it’s included at all, but I think it functions as a final act in a life that was itself forgettable. Nothing distinguishes Barney except his romanticism and the woman who inspires it. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("She is Miriam (Rosamund Pike), an ethereal beauty with a melodious voice and a patience with Barney that surpasses all understanding. They have two children, they live happily, Barney remains a mess, and at important moments in her career he would rather be getting drunk in a bar while watching hockey than being there for her. Yet he cannot live without her, and when she goes to New York for a week, he becomes reckless with loneliness. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I haven’t read the much-loved novel by Richler, which is told in Barney’s voice and has been compared by some to Saul Bellow’s "), _c('em', [_vm._v("Herzog. ")]), _vm._v("The novel is said to be richer and more complex than the movie, but having only seen the movie, I can respond favorably to what it does achieve. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Giamatti’s performance is one of those achievements. He is making a career of playing unremarkable but memorable men; remember his failed wine lover in "), _c('em', [_vm._v("Sideways")]), _vm._v(", his schlubby Harvey Pekar in "), _c('em', [_vm._v("American Splendor")]), _vm._v(", and his soul transplant victim in "), _c('em', [_vm._v("Cold Souls. ")]), _vm._v("(What he plans in his announced project "), _c('em', [_vm._v("Bubba Nosferatu: Curse of the She-Vampires ")]), _vm._v("is a question worthy of consideration.) Giamatti’s Barney is not especially smart, or talented or good-looking, but he is especially "), _c('em', [_vm._v("there")]), _vm._v("—a presence with a great depth of need that apparently appeals to the lovely Miriam. She’s one of those women who seems unaware that everyone must constantly be asking, “What does she see in him?” That women persist in seeing things in us, as men, we must be grateful. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Dustin Hoffman is very good here as Barney’s father, a retired Montreal detective who imparts wisdom, but not too excessively, and love, but not too smarmily. The bond between elderly father and aging son is cemented by good cigars, which I have seen work in other cases. There is a lot of truth in "), _c('em', [_vm._v("Barney’s Version. ")]), _vm._v("It is a mercy that Barney cannot see most of it. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a333"
    }
  }, [_vm._v("Battle: Los Angeles ½ "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v("-13, 116 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Aaron Eckhart (Staff Sergeant Michael Nantz), Michelle Rodriguez (Technical Sergeant Elena Santos), Ramon Rodriguez (Second Lieutenant William Martinez), Bridget Moynahan (Michele), Ne-Yo (Corporal Kevin Harris), Michael Peña (Joe Rincon). Directed by Jonathan Liebesman and produced by Jeffrey Chernov, Ori Marmur, and Neal H. Moritz. Screenplay by Christopher Bertolini. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_c('em', [_vm._v("Battle: Los Angeles ")]), _vm._v("is noisy, violent, ugly, and stupid. Its manufacture is a reﬂection of appalling cynicism on the part of its makers, who don’t even try to make it more than senseless chaos. Here’s a science-fiction film that’s an insult to the words “science” and “fiction,” and the hyphen in between them. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Meteors fall to Earth near the coasts of the world’s major cities (and in Ireland’s Dingle Bay—that meteor must have strayed off course). They contain alien troops, which march up from the beach with their weapons of war and attack mankind. No reason is given for this, although it’s mentioned they may want our water. We meet the members of a ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("U.S. Marine platoon and its battlescarred staff sergeant. They’re helicoptered into Santa Monica and apparently defeat the aliens. Since all of Los Angeles is frequently seen in ﬂames, it’s not entirely clear how the Santa Monica action is crucial, but apparently it is. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The aliens are hilarious. Do they give Razzies for special effects? They seem to be animal/machine hybrids with automatic weapons growing from their arms, which must make it hard to change the baby. As the marines use their combat knives to carve into an alien, they find one layer after another of icky, gelatinous, pusfilled goo. Luckily, the other aliens are mostly seen in long shot, where they look like stick figures whipped up by apprentice animators. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Aaron Eckhart stars as Staff Sergeant Nantz, a twentyyear veteran who has something shady in his record that people keep referring to, although the screenwriter, Christopher Bertolini, is too cagey to come right out and describe it. Never mind. Eckhart is perfectly cast, and let the word go forth that he makes one hell of a great-looking action hero. He is also a fine actor, but acting skills are not required from anyone in this movie. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The dialogue consists almost entirely of terse screams: “Watch it! Incoming! Move! Look out! Fire! Move!” The only characters I remember having four sentences in a row are the anchors on cable news. Although the platoon includes the usual buffet of ethnicities, including Hispanics, Asians, and a Nigerian surgeon, none of them get much more than a word or two in a row, so as characters they’re all placeholders. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("You gotta see the alien battleships in this movie. They seem to have been assembled by the proverbial tornado blowing through a junkyard. They’re aggressively ugly and cluttered, the product of a planet where design has not been discovered and even the Coke bottles must look like pin cushions. Although these ships presumably arrived inside the meteors, one in particular exhibits uncanny versatility, by rising up from the earth before the very eyes of the startled marines. How, you may ask, did it burrow for ten or twelve blocks under Santa Monica to the battle lines at Lincoln Boulevard? And well you may ask. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("There is a lazy editing style in action movies these days that assumes nothing need make any sense visually. In a good movie, we understand where the heroes are and where their opponents are and why, and when they fire on one another we understand the geometry. In a mess like this, the frame is filled with ﬂashes and explosion and shots so brief that nothing makes sense. From time to time there’ll be a close-up of Aaron Eckhart screaming something, for example, and on either side of that shot there will be unrelated shots of incomprehensible action. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("When I think of the elegant construction of something like "), _c('em', [_vm._v("Gunfight at the OK Corral")]), _vm._v(", I want to rend the hair from my head and weep bitter tears of despair. Generations of filmmakers devoted their lives to perfecting techniques that a director like Jonathan Liebesman is either ignorant of or indifferent to. Yet he is given millions of dollars to produce this assault on the attention span of a generation. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Young men: If you attend this crap with friends who admire it, tactfully inform them they are idiots. Young women: If your date likes this movie, tell him you’ve been thinking it over and you think you should consider spending some time apart. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a334"
    }
  }, [_vm._v("Battleship "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½ ")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v("-13, 130 m., 2012 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Taylor Kitsch (Alex Hopper), Alexander Skarsgard (Stone Hopper), Rihanna (Cora Raikes), Brooklyn Decker (Samantha Shane), Tadanobu Asano (Yugi Nagata), Gregory D. Gadson (Mick Canales), Liam Neeson (Admiral Shane), Hamish Linklater (Cal Zapata). Directed by Peter Berg and produced by Berg, Sarah Aubrey, Brian Goldner, Duncan Henderson, Bennett Schneir, and Scott Stuber. Screenplay by Erich Hoeber and Jon Hoeber. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("“This could be like Columbus and the Indians,” a nerdy radio astronomer worries. “Except we’re the Indians.” From a powerful transmission facility in Hawaii, he’s supervised the transmission of a signal to the Earthlike Planet G in another galaxy, and in no time at all aliens come calling. Considering that they arrive in weeks, they must have discovered fasterthanlight speeds, so it’s a little strange that when they arrive they’re strictly analog. Their vast warships splash down in the Pacific (except for fragments that devastate Hong Kong in one of those toppling skyscraper scenes so beloved in disaster movies). But these alien craft are armed only at a level that makes their battle with a ﬂeet of U.S. warships more or less a standoff. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Why would the U.S. ﬂeet conveniently already be near the splashdown point? It’s involved in war games with allies such as Japan, which provides an excuse for a Japanese officer to take temporary command of one of our ships and boost the grosses of "), _c('em', [_vm._v("Battleship ")]), _vm._v("in Asia. It is also handy that the aliens create a force field that forms an impenetrable barrier around their craft, which seals in three U.S. ships, locks out all other ships, and explains why our airplanes don’t simply nuke the SOBs. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Of course, our response to the alien visit is immediately military, in the old Bmovie tradition. There’s not one word of discussion about the aliens possibly just making a social call. We invite them, they come, and we open fire. This despite the fact that they’re remarkably humanoid; when we finally remove the helmet from one alien’s space suit, he turns out to look alarmingly like James Carville. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("In the setup, we meet a shiftless beach bum named Alex Hopper (Taylor Kitsch), whose brother Stone (Alexander Skarsgard) is a naval officer. In a bar, Alex makes a hit on the lithesome Samantha Shane (Brooklyn Decker), who, wouldn’t you know, is the daughter of the admiral of the ﬂeet (Liam Neeson). Breaking into a convenience store to get her a burrito, Alex is arrested and his brother delivers an ultimatum: Join the navy or else. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Meanwhile, the nerd (Hamish Linklater) supervises transmission of the signal to Planet G, and in no more time than it takes to get Alex into uniform and on board a U.S. destroyer, five alien spacecraft enter our solar system in tight formation. One alien craft then levitates from the ocean deeps, as large as a skyscraper and bristling with ominous protrusions. You gotta say it takes real nerve for a communications officer (Rihanna) and two seamen to speed over to it in a rubber boat armed with a machine gun. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Parallel stories. We learn Samantha is a physical therapist working with the army vet Mick Canales (real-life Iraq hero Gregory D. Gadson). She takes him on a hike up the mountainside where the big NASA radio dishes are located, they meet the nerd, and much depends on preventing the aliens from phoning home. In the Pentagon situation room, officials fret. There’s the obligatory montage of cable news reports on the alien invasion, and the U.S. destroyers exchange fire with the aliens. Two ships are destroyed, including the one commanded by Stone Hopper, and after several officers on Alex Hopper’s ship die, he turns out to be next in command and becomes the captain of the surviving U.S. destroyer. So that’s convenient. The characters we met at the beginning all become the key players. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("This movie is based on the Hasbro board game of the same name, unplayed by me. You get a little of that sense when radar doesn’t work and Rihanna figures out a way to deduce the underwater movements of the alien craft by tracking wave patterns on a grid with oldfashioned weather buoys. The film eventually comes down to a large number of scenes in which things get blowed up real good. One alien weapon is especially fearsome: a large metal ball with spikes, which rolls through things and ﬂattens them. Were lesssophisticated versions of this used in medieval times, maybe made of ﬂaming tar balls? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The film is in the tradition of the Transformers movies, also based on Hasbro games, and you get the feeling that Hasbro showed its director, Peter Berg, some Michael Bay movies and told him to go and do likewise. To his credit, this is a more entertaining film than the Transformers titles, more fun, because it has slightly more fully ﬂeshed characters, a better plot, and a lot of naval combat strategy. The work of Gregory D. Gadson, as the disabled vet, is especially effective; he has a fierce screen presence. Rihanna is as convincing as the character allows, and Taylor Kitsch makes a sturdy if predictable hero. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("But the nicest touch is that "), _c('em', [_vm._v("Battleship ")]), _vm._v("has an honest-to-God third act, instead of just settling for nonstop fireballs and explosions, as Bay likes to do. I don’t want to spoil it for you. Let’s say the Greatest Generation still has the right stuff, and leave it at that. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a335"
    }
  }, [_vm._v("Beautiful Boy "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 100 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Maria Bello (Kate), Michael Sheen (Bill), Alan Tudyk (Eric), Moon Bloodgood (Trish), Austin Nichols (Coop), Kyle Gallner (Sam), Meat Loaf Aday (Motel Clerk). Directed by Shawn Ku and produced by Lee Clay and Eric Gozlan. Screenplay by Ku and Michael Armbruster. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("The death of a child is a calamity. When that child has gone on a killing rampage at his campus and then taken his own life, it must be a tragedy so fundamental that it paralyzes thought. "), _c('em', [_vm._v("Beautiful Boy ")]), _vm._v("gives us a glimpse of the young student on the night before his murders, and then is about how his parents live with what he has done. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("No rational response seems possible. They cannot reason with madness. Their son fits all the clichés of sudden killers: He was quiet, shy, kept to himself, never caused trouble. In scenes before his death we see that his home was an arid minefield. His parents were closed off from each other and on the edge of divorce. When he telephones them on his last night, their advice is “study hard.” His mother speaks with him longer than his father, but neither picks up what we see: The boy (Kyle Gallner) is on the edge of tears. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Beautiful Boy ")]), _vm._v("is a sincere attempt to imagine the aftermath of tragedy for the parents. Maria Bello and Michael Sheen play Kate and Bill, two people living in a daze. The news of their son’s death is followed immediately by the news about his rampage. Ordinary grief is stunned senseless. Their home is immediately placed under siege by reporters and TV news crews demanding a statement. This is always the case. I always wonder what the reporters are hoping for. What can be said? When Bill finally reads out a statement of regret, it is perfunctory and useless. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Shawn Ku’s film follows them. Bill tries to continue working at his office, but his coworkers stare and wonder. Kate is an editor and works on the manuscript of a new author. In her attention to minute details she deadens herself. Driven from their home, they move in with her sister (Moon Bloodgood) and husband (Alan Tudyk). This can’t last. Finally they are alone in the world, check-ing into a hotel where the night clerk (Meat Loaf Aday) becomes the first person in the film to treat them as if they were ordinary people. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("They were ready to divorce. Now they are together because no one else in the world can share this devastating new fact with them. Were the killings their fault? Did their marriage produce a disturbed boy? Do they deserve more guilt than they already feel? It’s here, I believe, that the film fails, almost by default. In a way, it must fail. Ku, who is also the cowriter of the screenplay, has posed himself questions without answers. His story permits no catharsis. There are moments when some minuscule contentment creeps back into the lives of Kate and Bill, in a scene at the hotel where they have a dinner of snack food and whisky and remember a little why they were once in love. But there can never again be joy. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("A film like this can end honestly in only one way, and Ku is true to it. Life will go on, one baffling day after another. There can be no release, only a gradual deadening. So it must be with most parents of children who commit horrible deeds. People do things for which there are no reasons, and if they don’t kill themselves, they must live, like Mark David Chapman, in the debris of their madness. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("There is a film that dealt with such an incident from the killer’s point of view. Gus Van Sant’s "), _c('em', [_vm._v("Elephant ")]), _vm._v("(2003) was about the shooters at a high school massacre like Columbine. It dared to suggest no explanation, no insight, no theories. Shawn Ku does the same. Here is the crucial difference: Van Sant focused on the killers. Ku focuses on the parents. They are alive, and are forced to live with the fact that there is no reason and no consolation. The parents of their son’s victims are at least given the consolation of someone to hate. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a336"
    }
  }, [_vm._v("The Beaver "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v("-13, 91 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Mel Gibson (Walter Black), Jodie Foster (Meredith Black), Anton Yelchin (Porter Black), Jennifer Lawrence (Norah), Riley Thomas Stewart (Henry Black). Directed by Jodie Foster and produced by Steve Golin, Keith Redmon, and Ann Ruark. Screenplay by Kyle Killen. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_c('em', [_vm._v("The Beaver ")]), _vm._v("is almost successful despite the premise of its screenplay, which I was simply unable to accept. I concede it is possible that a man in depression might be able to heal himself by projecting his personality into a hand puppet. I am not sure it is possible, or even advisable, to make a serious movie about that. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("We go through the movie with Mel Gibson wearing a toothy beaver on his left hand, and that creates a whole lot of disbelief for us to suspend. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Yet here is another of Mel Gibson’s fine performances, a reminder that he is after all a superb actor. His personal life is in ruins because of the disease of alcoholism, which he is still struggling with. When he’s responsible for outrageous acts and statements, I think, this is not the good man I have met many times. From what I know about alcoholism, I believe he goes through personality changes, that he is content on some days and consumed by rage and madness on others, and that such changes are symptoms of the disease. Make your own diagnosis. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("It took some courage on the part of Jodie Foster to direct this film. I believe she knows Gibson’s good side and respects his talent. He was certainly the right choice for this material. All of his troubles through recent years are summed up by her opening shot, of an exhausted man ﬂoating on a raft in a swimming pool, his arms wide like the crucified Christ. A voice (later revealed to be the Beaver’s) informs us this is Walter Black, a man so deep in depression he has alienated his family and nearly destroyed his business. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("We meet his muchsuffering wife, Meredith (Jodie Foster), his resentful son, Porter (Anton Yelchin), and his disbelieving colleagues. Meredith finally throws him out, not without love. He buys a bottle, checks into a motel, tries to kill himself, and is interrupted by the hand puppet. Finding that the puppet has a voice of its own, he allows it to speak for him, and begins to reenter his life. Foster, Gibson, and the writer, Kyle Killen, make not the slightest attempt to employ the illusion of ventriloquism; Gibson manipulates the puppet and speaks from his own mouth, in an admirable if inexplicable Cockney accent. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("His life improves in ways I leave for you to discover. I also leave you to wonder if Matt Lauer on a real "), _c('em', [_vm._v("Today ")]), _vm._v("program would chat with a hand puppet quite as he does here. A parallel plot involves Porter, the son, whose gift is to ghostwrite papers for classmates that read as if written by themselves. The class valedictorian asks him to write her speech. If she’s that smart, why can’t she write it herself? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("She’s going through problems, which Porter will discover in a story that tends to lead us, however interestingly, away from the through-line. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("What sort of movie would have resulted with the same characters but not the beaver? We will never know. On the other hand, without "), _c('em', [_vm._v("The Beaver ")]), _vm._v("we would never have witnessed a sexual threesome involving a hand puppet. Foster and Gibson must have gone through some serious times while making this film, but don’t you suppose that while filming that sex scene they had to suppress the urge to giggle? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("That is the fatal ﬂaw in this sincere endeavor. As good as Gibson is, his character is still caught between the tragedy of the man and the absurdity of the beaver. Fugitive thoughts of Señor Wences crept into my mind. I’m sorry, but they did. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a337"
    }
  }, [_vm._v("Beginners "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½ ")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 105 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Ewan McGregor (Oliver), Christopher Plummer (Hal), Melanie Laurent (Anna), Goran Visnjic (Andy), Kai Lennox (Elliot), Mary Page Keller (Georgia), Keegan Boos (Young Oliver). Directed by Mike Mills and produced by Miranda de Pencier, Lars Knudsen, Leslie Urdang, Jay Van Hoy, and Dean Vanech. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Six months after his mother dies, Oliver’s father tells him something startling: “I am gay.” His father is seventy-five and was married for thirty-eight years. Oliver himself is about thirty-eight when he learns this news, and is in a different sort of closet: Afraid of failing, afraid of commitment, afraid to trust, he has never had a meaningful relationship. "), _c('em', [_vm._v("Beginners ")]), _vm._v("is about how both men find love. It is a film in which only a dog named Arthur seems to hold everything in perspective. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("No, this isn’t a comedy about a talking dog. Arthur has only a bit part and communicates in subtitles, thinking the kinds of thoughts that dogs, who are obsessed with the study of humans, might indeed think. But the presence of this wise Jack Russell terrier provides a perspective apart from sexuality and personality, one that perceives merely when everything is, or is not, as it should be. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Oliver, played by the engaging Ewan McGregor, is an artist whose work, apparently successful, communicates a reluctance to be sure and bold. His father, Hal, is played by Christopher Plummer as a man who arrived at an agreement with his wife, Georgia (Mary Page Keller), many years ago, and has been true to it. He has always known he is gay, and his revelation to his son conveys pride, relief, and a kind of joy. Perhaps he has arrived at an age when only his son could be expected to care about this unexpected information. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The film moves easily within three time frames. There is the period between his father’s announcement and his death a few years later, the period in Oliver’s life after the death, and ﬂashbacks to Oliver’s memories of childhood. If we must extract a meaning from "), _c('em', [_vm._v("Beginners")]), _vm._v(", it may be that it is never too late to make a fresh start, and the father sets an example for his son. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Christopher Plummer, an actor filled with presence and grace, brings a dignified joy to his new gay lifestyle. He delights in the Gay Pride rainbow, dances in clubs, throws parties, and introduces Oliver to his boyfriend, Andy (Goran Visnjic). This Andy is so improbably handsome that the liaison seems unlikely, but we grow convinced that Andy truly and deeply loves the old man, with a fullness that almost shames Oliver. The film pays due attention to Hal’s happiness and to the process of his death, which he approaches with the consolation that at last there is nothing he must keep secret. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Some months later, deep in idleness and distraction, sad in his bones, Oliver attends a costume party dressed as Freud. He stations himself next to a sofa and acquires a patient named Anna (Melanie Laurent). She communicates by writing notes in little spiral notebooks. She can’t speak because she has laryngitis. In a curious sense, her notes and the dog’s subtitles convey the same kinds of bottomline observation: “Why,” she writes, “did you come to a party when you were so sad?” She knows that he is sad, just as a dog doesn’t need to be told such things. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("One of the pleasures of Beginner"), _c('em', [_vm._v("s ")]), _vm._v("is the warmth and sincerity of the major characters. There is no villain. They begin by wanting to be happier and end by succeeding. The person left out is the dead mother, Georgia. She spent years in a pointless marriage. If Hal and Georgia were sticking it out for the sake of Oliver, that doesn’t seem to have turned out well. And once he was an adult and had left home—why did they persist? Did Hal lack the moral courage to declare himself? He could have been happier years sooner, and she could have had her chance, too. Hal is not quite as nice as he seems. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Another question occurs. Both Hal and Oliver find ideal romantic partners, who are breathtakingly good-looking, unﬂaggingly nice, deeply warmhearted, and loyal. Everyone who goes to gay bars or costume parties should be so lucky. That makes it all too neat, but then this isn’t a deep drama, anyway. It’s a hopeful fable with deep optimism and a cheerful style that kids itself. Like many dogs, it shrugs off setbacks and keeps hoping it can go outside and play. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a338"
    }
  }, [_vm._v("Behind the Burly Q "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NO MPAA RATING")]), _vm._v(", 98 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Alan Alda, Tempest Storm, Beverly Arlynne, Lou Costello, Sally Rand, Betty Rowland, Lili St. Cyr, Kitty West, Blaze Starr, and others. A documentary directed by Leslie Zemeckis and produced by Zemeckis, Sheri Hellard, and Jackie Levine. Screenplay by Zemeckis. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("My entry in the 1959 essay contest of the United Republican Fund won me a free trip to Chicago and the chance to shake Richard Nixon’s hand during a banquet at the Chicago Amphitheater. What I remember about that trip is stepping into a cab in front of the Conrad Hilton Hotel and telling the driver, “Take me to the best burlesque show in town.” He threw down the ﬂag on his meter and drove me one block, to the Rialto on South State Street. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("In those days both the Rialto and the Follies survived as part of the last gasp of American burlesque. The Rialto had once been owned by Harold Minsky, Broadway’s legendary burlesque impresario. There I beheld striptease artistes and a team of two comedians who told bawdy jokes about body parts, pulled improbable objects out of their pockets, and slapped each other with rubber chickens. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Burlesque survived there until the theaters were booked as porn houses. It made fitful revivals here and there around town, including at the Town, now the Park West, where in a seedy dressing room I interviewed the legendary Tempest Storm and found her kind and patient. Now it is gone and almost forgotten. Once it was known as the poor man’s Broadway. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("A new documentary named "), _c('em', [_vm._v("Behind the Burly Q ")]), _vm._v("recalls those days, but that’s about all it accomplishes. It gathers an impressive series of talking head interviews with surviving stars, including Tempest Storm herself, looking pretty damned good for a redhead aged eighty-two. In 1999, San Francisco mayor Willie Brown proclaimed a Tempest Storm Day. Catch Michael Bloomberg doing that. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("In its heyday a topﬂight burlesque show would run ninety minutes and feature a large cast, elaborate costumes, energetic choreography, and a nice little orchestra. Young comics got a start there, including Abbott and Costello. Alan Alda appears in this film to remember his father, Robert, a straight man on Forty Second Street. Burlesque was considered a step down from vaudeville, although it was a lot classier than the nude revues and lap dances that replaced it. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("There wasn’t total nudity, for one thing, although Sally Rand caused a sensation at the 1933 Chicago World’s Fair with her celebrated fan dance, during which she was apparently completely nude, but manipulated her fans so adroitly that you could never be absolutely sure. This proves the principle that it is more erotic to be about to see everything than it is to actually see it. Miss Rand died in 1979 at the age of seventy-five, and was still dancing in that decade. I know that for a fact because my friend John McHugh has a photograph of himself with her to prove it. In the picture he is conducting himself as befits a reporter from the "), _c('em', [_vm._v("Chicago Daily News ")]), _vm._v("while her perky nipples wink at him. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Behind the Burly Q")]), _vm._v(", written and directed by the burlesque historian Leslie Zemeckis (wife of Robert), settles too easily for an editing formula that alternates talking heads, toocursory performance footage, and montages of headlines and photographs. The timeline is unclear and the structure seems too random, but a composite picture emerges as young girls, often out of poverty, dream of stardom but end by taking it off. The successful ones had gimmicks. Lili St. Cyr appeared to make love with a parrot and Babette Bardot was allegedly Brigitte Bardot’s sister. Their names showed some invention, for example Blaze Starr’s; she famously had an affair with Louisiana governor Huey P. Long, and is in this film via telephone, refusing to be photographed. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The many burlesque veterans who do appear in the film look, it must be said, like attractive seniors, and in their faces and voices we glimpse a spirit and defiance. They were overworked and underpaid and generally considered to be hookers, but they supported themselves, some from the age of fourteen. You hear some nostalgia, but with most of them you don’t get the idea that if they had the chance they’d do it all again. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Note: My interview with Tempest Storm is at "), _c('a', {
    attrs: {
      "href": "http://j.mp/b7GnZb",
      "target": "_blank"
    }
  }, [_vm._v("http://j.mp/b7GnZb")]), _vm._v(". ")])]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a339"
    }
  }, [_vm._v("Being Elmo: A Puppeteer’s Journey "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NO MPAA RATING")]), _vm._v(", 80 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("A documentary narrated by Whoopi Goldberg and featuring Kevin Clash, Bill Barretta, Fran Brill, Joan Ganz Cooney, Rosie O’Donnell, Frank Oz, Martin P. Robinson, Caroll Spinney, and Cheryl Henson. Directed by Constance Marks and produced by Marks, Corinne LaPook, and James J. Miller. Screenplay by Philip Shane and Justin Weinstein. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("All Kevin Clash ever wanted to do was make puppets. That came even before he fixated on Muppets. One day he had an inspiration so urgent that it required cutting up his father’s coat. The result was a nice enough puppet, but when Kevin emerged from his creative frenzy he realized his father might have stern words for him. Called in trembling to the old man, all he heard was: “Next time, ask.” ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Kevin Clash was born into a large middle-class family in an African-American suburb of Baltimore, and perhaps found puppets and Muppets a way to express his otherwise quiet, shy personality. Using sheets on his mother’s clothesline as a backdrop, he put on shows for the neighborhood kids. He was picked on as a boy who “played with dolls,” but that changed after he won a job on a local TV show in Baltimore. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Being Elmo ")]), _vm._v("is a documentary that follows him through a series of good breaks that lead him into the universe of Jim Henson and "), _c('em', [_vm._v("Sesame Street")]), _vm._v(", and we even hear an eyewitness to the day he “discovered” the Elmo character. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("After another puppeteer grew frustrated and threw Elmo at Kevin saying, “Here, you try it,” Kevin fooled around with a series of voices until Elmo, one of the most beloved of all Muppets, emerged. He also defined Elmo’s central characteristic: All he wanted was to love and be loved, and hug you. What kid couldn’t identify? The original Elmo craze led to buyer panics for the Tickle Me Elmo dolls, and Clash’s life has been a happy one. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Was there more? We hear about the shocking and sudden death of of Jim Henson. That seems to have been the only tragedy in Clash’s life. We hear of an exwife and meet a beloved daughter, but learn little about them. We don’t know if he’s married now. The director, Constance Marks, either filmed or found film from a remarkable span of Kevin’s life; we see him at all ages and during such early events as his first Macy’s parade. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("What I hadn’t realized fully is how versatile the Muppeteers are, doing a variety of voices and studying the minute details of Muppet body language. There’s an interesting scene where he teaches Muppeteers for a French version of the Muppet show how you don’t want to let a Muppet spend much time with his mouth closed; backstage at the Muppet works, we see countless drawers filled with eyeballs, eyebrows, whiskers, and wigs. It’s the only world Kevin wanted to live in, and he made it. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a340"
    }
  }, [_vm._v("Being Flynn "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 101 m., 2012 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Robert De Niro (Jonathan Flynn), Paul Dano (Nick Flynn), Olivia Thirlby (Denise), Lili Taylor (Joy), Wes Studi (Captain), Julianne Moore (Jody Flynn). Directed by Paul Weitz and produced by Weitz, Michael Costigan, and Andrew Miano. Screenplay by Weitz, based on the memoir by Nick Flynn. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("An early shot in "), _c('em', [_vm._v("Being Flynn ")]), _vm._v("shows Robert De Niro behind the wheel of a Yellow Cab, and the ground shifts beneath the movie. To summon up his most iconic role must represent De Niro’s faith in this film. I can understand why he felt that much faith in the project but am not sure the film deserves it. De Niro plays Jonathan Flynn, in his own estimation one of the three greatest American writers (the others: Mark Twain and J. D. Salinger). He claims publishers have been bidding fortunes on his work in progress, but we follow his decline: He loses his apartment, loses his cab, and is reduced to hanging out in the wellheated lobbies of buildings. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("We learn about him from his son, Nick Flynn (Paul Dano), who also intends to be a great writer, and there are two voice-overs in the film, one by Jonathan, one by Nick, although Nick may be writing his father’s narration. There is a real Nick Flynn, who first told this story in a 2004 memoir, "), _c('em', [_vm._v("Another Bullshit Night in Suck City")]), _vm._v(". Whether his real-life father was a writer I’ve been unable to determine, but we know his parents were divorced when he was young, his mother killed herself when he was twenty-two, and he actually did go to work in a homeless shelter, where he met his father for the first time when the old man turned up looking for a room for the night. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("If you want to be a writer and something like that happens to you, it’s inevitable that it will turn up in a book. By all accounts the memoir is a powerful piece of work. Throughout the film, Nick’s subtext is “Am I doomed to be a failure like my dad?” Nick tells us his father was mostly absent during his childhood—in prison for bad check writing. His mother (Julianne Moore) explains this to the boy as well as she can. Alcoholism is the problem of the father; cocaine becomes the problem of the son. Assuming such a life doesn’t kill you, it reads nicely in those little authors’ biographies on the insides of dust jackets: “The author overcame drug addiction and worked in a homeless shelter before winning a Guggenheim.” ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("What’s admirable about "), _c('em', [_vm._v("Being Flynn ")]), _vm._v("is that it doesn’t cave in to the standard Hollywood redemption formulas, with the father redeemed and the son inspired. It’s more complicated than that. Jonathan Flynn perhaps has mental problems, or simply likes to prevaricate; does he really believe in his greatness? As for the son, his childhood memories seem limited to repeated games of catch and rummaging through a box full of letters that Jonathan sent from prison. Julianne Moore plays a loving mother, but not much is done with the character. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Paul Dano is an actor who can be distant and mystifying. He makes it interesting. He sometimes approaches a scene with passive aggression. He understands the material, he understands the character, but he isn’t going to do the heavy lifting for us. In films like "), _c('em', [_vm._v("There Will Be Blood")]), _vm._v(", "), _c('em', [_vm._v("The Ballad of Jack and Rose")]), _vm._v(", and "), _c('em', [_vm._v("Meek’s Cutoff")]), _vm._v(", he plays the silent dissent to the dominant characters. In "), _c('em', [_vm._v("Being Flynn")]), _vm._v(", he uses his writing to express feelings Nick isn’t forthright about in life. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("When Jonathan unexpectedly materializes, Nick’s at a loss, and his feelings are the subject of the film. De Niro’s father is a man who has run out of options. There is no longer anyone who much cares if he’s telling the truth. Nick, on the other hand, has a girlfriend named Denise (Olivia Thirlby) who cares for him and sees that he needs to be doing "), _c('em', [_vm._v("something")]), _vm._v(". She works at the homeless shelter and convinces him to give it a try. She perhaps instinctively spots Nick as one of those “writers” for whom it’s hard work, not writing every day. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I’m happy that the film didn’t settle for the Hollywood redemption formula, but ambivalent that it leaves us in suspense. Neither character is ready to have their chance meeting result in anything definite. Jonathan seems doomed. That would be the film’s easy way out, but it isn’t sure which way it should take. In a sense, director Paul Weitz ("), _c('em', [_vm._v("About a Boy")]), _vm._v(") has the same kind of passivity that works for Dano: He’ll take us so far and leave us. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Robert De Niro has been through a bad patch lately. His contemporary Al Pacino has moved from one success to another by going out of his way to choose challenging projects ("), _c('em', [_vm._v("You Don’t Know Jack")]), _vm._v(", "), _c('em', [_vm._v("The Merchant of Venice")]), _vm._v("). De Niro, perhaps absorbed in his Tribeca enterprises, has seemed to drift. He and Weitz worked together on "), _c('em', [_vm._v("Little Fockers")]), _vm._v(", not a high point for either. Now here is a much more ambitious film that almost but not quite justifies the hope inspired by that Yellow Cab. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Note: The invaluable Lili Taylor, seen in the homeless shelter, is Nick Flynn’s real-life companion. ")])]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a341"
    }
  }, [_vm._v("Bel Ami "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 102 m., 2012 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Robert Pattinson (Georges Duroy), Uma Thurman (Madeleine Forestier), Philip Glenister (Charles Forestier), Christina Ricci (Clotilde de Marelle), Kristin Scott Thomas (Virginie Rousset), Colm Meaney (Luc Rousset), Holliday Grainger (Suzanne Rousset). Directed by Declan Donnellan and Nick Ormerod and produced by Uberto Pasolini. Screenplay by Rachel Bennette, from the novel by Guy de Maupassant. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_c('em', [_vm._v("Bel Ami ")]), _vm._v("continues the aura of mystery that has enveloped Robert Pattinson since the "), _c('em', [_vm._v("Twilight ")]), _vm._v("pictures. That mystery involves why this actor, whose default mode is passive brooding, has been cast as a man irresistible to women. One can barely accept that a naive high school girl might fall for his strong, silent vampire, but in "), _c('em', [_vm._v("Bel Ami")]), _vm._v(", he successfully seduces three of the most powerful beauties in Paris society, despite having no talent, no money, and no conversation. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The movie, set in 1890, is based on a Guy de Maupassant novel about Georges Duroy, son of an illiterate peasant who serves in the French army in Algeria and then finds himself in Paris. The opening shot shamelessly lifts from Chaplin and countless other sources, as the penniless outcast stares hungrily through a restaurant window at the rich people dining inside. In his cramped garret, all he has is a crust of bread, a candle stub, and resentment. To make sure we get the point, the movie contrasts shots of a steamed lobster and Georges’s resident cockroach. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Good luck strikes the next day when in a bordello he encounters an old army buddy, Forestier (Philip Glenister). This man is now political editor of a Parisian daily. He invites Georges to dinner, and when Georges confesses he has no evening wear, gives him two gold pieces to buy some. This grants him entry into a dinner party of power couples: not only Forestier and his comely wife, Madeleine (Uma Thurman), but the paper’s editor, Rousset (Colm Meaney), and his inﬂuential wife, Virginie (Kristin Scott Thomas), and the married Clotilde (Christina Ricci), whose husband does not attend but is also high and mighty. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("In the course of the film Georges will seduce all three women, marry one and the daughter of another, and prove himself to be a thoroughgoing rotter, cad, and bounder. The women are all elegant and intelligent, they know the ways of the world, and they know Georges’s history. Why do they find him attractive? We don’t, and that failure is the downfall of the film. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("His first conquest is Madeleine, who not only comes up with an idea for an article he could write for her husband’s paper, but even writes it for him. She is a honeylipped charmer who prefers to write in a scoopnecked negligee while sprawled on her bed. Georges sells the article (which Forestier surely knows his wife wrote), sees it published, and permits himself the first of several selfsatisfied smiles. Pattinson, alas, is an actor who hasn’t mastered the art of smiling convincingly. He smiles as if saying “Cheese!” In this world of sophisticated decadence, he needs a sardonic smile. Imagine Jeremy Irons or Ethan Hawke. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The plot essentially involves only Georges’s affairs, although lip service is paid to intrigue about whether the French government plans to invade Morocco. Georges has been informed that in Paris it is not the men who have the power, but their wives, and he sets out to climb the social ladder in their beds. He so enraptures Clotilde (Ricci) that she establishes them in a cozy little love nest. His next victim is the distinguished Virginie (Scott Thomas), whom he has the effrontery to invite to the love nest for some quick rumpy-pumpy, hurrying her away just in the nick of time before Clotilde arrives. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The actresses do what they can with this sad sack. The surprise for me was Christina Ricci, whom I think of as undernourished and nervous, but who ﬂowers here in warm ripeness. Her character makes the mistake of actually loving Georges. This involves pure acting skill on her part, since Pattinson gives her so little to work with. The movie ends with Georges’s marriage to a young woman I haven’t yet mentioned, and as the new couple walk down the aisle, they pass those whom Georges has betrayed and savaged through the years. It is good to see a poor boy from the provinces make good. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a342"
    }
  }, [_vm._v("Bellflower "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 105 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Evan Glodell (Woodrow), Jessie Wiseman (Milly), Tyler Dawson (Aiden), Rebekah Brandes (Courtney), Vincent Grashaw (Mike), Zack Kraus (Elliot), Keghan Hurst (Sarah), Alexandra Boylan (Caitlin). Directed by Evan Glodell and produced by Glodell and Vincent Grashaw. Screenplay by Glodell. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_c('em', [_vm._v("Bellflower ")]), _vm._v("is a scrappy indie movie that comes out of nowhere and blows up stuff real good. It also possibly represents the debut of a oneofakind filmmaker, a natural driven by wild energy, like Tarantino. I know what the budget was, but if I told you, you’d arrive at all the wrong conclusions. Let’s say Evan Glodell had all the money he needed to make this particular movie, and more might have changed it for the worse. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Here is a movie about two buddies who aimlessly hang around in their workshop, designing, oh, you know, things like apocalyptic ﬂamethrowers. When they suspend a fuel tank in midair and fire at it with a shotgun just to see what might happen, I had the odd notion that they might have filmed the shot only once and found out at the same time we did. A movie this size, how many standby fuel tanks are you gonna buy? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Woodrow and Aiden (Evan Glodell and Tyler Dawson) are two "), _c('em', [_vm._v("Jackass ")]), _vm._v("types, and I mean that with the greatest respect. They were pals in Wisconsin, joined up to move to California, and live in a town that consists entirely of the poor neighborhood. They are apparently unemployed. They are customizing a classic muscle car they name the Medusa, which when it is finished will be capable of throwing terrifying plumes of ﬂame into the air and . . . making quite an impression. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("One night they are in a bar. They get involved in a contest requiring them to eat live crickets. This isn’t completely crazy; I understand insects are a good source of protein and minerals. Woodrow finds himself in the finals with a friendly blonde named Milly (Jessie Wiseman), and it’s kismet. You know how sometimes you lock eyes with another person and in a brief moment everything is said that needs to be said? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Woodrow does. Milly isn’t so sure. Maybe she’s met lovable cricket eaters before. “I could be bad for you,” she warns Woodrow. If he falls for her, he could get hurt. He accepts this risk, and on a lark they set off for Texas to have some good times. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("All of this happens with a certain foreboding of doom, because the movie has opened with a quickcut montage of alarming events apparently destined to happen later in the story. These are fragmented enough so that they’re not really spoilers, and indeed providing a straightforward chronology is not the movie’s purpose. It’s more about the rise and fall of their romance, the rise of Woodrow’s interest in Milly’s friend Courtney (Rebekah Brandes), a counterpoint with Aiden’s experiences, and the presence of a man named Mike (Vincent Grashaw), who Woodrow didn’t realize was already in Milly’s life. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The movie is essentially a mumblecore romcom, although that makes it sound too derivative. Glodell is an engaging hands-on director (he built not only Medusa but also the camera he uses), and an engaging actor. His cast is always convincing. His screenwriting lacks a shade in clarity, but then so do the lives of these characters. The cinematography, by Joel Hodge, is raw and high contrast, weathered and full of character, with lots of blood reds. It wouldn’t take much work by a designer to make a ripped Tshirt out of the look here. And when the Medusa belches ﬂames, man oh man, people notice. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a343"
    }
  }, [_vm._v("Bernie "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v("-13, 98 m., 2012 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Jack Black (Bernie Tiede), Shirley MacLaine (Marjorie Nugent), Matthew McConaughey (Danny Buck Davidson). Directed by Richard Linklater and produced by Liz Glotzer, David McFadzean, Dete Meserve, Judd Payne, Celine Rattray, Martin Shafer, and Ginger Sledge. Screenplay by Linklater and Skip Hollandsworth, based on the "), _c('em', [_vm._v("Texas Monthly ")]), _vm._v("article “Midnight in the Garden of East Texas” by Hollandsworth. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("I would buy a used coffin from this man. In Richard Linklater’s droll comedy "), _c('em', [_vm._v("Bernie")]), _vm._v(", Jack Black plays an east Texas funeral director named Bernie Tiede, and it is surely one of the best performances of the year. I had to forget what I knew about Black. He creates this character out of thin air, it’s like nothing he’s done before, and it proves that an actor can be a miraculous thing in the right role. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Black is not a giant. He stands five foot six. Yet the word for Bernie Tiede is "), _c('em', [_vm._v("hovering. ")]), _vm._v("He seems to hover above even those taller than him. He is solicitous, gentle, tactful. When Marjorie Nugent’s husband dies, he is the angel at her shoulder, creating the impression that no client has ever touched him quite so much as she. That’s a triumph because Marjorie (Shirley MacLaine) is the most disliked woman in Carthage. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("She was a real woman, and Bernie Tiede’s story is factual, based on a celebrated "), _c('em', [_vm._v("Texas Monthly ")]), _vm._v("article named “Midnight in the Garden of East Texas” by Skip Hollandsworth. The late Mr. Nugent, apparently a prince of a fellow, owned the local bank. Marjorie took over after his passing and started throwing loan applications into the wastebasket and otherwise offending the locals. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Was it her money that attracted Bernie Tiede? No one can say. Bernie was known and liked by almost everyone in town, sang in the church choir, served on charity boards, organized civic functions, provided a sympathetic shoulder. His origins were obscurely in Arkansas, but his manner was such that he got the job at the Carthage funeral home almost just by presenting himself. Among his many abilities was the tact to convince mourners he sincerely believed they had selected precisely the right coffin. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Bernie’s courtship of Marjorie is a masterpiece of social delicacy. In the odd dance between the two, he never seems to want anything in particular. Not sex, certainly; there were those in Carthage who assumed Bernie was gay, and there were rumored to be a few who knew. Nor was he boldly after her money, although he suggested purchases that in embellishing her lifestyle did nothing to diminish his. Surely Marjorie knew she was hated in the town, and surely she enjoyed being paid tribute; MacLaine allows the slightest of smiles to sometimes shine out from a fixed frown. They began to be seen around town, especially at the theatrical and artistic events Bernie supported and sometimes performed in. They shared such sublimated sexual experiences as holding hands while having simultaneous massages in a (respectable) local spa. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("There are ﬂatfooted ways this story could have been told. Richard Linklater finds a tricky note difficult to define. "), _c('em', [_vm._v("Bernie ")]), _vm._v("never declares itself a comedy; often when we laugh we’re thinking, “I can’t believe I’m seeing this.” An unspoken compact grows between Bernie and Marjorie in which neither one declares exactly what’s going on, but the fiction is maintained that Bernie believes her worthy of his kindest attentions, and she believes that at last a man has gotten her right. (Generally known spoiler.) But a relationship this problematic can’t last forever, and eventually Bernie shoots Marjorie four times in the back. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("And now Linklater surpasses himself. Bernie’s attempts to conceal the death are based on the ability of many good funeral directors to instinctively know what people really think about one another. In Marjorie’s case, no one liked her and she isn’t particularly missed. Bernie redoubles his local charities and continues to lead his accustomed lifestyle. Only a curious state’s attorney named Danny Buck Davidson (Matthew McConaughey) eventually sniffs out something wrong, and even as he comes under suspicion, Bernie Tiede remains a man who knows exactly how to behave in difficult situations. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Richard Linklater has made all kinds of movies, most of them very good. They have little else in common: He worked with Black in a completely different mode in "), _c('em', [_vm._v("School of Rock")]), _vm._v(", and has made such films as "), _c('em', [_vm._v("Dazed and Confused")]), _vm._v(", "), _c('em', [_vm._v("Before Sunrise")]), _vm._v(", "), _c('em', [_vm._v("Waking Life")]), _vm._v(", and "), _c('em', [_vm._v("Me and OrsonWelles. ")]), _vm._v("Why did he make "), _c('em', [_vm._v("Bernie")]), _vm._v("? I suspect he read the magazine article and knew it was a natural movie. Anyone could have seen that. His genius was to see Jack Black as Bernie Tiede. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a344"
    }
  }, [_vm._v("The Best Exotic Marigold Hotel "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½ ")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v("-13, 124 m., 2012 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Judi Dench (Evelyn Greenslade), Maggie Smith (Muriel Donnelly), Bill Nighy (Douglas Ainslie), Penelope Wilton (Jean Ainslie), Tom Wilkinson (Graham Dashwood), Celia Imrie (Madge Hardcastle), Ronald Pickup (Norman Cousins), Dev Patel (Sonny Kapoor), Tena Desae (Sunaina). Directed by John Madden and produced by Graham Broadbent and Peter Czernin. Screenplay by Ol Parker, based on the novel "), _c('em', [_vm._v("These Foolish Things ")]), _vm._v("by Deborah Moggach. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_c('em', [_vm._v("The Best Exotic Marigold Hotel ")]), _vm._v("is a retirement destination in India for “the elderly and beautiful.” It has seen better days, and if you want to see what the better days looked like, just examine the brochure, which depicts a luxurious existence in Udaipur, a popular tourist destination in Rajasthan. To this city travel a group of seven Brits with seven reasons for making the move—although the most urgent is that the local prices make retirement possible for them. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("As we meet them jammed on the bus from the airport, we suspect that the film will be about their various problems and that the hotel will not be as advertised. What we may not expect is what a charming, funny, and heartwarming movie this is, a smoothly crafted entertainment that makes good use of seven superb veteran actors. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("We’re introduced to them while they’re still at home in England. In the order of their billing, they are Evelyn Greenslade (Judi Dench), who has been forced to sell her London ﬂat; the sniffy Muriel Donnelly (Maggie Smith), who doesn’t like foreigners but requires a cheap hip replacement; Douglas and Jean Ainslie (Bill Nighy and Penelope Wilton), who are not merely unhappily married but have lost a bundle on their daughter’s Internet company; Graham Dashwood (Tom Wilkinson), who spent the happiest years of his life in India and has now returned to seek his young love; Madge Hardcastle (Celia Imrie), who is open to the possibility of finding a husband; and Norman Cousins (Ronald Pickup), who is open to the possibility of finding a one-night stand. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Greeting them at the entrance to the Best Exotic Marigold Hotel is its exuberant and optimistic young owner, Sonny Kapoor (Dev Patel, whom you may remember from "), _c('em', [_vm._v("Slumdog ")]), _vm._v("Millionaire, where he played the contestant on the TV quiz show). He’s inherited the shabby institution from his late father and plans to run it himself, against the objections of his mother, who wants him to live with her in Delhi and marry the bride of her choice. Sonny already has a bride picked out; she is Sunaina (Tena Desae), who works in a call outsourcing agency—the movie’s nudge that the West has not only outsourced many of its jobs to India, but is now outsourcing many of its senior citizens. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("How can I suggest what a delight this film is? Let me try a little shorthand. Recall some of the wonderful roles you’ve seen from Judi Dench, Maggie Smith, Tom Wilkinson, Bill Nighy, and the others, and believe me when I say that this movie finds rich opportunities for all of them. Director John Madden ("), _c('em', [_vm._v("Shakespeare in Love")]), _vm._v(") has to juggle to keep his subplots in the air, but these actors are so distinctive they do much of the work for him. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Tom Wilkinson is the most affecting character. He was raised and educated in India and moved with his parents to England, leaving love, regret, and guilt behind. His character is instinctively open to India, and wanders off on daily secret missions that excite the curiosity of the others and may involve no more than sharing cricket tips with street kids. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The Maggie Smith character is at the other end of the scale. She dislikes India, and indeed, anyplace that is not England, and refuses to eat any food she cannot pronounce. Awaiting her affordable hip replacement, she notices a lowcaste girl who is sweeping the hotel and gives her a hint. Smith, we discover, spent her entire life in service, raising the children of others, and now in retirement there is no one to take care of her. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The Judi Dench character apparently spent most of her life having her husband settle all important questions, something to regret after he dies and she finds herself broke. She focuses on young Sonny, his struggle with his mother, and his optimistic plans to renovate the hotel. A good start might be chasing the pigeons from the rooms. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The story is lightfooted and cheerful for the most part, especially when Dench goes job hunting and the romance seekers experiment with online dating services. Still there’s a fair amount of humanity in the screenplay by Ol Parker, based on the novel Thes"), _c('em', [_vm._v("e ")]), _vm._v("Foolis"), _c('em', [_vm._v("h ")]), _vm._v("Thing"), _c('em', [_vm._v("s ")]), _vm._v("by Deborah Moggach. Events move along so engagingly that they sneak up on a few surprisingly touching developments, especially the payoff of Wilkinson’s story. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("India itself is a supporting character. People in other places begin to seem standardized in contrast with the brash eccentricities here, and we wonder if Dev Patel as the hotel owner possibly learned his job by watching reruns of "), _c('em', [_vm._v("Fawlty Towers. ")]), _vm._v("Let us suggest that if you were an aging Brit with a limited income and you moved into the Best Exotic Marigold Hotel, you could have done a lot worse. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a345"
    }
  }, [_vm._v("Best Worst Movie "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NO MPAA RATING")]), _vm._v(", 91 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("George Hardy, Claudio Fragasso, Margo Prey, Jason Steadman, and Darren Ewing. A documentary directed by Michael Paul Stephenson and produced by Mary Francis Groom, Brad Klopman, Jim Klopman, Jim McKeon, Lindsay Rowles Stephenson, and Michael Paul Stephenson. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("I bought the DVD of "), _c('em', [_vm._v("Troll 2 ")]), _vm._v("because a friend advised me to see it. “You’re busy,” he told me. “You don’t have time to see every bad movie. So you might as well see the worst of all time.” Yes, reader, "), _c('em', [_vm._v("Troll 2 ")]), _vm._v("has a coveted 0 percent rating on the Tomatometer: the lowestrated film ever made. A critic could become the mosthated person in fan circles by awarding it even half a star and spoiling the perfection of that zero. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I always intended to view "), _c('em', [_vm._v("Troll 2 ")]), _vm._v("but, I dunno, never found the time. Now comes "), _c('em', [_vm._v("Best Worst Movie ")]), _vm._v("to save me the trouble. This is a documentary about what happens to you when you appear in "), _c('em', [_vm._v("Troll 2. ")]), _vm._v("It stars the star of the original film, a dentist from a small town in Alabama named George Hardy. This is one nice guy. Even his exwife says so. He has a Harrison Ford head of hair and a smile so wide it’s like a toothpaste billboard. He treats poor kids for free. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("He made the movie twenty years ago when he was living in Utah. It was being directed by an Italian named Claudio Fragasso, who didn’t speaka the English but said he understood Americans better than they understood themselves. The movie was named "), _c('em', [_vm._v("Goblin, ")]), _vm._v("but then the title was changed to "), _c('em', [_vm._v("Troll 2 ")]), _vm._v("because that sounded more commercial. It is only a technicality that there was no movie named Troll"), _c('em', [_vm._v(". ")]), _vm._v("You could go out and make one, but then this would be the sequel. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("We catch glimpses of "), _c('em', [_vm._v("Troll 2 ")]), _vm._v("in "), _c('em', [_vm._v("Best Worst Movie. ")]), _vm._v("Don’t ask me to explain it. It’s about vegetarian goblins who cause their human victims to start growing branches and leaves. The special effects make the victims look like people who have tree limbs strapped to their arms with duct tape. The goblins wear homemade masks a child wouldn’t be caught dead wearing on Halloween. The budget was so small the actors had to provide their own clothes. One actor recalls a scene where it was necessary to nail his shoe to the ground. “They used my own shoe,” he moans. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("For some time, George Hardy forgot all about having made the movie. Then some of his patients started looking at him strangely and asking him if he’d appeared in this horror film they’d seen on cable. The film had been discovered and embraced by the bottomfeeders of horror film fandom, and soon Hardy found himself being invited to revivals and horror conventions. The other actors were also suddenly in demand. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("One of them, Michael Paul Stephenson, who played the kid in the movie, is the director of this documentary. Neither he nor anyone else knew what Fragasso was attempting or even if he was quite serious. One actor explains he was out on a pass from a mental institution when he was cast as the ominous store owner: “The actor they hired didn’t turn up and they said, ‘OK, you’ve got the job.’ Watching himself in a scene, he says, ‘You can see I was crazy.’” ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("If the film didn’t make much of an impression at the time, its rediscovery certainly did. The actors got standing ovations and started autographing photos, Tshirts and body parts at conventions. Claudio Fragasso himself, who looks very slightly like an embittered Fellini, attended revivals at the Nuart in Los Angeles and in Salt Lake City, and said his actors were morons then and are morons today. He adds that to make the worst film is as great an honor as making the best one. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("But there is a bittersweet ending in this curiously touching doc. Stephenson follows George Hardy to conventions where only half a dozen people attend his panel. He films him standing at the "), _c('em', [_vm._v("Troll 2 ")]), _vm._v("table at a horror exhibition, completely ignored. Hardy is reduced to drumming up business: “Have you heard of Trol"), _c('em', [_vm._v("l ")]), _vm._v("2? You haven’t? You should see it! It’stheworst movie of all time!” Depressed, he observes, “There’s a lot of gingivitis in this room.” ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("There’s something irresistible about the movies. If you’ve been the star of a famous one, that means something, doesn’t it? Even if it’s the worst? How many people get even that far? The lesson, I guess, is that you can only be the ﬂavor of the month for about thirty days, sometimes thirtyone. "), _c('em', [_vm._v("Troll 2 ")]), _vm._v("was February. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a346"
    }
  }, [_vm._v("A Better Life "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v("-13, 98 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Demian Bichir (Carlos Galindo), Jose Julian (Luis Galindo), Dolores Heredia (Anita), Joaquin Cosio (Blasco Martinez), Carlos Linares (Santiago), Gabriel Chavarria (Ramon). Directed by Chris Weitz and produced by Weitz, Jami Gertz, Paul Junger Witt, Stacey Lubliner, and Christian McLaughlin. Screenplay by Eric Eason. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Carlos is an undocumented immigrant from Mexico who works as a gardener tending the lawns of Los Angeles residents who are rich, especially from his point of view. He lives from hand to mouth and day to day in a tiny house whose garden is used to raise starter plants for the clients. His wife left some years ago, and he raises his fifteen-year-old son, Luis, by himself. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("These two men are being pulled apart by life in America. Carlos (Demian Bichir) keeps a low profile, works hard, holds traditional values. Luis (Jose Julian) hasn’t joined a gang in his neighborhood yet, but that would seem to be his trajectory. He misses school, he quietly considers his dad an irrelevant loser, and when he asks for money and there isn’t any, he knows how to get under his father’s skin: “I’ll jack a little old lady.” ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Carlos works for Blasco (Joaquin Cosio), who owns a landscaping truck and the business that goes with it. Now Blasco has enough money to return to Mexico and his own little farm, and offers to sell Carlos his truck, tools, client list—everything. But Carlos can’t get a driver’s license, and a police stop would mean deportation. His sister reluctantly lends him some money, and the next day the truck is stolen. He thinks he might be able to find the man who took it, and enlists his son to help him search in likely places. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Now the story takes on some of the shape of "), _c('em', [_vm._v("Bicycle Thieves")]), _vm._v(", the 1948 Italian neorealist classic by Vittorio de Sica. Father and son depend on the stolen truck for their existence. And in a low-key, observant way, "), _c('em', [_vm._v("A Better Life ")]), _vm._v("provides a tour of Los Angeles during the search; not the L.A. of Sunset Boulevard or Rodeo Drive, but the L.A. of restaurants where the kitchen staff is undocumented, of Mexican rodeos, of gang territory, of marginal workers who are essential to the city’s economy. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The film’s trajectory is rather predictable, but then so was the story told by "), _c('em', [_vm._v("Bicycle Thieves. ")]), _vm._v("But the performances are pitch perfect, even including Gabriel Chavarria as Ramon, the man who steals the truck. It adds an important element to the film that he embodies a desperate man, not a bad one. And when Carlos acts at a crucial moment, he is recognizing that. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The film was directed by Chris Weitz. Ring a bell? His previous film was "), _c('em', [_vm._v("The Twilight Saga: New Moon. ")]), _vm._v("Why do I imagine he was happier making this film than that one? You need to possess considerable talent to become a successful director, and his credits also include "), _c('em', [_vm._v("About a Boy ")]), _vm._v("(2002), where the boy is the one teaching life lessons to the man. In a perfect world, I imagine Weitz would rather make films like "), _c('em', [_vm._v("A Better Life ")]), _vm._v("than "), _c('em', [_vm._v("Twilight 2. ")]), _vm._v("Of course, that’s only a guess. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a347"
    }
  }, [_vm._v("The Big Uneasy "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NO MPAA RATING")]), _vm._v(", 98 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Harry Shearer, Maria Garzino, Ivor Van Heerden, Robert Bea, John Goodman, and the voices of Brad Pitt, Jennifer Coolidge, Wendell Pierce, and Will Lyman. A documentary directed by Harry Shearer. Screenplay by Shearer. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("What Hurricane Katrina did to New Orleans was not an act of God, a “natural disaster,” or a failure by FEMA. It was the almost inevitable result of years of incompetent and dangerous work by the Army Corps of Engineers, which then used its power to cover its ass. That is the message, much repeated, in Harry Shearer’s documentary "), _c('em', [_vm._v("The Big Uneasy. ")])]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Using soil and ﬂoodcontrol experts, Google maps, new footage, and damning video, Shearer builds a compelling case against the corps’s ﬂawed planning and leaky levees. I was convinced. Unfortunately, I was also convinced that trapped within this ninetyeightminute film is a good thirtyminute news report struggling to get out. Shearer, who is a bright and funny man, comes across here as a solemn lecturer. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("His facts are depressing. The Army Corps constructed levees on sand that was water permeable and unable to hold concrete walls in place under the pressure of ﬂood waters. He shows large sections of levees not “breeched,” as we were told, but actually pushed aside by the ﬂooding. He documents—with the aid of a corpswoman whose whistleblowing was disregarded at the time—that pumps installed to handle ﬂood waters were inadequate and malfunctioning. He shows that the lovely city was set up for destruction, and that with wiser planning it might have suffered no worse than “wet ankles.” Incredibly, we learn that one of the contractors whose company was constructing the levees even went into court to argue the corps’s plans were ﬂawed—and lost. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("His view of the army engineers is thoroughly depressing. Far from welcoming advice and analysis from academic experts, they installed barbedwire fences to block their access to crucial areas. They spent more than $1 million on a public relations campaign to repair their image. They were responsible directly or indirectly for the firing, demotion, or silencing of many of their critics. They stand indicted—and, Shearer says, their similar mistakes may mean the city of Sacramento is vulnerable to ﬂood damage on a similar scale. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("This is important and needs to be made known. Unfortunately, Shearer as a documentarian is not the right man for the job. The Bi"), _c('em', [_vm._v("g ")]), _vm._v("Uneas"), _c('em', [_vm._v("y ")]), _vm._v("lacks the dramatic impact and artistic imagination of many recent docs about environmental issues. An attempt to liven things up by shoehorning John Goodman into the action fails, when he appears out of any context to introduce awkward segments in which Shearer and other New Orleans residents answer criticisms of their city. Th"), _c('em', [_vm._v("e ")]), _vm._v("Bi"), _c('em', [_vm._v("g ")]), _vm._v("Uneas"), _c('em', [_vm._v("y ")]), _vm._v("plays way too much like an educational film. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a348"
    }
  }, [_vm._v("The Big Year "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v(", 102 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Steve Martin (Stu Preissler), Jack Black (Brad Harris), Owen Wilson (Kenny Bostick), Brian Dennehy (Raymond), Anjelica Huston (Annie Auklet), Rashida Jones (Ellie), Rosamund Pike (Jessica), Dianne Wiest (Brenda), JoBeth Williams (Edith). Directed by David Frankel and produced by Stuart Cornfeld, Carol Fenelon, Curtis Hanson, Karen Rosenfelt, and Ben Stiller. Screenplay by Howard Franklin, based on the book by Mark Obmascik. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Birders. You call them birders. Calling them “birdwatchers” is insulting, like calling a Trekker a Trekkie. They are aware that some people find birding to be an eccentric hobby, but you get better exercise and scenery than you do with golf, and you don’t have to play the game. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I had no idea there was such a thing as competitive birdwatching, but "), _c('em', [_vm._v("The Big Year ")]), _vm._v("assures us there is. An annual award goes to the birder who sees the most species in a year. They will not conveniently ﬂutter before your eyes. You have to look hard for them. In championshiplevel birding, this is known as having a Big Year. Is there nothing left in our society that isn’t competitive? Would you believe the winners score above seven hundred? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("The Big Year ")]), _vm._v("is about such a year, involving Kenny Bostick (Owen Wilson), the defending champion, and two others who are trying to sprinkle salt on his tail: Brad Harris (Jack Black) and Stu Preissler (Steve Martin). If you know the actors you know the characters, especially Bostick, who is the standardissue Owen Wilson, a smooth-talking master of oneupmanship. Jack Black plays his usual overenthusiastic bumbler, and Steve Martin seems always in a zone of intense earnestness. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("You must have to be wealthy to do a Big Year. Bostick, for example, seems permanently on leave from his job as a CEO. You spend all of your time frantically chasing down rumors of rare bird sightings in remote locations, of which the most remote is an island in the Aleutians that is closer to Tokyo than Anchorage. There’s apparently a nice little tourist trade. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The comedy involves Bostick’s dirty tricks, camaraderie among the others, various romances in the field, other peculiar birders, and evidence that marriage to a birder, as we might suspect, is no easy task. The film is always somewhere going somewhere else, and while the characters are spotting birds, we can spot actors: Kevin Pollak, Tim Blake Nelson, Rashida Jones, Anjelica Huston, Zahf Paroo, Rosamund Pike, Joel McHale, JoBeth Williams, Paul Campbell, Brian Dennehy, and even Al Roker. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("There is some great bird photography here. I wish there had been more. I think I may have seen Jack Black falling down enough for this lifetime. The movie is getting the enthusiastic support of the Audubon Society, and has an innocence and charm that will make it appealing for families, especially those who have had enough whales and dolphins for the year. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a349"
    }
  }, [_vm._v("Bill Cunningham New York "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NO MPAA RATING")]), _vm._v(", 84 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Bill Cunningham, Tom Wolfe, Anna Wintour, Carmen Dell’Orefice, Annette de la Renta, John Kurdewan, Iris Apfel, Josef Astor, Editta Sherman, Anna Piaggi, Shail Upadhya, and Thelma Golden. A documentary directed by Richard Press and produced by Philip Gefter. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Here is a movie about a happy and nice man. Bill Cunningham was lucky to find what he loves to do, and do it, and win universal affection from all who know him, and to make a contribution to our lives and times. Doing what he loves is very nearly "), _c('em', [_vm._v("all ")]), _vm._v("he does, except to sleep and eat. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Ever since reading Thoreau’s "), _c('em', [_vm._v("Walden ")]), _vm._v("I have been teased by the notion of leading a life with only the bare essentials of life and peacefulness. I lacked the nerve to find that little cottage and plant those rows of beans. Bill Cunningham lives a life as pure and idealistic as Thoreau, and he does it in the middle of Manhattan. Until a couple of years ago, when he was evicted by the landlord, Bill lived in a tiny rentcontrolled apartment in Carnegie Hall. Yes, Carnegie Hall, in one of the artists’studios on the upper ﬂoors set aside when greed didn’t decide everything. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Bill celebrates his eightieth birthday in the movie. Every day of his life he still pedals around Manhattan on his bicycle, taking photographs of what people are wearing. He has been famous for many years for doing this, and his work has been featured in such places as "), _c('em', [_vm._v("Women’s Wear Daily")]), _vm._v(", "), _c('em', [_vm._v("Vogue")]), _vm._v(", and the original "), _c('em', [_vm._v("Details ")]), _vm._v("magazine, which once devoted forty-one pages to a portfolio. These days you can find him featured in big spreads in the "), _c('em', [_vm._v("New York Times")]), _vm._v(", whose publisher, Arthur Sulzberger, was among those at his birthday party. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Do not make the mistake of calling Bill Cunningham a “fashion photographer.” He is a photographer of people and what they wear. Don’t call him a “paparazzo.” He doesn’t know who half the celebrities are, and doesn’t care. He’s genuinely fascinated by what people wear—not by haute couture, but by what makes people feel good about themselves. He cycles to social events and openings, to street fairs and parades, to parks and markets, and will stop in the middle of the street if he spots an interesting hat. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Sometimes his photos don’t even show faces. “I’ve always loved clothes,” he says. And shoes. And individualistic looks. Fashion editors study his work because he seems to be early to notice a developing trend. In Bill’s view, fashion begins with creative individuals and not “tastemakers,” and he is as interested in Tshirts as evening wear. It’s not that he’s a snob about the high and mighty; it’s that he’s sincerely affectionate about whatever people wear and whoever they are. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Bill lives the life of a monk. His Carnegie Hall apartment was so filled with file cabinets of his decades of negatives that there was literally nothing else there but a mattress on top of some files. No kitchen. Bathroom down the hall. When he was relocated to another rentcontrolled apartment overlooking Central Park, he had the landlord remove the kitchen appliances to make room for more filing cabinets. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("“Who needs a kitchen?” he asks. And yet here is a man who never tastes the free food and drink at so many of the functions he covers. That would be crossing some line in his mind. Nor, despite his life of the love of clothing, does he own many clothes. He dresses in black tie when the job requires it, but otherwise always wears one of the cheap blue smocks he finds in Paris—the ones garbagemen wear—because they have lots of pockets for his film. He works pretty much all day every day, taking off a little time every Sunday to attend Mass. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Cunningham is vague about his life. He seems to have all the money he needs, but he didn’t come from a rich family. Richard Press, the director of this documentary, asks: “You don’t need to answer this, but, have you ever had a romantic relationship?” Bill is delighted by the question, and laughs spontaneously: “Are you asking if I’m gay?” He doesn’t say if he is or not, but his reply seems to suggest that he wasn’t raised to think much about sex, and doesn’t. He loves his work too much. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I mentioned his laugh. This is a man who seems always delighted. He smiles and laughs warmly and easily. Does that make him sound simple? There is nothing simple about Bill Cunningham, who is an artist and a philosopher. Here’s what it is: Bill is happy. He has invented an occupation he does better than anyone else ever has, he has simplified his life until nothing interferes with that vocation, and now, at over eighty, he is still biking around Manhattan in his blue smock of many pockets and taking photos of people who had a little extra fun when they got dressed today. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("It doesn’t matter if you care nothing at all about clothing, fashion, or photography. You might still enjoy "), _c('em', [_vm._v("Bill Cunningham New York, ")]), _vm._v("because here is a good and joyous man who leads a life that is perfect for him, and how many people do we meet like that? This movie made me happy every moment I was watching it. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a350"
    }
  }, [_vm._v("Birdwatchers "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NO MPAA RATING")]), _vm._v(", 102 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Claudio Santamaria (Roberto), Alicelia Batista Cabreira (Lia), Chiara Caselli (Beatrice), Abrisio da Silva Pedro (Osvaldo), Ademilson Concianza Verga (Ireneu), Ambrosio Vilhalva (Nadio), Fabiane Pereira da Silva (Maria), Leonardo Medeires (Lucas Moreira). Directed by Marco Bechis and produced by Bechis, Caio Gullane, Fabiano Gullane, and Amedeo Pagani. Screenplay by Bechis and Luiz Bolognesi. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("There’s an opening overhead shot of the Brazilian rain forest, dense and limitless. As a tourist boat slides along a river, native Indians materialize on the banks to regard it reproachfully. They hold bows and arrows and don’t seem fond of these visitors. But hold on; one of the young men has a layered haircut with the top blond. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("As recently as the 1970s, when Herzog filmed "), _c('em', [_vm._v("Aguirre ")]), _vm._v("in such a forest, these Indians would have been “real.” But the time is the present and the forest a preserved facade shielding fields, which have been stripped of trees and devoted to farming. The Indians can, if they want, pile into the back of a truck and hire out as day laborers. But all of their traditions center on the forest and its spirits, and this new life is alienating. Some simply commit suicide. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("This is all true, as we have been told time and again, and meanwhile the Brazilian government remains benevolent toward the destruction of the planet’s richest home of life forms and its crucial oxygen source. Indians have been stripped of ownership of their ancestral lands and assigned to reservations far from the bones of their parents; it is the same genocide the United States practiced, for those with power have not developed a conscience in the years since. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Marco Bechis’s "), _c('em', [_vm._v("Birdwatchers ")]), _vm._v("is a groundlevel drama involving a group of Indians that packs up one day, leaves “their” federal land, and builds shelters of tree limbs and plastic sheets on farmland that once was their tribe’s. This goes down badly with the farmer, who with his family lives in a spacious home with a pool and (Indian) servants. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The film portrays the descendants of colonialists very broadly; its strength is in the directness of the performances by Indians. I assume their performances are informed by actual life experience, because Bechis shot on location with local nonactors. They’re cohesive in the group, grow depressed when separated from it, are attuned to spirit omens (or believe they are, which amounts to the same thing). Without conversational preludes, they say bluntly what they mean:“I want to be with you, you’re a big dick man, you must leave here and never return.” ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("This doesn’t mean they lack subtlety. It means they keep a lot of things to themselves. We follow two adolescent boys, Osvaldo (Abrisio da Silva Pedro) and Ireneu (Ademilson Concianza Verga), the first the son of the leader, the second he of the haircut and a yearning for sneakers. The leader, Nadio (Ambrosio Vilhalva), is strong enough to lead the group onto the farmlands, enforce discipline, and deal with many newcomers. But he’s an alcoholic, his booze happily supplied by a merchant who controls them by giving credit. Shades of the company store. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Sex is in the air. The farmer’s teenage daughter, in a bikini, and one of the boys, in a loincloth, begin meeting at the river, he to collect water, she to swim, and although they don’t get very far, an intriguing tension is there between them. On both sides there is the allure of unfamiliarity. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The group is chronically low on food and funds, and Nadio correctly realizes that day labor is a form of bondage. He begins to call his followers “the movement.” Sooner or later there will be a clash and there is, but one that unfolds in a way unique to these people. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Birdwatchers ")]), _vm._v("is impressively filmed and never less than interesting. If it has a weakness, it’s that this is a familiar sermon: Save the rain forest. Respect its inhabitants. Bechis and his cowriter, Luiz Bolognesi, don’t really develop the characters much beyond their functions. But the reality of the Indians and the locations adds its own strength. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Note: I learn from the press notes that the Europeansounding sacred music was composed by Domenico Zipoli, an Italian Jesuit who lived with this same Guarani tribe in the 1700s. ")])]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a351"
    }
  }, [_vm._v("Biutiful "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 148 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Javier Bardem (Uxbal), Maricel Alvarez (Marambra), Eduard Fernandez (Tito), Diaryatou Daff (Ige), Cheng Tai Shen (Hai), Luo Jin (Liwei). Directed by Alejandro Gonzalez Inarritu and produced by Inarritu, Fernando Bovaira, and Jon Kilik. Screenplay by Gonzalez Inarritu, Armando Bo, and Nicolas Giacobone, based on a story by Inarritu. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Alejandro Gonzalez Inarritu’s "), _c('em', [_vm._v("Biutiful ")]), _vm._v("stars Javier Bardem as a lowlevel criminal in Barcelona who is told by his doctor he has very little time to live. He works as a middleman in an industry that makes fake luxury items in sweatshops and sells them to tourists through sidewalk vendors. You’ve seen the Gucci bags lined up on pavements. He’s also involved in importing and housing the undocumented Chinese workers who exist in poverty and manufacture the items. Both fake Gucci and real Gucci are made by poor people, but the real Guccis are made in China. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Uxbal’s life is a mess. He is separated from his bipolar wife. He tries to care for the sons he loves. He is under urgent pressure from his criminal associates. He sees after the living conditions of his illegal immigrants. There is blood in his pee. He works in crime but is not a bad man, and indeed under sentence of death he is moved, like the hero of Kurosawa’s "), _c('em', [_vm._v("Ikiru")]), _vm._v(", to try to do something good. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("One gesture he makes ends in tragic consequences. His workers are cold in their crowded basement, and he tries to alleviate that. He also tries to make some money in the process. He’s devastated. Surely few actors have faces that project sorrow more completely than Bardem. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Gonzalez Inarritu follows Uxbal’s last days with great intimacy, burying his camera in the seamy street life Uxbal lives, introducing many characters in sharp and colorful relief. He grants his characters the dignity of having feelings and reasons, and not simply behaving as mechanical inhabitants of a crime plot. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The moral sense of the film is heartfelt, but not especially daring; by giving us a good man as his hero, Gonzalez Inarritu possibly weakens his case against the general sense of injustice in his film. Uxbal is so wholly sympathetic that it’s hard for us to assign blame for his sins, and yet surely they are sins. Perhaps the idea is that he inhabits a world so lacking in goodness that his possibilities for choice are limited. Everyone he comes into contact with is ﬂawed, with the exception of his children and Ige (DiaryatouDaff), a Senegalesewoman he hires as a nanny for his children. And her love for them (and to a degree for him) is warm but almost obligatory in a story of this sort; one more unworthy character would be unthinkable. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("What drew me into the film and engaged my sympathy was the presence of Bardem himself. He is a vastly human actor. He can be handsome, ugly, hard, tender, or a monster (as he was in "), _c('em', [_vm._v("No Country for Old Men")]), _vm._v("). Here he suffers, and is good, and suffers partly simply because he cannot do good things. That isn’t a complex message, but I see films every day like "), _c('em', [_vm._v("The Mechanic ")]), _vm._v("that will entertain millions with cold, amoral violence, and sometimes it’s good to simply see a man who cares about the consequences of his actions. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a352"
    }
  }, [_vm._v("Black Swan "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 108 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Natalie Portman (Nina Sayers), Vincent Cassel (Thomas Leroy), Mila Kunis (Lily), Barbara Hershey (Erica Sayers), Winona Ryder (Beth MacIntyre). Directed by Darren Aronofsky and produced by Scott Franklin, Mike Medavoy, Arnold Messer, and Brian Oliver. Screenplay by Mark Heyman, Andrew Heinz, and John McLaughlin. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Darren Aronofsky’s "), _c('em', [_vm._v("Black Swan ")]), _vm._v("is a full-bore melodrama, told with passionate intensity, gloriously and darkly absurd. It centers on a performance by Natalie Portman that is nothing short of heroic, and mirrors the conﬂict of good and evil in Tchaikovsky’s "), _c('em', [_vm._v("Swan Lake. ")]), _vm._v("It is one thing to lose yourself in your art. Portman’s ballerina loses her mind. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Everything about classical ballet lends itself to excess. The art form is one of grand gesture, of the illusion of triumph over reality and even the force of gravity. Yet it demands from its performers years of rigorous perfectionism, the kind of physical and mental training that takes ascendancy over normal life. This conﬂict between the ideal and the real is consuming Nina Sayers, Portman’s character. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Her life has been devoted to ballet. Was that entirely her choice? Her mother, Erica (Barbara Hershey), was a dancer once, and now dedicates her life to her daughter’s career. They share a small apartment that feels sometimes like a refuge, sometimes like a cell. They hug and chatter like sisters. Something feels wrong. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Nina dances in a company at Lincoln Center, ruled by the autocratic Thomas Leroy (Vincent Cassel). The reach of his ego is suggested by his current season, which will “reimage” the classics. Having cast off his former prima ballerina and lover, Beth MacIntyre (Winona Ryder), he is now auditioning for a new lead. "), _c('em', [_vm._v("Swan Lake ")]), _vm._v("requires the lead to play opposite roles. Nina is clearly the best dancer for the White Swan. But Thomas finds her too “perfect” for the Black Swan. She dances with technique, not feeling. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The film seems to be unfolding along lines that can be anticipated: There’s tension between Nina and Thomas, and then Lily (Mila Kunis), a new dancer, arrives from the West Coast. She is all Nina is not: bold, loose, confident. She fascinates Nina, not only as a rival but even as a role model. Lily is, among other things, a clearly sexual being, and we suspect Nina may never have been on a date, let alone slept with a man. For her Lily presents a professional challenge and a personal rebuke. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Thomas, the beast, is well known for having affairs with his dancers. Played with intimidating arrogance by Cassel, he clearly has plans for the virginal Nina. This creates a crisis in her mind: How can she free herself from the technical perfection and sexual repression enforced by her mother, while remaining loyal to their incestuous psychological relationship? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("No backstage ballet story can be seen without "), _c('em', [_vm._v("The Red Shoes ")]), _vm._v("(1948) coming into mind. If you’ve never seen it, of course eventually you will. In the character of Thomas, Aronofsky and Cassel evoke Boris Lermontov (Anton Walbrook), the impresario in that film, whose autocratic manner masks a deep possessiveness. And in Nina there is a version of Moira Shearer’s ingénue, so driven to please. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Black Swan ")]), _vm._v("will remind some viewers of Aronofsky’s previous film, "), _c('em', [_vm._v("The Wrestler. ")]), _vm._v("Both show singleminded professionalism in the pursuit of a career, leading to the destruction of personal lives. I was reminded also of Aronofsky’s brilliant debut with "), _c('em', [_vm._v("Pi ")]), _vm._v("(1998), about a man driven mad by his quest for the universal mathematical language. For that matter, his "), _c('em', [_vm._v("The Fountain ")]), _vm._v("(2007) was about a man who seems to conquer time and space. Aronofsky’s characters make no little plans. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The main story supports of "), _c('em', [_vm._v("Black Swan ")]), _vm._v("are Rea (Mackinley), Magaly Solier (Yana), traditional: backstage rivalry, artistic jealousy, a great work of art mirrored in the lives of those performing it. Aronofsky drifts eerily from those reliable guidelines into the mind of Nina. She begins to confuse boundaries. The film opens with a dream, and it becomes clear that her dream life is contiguous with her waking one. Aronofsky and Portman follow this fearlessly where it takes them. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Portman’s performance is a revelation from this actress who was a thirteen-year-old charmer in "), _c('em', [_vm._v("Beautiful Girls ")]), _vm._v("(1996). She has never played a character this obsessed before, and never faced a greater physical challenge (she trained for ten months). Somehow she goes over the top and yet stays in character: Even at the extremes, you don’t catch her acting. The other actors are like dance partners holding her aloft. Barbara Hershey provides a perfectly calibrated performance as a mother whose love is real, whose shortcomings are not signaled, whose own perfectionism has all been focused on the creation of her daughter. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The tragedy of Nina, and of many young performers and athletes, is that perfection in one area of life has led to sacrifices in many of the others. At a young age everything becomes focused on pleasing someone (a parent, a coach, a partner), and somehow it gets wired in that the person can "), _c('em', [_vm._v("never ")]), _vm._v("be pleased. One becomes perfect in every area except for life itself. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("It’s traditional in many balletbased dramas for a summingup to take place in a bravura third act. "), _c('em', [_vm._v("Black Swan ")]), _vm._v("has a beauty. All of the themes of the music and life, all of the parallels of story and ballet, all of the confusion of reality and dream come together in a grand exhilaration of towering passion. There is really only one place this can take us, and it does. If I were you, I wouldn’t spend too much time trying to figure out exactly what happens in practical terms. Lots of people had doubts about the end of "), _c('em', [_vm._v("The Red Shoes, ")]), _vm._v("too. They were wrong, but they did. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a353"
    }
  }, [_vm._v("Blackthorn "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 98 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Sam Shepard (Blackthorn [Butch Cassidy]), Eduardo Noriega (Eduardo Apodaca), Stephen Dominique McElligott (Etta Place), Nikolaj Coster-Waldau (Young James), Padraic Delaney (Sundance Kid). Directed by Mateo Gil and produced by Ibon Cormenzana and Andrews Santana. Screenplay by Miguel Barros. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("There is a list of people whose deaths remain “unresolved.” Jimmy Hoffa. Butch Cassidy and the Sundance Kid. Judge Crater. Amelia Earhart. B. Traven. They all must be dead by now anyway, but we have a need for closure. Such cases also provide an excellent inspiration for movies. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The test of these movies is simple enough: If they were about fictional people, would they be worth seeing? Sometimes the answer is yes, as in several tales about the alleged later life of Sherlock Holmes. I know, I know, he was never alive in the first place, but give me a break here. In the case of Butch and the Kid, how many people had even heard of them before the 1969 movie? In it there was the possibility that they escaped to Bolivia, and that’s where "), _c('em', [_vm._v("Blackthorn ")]), _vm._v("joins Butch in old age, circa 1928. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Played by Sam Shepard, who may be the most photogenic of modern playwrights, he inhabits an isolated horse ranch in a sere landscape and shares the company of the comely Yana (Magaly Solier). But memories of past glory fill him with thoughts about a return to America, where a son may live who would be his child with Etta Place—or with the Kid, if you follow me. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("He cashes in all his money and sets off across the Bolivian vastness on horseback, where he’s waylaid by Eduardo (Eduardo Noriega), a mining engineer. Butch’s net worth was stashed in the saddlebags of his horse, which runs away, making him rather hard to steal from. Butch knows that this Eduardo may have stolen the fortune of a local millionaire, and Eduardo leads him on what is possibly a wild goose chase down into the abandoned mine where it’s perhaps hidden. What Eduardo needs is protection from the millionaire’s men, who are following him. Meanwhile,   they’re trailed by a man who is either the most stubborn or the most foolish of Pinkerton agents, Mackinley (Stephen Rea), who has allegedly been tirelessly tracking Butch for twenty years. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("This story is well-acted by Shepard, whom I a scene in the film that has details I’m pretty have never seen unconvincing. There’s a dash of Kris Kristofferson in his performance, as when he ambles through the country singing rusty old songs like “Sam Hall” (“Damn your eyes!”). The cinematography is breathtaking; we rarely see Bolivia in Westernstyle films, and the way it looks here might have convinced John Ford to move on from Monument Valley. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("But the movie as a whole isn’t much. Flashbacks to the good old days, with Nikolaj Coster-Waldau and Padraic Delaney standing in for Paul Newman and Robert Redford, are unconvincing and without much purpose, and given the moral twistiness of the original story, this rehash seems to lack purpose. Butch has grown old? And homesick? And gets waylaid, and is back in action again? Was this trip necessary? The first-time director is Mateo Gil, known for the screenplays of "), _c('em', [_vm._v("Open Your Eyes")]), _vm._v(", "), _c('em', [_vm._v("The Sea Inside")]), _vm._v(", and "), _c('em', [_vm._v("Agora. ")]), _vm._v("Ironic, that the film’s weakness is its screenplay. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a354"
    }
  }, [_vm._v("Blood Done Sign My Name "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v("-13, 128 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Rick Schroder (Vernon Tyson), Nate Parker (Ben Chavis), Nick Searcy (Robert Teel), Lela Rochon (Roseanna Allen), Afemo Omilami (Golden Frinks), Darrin Dewitt Henson (Eddie McCoy), Michael Rooker (Billy Watkins), Gattlin Griffith (Tim Tyson). Directed by Jeb Stuart and produced by Mel Efros, Jeb Stuart, and Mari Stuart. Screenplay by Jeb Stuart, based on the book by Tim Tyson. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("In 1970 in Oxford, North Carolina, it was perfectly possible for a young black man to be beaten and clubbed by three whites, and shot dead by one of them. And for an allwhite jury to hear from two eyewitnesses, and watch the white defendant’s young son break down in tears and confess his testimony had been forced on him by his father’s lawyers. And for the jury to vote unanimously that the white man was not guilty. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Blood Done Sign My Name")]), _vm._v(" tells the story of that murder, and how it was a catalyst for change in Oxford and in the lives of those who lived there. It’s based on a memoir by the son of a liberal white Methodist preacher, and there’s sure the son witnessed when he was a boy. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("His father said he wanted to show him something. They crept behind a rock and observed a Ku Klux Klan meeting. A cross was being erected. “It’s a revival!” young Tim Tyson said. “No, it’s not a revival,” his father said, and that night they watched the cross being burned. The part I believe he remembers was this: The whole event was treated as a family picnic, with kids playing and mothers unpacking picnic hampers, and the sickness of racism almost "), _c('em', [_vm._v("looking ")]), _vm._v("like a revival. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The film tells two parallel stories. One involves a young black man who graduates from college and comes home to Oxford to teach at a black high school (black, although the schools had in theory been integrated). This is Ben Chavis (Nate Parker), who later became the president of the NAACP. The other is Vernon Tyson (Rick Schroder), the minister, who lost his congregation because of his liberal views, but found other churches in North Carolina and retired only recently. His son, Tim, went on to become a scholar of African-American studies and now teaches at Duke. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I go into biographical details because the events in 1970 are clearly remembered by Chavis and the younger Tyson as the turning points in their lives. The civil rights movement sent Golden Frinks (Afemo Omilami), an “outside agitator,” to Oxford to organize the black community after the murder. He led a historic march fifty miles from Oxford to Raleigh, the state capital, where the governor refused to meet with the marchers—but the point had been made. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Unlike a more conventional film, "), _c('em', [_vm._v("Blood Done Sign My Name ")]), _vm._v("doesn’t end with the courtroom verdict. It starts there, as Chavis leads an economic boycott of stores that took black dollars and valued black customers but hired no blacks in a county that was 40 percent African-American. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The movie tells this story in a traditional, straightforward way. No fancy footwork. No chewing the scenery. Meat and potatoes, you could say, but it’s thoughtful and moving. The writer and director, Jeb Stuart, focuses on the events and people and lets them speak for themselves. He uses a level, unforgiving gaze. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Apart from the Oxford racists, his only major white characters are the minister and his family. And they’re rather remote from the turmoil. Rev. Tyson invites the president of a black college to speak to his congregation, which clears out half the Christians pretty quickly, and then his son recorded these momentous days in his book. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Ben Chavis is energized and angered, but it’s clear the prime mover was Golden Frinks, also a real man, whose full-time job, you could say, was outside agitating. The day of the trial, he tells Chavis he’s on his way to another town: “It’s up to you now.” And that’s what happened, essentially: The civil rights marchers led the way for the rise of a black middle class in the South. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("In the opening scenes of the film, you assume the stories of Chavis and the Tyson family will connect. They don’t. Each man undoubtedly knew about the other, but they were on paths that didn’t intersect. I guess that’s the way it was. By the time Oxford began to change, Rev. Tyson had an African-American congregation elsewhere in the state. One story at a time, things change. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Those born in 1970 will be forty this year. The acquittal of white racists by allwhite juries is no longer the Southern routine. It took unpopular and courageous actions by a lot of people to bring about that change, and it is not yet complete. But it happened, and I think Tim Tyson, who isn’t fifty yet, wrote his book to say it happened. If you know how to look, history doesn’t take place too fast to be seen. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a355"
    }
  }, [_vm._v("Blue Valentine "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 120 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Ryan Gosling (Dean), Michelle Williams (Cindy), Faith Wladyka (Frankie), Mike Vogel (Bobby), John Doman (Jerry), Ben Shenkman (Dr. Feinberg), Jen Jones (Gramma), Maryann Plunkett (Glenda). Directed by Derek Cianfrance and produced by Lynette Howell, Alex Orlovsky, and Jamie Patricof. Screenplay by Cianfrance, Joey Curtis, and Cami Delavigne. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Who was it who said we get married because we want a witness to our lives? That may provide an insight into the troubled minds of the married couple in "), _c('em', [_vm._v("Blue Valentine")]), _vm._v(", which follows them during their first six years of mutual witness. Did Dean and Cindy get married because they wanted to be sure someone was watching? Or was that Dean’s need, and did Cindy lose the thrill of the watch? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Here is a film that watches pretty well itself. Derek Cianfrance, the director, observes with great exactitude the birth and decay of a relationship. This film is alive in its details. Toward the end of the six years, when Cindy is hardly able to remember why she wanted to marry Dean, Cianfrance observes the physical and mental exhaustion that have overcome her. And the way that Dean seems hardly to care—just so long as Cindy remains his wife and his watcher, which in his mind was the deal. Dean thinks marriage is the station. Cindy thought it was the train. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("They’re played by Ryan Gosling and Michelle Williams as a Pennsylvania working couple with a daughter, Frankie. She was born right at the start. Cindy is a nurse. Dean is a house painter. When they met, and for some time after, work was hardly central to their lives. It was where they went to and where they returned from. In effective physical transformations, Williams and Gosling give us Dean and Cindy at two ages: their age at present, and at the beginning, when they were filled with that dreamy knowledge that the touch of the other brings quick sensuality. It is easier for an actor to play the same character at twenty-four and sixty than at twenty-four and thirty. Although some bodily change takes place, what really happens is a transformation of inner certainty. Williams plays a woman who sits inside her body and no longer knows what it’s for and what she wants to do with it. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("All marriages have legendary milestone moments, events of startling clarity that allow the new lovers to see themselves as a couple that has been defined. Dean is capable of grand, goofy romanticism, and Cindy likes that. She yearns toward it. They first meet at her grandmother’s retirement home. Have you ever had one of those chance meetings with a stranger in a place neither one of you belongs? A space empty of your lives, so that you start new with your first conversation, and plunge straight ahead into a suddenly new future? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("That’s what it’s like that day. Soon they’re playing at this new toy, their love. They do things together as if they were children doing them. Then they get married and have (the unplanned but welcomed) Frankie, and the realities of making a living and work schedules and child raising and "), _c('em', [_vm._v("real ")]), _vm._v("marriage settle in. Dean seems stuck. He seems to stay fixed at the initial stage. Can you see the difference between (1) “He loves me as much as he always did,” and (2) “He loves me exactly like he always did”? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Blue Valentine ")]), _vm._v("moves between past and present as if trying to remember what went wrong. From Dean’s point of view, maybe nothing did. He wanted to be married to Cindy, and he still does and he still is. Cindy can’t stand that. He never signed off on the “grow old along with me” part. He doesn’t think the best is yet to be. He thinks it’s just fine now. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Williams plays Cindy as a woman who has lost her pride of body and self. No, she doesn’t become a drunk—he’s the one who drinks too much. But that’s not the problem. It’s his infuriating inability to care for this Cindy, right here, right now, because when she married him she became exactly the Cindy he required. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I wonder what kind of script conferences Cianfrance had with his cowriters, Joey Curtis and Cami Delavigne. They were writing about something ineffable, a void, a need. This wasn’t a story with convenient hooks involving things like, you know, disease—things stories are familiar with. It was about inner defeat and the exhaustion of hope. I’ve read reviews saying Cianfrance isn’t clear about what went wrong as they got from there to here. Is anybody? ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a356"
    }
  }, [_vm._v("The Book of Eli "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 118 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Denzel Washington (Eli), Gary Oldman (Carnegie), Mila Kunis (Solara), Ray Stevenson (Redridge), Jennifer Beals (Claudia), Frances de la Tour (Martha), Michael Gambon (George). Directed by the Hughes brothers and produced by Broderick Johnson, Andrew A. Kosove, Joel Silver, and David Valdes. Screenplay by Gary Whitta. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("I’m at a loss for words, so let me say these right away: The Book o"), _c('em', [_vm._v("f ")]), _vm._v("El"), _c('em', [_vm._v("i ")]), _vm._v("is very watchable. You won’t be sorry you went. It grips your attention, and then at the end throws in several WTF! moments, which are a bonus. They make everything in the entire movie impossible and incomprehensible—but, hey, WTF. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Now to the words I am at a loss for. The story involves a lone wanderer (Denzel Washington) who wears a name tag saying, “Hi! My name is Eli.” It may not be his name tag, but let’s call him Eli anyway. Eli has been walking west across the devastated landscape of America for thirty years, on his way to the sea. I haven’t walked it myself, but I’m pretty sure it doesn’t take that long. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("On the other hand, maybe Eli only thought he was walking west. On his final trek, he walks from right to left across the screen, which in movie shorthand is walking east. “How do you know you’re walking the right way?” he’s asked. “Faith,” he says, a reply that takes on added resonance later in the film. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Eli is a quick hand with knives, pistols, riﬂes, shotguns, and karate. He needs to be. After a catastrophe has wiped out most of the earth’s population and left ruin and desolation behind, the remaining humans are victimized by roaming motorcycle gangs of hijackers and thieves. These gangs are each issued with a perquisite tall bald man, a short hairy scruffy one, and their gofers. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The Hughes brothers, Albert and Allen, film this story in sunburned browns and pale blues, creating a dry and dusty world under a merciless sky. Water is treasure. This wasteland Eli treks at an implacable pace. Set upon in an ambush, he kills all his attackers. He’s got one of those knives that makes a “snickersnack” noise all by itself, and is a oneman army. Why don’t the bad guys just shoot at him? Later in the film, they try that. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Denzel and the Hughes brothers do a good job of establishing this man and his world, and at first "), _c('em', [_vm._v("The Book of Eli ")]), _vm._v("seems destined to be solemn. But then Eli arrives at a Western town ruled by Carnegie (Gary Oldman), who, like all the local overloads in Westerns and gangster movies, sits behind a big desk ﬂanked by a tall bald guy and of course a short scruffy one. How are these guys recruited?“Wanted: Tall bald guy to stand behind town boss and be willing to sacrifice life. All the water you can drink.” ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("In this town, desperate and starving people live in rusty cars and in the streets. We meet Carnegie’s abused wife, Claudia (Jennifer Beals), and her daughter, Solara (Mila Kunis), named for some reason after the cause of all the destruction. She’s a prostitute in Carnegie’s bar, having made the mistake of coming on Take Your Child to Work Day. Carnegie hurts Claudia to control Solara. How he controls the fearsome bald guy is hard to say. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The third act is recycled, but done well, out of many Westerns in which the hero and the girl hole up and are surrounded. So many other movies are quoted that we almost miss it when their hideout house is perforated by bullets, "), _c('em', [_vm._v("L.A. Confidential ")]), _vm._v("style. That allows countless beams of sunlight to shine in and function as a metaphor. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Carnegie needs Eli because Eli has maybe the last remaining copy of a book that Carnegie believes will allow him to expand and rule many more towns. I am forbidden by the Critic’s Little Rule Book from naming the volume, but if you’ve made a guess after seeing numerous billboards stating “Religion Is Power,” you may have guessed right. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The Hughes brothers have a vivid way with imagery here, as in their earlier films such as "), _c('em', [_vm._v("Menace II Society ")]), _vm._v("and the underrated "), _c('em', [_vm._v("From Hell. ")]), _vm._v("The film looks and feels good, andWashington’s performance is more uncanny the more we think back over it. The ending is “ﬂawed,” as we critics like to say, but it’s so magnificently, shamelessly, implausibly ﬂawed that (a) it breaks apart from the movie and has a life of its own, or (b) at least it avoids being predictable. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Now do yourself a favor and don’t talk to "), _c('em', [_vm._v("anybody ")]), _vm._v("about the film if you plan to see it. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a357"
    }
  }, [_vm._v("The Bounty Hunter "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v("-13, 110 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Jennifer Aniston (Nicole Hurly), Gerard Butler (Milo Boyd), Christine Baranski (Kitty Hurley). Directed by Andy Tennant and produced by Neal H. Moritz. Screenplay by Sarah Thorp. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("I’m on the brink of declaring a new entry for Ebert’s Little Movie Glossary: No comedy not titled Caddyshac"), _c('em', [_vm._v("k ")]), _vm._v("has ever created a funny joke involving a golf cart. The only thing preventing me is that I can’t remember if Caddyshac"), _c('em', [_vm._v("k ")]), _vm._v("had golf cart jokes. In any event, if there is a golf cart, it will sooner or later drive into a water hazard. The funny angle here is that the filmmakers went to all that trouble because they trusted the audience to laugh. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I stared with glazed eyes at "), _c('em', [_vm._v("The Bounty Hunter. ")]), _vm._v("Here is a film with no need to exist. Among its sins is the misuse of Jennifer Aniston, who can be and has been very funny, but not in dreck like this. Lacking any degree of character development, it handcuffs her to a plot of exhausted action comedy clichés—and also to a car door and a bed. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The handcuffer is her former husband, Milo (Gerard Butler), a former cop who is now a bounty hunter and draws the assignment of tracking down his exwife, who has skipped bail. Have I lost touch here, or are bounty hunters routinely deployed to track down criminals accused of no more than a nonfatal traffic violation? Never mind. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Let’s do a little mental exercise here, the same sort that the screenplay writer, Sarah Thorp, must have done. Remember the ground rules: The movie must contain only clichés. I used to test this exercise on my film class. I’d give them the genre, and begin sentences ending with an ellipsis. They’d compete to be first to shout out the answer. ")]), _vm._v(" "), _c('p', {
    staticClass: "fs1"
  }, [_vm._v("  1. The story involves a formerly married couple. He is a bounty hunter tracking her down for . . . ")]), _vm._v(" "), _c('p', {
    staticClass: "fs1"
  }, [_vm._v("  2. They dislike one another. Therefore by the end of the movie . . . ")]), _vm._v(" "), _c('p', {
    staticClass: "fs1"
  }, [_vm._v("  3. He drives a . . . ")]), _vm._v(" "), _c('p', {
    staticClass: "fs1"
  }, [_vm._v("  4. Because . . . ")]), _vm._v(" "), _c('p', {
    staticClass: "fs1"
  }, [_vm._v("  5. And his beloved . . . ")]), _vm._v(" "), _c('p', {
    staticClass: "fs1"
  }, [_vm._v("  6. He loves to gamble. Their road trip takes them to . . . ")]), _vm._v(" "), _c('p', {
    staticClass: "fs1"
  }, [_vm._v("  7. Where he . . . ")]), _vm._v(" "), _c('p', {
    staticClass: "fs1"
  }, [_vm._v("  8. And gets into trouble with . . . ")]), _vm._v(" "), _c('p', {
    staticClass: "fs1"
  }, [_vm._v("  9. Inspiring . . . ")]), _vm._v(" "), _c('p', {
    staticClass: "fs1"
  }, [_vm._v("10. In a golf cart, they . . . ")]), _vm._v(" "), _c('p', {
    staticClass: "fs1"
  }, [_vm._v("11. During the movie, he gets kicked . . . ")]), _vm._v(" "), _c('p', {
    staticClass: "fs1"
  }, [_vm._v("12. She wears clothes so we can . . . ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Well, I already gave you number ten. To the others, clever students would answer: (1) a nonserious crime, since this is a comedy; (2) they will fall back in love; (3) vintage convertible; (4) movies like them because older cars look like real cars, and with a convertible you can more easily light the characters and show the landscape at the same time; (5) gets damaged; (6) you can be excused for guessing Las Vegas, but it’s Atlantic City; (7) wins big or loses big, but either way . . . ; (8) gangsters; (9) chase scenes, CGI sequences, impossible action, and lots of shots of her running in high heels; (10) you know; (11) in the crotch; (12) peek down her neckline. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Why, oh why, was this movie necessary? Could it have been redeemed by witty dialogue? Perhaps, but neither character is allowed to speak more than efficient sentences serving to further the plot. Hollywood movies started to simplify the dialogue when half the gross started to roll in from overseas. Has anyone noticed the great majority of nations dub foreign movies, so that subtitles aren’t a problem? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Gerard Butler is a handsome hunk who can also act; he’s currently starring in Ralph Fiennes’s "), _c('em', [_vm._v("Coriolanus. ")]), _vm._v("Jennifer Aniston is a gifted comedienne. If you could pay their salaries, wouldn’t you try to put them in a better movie than this? I saw the poster and had a sinking feeling the title gave away the whole story. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a358"
    }
  }, [_vm._v("Boy "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NO MPAA RATING")]), _vm._v(", 90 m., 2012 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("James Rolleston (Boy), Te Aho Aho Eketone-Whitu (Rocky), Taika Waititi (Alamein), Moerangi Tihore (Dynasty), Haze Reweti (Dallas), Rajvinder Eria (Tane), Cherilee Martin (Kelly). Directed by Taika Waititi and produced by Cliff Curtis, Ainsley Gardiner, and Emanuel Michael. Screenplay by Waititi. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_c('em', [_vm._v("Boy ")]), _vm._v("is narrated by its title character, called that name by everyone, an enormously likable eleven-year-old Maori kid who lives in a village near the Bay of Plenty in New Zealand. It’s 1984, which becomes unmistakable when we note that his younger brother is named Rocky, two characters are Dallas and Dynasty, and Michael Jackson’s "), _c('em', [_vm._v("Thriller ")]), _vm._v("video is the central fact of his life. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Before the story even takes shape, Boy (James Rolleston) impresses us as smart, with a lively imagination and the most responsibility of anyone in the crowd of children he joins every day on the beach. Does he even notice what breathtaking scenery surrounds him? We learn that Boy’s mother died giving birth to Rocky. Boy idealizes his absent father as a version of Michael Jackson. He and Rocky live with his grandmother, who leaves for a funeral in an opening scene. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("And then a big ol’ car comes swerving up a country road in a cloud of dust, and the man at the wheel introduces himself as Boy’s father. This is Alamein (Taika Waititi, also the film’s writer and director). He looks a little like Dennis Hopper in "), _c('em', [_vm._v("Easy Rider")]), _vm._v(", and easily smokes as much pot. The two clueless guys in the front seat with him are allegedly members of the motorcycle gang he leads, although at no time does he ever produce a motorcycle. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Alamein, apparently named after the famous battle, has been absent for a good reason: He’s just finished a prison sentence. He’s returned in part to see Boy, and in larger part to find a bundle of loot he wrapped in plastic and buried somewhere in a pasture. The treasure spot should line up with some trees, although after all this time he doesn’t quite remember just which ones. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Boy ")]), _vm._v("threatens to contain too much of a couple of elements. The father could turn out to be bad to the bone, introducing a threat to the son. And the movie, which includes ﬂip card–style animation, threatens to go overboard on ﬂashy style. Neither thing happens, and what gradually reveals itself is a bittersweet coming-of-age experience in which Boy outgrows his hero worship and realizes most of Alamein’s most admirable qualities exist only in his imagination. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The film contains a great deal of offhand information about this Maori community. Much of it is about how global pop culture has imposed an imaginary media reality on children’s lives. I was reminded of "), _c('em', [_vm._v("Whale Rider ")]), _vm._v("(2003), a New Zealand film about a twelve-year-old girl who would be next in line as chief of her tribe—if only she weren’t a girl. Unlike the depth and detail of that film, with its meetings of tribal elders and their debates about traditions, "), _c('em', [_vm._v("Boy ")]), _vm._v("shows a community adrift in the present. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("One of the things we notice is that Boy and his contemporaries are basically raising themselves. His father gives him a sip of beer, and he helps himself to pot (with no evident reaction). This is alarming, but there’s a bedrock common sense in his makeup that helps him see his father as an inconsequential man, and when the old man finally leaves, it is in the nature of a depressed retreat. He can’t even impress his own son. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The film is delightful in its colorful production values, with animated and fantasy interludes, many of which center around the dead mother’s tombstone, which Rocky spends many hours at. Its surface is decorated with his bright designs and pictures, and seems in celebration of the dead woman. What a contrast with the living, who Boy and his pals observe from the shadows as they hang out on the porch of a store, getting drunk, smoking weed, and killing time. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("A film like this would have little chance without the right casting, and James Rolleston is so right as Boy it’s difficult to imagine anyone else. Waititi apparently found him as an extra on the film, and substituted him for an actor he had already cast only two days before shooting began. Like many child actors, he has a natural quality adults can only envy. Waititi himself is also crucial in the film; he’s an irresponsible dad but not cruel or indifferent, and he extracts low-key humor from the character. It’s not a surprise to learn he’s a stand-up comic in New Zealand. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The question the film doesn’t need to pose is this: What direction will Boy’s life take? Rocky seems already pulled toward art. Boy’s imagination was occupied by his father until he met him. Now what? When Taika Waititi was working on this screenplay at the Sundance Writers’ Lab, its working title was "), _c('em', [_vm._v("Choice. ")])]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a359"
    }
  }, [_vm._v("Boy Wonder "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 93 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Caleb Steinmeyer (Sean Donovan), Zulay Henao (Teresa Ames), Bill Sage (Terry Donovan), James Russo (Larry Childs), Tracy Middendorf (Mary Donovan), Daniel Stewart Sherman (Gary Stensen), Chuck Cooper (Bill Baldwin). Directed by Michael Morrissey and produced by Morrissey and John Scaccia. Screenplay by Morrissey. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Here’s another movie about a young vigilante hero, like "), _c('em', [_vm._v("Super ")]), _vm._v("or "), _c('em', [_vm._v("Kick-Ass")]), _vm._v(", but darker, more brooding, and without the easy payoffs. It takes itself more seriously and plays more like a psychological thriller about a young man driven to extremes. Any connection between the title and Batman’s sidekick is purely ironic. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The most essential element in the film is the performance by Caleb Steinmeyer, as Sean, a quiet high school student who was traumatized as a child by witnessing his mother being murdered by a carjacker. He lives in a truce with his father (Bill Sage), a recovering alcoholic, who sometimes beat Sean’s mother while the boy was watching. His dad has changed and apologized, but the damage has been done. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Sean gets straight A’s in school and is capable, in some scenes, of startling us by the depth of his unexpected knowledge. He is introverted, withdrawn, bottled up. After school he sneaks away to a shabby boxing gym and works out. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("He doesn’t become a vigilante because he reads comic books, or for any other facile reason. Although the movie premiered at Chicago’s Comic Con, it has no connection with comic books except probably for writer-director Michael Morrissey’s noir lighting and framing, dramatized in the style of dark graphic novels. Because of its marketing, the movie has drawn reviews mostly from the comicsoriented websites, which find it lacking in comic fan orientation, but don’t seem to pick up on the deeper currents. I started watching it with moderate expectations and was surprised by how quickly I was drawn in; the movie works insistently on an emotional level. I don’t care how plausible Sean or his actions are; for the length of the film, I was involved in how things would play out. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Sean’s revenge for his mother’s death and father’s abuse takes the form of sudden violence against abusive characters he meets while prowling the meaner streets of Manhattan, and even at a teen party (his father is gratified that his loner kid is even going to a party). The pattern: He sees someone being violently abusive, he challenges the behavior, the other guy attacks him, he absorbs enough pain to demonstrate the other person’s savagery, and then he beats him to a pulp, or worse. He gets no satisfaction in his victories; there’s more the aura of the masochistic performance of duty. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Lending this framework a great deal of interest is the story of Sean’s interaction with the local police precinct. The cops know of his tragic childhood. They let him hang around the station, looking at mug shots in which he has long since lost hope of finding his mother’s killer. A new detective named Teresa, played with warmth and energy by Zulay Henao, takes an interest in him at the same time she begins to investigate the series of vigilante incidents. She and her partner (Daniel Stewart Sherman, quickly likable) discuss him. Slowly, her instincts about Sean suggest something is not quite right. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("In a genre populated with formulas and dreck, "), _c('em', [_vm._v("Boy Wonder ")]), _vm._v("is an ambitious exception: well made, drawing us in. It is particularly notable how Caleb Steinmeyer, a relative newcomer, calmly embodies his character and never cranks Sean up too much. This is a suffering boy. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a360"
    }
  }, [_vm._v("Bran Nue Dae "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v("-13, 85 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Rocky McKenzie (Willie), Jessica Mauboy (Rosie), Ernie Dingo (Uncle Tadpole), Missy Higgins (Annie), Geoffrey Rush (Father Benedictus), Deborah Mailman (Roxanne), Tom Budge (Slippery), Magda Szubanski (Roadhouse Betty). Directed by Rachel Perkins and produced by Graeme Isaac and Robyn Kershaw. Screenplay by Perkins, Reg Cribb, and Jimmy Chi. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Here’s something I wasn’t expecting: an Aboriginal musical from Australia, set in a late hippie era and featuring production numbers with a dash of Bollywood. It isn’t a masterpiece, but it is a good-hearted, sweet comedy, featuring an overland chase that isn’t original but sure is energetic. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The movie opens with its two young lovers shyly making eyes at each other. These are the young teenagers Willie (Rocky McKenzie) and Rosie (Jessica Mauboy). They daringly peek into a local saloon, and the singer invites the pretty Rosie (but pointedly not Willie) inside. Rosie can’t resist a chance at a microphone, and magically becomes the center of the movie’s first dance number. The way everyone in the room seems to have rehearsed the choreography is the hint of Bollywood, where characters seem to arrange themselves instinctively into chorus lines. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Willie’s pious mother is determined to see her son win respect and get a good job as a priest. She whisks him away from his hometown to a rather strange seminary, ruled by Father Benedictus (Geoffrey Rush), who has a German accent but not overmuch of the holy spirit. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Willie yearns for home and Rosie, and runs away, finds a hobo camp, and is befriended by Uncle Tadpole (Ernie Dingo), who claims to be a relative but forgets about that in the morning. No matter. Uncle Tadpole comes along for the trip, and they hitch a ride in a van painted in a psychedelic 1960s style and piloted by two jolly hippies. Father Benedictus follows in unconvincing and not very clerical fashion as he goes in pursuit, having forgotten, I guess, that Willie must want to be a priest and not be captured and forced. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("And so on. I learn "), _c('em', [_vm._v("Bran Nue Dae ")]), _vm._v("was a hit on the Australian stage in 1990. Many of the songs, some with serious undertones, reﬂect the treatment of Aborigines, who were treated as cruelly as Native Americans, and in such recent decades you’d think a more enlightened vision might have seeped into Australia, not that we have anything to feel smug about. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The two leads are sweet and attractive, their roles don’t place great demands, and the movie skips along happily, if a little disorganized. Its look is striking; the cinematography, by Andrew Lesnie of "), _c('em', [_vm._v("The Lord of the Rings")]), _vm._v(", gives the exteriors an almost DayGlo brightness, as if the sun is shining through the screen. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a361"
    }
  }, [_vm._v("Brave "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v(", 100 m., 2012 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("With the voices of: Kelly Macdonald (Merida), Billy Connolly (King Fergus), Emma Thompson (Queen Elinor), Julie Walters (The Witch), Robbie Coltrane (Lord Dingwall), Kevin McKidd (Lord MacGuffin), Craig Ferguson (Lord Macintosh). Directed by Mark Andrews and Brenda Chapman and produced by Katherine Sarafian. Screenplay by Andrews, Chapman, Steve Purcell, and Irene Mecchi. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_c('em', [_vm._v("Brave ")]), _vm._v("is the new animated film from Pixar, and therefore becomes the film the parents of the world will be dragged to by their kids. The good news is that the kids will probably love it, and the bad news is that parents will be disappointed if they’re hoping for another Pixar groundbreaker. Unlike such brightly original films as "), _c('em', [_vm._v("Toy Story")]), _vm._v(", "), _c('em', [_vm._v("Finding Nemo")]), _vm._v(", "), _c('em', [_vm._v("WALL-E")]), _vm._v(", and "), _c('em', [_vm._v("Up")]), _vm._v(", this one finds Pixar poaching on traditional territory of Disney, its corporate partner. We get a spunky princess, her mum the queen, her dad the gruff king, an old witch who lives in the woods, and so on. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The princess is Merida (voice by Kelly Macdonald), who is seen in an actionpacked prologue as a ﬂamehaired Scottish tomboy whose life is changed by an early birthday gift of a bow, which quickly inspires her to become the best archer in the kingdom. Then we ﬂash forward to Merida as a young lady of marriageable age, who is startled by being required by her mother, Elinor (Emma Thompson), to choose among three possible husbands chosen by her clan. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Nothing doing, especially since all three candidates are doofuses. Merida leaps upon her trusty steed and ﬂees into the forest, where her friends the willo’thewisps lead her to the cottage of a gnarled old witch (Julie Walters). She begs for a magic spell that will change Queen Elinor’s mind, but it changes more than that: It turns her into a bear. Witches never know how to stop when they’re ahead. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Luckily, the magic spell comes with an escape clause. Merida has exactly two days to reverse the charm. After she and her mother absorb what has happened, they begin to work together and grow closer than ever, even though the queen cannot speak. There is a tricky complication. King Fergus (Billy Connolly) had his leg bitten off by a bear (in the prologue), and has been indisposed toward them ever since. Unsurprisingly, when he sees his wife as a bear, he fails to recognize her. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("And so on. This is a great-looking movie, much enlivened by the inspiration of giving Merida three small brothers, little red-headed triplets. The Scottish Highlands are thrillingly painted in astonishing detail, and some action shows Merida’s archery more than adequate in assorted emergencies. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Brave ")]), _vm._v("has an uplifting message about better communication between mothers and daughters, although transforming your mom into a bear is a rather extreme first step. Elinor is a good sport, under the circumstances. But Merida is far from being a typical fairytale princess. Having ﬂatly rejected the three suitors proposed by her family, she is apparently prepared to go through life quite happily without a husband, and we can imagine her in later years, a weathered and indomitable Amazon queen, sort of a Boudica for the Scots. The movie seems at a loss to deal with her as a girl, and makes her a sort of honorary boy. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a362"
    }
  }, [_vm._v("Bride Flight "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 130 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Waldemar Torenstra (Frank), Karina Smulders (Ada), Anna Drijver (Esther), Elise Schaap (Marjorie), Petra Laseur (Older Marjorie), Pleuni Touw (Older Ada), Willeke van Ammelrooy (Older Esther), Rutger Hauer (Older Frank). Directed by Ben Sombogaart and produced by Hanneke Niens and Anton Smit. Screenplay by Marieke van der Pol. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_c('em', [_vm._v("Bride Flight ")]), _vm._v("derives its title from an actual ﬂight in 1953 between London and Christchurch, New Zealand—part of the Last Great Air Race. The Dutch plane in the race carries many women ﬂying to New Zealand to meet current or prospective husbands, and the movie will follow the fortunes of three of them for many tumultuous years, using two actors to portray each of them as younger and older. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The events in the plot are the stuff of soap opera, but the movie treats it seriously, and the acting is convincing enough that we forgive the story and begin to care about the characters. Four people on the ﬂight will find their lives linked in New Zealand. Ada (Karina Smulders) and Marjorie (Elise Schaap) are ﬂying out to meet their husbands. Esther (Anna Drijver), a Holocaust survivor, is a fashion designer hoping to start a new business. Frank (Waldemar Torenstra) is a hunky rancher. During the ﬂight, Ada, who has met her new husband only once, finds that she and Frank are falling in love. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("In Christchurch they all find an optimistic postwar city that’s filled with opportunity, especially in contrast with wartorn Holland. Ada stays with her husband (Micha Hulshof ), a fiercely censorious Calvinist. Esther opens a design studio. Marjorie finds she can’t have children. Esther finds she can but doesn’t want to; her career comes first. And Frank—well, Frank is a genial lad, well liked, and if he isn’t with the one he loves, he loves the one he’s with. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Bride Flight ")]), _vm._v("takes this melodrama and adds details of period, of behavior, of personality, to somewhat redeem its rather inevitable conclusion. The key figure is Ada, who has three children and then arrives at a momentous decision that colors everything else that happens. Esther and Marjorie find that their own decisions are not so easily left in the past. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("You can sense I’m not describing much of the story. It wouldn’t be fair. A film like "), _c('em', [_vm._v("Bride Flight ")]), _vm._v("works because we want to see it unfolding. We observe the pieces going into place and want to see how it will all work out. That it works out more or less inevitably is to be expected, I suppose, but you’d be upset if I revealed some of the twists and turns. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("This is the biggestbudgeted film ever made in Holland, not least because the story of the real bride ﬂight is well known and involves a period fraught with emotion. So considerable is the production that Rutger Hauer has returned to Dutch films after thirty years to play the older Frank. The young actresses who play the three leads are all capable, and Karina Smulders much more than that, in a role that takes her more deeply than the others. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Three observations. (1) There’s a danger in assigning a mannerism to a character and enforcing it too relentlessly. Esther smokes using a little cigarette holder, which she "), _c('em', [_vm._v("always ")]), _vm._v("holds next to her face. This begins to be a glitch. (2) In a scene at an airport, a crucial piece of information is imparted in a subtle and rather elegant understatement. You’ll see what I mean. (3) There is a love scene of real urgency and passion. Often movie sex scenes seem to be merely energetic exercise. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a363"
    }
  }, [_vm._v("Bridesmaids "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 128 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Kristen Wiig (Annie), Maya Rudolph (Lillian), Rose Byrne (Helen), Wendi McLendon-Covey (Rita), Ellie Kemper (Becca), Melissa McCarthy (Megan), Chris O’Dowd (Rhodes). Directed by Paul Feig and produced by Judd Apatow, Barry Mendel, and Clayton Townsend. Screenplay by Annie Mumolo and Kristen Wiig. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Three of my good female friends, who I could usually find overcoming hangovers at their Saturday morning Recovery Drunches at Oxford’s Pub, once made pinpricks in their thumbs and performed a ceremony, becoming blood sisters. They were the only people I have actually known who could inspire a Judd Apatow buddy movie, and all three could do what not all women do well, and that is perfectly tell a dirty joke. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Maybe I liked "), _c('em', [_vm._v("Bridesmaids ")]), _vm._v("in their honor. Kristen Wiig’s new comedy is about a group of women friends who are as unbehaved as the guys in "), _c('em', [_vm._v("The Hangover. ")]), _vm._v("Don’t tell me “unbehaved” isn’t a word. It is now. And Wiig is rather brilliant in her physical comedy as she ﬂies to Vegas as part of her BFF’s bachelorette party; if it were not the wedding of her BFF, this trip would get her thrown out of the wedding. Her motto: “What happens in Vegas, starts on the plane.” ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Wiig plays Annie, whose Milwaukee bakery shop has just gone bust, who rooms with a surpassingly peculiar British brother and sister, and whose longtime friend Lillian (Maya Rudolph) is getting married. Naturally, she expects to be maid of honor, but begins to fear a rival in Helen (Rose Byrne), the rich and overconfident trophy wife of the groom’s boss. You see that can lead to trouble. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Helen is one of those people who at birth was placed in charge of everything for everyone. It’s not that she’s trying to steal Annie’s thunder, it’s just that she can’t comprehend that she isn’t running the wedding. This leads finally to Annie’s explosion at a bizarre Frenchthemed bridal shower with an item of pastry that would strike even an editor of the "), _c('em', [_vm._v("Guinness Book of World Records ")]), _vm._v("as, well, excessive. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The movie, written by Wiig and Annie Mumolo and directed by Paul Feig ("), _c('em', [_vm._v("The Office")]), _vm._v("), does a good job of introducing a large cast, and in particular, keeping all the members of the bridal party in play. These include Rita (Wendi McLendon-Covey), a mother of three adolescent sons (“My house is covered in semen”), and (my favorite) Megan (Melissa McCarthy), who has the sturdiness and the certainty of a fireplug. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Did I mention the movie was produced by Apatow? Love him or not, he’s consistently involved with movies that connect with audiences, and "), _c('em', [_vm._v("Bridesmaids ")]), _vm._v("seems to be a more or less deliberate attempt to cross the chick ﬂick with the raunch comedy. It definitively proves that women are the equal of men in vulgarity, sexual frankness, lust, vulnerability, overdrinking, and insecurity. And it moves into areas not available to men, for example the scene when they’re all trying on dresses at a bridal shop and the lunch they’ve just shared suddenly reappears, if you get my drift. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Not everybody can do physical comedy. Wiig’s behavior on the ﬂight to Vegas would win the respect of Lucille Ball. I don’t even want to start describing what happens. In these days when you can get arrested on a plane for taking out your car keys, her behavior is a throwback to the good old days of airborne slapstick. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Yet the movie has a heart. It heals some wounds, restores some hurt feelings, confesses some secrets, and in general ends happily, which is just as well, because although there are many things audiences will accept from women in a comedy, ending miserably is not one of them. That may be sexist, but there you are. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a364"
    }
  }, [_vm._v("Brighton Rock "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NO MPAA RATING")]), _vm._v(", 111 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Sam Riley (Pinkie), Andrea Riseborough (Rose), John Hurt (Phil Corkery), Helen Mirren (Ida), Andy Serkis (Colleoni), Sean Harris (Hale), Nonso Anozie (Dallow). Directed by Rowan Joffe and produced by Paul Webster. Screenplay by Joffe, based on the novel by Graham Greene. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Pinkie Brown is a lowlevel thug in a secondrate gang in Brighton, the British seaside holiday town known for its pier. He is also a psychopath in over his head. One day he chats up a waitress named Rose in a tea shop, goes walking on the pier with her, and is snapped by a tourist photographer just when they meet a fellow gang member. Not long after, he batters the man to death beneath the pier, and then sets out to retrieve the damning evidence of the photo. He also must silence Rose, who realizes she met the murder victim whose picture is in the paper. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("This sets in motion "), _c('em', [_vm._v("Brighton Rock")]), _vm._v(", the second film adaptation of Graham Greene’s 1938 novel. Greene’s Catholicism plays a central role in the lives of many of his characters, few more than Pinkie and Rose—she because she holds a simple faith, he because he believes in hell and that he is headed there. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("This Pinkie (Sam Riley) is an evil young man, deadeyed, fearful, violent. Why does Rose (Andrea Riseborough) fall in love with him? Just as well she does. Pinkie would have killed her to silence her; instead, he marries her so she can’t testify against him. This is explained to Rose, too late, by Ida (Helen Mirren), the steely owner of the tea shop, who figures out the whole story but can’t prevent Rose from falling under Pinkie’s power. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Brighton Rock ")]), _vm._v("is a film of ominous gloom. The sea rolls darkly under the pier, the gull cries are forlorn, the music is mournful, the colors are muted. It is often overcast, or dusk, or night, and there is little sunshine for those seeking a holiday. It takes place in shabby boardinghouses and on chilly cliffs, and when the action moves to the grand hotel where the gangsters meet, some of the characters seem uneasy there. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Andrea Riseborough evokes a hapless Rose. Probably she is a little dim. Pinkie has scarcely even been nice to her, and she knowingly puts her life at risk for him. Ida tries to talk sense into the girl, and confides in her old friend Corkery (John Hurt). Because the movie doesn’t make the Catholicism of Pinkie and Rose as important as Greene does, their motivations sometimes seem merely self-destructive. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Brighton Rock")]), _vm._v(" was adapted in 1947 by the Boulting brothers, with Richard Attenborough in an early role as the merciless Pinkie (the movie’s U.S. title was "), _c('em', [_vm._v("Young Scarface")]), _vm._v("). I haven’t seen it. But I know the novel, and as dark as this film is, I believe it hesitates to follow Greene into his dark abyss. It is about helplessness and evil, but isn’t merciless enough. Consider the ending. It involves a recording made by Pinkie. In the novel, after all she’s been through, Rose has yet to listen to it, but she will. In the movie, she loses her chance to hear what Pinkie said. It might, after all, have given her some release. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a365"
    }
  }, [_vm._v("Brooklyn’s Finest "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 140 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Richard Gere (Eddie), Don Cheadle (Tango), Ethan Hawke (Sal), Wesley Snipes (Caz), Will Patton (Hobarts), Lili Taylor (Angela), Shannon Kane (Chantel), Ellen Barkin (Smith). Directed by Antoine Fuqua and produced by Elie Cohn, Basil Iwanyk, John Langley, Avi Lerner, and John Thompson. Screenplay by Michael C. Martin. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Three cops, three journeys to what we suspect will be doom. No good can come of the lives they lead. They aren’t bad guys, not precisely, but they occupy a world of such unremitting violence and cynicism that they’re willing to do what it takes to survive. In the kind of coincidence provided only by fate or screenplays, each one will mean trouble for the other two. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Richard Gere gets top billing as Eddie, a veteran with one week left before retirement. It is a movie convention that anyone who has a week to go before retirement must die before that week is up, but Eddie seems impatient. As the film opens, he wakes up, chugs some whiskey from a bottle, and points a revolver into his mouth, never a good sign. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Don Cheadle is Tango, who is completely embedded undercover in Brooklyn’s toughest drug precinct, where he has blended in so well with the bad guys that it’s a fine line separating him from crime. His friend is Caz (Wesley Snipes), a dealer trying to go straight after prison; they share one of those inexplicable bonds between two tough guys, causing them to consider each other brothers when they should really be nothing of the kind. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The third cop, Sal (Ethan Hawke), is a narc whose wife (Lili Taylor) provides him with more of a melodramatic emergency than we are perhaps prepared to believe. They have seven kids, live in a house too small for them, and the mold in the walls provokes potentially dangerous asthma attacks. Oh, and she’s pregnant. Having twins. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Sal has made an offer on a new place for which he cannot make the first payment. He desperately needs cash, and there’s a lot of it around in his work. Tango needs to somehow use Caz and yet spare him. Eddie needs to negotiate an alcoholic haze for seven more days before he can go fishing. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The film and the actors do a good job of establishing these characters in their own lives. Indeed, the best things about "), _c('em', [_vm._v("Brooklyn’s Finest ")]), _vm._v("are the oneonone scenes. These are fine actors. The milieu involves a tough, pokerplaying, substanceabusing, hardbitten world where the law meets crime and the two sides have more in common with each other than with civilians. I don’t believe it’s like this for most cops, but somehow it is for the great majority of movie cops. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Cheadle and Snipes have some very good scenes involving what is left unsaid but not unsuspected. Ethan Hawke has a fierce loyalty to his wife and family, and Lili Taylor does her usual touching job with what’s basically a soap opera role. Hawke is especially effective in desperate scenes where he takes crazy risks because he needs to raise cash quickly. Richard Gere’s character is not as rich as the other two, is more depressed, is on a more predictable trajectory. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("What is rather startling is the level of the violence and killing. Although cops-vs.-drugs movies are traditionally awash in blood, "), _c('em', [_vm._v("Brooklyn’s Finest ")]), _vm._v("demonstrates a trope I’ve seen with disturbing frequency: the scene in which one character lifts a firearm and peremptorily blows away another one—almost casually or unemotionally, like cleaning house. I complained for years about the Talking Killer Syndrome, in which the shooter delays in order to explain himself to a man who will presumably be dead soon. But Instant Killers are not the answer. The fact of taking life is robbed of weight and meaning. The gun becomes the instrument of merciless selfwill. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The director of Brooklyn’"), _c('em', [_vm._v("s ")]), _vm._v("Finest"), _c('em', [_vm._v(", ")]), _vm._v("Antoine Fuqua, made Trainin"), _c('em', [_vm._v("g ")]), _vm._v("Da"), _c('em', [_vm._v("y ")]), _vm._v("(2001), the film Denzel Washington won an Oscar for. That powerfully costarred Ethan Hawke. This film has the same level of savage violence and the same cops operating outside the same law, but the human stakes are more obvious and less convincing. The lives of the three cops intersect through a series of coincidences and inevitabilities, and I think we become a little too conscious that they’re being guided less by chance than by a screenwriter. The film has a basic strength in its performances and craft, but falls short of the high mark Fuqua obviously set for himself. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a366"
    }
  }, [_vm._v("Buck "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v(", 88 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Buck Brannaman, Reata Brannaman, Mary Brannaman, Betsy Shirley, Shayne and Jo-Anne Jackson, Betty and Craig Staley, Robert Redford, Bibb Frazier, Gwynn Turnbull Weaver, Annette Venteicher, and Nevada Watt. A documentary directed by Cindy Meehl and produced by Julie Goldman. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Buck Brannaman was the original “horse whisperer,” the character Nicholas Evans based his novel on and Robert Redford used as the onset consultant for his film. He has a way with horses, and Cindy Meehl’s documentary is moving as she shows them engaged in dances of understanding. W. G. Sebald wrote, “Men and animals regard each other across a gulf of mutual incomprehension,” but Buck and his animals seem to have bridged it. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("We see footage of Buck and his brother, Bill, in childhood as “Buckshot and Smokie, the Idaho Cowboys.” They appeared onstage, at rodeos, and even on a TV game show, and were being beaten regularly by their father. They were well trained. They could do rope tricks while blindfolded, but in the footage, we see they never look happy but more like frightened robots. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("One of the most affecting moments in the film comes when Buck remembers a high school coach telling him to undress and take a shower, and then seeing the welts on his back and legs. A deputy sheriff was called in, and Buck was taken away from his father and placed in a foster home. Curiously, the movie makes no mention of Bill. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("There was an older approach to horse training that resembled Buck’s father’s cruelty as he trained his boys. Standing against this trend, we learn, were two legendary horse trainers named Tom Dorrance and Ray Hunt, and when young Buck saw Hunt at work, one must assume he powerfully yearned to have been treated with as much gentleness and compassion. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The key to this approach involves empathy for the feelings of the horse. Buck understands how horses read humans, how they interpret gestures, and how they’re “so sensitive they can feel a ﬂy land.” I was reminded of Temple Grandin, the autistic designer of cattlehandling chutes, whose secret was identifying the feelings of cattle with her own. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Buck Brannaman spends most of every year on the road, giving four-day workshops on horse handling. Sometimes his wife, Mary, travels with him, and his daughter Reata comes along every July and August, sometimes sleeping in a tent next to the big horse trailer. Reata seems calm and happy as her father never was as a child; he recalls being made to sit at a kitchen table until he almost had the grain of the wood memorized. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The film perhaps goes too far in visiting the sins of a horse upon its owner. There’s a beautiful but dangerous stud toward the end of the film who is a “predator,” Buck warns. This horse’s dam died while giving birth, and in a cold winter the foal was raised in the house. That sounds kind, but something went wrong, perhaps oxygen deprivation during birth, and the horse is very aggressive. Advising its owner to have the horse castrated, Brannaman learns she has a field full of twelve more studs at home: “That’s looking for trouble.” ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("In some of his commentaries during workshops, it seemed to me that Buck attributed qualities to the horses and their owners that owed as much to his abusive childhood as anything. Well, why not? We meet Robert Redford, who talks about the trainer’s contribution to "), _c('em', [_vm._v("The Horse Whisperer ")]), _vm._v("(1998), and see in one scene how Buck’s own horse is used to perform in a way a highly trained Hollywood “trick horse” is incapable of. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("What I was left with was the goodness of Buck Brannaman as a man. He was dealt a hand that might have destroyed him. He overcame his start and is now a wise and inﬂuential role model. He does unto horses as he wishes his father had done unto him. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a367"
    }
  }, [_vm._v("Bullhead "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 128 m., 2012 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Matthias Schoenaerts (Jacky Vanmarsenille), Jeroen Perceval (Diederik Maes), Jeanne Dandoy (Lucia Schepers), Barbara Sarafian (Eva Forrestier), Tibo Vandenborre (Antony de Greef), Frank Lammers (Sam Raymond), Sam Louwyck (Marc Decuyper), Robin Valvekens (Young Jacky), Baudoin Wolwertz (Young Diederik). Directed by Michael R. Roskam and produced by Bart Van Langendonck. Screenplay by Roskam. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_c('em', [_vm._v("Bullhead ")]), _vm._v("contains the elements of a simple but overwhelming personal tragedy. It also contains other elements that create a muddle. It’s one of those films you have to reconstruct in your mind. It involves Jacky, a lowlevel Belgian farmer and criminal, who is paralyzed by fear and insecurity about his masculinity. Because he has easy access to testosterone and animal growth hormones, he uses them to build muscle and body mass. These have turned him into a raging bull. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I understand why "), _c('em', [_vm._v("Bullhead ")]), _vm._v("was one of this year’s Oscar nominees for best foreign film. I’m not sure it was one of the best five in the running, but that goes with the territory. It impresses because of the pain, sadness, and rage contained in the title performance by the Flemish actor Matthias Schoenaerts, who bulked up for the role (without steroids), and seems ready to burst from his clothes and even his skin. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("He had something happen to him when he was young. It happened on the very day he first took notice that girls have breasts. This was during a talk with his best friend, Diederik (Baudoin Wolwertz), as they regarded the sister of a neighbor. It was one of those talks many children have in which the facts of life fall into place with a blinding insight. Yes, you know about such things in a distracted sort of incomplete way because they aren’t especially interesting to you. Then suddenly they become the most important things in your life. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("As a boy, young Jacky (Robin Valvekens) is a handsome mop head with a sunny personality. On that day, everything changed. We meet the adult Jacky at the start of the film; we see him consumed by sudden angers and intimidating people for his uncle, who raises beef cattle. We learn about animal growth hormone, which they use, and in his bathroom we see a little medical refrigerator containing countless bottles, vials, and syringes of such drugs. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Jacky has become expert in their use. A casual conversation about their dangers indicates that he recklessly consumes what would be lethal self dosages if he didn’t have such a high resistance. He gobbles pills, stabs himself with needles, throws punches in the air like De Niro in "), _c('em', [_vm._v("Raging Bull. ")]), _vm._v("He still maintains an obsession with the girl he was looking at on that fateful childhood day. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Because that day provided the engine driving his entire life, I’m not sure it was wise for Michael R. Roskam, the writer-director, to delay it until a ﬂashback halfway through. Something made this guy this way, we’re thinking, but the ﬂashback information causes us to rethink everything. Well, that’s what ﬂashbacks often do, but in "), _c('em', [_vm._v("Bullhead ")]), _vm._v("there’s too much to rethink. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The movie reminded me of Michael Fassbender’s masterful work in Steve McQueen’s "), _c('em', [_vm._v("Shame. ")]), _vm._v("Both characters allow their existence to focus on their genitals. "), _c('em', [_vm._v("Shame ")]), _vm._v("is what Paul Schrader calls a Man in a Room movie, like "), _c('em', [_vm._v("Raging Bull ")]), _vm._v("or "), _c('em', [_vm._v("American Gigolo")]), _vm._v(", in which the hero’s tormented existence is solitary. "), _c('em', [_vm._v("Bullhead ")]), _vm._v("introduces a plot involving Belgium’s “hormone mafia,” a police informer, two rival criminals, the childhood friends still around, a murder of a cop, a stolen car, and two dimwitted Walloon auto mechanics, dumb and dumber. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The result is a film more confusing than it needs to be. At its center is a man and his obsession, and the way hormone use has driven him out of control. That is more than enough. The one excellent aspect of the film is Matthias Schoenaerts’s performance. We often follow him walking in a controlled lurch from side to side, as if merely walking is not enough of a challenge for him. We see his eyes, burning with pain. He speaks as if forcing out every word. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Perhaps it was something he overheard on that day in childhood. Perhaps it was misunderstood comments from a crooked veterinarian about the effect of hormones on bulls. There is no need for him to be this crazed. What happened to him hasn’t destroyed his life. This is the story of a man being eaten from within by chemicals. That alone would have been more than enough. I’m damned if I could follow the scheming involving the mechanics and those two sets of stolen auto tires. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a368"
    }
  }, [_vm._v("Bully "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NO MPAA RATING")]), _vm._v(", 106 m., 2012 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("A documentary featuring“Alex,” “Ja’Meya,” “Kelby,” David Long, Tina Long, Kirk Smalley, Laura Smalley. Directed by Lee Hirsch and produced by Hirsch and Cynthia Lowen. Screenplay by Hirsch and Lowen. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("There’s a ﬂeeting shot in "), _c('em', [_vm._v("Bully ")]), _vm._v("of a kid who just plain looks mean. He has a cruel mouth and squinting eyes, and you wonder if he knows how to smile. The movie singles him out but says nothing about him. Is he one of the bullies? Who knows? He reminded me of a kid in grade school who called me Fatso. I called him Stupid. We were both right. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("There’s only one bully actually identified in the film. A clueless teacher has pulled together two kids who got in a fight and insists they shake hands. One kid is as friendly as an insurance salesman, and sticks out his paw with a friendly smile. The other kid refuses. The teacher sends the friendly kid away and lectures the other one. Of course it’s the “nice kid” who is the bully. He probably gets away with more stuff than a con man. His victim knows it. He’s been down this path before. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("If the teacher were more clued in, she’d know it, too. One of the themes in Lee Hirsch’s documentary is how many parents and teachers have no idea what’s really happening in the secret society of children in their care. Many bullied children are reluctant to tell anyone what’s happening to them. Are they embarrassed, or scared? Bullying is designed to make them feel inferior, and in their cases, perhaps it has worked. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The film follows the stories of several children in Mississippi, Oklahoma, Iowa, and Georgia. Two of them committed suicide. Their lives had become unendurable without anyone noticing, or taking it seriously enough. I can believe it. The most infuriating people in the film are teachers or administrators who don’t know what’s happening—or don’t want to know, perhaps afraid of bureaucratic difficulties or angry parents. (I imagine, but don’t know, that the parents of bullies are likely to ﬂare up in anger at accusations against their children—and then possibly abuse their kid themselves later. Do bullies often have nice parents?) ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Sometimes an entire community gets in on the act. A girl who is a lesbian is humiliated by a teacher in front of other students, and her parents observe that many of their own friends of long standing have become hostile. A culture of ignorance and homophobia feeds this. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Much has been made of how the MPAA gave this film an R rating for its language. (A "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v("-13 has belatedly been handed out to a version with some words taken out.) It was widely said that the MPAA was preventing admission to those very kids under seventeen who could benefit from it the most. That part I’m not so sure about. The movie contains little solid information about bullying, and although we feel sorry for the victims who are profiled, it is unclear what can be learned from observing them. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("My notion is that a fictional film might be more effective than a documentary. It could encourage young viewers to identify with victims of bullying and dislike bullies. Movies that encourage empathy are more effective than those that objectify problems. Some kids will think: “I’m not like those losers.” The right kind of fictional story might make that harder to do. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Why are some people bullied? Because they are different. How? It doesn’t matter. A bully can act as the catalyst for encouraging a group to draw together in cruelty against someone perceived as not a member. This process was shown with great power in Larry Clark’s "), _c('em', [_vm._v("Bully ")]), _vm._v("(2001), which added an unexpected twist: A brutal bully is actually murdered by a group of his victims, who together are moved to do something none of them could ever do alone. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Bully")]), _vm._v(" is a sincere documentary, but not a great one. We feel sympathy for the victims in the film and their parents or friends, but the film seems to helplessly treat bullying as without a solution. I can think of one thing that might help. Parents and schools should place great emphasis on the fact that it is all right to be different. Racism and all the other isms grow from primitive tribalism, the instinctive hostility against those of another tribe, race, religion, nationality, class, or whatever. You are a lucky child if your parents taught you to accept diversity. Teaching prejudice to a child is itself a form of bullying. You’ve got to be taught to hate. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a369"
    }
  }, [_vm._v("Buried "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½ ")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 95 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Ryan Reynolds (Paul Conroy). Directed by Rodrigo Cortes and produced by Adrian Guerra and Peter Safran. Screenplay by Chris Sparling. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Buried alive. It must be a universal nightmare. I read Edgar Allan Poe’s "), _c('em', [_vm._v("The Premature Burial ")]), _vm._v("when I was seven or eight, and the thought troubled me for many a dark night. You are alive, you can move, you can scream, but no one will hear. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Paul Conroy is a truck driver working for a private contractor in Iraq. He comes to consciousness in blackness. He reaches out, feels, realizes. He finds a lighter. In its ﬂame his worst fears are realized. He finds a cell phone. He learns he has been kidnapped and is a hostage. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Obviously his captors want him to use the phone. They want to prove he is alive because they plan to demand ransom. And by now we are identifying with Conroy’s desperate thinking. Who can he call who can rescue him before the oxygen in the coffin runs out? Thankfully the coffin is longer than usual, allowing it to contain more air and also permitting certain camera angles that enhance the action. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Because there is action. Although the entire movie takes place in the enclosed space, director Rodrigo Cortes and writer Chris Sparling are ingenious in creating more plausible action than you would expect possible. They also allow themselves a few POV shots from outside the coffin—not on the surface, but simply from undefined darkness above the space. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Paul (Ryan Reynolds) uses the phone to call 911. The Pentagon. His employer’s office. His wife. He receives calls from his kidnappers. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("These calls are exercises in frustration. There is nothing quite like being put on hold while you’re buried alive. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("It is their wise decision to omit any shots of the action at the other end of the calls. No shots of 911 operators, Pentagon generals, or corporate PR types. No shots of his desperate kidnappers. No ﬂashbacks to the ambush and kidnapping itself. No weeping wife. The movie illustrates the strength of audiobooks and radio drama: The images we summon in our minds are more compelling than any we could see. A seen image supplies satisfaction. An imagined one inspires yearning. Along with Paul, we’re trying to transport ourselves to the other end of each call. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("It would not be fair to even hint at some of the events in the coffin. Let it be said that none of them is impossible. There is no magic realism here. Only the immediate situation. The budget for "), _c('em', [_vm._v("Buried ")]), _vm._v("is said to be $3 million. In one sense, low. In another sense, more than adequate for everything director Cortes wants to accomplish, including his special effects and the voice talents of all the people on the other end of the line. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Ryan Reynolds has limited space to work in, and body language more or less preordained by the coffin, but he makes the character convincing if necessarily limited. The running time, 95 minutes, feels about right. The use of 2:35 widescreen paradoxically increases the effect of claustrophobia. I would "), _c('em', [_vm._v("not ")]), _vm._v("like to be buried alive. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Notes: My top ten reasons for wanting to be cremated are at "), _c('a', {
    attrs: {
      "href": "http://j.mp/dpQwYu",
      "target": "_blank"
    }
  }, [_vm._v("http://j.mp/dpQwYu")]), _vm._v(". Read ")]), _vm._v("The Premature Burial "), _c('em', [_vm._v("by Edgar Allan Poe at "), _c('a', {
    attrs: {
      "href": "http://j.mp/bput7O",
      "target": "_blank"
    }
  }, [_vm._v("http://j.mp/bput7O")]), _vm._v(". ")])]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a370"
    }
  }, [_vm._v("Burlesque "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v("-13, 116 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Cher (Tess), Christina Aguilera (Ali), Eric Dane (Marcus), Cam Gigandet (Jack), Julianne Hough (Georgia), Alan Cumming (Alexis), Peter Gallagher (Vince), Kristen Bell (Nikki), Stanley Tucci (Sean). Directed by Steven Antin and produced by Donald De Line. Screenplay by Antin. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("The burlesque shows in "), _c('em', [_vm._v("Burlesque")]), _c('em'), _vm._v("feature no nudity, no striptease, no baggy-pants comedians, and no performers with names like Porsche Galore. Other than that, the shows are identical to the offerings at the Rialto and Follies burlesque houses that ﬂourished on South State Street when I first visited Chicago as a sinseeking teenager. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("This is burlesque if it died and went to heaven. Behind a tawdry side entrance on Sunset Strip, a club exists that would make a Vegas casino proud. It has the eerie expanding and contracting dimensions of fantasy. At first, the stage is the right size for an intimate cabaret; later, there’s enough space to present a production number with dozens of (unaccounted for) dancers descending a staircase worthy of Busby Berkeley. The audience is all shadowy extras, whose friends will have to look real hard to spot them. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The Burlesque Lounge attracts the attention of Ali (Christina Aguilera), the proverbial small-town girl just off the bus from Iowa. She walks in just in time to see Tess (Cher) conveniently performing the number “Welcome to Burlesque.” In this scene and throughout the movie, Cher looks exactly as she always does. Other people age. Cher has become a logo. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The movie has a limited cast of broadly drawn characters, used to separate song and dance numbers. Tess coowns the club with her ex-husband, Vince (Peter Gallagher). As a couple, they inspire games of What Is Wrong with This Picture? His function is to eagerly hope they can sell out to Marcus (Eric Dane), the realestate developer who wants to tear down the club and put up condos. The club bartender is Jack (Cam Gigandet), who wears eyeliner but turns out to be straight. He allows Ali to crash on his sofa, but there’s no sex because he has a fiancée in New York and also because the film has a "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v("-13 rating. The stage manager is Sean (Stanley Tucci). He’s gay, except for one unforgettable night with Tess in Reno. Or Lake Tahoe. She forgets. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The star dancer is Nikki (Kristen Bell), who grows instantly angry with Ali after the farm girl tells her she looks like a drag queen. They must not see many drag queens in Iowa. There is also the nice girl named Georgia (Julianne Hough), who . . . well, a plot like this only leaves one thing for her, doesn’t it? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Sorry, I got distracted again, thinking of the condo tower Marcus wants to build. How big a footprint will it need? We get repeated shots of the exterior of the lounge, which consists of an arch of lightbulbs next to what looks like the side of a modest frame building with outside steps to a second ﬂoor that doesn’t seem to exist inside. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("On the landing of those steps on that first night, Ali sees a black girl standing, who smiles nicely to her. We see this same girl repeatedly during the film, but she never gets a name or any dialogue. She has the role of the Black Girl Who Is Seen but Not Heard as a Member of the Club Family. She shouldn’t complain. No other dancer gets to be anything at all. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("In the film, both Cher and Christina Aguilera are showcased in big song numbers, which I enjoyed on a music video level. Aguilera has an unforced charm in her early scenes, but as she morphs into a glamorous star, she becomes increasingly less interesting. We learn she is an orphan. That simplifies the backstory. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("You know how in Bollywood musicals the star actress will be all by her lonely self on a mountaintop, and when she starts to sing and dance, a dozen male singerdancers materialize out of thin air? That happens here in the big final number. The girls form a perfect chorus line, a stairway to the stars appears, and a dozen male dancers descend. Where did they come from? Where will they go? Remember, this club is so small there is only one clothing rack backstage for all the costumes. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Is this the movie for you? It may very well be. You’ve read my review, and you think I’m just making snarky comments and indulging in cheap sarcasm. Well, all right, I am. "), _c('em', [_vm._v("Burlesque ")]), _vm._v("shows Cher and Christina Aguilera being all that they can be, and that’s more than enough.")])])])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(84),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "margin-bottom"
  }, [_vm._v("C")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a13"
    }
  }, [_vm._v("The Cabin in the Woods "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 105 m., 2012 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Kristen Connolly (Dana), Chris Hemsworth (Curt), Anna Hutchison (Jules), Fran Kranz (Marty), Jesse Williams (Holden), Richard Jenkins (Sitterson), Bradley Whitford (Hadley), Brian White (Truman), Amy Acker (Lin). Directed by Drew Goddard and produced by Joss Whedon. Screenplay by Goddard and Whedon. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("You’re not going to see this one coming. You might think you do, because the TV ads and shots at the top reveal what looks like the big surprise—and it certainly comes as a surprise to the characters. But let’s just say there’s a lot more to it than that. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("The Cabin in the Woods ")]), _vm._v("sets off with an ancient and familiar story plan. Five college students pile into a van and drive deep into the backwoods for a weekend in a borrowed cabin. Their last stop is of course a decrepit gas station populated by a demented creep who giggles at the fate in store for them. In these days when movies are sliced and diced for YouTube mashups, I’d love to see a montage of demented redneck gas station owners drooling and chortling over the latest carloads of victims heading into the woods. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("It will seem that I’m revealing a secret by mentioning that this is no ordinary cabin in the woods, but actually a set for a diabolical scientific experiment. Beneath the cabin is a basement, and beneath that is a vast modern laboratory headed by technology geeks (Richard Jenkins and Bradley Whitford) who turn dials, adjust levers, and monitor every second on a bank of TV monitors. Their scheme is to offer the five guinea pigs a series of choices, which will reveal—something, I’m not sure precisely what. There is some possibility this expensive experiment is involved with national security, and we get scenes showing similar victims in scenarios around the world. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Now, in your standard horror film, that would be enough: OMG! The cabin is being controlled by a secret underground laboratory! Believe me, that’s only the beginning. The film has been produced and cowritten by Joss Whedon (creator of "), _c('em', [_vm._v("Buffy the Vampire Slayer ")]), _vm._v("and "), _c('em', [_vm._v("Angel")]), _vm._v(") and directed by his longtime collaborator Drew Goddard (writer of "), _c('em', [_vm._v("Cloverfield")]), _vm._v("). Whedon has described it as a “loving hate letter” to horror movies, and you could interpret it as an experiment on the genre itself: It starts with five standardissue characters in your basic cabin in the woods, and we can read the lab scientists as directors and writers who are plugging in various story devices to see what the characters will do. In some sense, the Jenkins and Whitford characters represent Whedon and Goddard. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Ah, but they don’t let us off that easily. That’s what I mean when I say you won’t see the ending coming. This is not a perfect movie; it’s so ragged, it’s practically constructed of loose ends. But it’s exciting because it ventures so far off the map. One imagines the filmmakers chortling with glee as they devise first one bizarre development and then another in a freeforall for their imaginations. They establish rules only to violate them. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("That begins with the characters. They’re stock archetypes. We get an action hero (Curt, played by Chris Hemsworth); a good girl (Dana, played by Kristen Connolly); a bad girl (Jules, played by Anna Hutchison); the comic relief (Marty the pothead, played by Fran Kranz); and the mature and thoughtful kid (Holden, played by Jesse Williams). What the scientists apparently intend to do is see how each archetype plays out after the group is offered various choices. There are even side bets in the lab about who will do what—as if they’re predicting which lever the lab rats will push. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("This is essentially an attempt to codify free will. Do horror characters make choices because of the requirements of the genre, or because of their own decisions? And since they’re entirely the instruments of their creators, to what degree can the filmmakers exercise free will? This is fairly bold stuff, and grows wilder as the film moves along. The opening scenes do a good job of building conventional suspense, the middle scenes allow deeper alarm to creep in, and by the end we realize we’re playthings of sinister forces. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Horror fans are a particular breed. They analyze films with such detail and expertise that I am reminded of the Canadian literary critic Northrop Frye, who approached literature with similar archetypal analysis. "), _c('em', [_vm._v("The Cabin in the Woods ")]), _vm._v("has been constructed almost as a puzzle for horror fans to solve. Which conventions are being toyed with? Which authors and films are being referred to? Is the film itself an act of criticism? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("With most genre films, we ask, “Does it work?” In other words, does this horror film scare us? "), _c('em', [_vm._v("The Cabin in the Woods ")]), _vm._v("does have some genuine scares, but they’re not really the point. This is like a final exam for fanboys. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a480"
    }
  }, [_vm._v("Captain America: The First Avenger "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v("-13, 125 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Chris Evans (Captain America/Steve Rogers), Hayley Atwell (Peggy Carter), Sebastian Stan (Bucky Barnes), Tommy Lee Jones (Colonel Chester Phillips), Hugo Weaving (Schmidt/Red Skull), Dominic Cooper (Howard Stark), Richard Armitage (Heinz Kruger), Stanley Tucci (Dr. Abraham Erskine), Samuel L. Jackson (Nick Fury), Toby Jones (Dr. Arnim Zola). Directed by Joe Johnston and produced by Kevin Feige and Amir Madani. Screenplay by Christopher Markus and Stephen McFeely, inspired by the Marvel comic books. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("It was a pleasure to realize, once "), _c('em', [_vm._v("Captain America: The First Avenger ")]), _vm._v("got under way, that hey, here was a real movie, not a noisy assembly of incomprehensible special effects. Of course it’s loaded with CGI. It goes without saying it’s preposterous. But it has the texture and takes the care to be a full-blown film. You know, like with a hero we care about and who has some dimension. And with weight to the story. As we plunge ahead into a limitless future of comic book movies, let this be an inspiration rather than "), _c('em', [_vm._v("Thor ")]), _vm._v("or "), _c('em', [_vm._v("Green Lantern. ")])]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The words "), _c('em', [_vm._v("The First Avenger ")]), _vm._v("are weighted with significance for Marvel fans. We have already had films inspired by Iron Man, the Hulk, and Thor. Still to come, without doubt, are AntMan and Wasp. This film opens with the discovery of an enormous ﬂying wing embedded in polar ice, and when a gloved hand reaches out to brush away the ice on a window, why, there’s Captain America’s shield! The plot of this film involves his origin story and adventures during World War II, and I’m sure we’ll discover in sequels that he was revived after the cryogenic nap to crusade again in the new day. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("We open with an archetypal ninetypound weakling; comic books of that period featured ads showing muscle men kicking sand into the faces of such specimens, who were advised to mailorder Charles Atlas for bodybuilding help. Young Steve Rogers (Chris Evans) is a puny Brooklyn kid who is routinely beat up on by bullies, and dreams of joining the army and defending America against the Nazis. Turned down as 4F, he tries again and again to enlist, and eventually makes it into basic training, where he’s always falling off the rope and bringing up the rear. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("But the kid has courage. This attracts the attention of the hard-boiled Colonel Phillips (Tommy Lee Jones) and a scientist named Erskine (Stanley Tucci), who supervises a secret government program. In no time at all, and without really receiving any explanation, he’s being strapped into an ominous sarcophagus in Erskine’s laboratory, which emits sparks and smoke and eventually the new Steve Rogers, now a foot taller and built like Mr. Universe. He adopts a costume and a starsandstripes shield that serve primarily to make him highly visible, although the shield has special powers (but only when it’s positioned correctly?). ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Young Steve’s army confidante both before and after his transformation is the sultry Peggy Carter (Hayley Atwell), whose full red lips make her resemble a classic military pinup of the period. He narrates their tour of the Brooklyn neighborhoods where he was picked on, and they grow close, but only "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v("-13 close, because Marvel has apparently determined that fanboys find sex to be icky. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Now the fullbodied story comes into play, involving, as all good comic book movies must, a really first-rate villain. This is a Nazi commandant named Johann Schmidt (Hugo Weaving), who essentially controls his own private army and has dreams of surpassing Hitler. His minions salute him, not "), _c('em', [_vm._v("Der Fuhrer")]), _vm._v(", and he has dreams of creating super weapons. Eventually, as the rules of comic book drama require, Captain America will pair off against Schmidt, who is revealed to actually be the hideous Red Skull, whose skin tone makes him resemble those ducks marinated in red sauce you sometimes see hanging in restaurant windows in Chinatown. Schmidt demonstrates once again that, when it comes to movie villains, you can’t do better than Nazis. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The film pays full dues to Marvel mythology, providing Captain America with his sidekick, Bucky Barnes (Sebastian Stan), not such a kid as he was in the comics. We also meet Howard Stark (Dominic Cooper), who supports Erskine’s research and will eventually, as we know, father Iron Man. And there is Nick Fury (Samuel L. Jackson), another World War II hero destined to graduate to his own comic book and, no doubt, movie. Jackson has the chops to play a first-rate superhero. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The adventures of Captain America are fabricated with first-rate CGI, and are slightly more realityoriented than in most superhero movies—sad to say, they’re still wildly absurd—but set up and delivered with more control. CGI makes another invaluable contribution to the movie by shrinking the sixfoot Chris Evans into a vertically challenged ninetypound weakling, and then expanding him dramatically into the muscular Captain America. This is done seamlessly and he’s convincing at both sizes; I doubt there’s a single shot in the movie that shows Evans as he really is. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I enjoyed the movie. I appreciated the 1940s period settings and costumes, which were a break with the usual generic cityscapes. I admired the way director Joe Johnston ("), _c('em', [_vm._v("October Sky, Jumanji")]), _vm._v(") propelled the narrative. I got a sense of a broad story, rather than the impression of a series of sensational set pieces. If Marvel is wise, it will take this and "), _c('em', [_vm._v("Iron Man ")]), _vm._v("as its templates. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a481"
    }
  }, [_vm._v("Carlos "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NO MPAA RATING")]), _vm._v(", 165 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Edgar Ramirez (Carlos), Juana Acosta (Girlfriend), Alexander Scheer (Johannes Weinrich), Nora von Waldstatten (Magdalena Kopp), Ahmad Kaabour (Wadie Haddad), Christoph Bach (HansJoachim Klein), Rodney El-Haddad (Khalid), Julia Hummer (Nada). Directed by Olivier Assayas and produced by Jens Meurer. Screenplay by Assayas and Dan Franck. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("The man known as Carlos the Jackal said that Marxism was his religion and he was dedicated to the Palestinian cause. Having seen the long version of Olivier Assayas’s remarkable "), _c('em', [_vm._v("Carlos")]), _vm._v(", I conclude that for Carlos, his religion and his cause were the same, and they were himself. This is a terrifying portrait of an egomaniac who demands absolute obedience, and craves it even more when his power and relevance are drained away. All he has left at the end are a few pathetic nonentities who obey him. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("If Carlos is a shabby excuse for a great man, "), _c('em', [_vm._v("Carlos ")]), _vm._v("is nonetheless a powerful film from recent history, considering in (largely fictionalized) detail how the myth of Carlos shadowed the years from 1975, when he led a raid on OPEC oil ministers in Vienna, until 1994, when he was betrayed by former comrades, arrested in Sudan, and returned to France for trial. He is now serving a life sentence, and from prison has complained that this film is inaccurate. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I have no knowledge of the real Carlos and can only review the film. On that basis, Ilich Ramirez Sanchez, a Venezuelan born in 1949 and educated at a Cuban training camp and Patrice Lumumba University in Moscow, used his ideology primarily to dominate others and excuse his megalomania. Toward the end, even his superiors in the Palestinian liberation movement were fed up with him, and after exhausting the hospitality of Libya, Syria, and Iraq, he became a man without a country. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Carlos is played by Edgar Ramirez, an actor of great vitality and conviction. I learn he speaks five languages, and in Carlo"), _c('em', [_vm._v("s ")]), _vm._v("he performs dialogue in even more, as he functions in France, Spain, Germany, Egypt, Iraq, Russia, and North Africa. (The film is largely in English, the international language of terrorism.) Without using any apparent makeup tricks, he successfully ages from a young hothead to a middle-age “Syrian businessman” with a nice little pot belly, while passing through a period when he is lean and muscular after guerrilla training. His sideburns ﬂourish and disappear, beards and mustaches come and go, and yet clearly he is Carlos if you take a good look at him. He passed through countless passport controls where apparently nobody did, although once years ago at London Heathrow I was pulled aside on suspicion of being Carlos. He ran on the plump side, for a jackal. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("In notes and anonymous phone calls taking blame (or “credit”) for bombings, murders, and missile attacks, he identified his group as “the armed branch of the Palestinian Liberation Struggle.” I have no idea what the reality was. In the film, this organization seems to consist largely of himself as the autarch of a small group of submissive followers who had loose connections with betterorganized cells in Germany and France. He was well financed by mischievous governments, including Russia, East Germany, and Iraq; shipped crates of weapons by using diplomatic immunity; and lived in swank hotels or sometimes in safe houses or borrowed apartments. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("His “operations” seem almost anarchic. He and his followers have the strategy of walking in armed and doing what they intend. In a public observation area at an airport, surrounded by others, they attempt to deploy a rocket launcher to blow up airplanes. Their getaway strategy usually comes down to get the hell outta there. He got his nickname from the Frederick Forsyth novel "), _c('em', [_vm._v("The Day of the Jackal")]), _vm._v(", but the hero of the excellent Fred Zinnemann film of that name takes meticulous care in his planning. Carlos seems impulsive. It’s extraordinary how long he survived on the run. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("His major operation was the OPEC raid. He took forty-two hostages and demanded an airplane to take them to Algiers. That led to an odyssey on to Baghdad and Tripoli before returning to Algiers. Assayas is at his best showing this undertaking, during which Carlos fails to execute two of the oil ministers as ordered and is berated by his superior in the movement, Wadie Haddad (Ahmad Kaabour). Then as later, his personal fame and publicity were felt to distract from the focus of the Popular Front for the Liberation of Palestine. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Did he care deeply about Palestine? I get the impression that he cared deeply about seeming to care deeply. His personality would have been equally well suited to any other revolutionary struggle. He hated any authority except his own, and granted himself life and death power over others because—well, because he was Carlos. Given the opportunity, he might have made a Stalin, Hitler, or Pol Pot. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Much of the film is devoted to the periods between action. We meet the private Carlos, whose sexuality depends on the conquest and domination of women. He is enabled by a longsuffering girlfriend and wife, Magdalena Kopp (Nora von Waldstatten), before they have a child and she walks out for the child’s sake. Also by a series of mistresses, especially Nada (Julia Hummer), who stands by him during a painful illness with a testicular tumor. It is an insight into Carlos’s ego that he postponed tumor surgery for a more important operation: liposuction. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("That he satisfies women sexually there seems no doubt. They accept, not always happily, his many affairs with others, including prostitutes. He is such a great man he is exempt from ordinary behavior. All along the way he is accompanied by his sidekick HansJoachim Klein (Christoph Bach), an uncertain man with a wispy mustache, who has a way of drinking himself unconscious, not a valuable trait in a terrorist. When the two of them party with hookers in East Berlin, they’re too naive to suspect they’re plants by the secret police. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Carlos ")]), _vm._v("exists in three formats. The theatrical version runs 165 minutes; there’s a roadshow version in two parts totaling 332 minutes. The full threepart miniseries, totaling 5:35, played on the Sundance Channel. I saw the longest, and I was not bored. Olivier Assayas doesn’t make the mistake of wearing us out with action, which in excess is simply boring; he’s fascinated by the minutiae of daily routine in the life of a wanted and hated man. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("There is a detail I must mention. I have never seen more smoking in a movie. Every character smokes heavily, and Carlos constantly, indeed distractingly. No doubt this is based on fact, but what does Assayas mean by depicting it so pointedly? It shows Carlos addicted to quick and constant fixes. He never shows any pleasure in smoking. He simply has to do it. It may be a metaphor for terrorism. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a482"
    }
  }, [_vm._v("Carnage "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 79 m., 2012 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Jodie Foster (Penelope Longstreet), Kate Winslet (Nancy Cowan), Christoph Waltz (Alan Cowan), John C. Reilly (Michael Longstreet). Directed by Roman Polanski and produced by Said Ben Said. Screenplay by Polanski and Yasmina Reza, based on her play "), _c('em', [_vm._v("God of Carnage. ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Roman Polanski’s "), _c('em', [_vm._v("Carnage ")]), _vm._v("involves time spent by two married couples in a luxurious Manhattan condo as afternoon fades into evening. The film is very well named. We have seen this dramatic trajectory before, where smooth politeness relentlessly erodes into foul-mouthed imprecations, but the point isn’t the plot anyway, it’s the performances. Here four familiar actors seem ideally cast for their roles. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The condo belongs to Penelope and Michael Longstreet (Jodie Foster and John C. Reilly). In the film’s opening scene, in long shots so we can’t tell the rights from the wrongs, their boy Zachary is hit with a stick by a school friend. The stick was swung by the son of Alan and Nancy Cowan (Christoph Waltz and Kate Winslet). Both boys are eleven. This has inspired the visit by the Cowans to discuss the regrettable incident, which in another social milieu might be considered just one of those things that kids get themselves into. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Not these people. They are rich (considering the apartment). Michael sells kitchen implements, countless ones, it would appear. Alan is a lawyer whose life cannot be conducted without frequent and urgent cell phone calls. Their kids go to the same expensive school, and the details of their lives are carefully ordered in uppermiddle (or lowerupper?) class taste. At the beginning their performance is designed to indicate they are decent and civilized and can work this thing out. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("“Performance” is the correct word. Carnag"), _c('em', [_vm._v("e ")]), _vm._v("has been adapted by Polanski and Yasmina Reza from her Tony Award–winning play "), _c('em', [_vm._v("God ")]), _vm._v("o"), _c('em', [_vm._v("f ")]), _vm._v("Carnage, and no particular effort is made by Polanski to open it up. The action all takes place in that apartment and its hallway, with the Cowans occasionally getting as much of a show inside the elevator before an unfortunate remark draws them back inside. Plays like this work particularly well within the space and time constraints of a stage. I’m not sure it called out to be filmed. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The progress of the action is meticulously modulated. The Cowans have sent ahead a bouquet of expensive yellow tulips. Penelope Longstreet has baked a cobbler. Tea is served. The problem is that all four adults are compelled to assign guilt in the incident. I believe it likely that the two boys (never seen again after the opening scene) stumbled into an unfortunate and trivial shoving match in which either could easily have held the stick and either have lost the teeth. That’s not good enough for the two couples. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("There’s a macabre interest in watching the level of civility decrease in the room. Polanski pays much attention to the modulation of dialogue and body language. Alliances are formed and broken; the men and women at times side with each other, until the couples fall back into opposition. Certain regrettable words are introduced which can be interpreted as inﬂammatory, and all four characters are very alert to listen for them. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Step by step, the occasion disintegrates. One character eventually makes himself right at home by sitting on the ﬂoor instead of the sofa. Tulips and cobbler are hurled, in more ways than one. Did I mention that whiskey had been introduced? And Cuban cigars? (During the male bonding stage.) ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("This is not a particularly memorable film, but Polanski brings a great deal of skill to its staging, and it looks as if the actors enjoy themselves. It’s not every seventy-nine minute movie that allows all four characters to hurtle through a full gamut of emotions. The message, if any, is that good manners are often skin deep, that compassion and forgiveness are hard to come by, and that when it comes down to your son and my son, I’m going to consider my son in the right, and yours, well, possibly, a homicidal maniac. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a483"
    }
  }, [_vm._v("Cars 2 "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("G")]), _vm._v(", 107 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("With the voices of Larry the Cable Guy (Mater), Owen Wilson (Lightning McQueen), Michael Caine (Finn McMissile), Emily Mortimer (Holley Shiftwell), Eddie Izzard (Miles Axlerod), John Turturro (Francesco Bernoulli). Directed by John Lasseter, codirected by Brad Lewis, and produced by Denise Ream. Screenplay by Ben Queen. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("While I was watching "), _c('em', [_vm._v("Cars 2")]), _vm._v(", an elusive nostalgia tugged at my mind. No, I wasn’t remembering Pixar’s original "), _c('em', [_vm._v("Cars ")]), _vm._v("from 2006. This was something more deeply buried, and finally, in the middle of one of the movie’s sensational grand prix races, it came to me: I was sitting on the ﬂoor of my bedroom many years ago, some toy cars lined up in front of me, while I used my hands to race them around on the ﬂoor and in the air, meanwhile making that noise kids make by squooshing spit in their mouths. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("In this memory I was completely engrossed with my cars. They were as real as people, and I played favorites and identified one car as my surrogate. Maybe my hands were swooping around with toys, but my imagination was somewhere else, and I performed the dialogue for the cars: “Oh yeah?” “Take that!” “We’ll see!” “Eeeeyowww!” ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("This memory was not random. I think it was inspired by the spirit of John Lasseter’s movie. I believe in some sense the great animator was sitting Indian style on the ﬂoor of his Pixar playroom and hurtling his cars through time and space with sublime, reckless delight. We learned from "), _c('em', [_vm._v("Cars ")]), _vm._v("that Lasseter loves automobiles, and here we learn that they can serve him as avatars in an international racingandspying thriller as wacky as a Bond picture crossed with Daffy Duck. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I have no idea what kids will make of the movie. At a time when some “grown-up” action films are relentlessly shallow and stupid, here is a movie with such complexity that even the cars sometimes have to pause and explain it to themselves. It mixes concerns about fossil fuels with spy craft and a lot of grand prix racing where more is at stake than who wins. And it has a new hero: The shiny red Lightning McQueen (voice by Owen Wilson) is eclipsed by a rusty, bucktoothed tow truck named Mater (Larry the Cable Guy), who was only a supporting vehicle in the first film. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("A plot synopsis would spin us into bafflements, and the movie isn’t about a plot so much as the action it involves. Brieﬂy, Sir Miles Axlerod (Eddie Izzard) has invented a new fuel that doesn’t deplete the planet’s shrinking oil reserves, and wants to prove it in a World Grand Prix to be run in England, Japan, and Italy. This is a masterful way of introducing new backdrops into the races, and the movie is so visually complex that I imagine Lasseter and his colleagues slipped details in just for fun. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("At one point, in a shot so brief you don’t want to blink, we even learn that the Popemobile travels in its own Popemobile. This inspires the theological puzzle of whether the one inside is the pope. One of my fellow viewers said she didn’t even see a Popemobile. Maybe I dreamed it. In any event, there are no humans in the movie who could be the pope, although much is made of the dinosaurs who are a source of fossil fuels. Actually, I believe oil originated from ancient plants and microorganisms and not so much from dinosaurs, but in the Lasseter universe, it no doubt comes from gasguzzling dinosaurs like in those old Rambler ads. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("But I digress. Lightning McQueen ends up in a championship duel with the Italian car Francesco Bernoulli (John Turturro at full throttle). He and Mater the tow truck find themselves in the middle of a clandestine war between the forces of fossil and alternative fuels, also involving the British secret agents Finn McMissile (Michael Caine) and Holley Shiftwell (Emily Mortimer). Having recently admired Steve Coogan and Rob Brydon doing dueling Michael Caine imitations in "), _c('em', [_vm._v("The Trip")]), _vm._v(", I noted that Michael Caine does a pretty good one himself. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The original film was an elegy to a past when America spun out along Route 66 and now classic cars occupied an iconic role in American lives. The cars in "), _c('em', [_vm._v("Cars 2 ")]), _vm._v("have developed an array of new bells and whistles; they extrude so many wires, spikes, weapons, and gimmicks they must really be shape-shifters, and Mater in particular is expert at disguising himself. This is not surprising because a lot of the guys you find around tow trucks are pretty good using paint jobs to dress up beaters. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Anyway, Car"), _c('em', [_vm._v("s 2 ")]), _vm._v("is fun. Whether that’s because John Lasseter is in touch with his inner child or mine, I cannot say. There remains one bone to pick. Although the hero of the 2006 film was a Hudson with the stepdown design and there are AMC Gremlins in this film, as nearly as I can tell you, Lasseter entirely ignores the greatest independent American automaker of them all, Studebaker. Maybe I missed one. Maybe I stepped out to pee. I don’t think so. There is a more obvious reason. Introducing a Studebaker Golden Hawk into this film would make all of the other characters look shabby. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a484"
    }
  }, [_vm._v("Casa de Mi Padre "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 84 m., 2012 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Will Ferrell (Armando), Gael Garcia Bernal (Onza), Diego Luna (Raul), Genesis Rodriguez (Sonia), Pedro Armendariz Jr. (Miguel Ernesto), Nick Offerman (DEA Agent Parker), Efren Ramirez (Esteban), Adrian Martinez (Manuel). Directed by Matt Piedmont and produced by Emilio Diez Barroso, Jessica Elbaum, Will Ferrell, Darlene Caamano Loquet, Adam McKay, and Kevin J. Messick. Screenplay by Andrew Steele. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_c('em', [_vm._v("Casa de Mi Padre ")]), _vm._v("is a cheeky comedy by Will Ferrell and his compadres at "), _c('em', [_vm._v("Saturday Night Live ")]), _vm._v("and the Web site Funny or Die. And when I say “cheeky,” it’s what you’re thinking second. The movie has more butt groping than anything this side of the Rio Grande. And the other side. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Ferrell and the entire cast perform entirely in Spanish, and Ferrell sings a song that has already gone viral on YouTube. He sounds perfectly ﬂuent to me, but then, how would I know? The movie is a jolly send-up of horse operas on Telemundo, which I have never seen, but my lack of qualifications isn’t fatal because the movie hopes to do crossover business in addition to its obvious target audience. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("What possessed Ferrell to make this satire? My guess is, he got straight As in Spanish and has spent years asking himself how that will further his career. Another possibility: He’s made a lot of genre spoofs, and why stop now? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Ferrell stars as Armando, the good-hearted, slowwitted son of a macho rancher (the legendary Pedro Armendariz Jr., who died in 2011). His father fawns on Armando’s sleek, successful brother Raul (Diego Luna), who all of his life has gotten everything right that Armando got wrong. So feckless is Armando, indeed, that he has never felt the love of a woman. But when Raul returns home with the ravishing Sonia (Genesis Rodriguez), Armando and Sonia need no more than to meet eyes and the earth trembles with their instinctive passion. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("What the old man doesn’t suspect is that his ideal son is actually a drug dealer in cahoots with the dastardly drug lord Onza (Gael Garcia Bernal). Poor, innocent Sonia doesn’t know this either, and so it is up to Armando to save Sonia from the two scumbags and restore the honor of the family name. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("This is done in a film that quietly kids many of the technical shortcomings of low-rent Westerns, in particular the way they use backdrops and special effects to cover the lack of location shooting. Armando and Sonia, for example, ride side by side in a shot that doesn’t show their horses, and the background slides past at a different speed than the horses are apparently galloping. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The movie is only 84 minutes long, including credit cookies, but that is quite long enough. All the same, it’s fitfully amusing, and I have the sense that Spanishspeaking audiences will like it more than I did, although whether they’ll be laughing with it or at it, I cannot say. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a485"
    }
  }, [_vm._v("Casino Jack "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 108 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Kevin Spacey (Jack Abramoff), Barry Pepper (Michael Scanlon), Kelly Preston (Pam Abramoff), Rachelle Lefevre (Emily Miller), Jon Lovitz (Adam Kidan), Maury Chaykin (Big Tony). Directed by George Hickenlooper and produced by Gary Howsam, Bill Marks, and George Zakk. Screenplay by Norman Snider. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Political movies often play cute in drawing parallels with actual figures. They drop broad hints that a character is “really” Dick Cheney or Bill Clinton and so on. Casin"), _c('em', [_vm._v("o ")]), _vm._v("Jac"), _c('em', [_vm._v("k ")]), _vm._v("is so forthright it is stunning. The film is “inspired by real events,” and the characters in this film have the names of the people in those real events: Jack Abramoff, Michael Scanlon, Representative Tom DeLay, Ralph Reed, Karl Rove, George W. Bush, Representative Bob Ney, and Senator John McCain. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("This decision to name names by the director George Hickenlooper seems based on boldness, recklessness, or perhaps iron-clad legal assurances. His film uses a fictional sledgehammer to attack the cozy love triangle involving lobbyists, lawmakers, and money. It stars Kevin Spacey in an exact and not entirely unsympathetic performance as Abramoff, once one of the most powerful lobbyists in Washington, who was convicted on charges involving the funds he stole from wealthy Indian casinos while arranging laws for their convenience on Capitol Hill. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The first press screening of the film at the Toronto International Film Festival was witnessed in a sort of stunned silence by a capacity audience, interrupted slightly by an undercurrent of incredulous murmurs and soft laughter when Spacey, as Abramoff, in a fantasy sequence, explodes at a Senate hearing being chaired by McCain. Having invoked the Fifth Amendment repeatedly, he’s unable to restrain himself any longer and jumps to his feet to accuse the very members of the panel of having taken campaign contributions and favors from his Indian clients, and voting in their favor. Abramoff shows some degree of honor among thieves by not pulling such a stunt. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Astonishingly, Hickenlooper intercuts real footage of the real hearing and the real John McCain with Spacey’s performance. Can he get away with this? I guess so. The distributors, ATO, have no doubt had the film scrutinized by their attorneys. Apart from that, there’s the likelihood (which lawyers may think but cannot say) that no one named in this film is very likely to sue. The Abramoff scandal was called at the time the biggest since Watergate (both were broken by the "), _c('em', [_vm._v("Washington Post")]), _vm._v("), but in the years since his sentencing in 2006, his name has faded from everyday reference, and it’s doubtful anyone desires to make it current again. With Alex Gibney’s current doc "), _c('em', [_vm._v("Casino Jack and the United States of Money ")]), _vm._v("also around, those deep waters are being sufficiently stirred. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The film’s story line can be brieﬂy summarized: The lobbyist Abramoff was a dutiful family man and Republican standard bearer who defrauded Indian tribes out of millions to lobby for their casinos. That enriched him and his partner, Michael Scanlon (Barry Pepper), and a good many members of Congress, not all of them Republicans. He worked out every day, was an observant member of his temple, and a smooth and elegant dresser. And somehow at his core there were no principles and no honesty. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("If Casino Jack put up a good front, George Hickenlooper’s film is merciless with Scanlon, a venal and vulgar man with the effrontery to ﬂaunt his corruption. It is Spacey’s performance that contains most of the mystery of the movie, because although Abramoff’s actions left little room for justification, in Spacey’s performance there is some. He used much of the stolen money for good works, which made him appear charitable. His principal charity was himself, but there you are. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("There are scenes here that make you wonder why the Abramoff scandals (plural) didn’t outshine Watergate as the day does the night. Within Abramoff there is some small instinct for simple justice, and the film’s most dramatic scene comes as he snaps at that hearing, ignores his lawyer, forgets the Fifth Amendment, and tells the panel members to their faces that they were happy to take his cash. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The overall message of "), _c('em', [_vm._v("Casino Jack ")]), _vm._v("has become familiar. Corporate and industry lobbyists are the real rulers in Washington, and their dollars are the real votes. Both parties harbor corruption, the Republicans grabbing the breasts and thighs, the Democrats pleased to have the drumsticks and wings. Jack Abramoff didn’t invent this system. He simply gamed it until Scanlon’s boldness betrayed them and another generation of lobbyists took over. Have you heard the banks are broke again? ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a486"
    }
  }, [_vm._v("Catfish "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v("-13, 86 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Nev Schulman, Ariel Schulman, Henry Joost, Angela Pierce, Vince Pierce, and Abby Pierce. A documentary directed by Ariel Schulman and Henry Joost and produced by Schulman, Joost, Andrew Jarecki, and Marc Smerling. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Here’s one way to look at "), _c('em', [_vm._v("Catfish: ")]), _vm._v("Some filmmakers in New York City, who think they’re way cool, get taken apart by an ordinary family in Ishpeming, Michigan. You can also view it as a cautionary tale about living your emotional life on the Internet. Or possibly the whole thing is a hoax. At Sundance 2010, the filmmakers were given a severe crossexamination and protested their innocence, and indeed everyone in the film is exactly as the film portrays them. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("To go into detail about that statement would involve spoiling the film’s effect for you. I won’t do that because the effect is rather lovely. There’s a point when you may think you know what I’m referring to, but you can’t appreciate it until closer to the end. The facts in the film are slippery, but the revelation of a human personality is surprisingly moving. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The film opens in the Manhattan office of Nev Schulman, Ariel Schulman, and Henry Joost, who make videos and photographs of modern dancers. I’m going to guess they’re thirtyish. Nev has received a painting of one of his photographs from Abby Pierce, an eight-year-old girl. They enter into a correspondence—or, more accurately, Abby’s mom, Angela Pierce, e-mails for her. Just as well. Would you want your eight-year-old daughter in a chat room with some strange adult Facebook friend? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Never mind. Nev, a wholesome, even naive man, is touched by Abby’s paintings, and begins to identify with the whole family. He learns of school plans, pie baking, Sunday family breakfast, and the horse farm Abby’s nineteen-year-old sister, Megan, is buying. I doubted that detail. It would take a New Yorker to believe horse farms in Michigan are cheap enough for a nineteen-year-old to buy. She could afford a horse, farm not included. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Nev and Megan correspond and talk on the phone. Megan composes songs for Nev. They begin a cyberromance. Nev begins to wonder if this could possibly be the girl for him. There are dozens of photos on her Facebook site, and he even starts using software to put himself and Megan in the same photos. In anyone over, oh, fourteen, this is a sign of immaturity, wouldn’t you say? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The three videographers have to ﬂy to Vail to shoot a dance event. On the way back east, they decide to make a detour to Ishpeming. Were they born yesterday? Do they think you drop in unannounced on strangers? Using everhelpful GPS navigation, they pay a midnight visit to Megan’s horse farm, and find . . . no horses. In Ishpeming they do indeed find the Pierce home and family, and I suppose are welcomed with as much grace as possible under the circumstances. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The key to the human qualities in the film can be found in Angela, the mother, and in a couple of thoughtful statements by Vince, the father. You’ll see what I mean. Living in Ishpeming may not be the ideal choice for people with an artistic temperament. I haven’t been there and can’t say. But this family has adapted to realities and found ways of expression, and who are we to say making dance videos in New York is preferable? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Angela Pierce comes across as an essentially good person, as complex as the heroine of a novel. At the end of the day, I believe she humbles Nev and his friends. I wonder if they agree. They all seem to be nice people. Let’s agree on this: We deserve to share happiness in this world, and if we supply it in the way it’s sought and nobody gets hurt, is that a bad thing? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Note: Angela Pierce’s Web site is at "), _c('a', {
    attrs: {
      "href": "http://www.artbyapierce.com",
      "target": "_blank"
    }
  }, [_vm._v("http://www.artbyapierce.com")]), _vm._v(". ")])]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a487"
    }
  }, [_vm._v("Cave of Forgotten Dreams "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NO MPAA RATING")]), _vm._v(", 90 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("A documentary directed by Werner Herzog and produced by Adrienne Ciuffo and Erik Nelson. Screenplay by Herzog. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("About thirty-two thousand years ago, in a limestone cave above the Ardeche River in southern France, humans created the oldest cave paintings known to exist. They spring from the walls with boldness and confidence, as if the artists were already sure what they wanted to paint and how to paint it. Perhaps twenty-five thousand years ago, a child visited the cave and left a footprint, the oldest human footprint that can be accurately dated. At some time after the child’s visit, a rock slide sealed the entrance to the cave. In 1994, French archaeologists, searching for air plumes that might reveal the presence of a cave, found it again. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("They had to descend a narrow opening to its ﬂoor, far below on the original entrance level. It is their entry route that Werner Herzog follows in his spellbinding new film, Cav"), _c('em', [_vm._v("e ")]), _vm._v("o"), _c('em', [_vm._v("f ")]), _vm._v("Forgotten Dreams"), _c('em', [_vm._v(". ")]), _vm._v("Herzog filmed in 3-D to better convey how the paintings follow and exploit the natural contours of the ancient walls. The process also helps him suggest how the humans of the Upper Paleolithic era might have seen the paintings themselves, in the ﬂickering light of their torches. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Access to Chauvet Cave, named for one of its discoverers, was immediately closed off by the French government, and a locked steel door now bars the way to the air shaft. Behind that door the cave’s guardians enforce a strict regime. Herzog is allowed a four-man crew, including himself. They are limited to four cold-panel lights, powered from battery belts. They dare step only on two-foot-wide aluminum pathways that have been installed. They are allowed four hours. If anyone has to leave for any reason—even to get a screwdriver—that day’s visit is over; the guardians want to shield the cave’s air supply. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Surely men must have been painting somewhere before these cave walls were covered. It is hard to believe that these confident lines and shapes came into being without prelude. Or was there something innate in these forms? Accurate carbon dating suggests that other artists returned to the cave at least two thousand years after the first ones, and continued the work in the same style. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Only two very small sculptures in the cave show human forms. One is a woman, her sexual organs exaggerated to dramatize her fertility. The paintings themselves are all of animals, an astonishing variety, providing a bestiary of the valley at the time. Mammoths, cave bears, lions, bison, panthers, horses, rhinos. The rhinos have what are surely exaggerated horns, suggesting a desire to emphasize their power. Some of the drawings repeat horns and legs in an obvious attempt to depict movement. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("In addition to the footprint, there are poignant signs that humans were here. Near the original entrance, where outside light was still present, many visitors left their palm prints on a wall in red ochre. Were these the artists’ marks? Calling cards? Why did many leave them? A palm print stands out: One man had a damaged little finger. Farther back in the cave, they found another mark with the same finger. His two visits and a child’s footprint remain after twenty-five millennia. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Herzog’s limitation of four small portable light panels works to his advantage; as they move they suggest how the ﬂickering torches might have created an illusion of movement in those repeated features. The space was so limited it was impossible for his crew to stay out of many shots, and their shadows dance on the walls, just as the shadows of forgotten ancestors must have danced in the torchlight. Herzog’s inspiration is to show us the paintings as the cave’s original visitors must have seen them. I have seen perfectly lighted photographs of other cave paintings that are not so evocative. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Herzog says that in general he dislikes 3-D. But he believes there are occasions when 3-D is appropriate, and his film is one of them. It was shown with bright, wellfocused digital projection. Apart from a oneshot joke at the very end, he never allows his images to violate the theater space; he uses 3-D as a way for us to enter the film’s space, instead of a way for it to enter ours. He was correct to realize how useful it would be in photographing these walls. To the degree that it’s possible for us to walk behind Herzog into that cave, we do so. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Note: Based on my blog entry from the Toronto 2010 film festival. ")])]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a488"
    }
  }, [_vm._v("Cedar Rapids "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 87 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Ed Helms (Tim Lippe), John C. Reilly (Dean Ziegler), Anne Heche (Joan OstrowskiFox), Sigourney Weaver (Miss Vanderhei), Isiah Whitlock Jr. (Ronald Wilkes), Stephen Root (Bill Krogstad), Kurtwood Smith (Orin Helgesson), Alia Shawkat (Bree), Rob Corddry (Gary). Directed by Miguel Arteta and produced by Jim Burke, Alexander Payne, and Jim Taylor. Screenplay by Phil Johnston. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("You are making the mistake of thinking of Cedar Rapids as a small town. In Ceda"), _c('em', [_vm._v("r ")]), _vm._v("Rapids, a sweet comedy with a dirty mind, it is the metropolis, a sinkhole of sex, sin, and high living at an annual insurance industry convention. Into this pit of depravity descends the innocent and naive Tim Lippe (Ed Helms), who never before in his life has left his hometown of Brown Valley, Wisconsin. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Helms, from "), _c('em', [_vm._v("The Office")]), _vm._v(", is assigned to take the big trip after his boss dies in embarrassing circumstances. His character is a bachelor who still lives in his childhood home, although excitement has recently entered his life with his first affair. Yes, he’s sleeping with his grade school teacher Miss Vanderhei, who is played by Sigourney Weaver as a woman who has seen it all—if it’s in Brown Valley, anyway. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Lippe’s assignment: Attend the convention and come home with the coveted Two Diamonds Award. I immediately ﬂashed on the older son in "), _c('em', [_vm._v("Gates of Heaven")]), _vm._v(", sitting proudly behind and in front of plaques and statuettes and observing that he is displaying “the maximum trophies” to impress young recruits into—yes, it was the insurance business there, too. Apparently, the folks in Brown Valley prefer to deal with Two Diamonds winners. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The coveted award is the gift of Orin Helgesson (Kurtwood Smith), a mighty figure at the convention. I recall from my days as a cub reporter the selfimportance of “industry legends” who lovingly spoke at length to their captive audiences. Helgesson is very public with his piety, and it would be a disaster if he discovers how Lippe’s boss died. Lippe’s job is to stay out of trouble. Since he doesn’t smoke or drink and his sexual adventures are possibly limited to Miss Vanderhei, this should be easy. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The director, Miguel Arteta, understands that real laughter grows from characters. He has a rich start with Lippe, played by Helms as a man who is thrilled even to go through security at the airport. He calls Miss Vanderhei with breathless reports that his hotel has a swimming pool and that there is, gasp, an African-American in his room! This turns out to be his roommate, Ronald Wilkes (Isiah Whitlock Jr.), who is an old hand at the convention and a useful ally. His other roommate, Dean Ziegler (John C. Reilly), is trouble—a harddrinking womanizer and client poacher. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Now we know the story arc. Ziegler will lead Lippe into temptation, Wilkes will try to caution him, Orin Helgesson will be outraged, and the hotel pool will be involved in an unseemly way. All of this works out to be pretty funny, especially with the intervention of the sexy Joan OstrowskiFox (Anne Heche), whose trips to the convention are the highlight of her sex life, I hope. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Cedar Rapids ")]), _vm._v("has something of the same spirit of "), _c('em', [_vm._v("Fargo ")]), _vm._v("in its approach to the earnest natures of its small-towners. The two films, otherwise so different, like their characters. Some of them do unspeakable things, especially in "), _c('em', [_vm._v("Fargo")]), _vm._v(", but none of them "), _c('em', [_vm._v("want ")]), _vm._v("to be evil. They just hope to get out in one piece. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("It is a relief, for example, that Reilly’s Dean Ziegler isn’t a malicious buffoon, but simply a nice guy, terminally immature. And Ed Helms makes an ideal leading man because he always seems to be searching for someone to stand behind. The problem with so many madcap comedies is that their heroes cannot fully embrace cluelessness. It is funnier for a second banana to play the lead than for a lead to pretend to second bananahood. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a489"
    }
  }, [_vm._v("Cell 211 "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NO MPAA RATING")]), _vm._v(", 111 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Luis Tosar (Malamadre), Alberto Ammann (Juan Oliver), Antonio Resines (Jose Utrilla), Manuel Moron (Ernesto Almansa), Marta Etura (Elena), Carlos Bardem (Apache). Directed by Daniel Monzon and produced by Alvaro Augustin, Juan Gordon, and Borja Pena. Screenplay by Monzon and Jorge Guerricaechevarria, based on the novel by Francisco Perez Gandul. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_c('em', [_vm._v("Cell 211 ")]), _vm._v("is a thriller about a man’s attempt to save his life by thinking quickly. It never explains. It simply sets out the situation and shows us what he does and what the results are. You might be surprised by how much more exciting this is than conventional action. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The film won eight Goya awards, the Spanish Oscars, this year. It deserves them. In addition to its effectiveness as a thriller, it is also a film showing a man in the agonizing process of changing his values. And it is a critique of a cruel penal system. It doesn’t preach, it doesn’t end with a message, but it makes us think. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The story involves Juan Oliver (Alberto Ammann), a serious young man who reports a day early for his new job as a prison guard. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("We spend a little time with him at home with his wife, Elena (Marta Etura). She is pregnant. They are head over heels in love. They don’t have much money, but his new job will be a big help. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("As other guards are taking him on a tour of the prison, he is knocked unconscious in an accident. They carry him to a bunk in an empty cell, Cell 211, and are calling for help when a violent prison riot breaks out. Their lives are in danger, and they must leave him behind when they ﬂee. He regains consciousness and hears what is going on outside. He doesn’t know why he’s been left behind—he probably doesn’t recall the falling debris that knocked him unconscious—but he knows his shoes, shoelaces, and belt are fatal giveaways that he’s not a prisoner. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("And now we enter into real time with him, as he boldly walks into a public area and passes himself off as a new prisoner who was admitted only shortly before. The rioting prisoners are desperate. They’re led by a brutal strongman, a lifer with nothing to lose named Malamadre (Luis Tosar). Juan reads the situation immediately and improvises. Instinctively he takes the role of a man siding with his fellow prisoners. When he makes canny strategic suggestions, he seems to prove his worth. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I don’t want to describe any more than that in specific terms. Those really would be spoilers because in "), _c('em', [_vm._v("Cell 211 ")]), _vm._v("it is actually impossible to anticipate what will happen. The story follows no established formula. It discourages attempts at anticipation. It unfolds convincingly at every stage, but unpredictably. As Juan faces more stringent tests, he continues to improvise, sometimes devising masterstrokes. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The events in the cellblock are paralleled by two other stories: In the prison office, the warden and security staff monitor the security cameras. And in the city, Elena does some shopping and then learns of the riot in the prison where she knows her husband went that morning. Another strand consists of ﬂashbacks to their loving moments together, which are much more effective dropped in like this than coming before everything. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The dynamic in the film happens between Juan and Malamadre. In a subtle way, the director, Daniel Monzon, shows an understanding developing. Malamadre is relentless and unforgiving, resentful when Juan takes the lead in making suggestions but admiring of the new man’s courage. Very gradually, in the midst of the chaos, they exchange personal information. As Malamadre’s understanding of the full situation changes, his interpretation of it keeps pace. He isn’t a stupid man. Given his information, he makes logical decisions. When his information changes, he responds sanely and not without reason. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The term“mounting tension” is an overused cliché. To use it here would be appropriate. Little by little, one development at a time, the situation becomes more critical and the options for Juan and Malamadre grow more limited. And Juan’s life always hangs in the balance. There is a moment, indeed, when he says something on a walkietalkie that would have betrayed him if anyone had been listening. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The actors are well chosen. Luis Tosar, as Malamadre, is a powerful man, shorter than Juan but more muscular, his head shaved, his mustache and beard somehow ominous. Alberto Ammann, as Juan, is of medium build, not aggressive, a convincing mimic in the role he adopts. He is not too heroic and Tosar is not too villainous. They are trapped in this situation, and unwittingly they come to share it. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a490"
    }
  }, [_vm._v("Certifiably Jonathan "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NO MPAA RATING")]), _vm._v(", 80 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Themselves: Jonathan Winters, Jeffrey Tambor, Ryan Stiles, Sarah Silverman, Rob Reiner, Gary Owens, Howie Mandel, Robert Klein, Jimmy Kimmel, Kevin Dunn, Nora Dunn, Tim Conway, Rosanna Arquette, Patricia Arquette, David Arquette, Robin Williams, Jim Carrey. Directed by Jim Pasternak and produced by Richard Marshall. Screenplay by Pasternak. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Jonathan Winters is a fine and funny fellow, and deserves better than this. Out of the goodness of his heart, he agreed to be at the center of a mockumentary directed by Jim Pasternak. The result is not merely a bad film, but a waste of an opportunity. As he approaches eightysix, Winters is still active, still funny, enthusiastically involved in painting, and could have been the subject of a good film. This isn’t it. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The mockumentary form has many possibilities. They usually depend on satirizing the tone and feeling of a genre. The simple fact that it’s fake doesn’t make one successful. This one purports to show Winters at a crucial moment in his late ﬂowering as an artist, during which he gets a gallery opening, is championed by a famous art critic, and promised a show at the Museum of Modern Art. None of these nonevents is staged with style or conviction. They are simply walked through as if really happening. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("At the gallery, one of his paintings is stolen from a wall and Winters goes into a depression, finding himself unable to paint. It was, you see, his favorite painting. Pasternak leads a team that includes Winters himself to go to the house of the alleged thief. The house is unlocked, they walk in and find the painting, and Winters can paint again. Is there anyone reading this who can’t think of an approach that isn’t so lame? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Consider, too, the “curator” at the Museum of Modern Art. She is a pleasant woman who looks at negatives of Winters’s subDali paintings through a little magnifier and declares him worthy of a show. No effort is made to make her character or her process funny. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("It appears one reason for this film was for Pasternak to gain access to Jonathan Winters, spend an excess amount of time personally on camera, and use Winters as bait to lure his famous friends into the film. These include Robin Williams, Howie Mandel, Nora Dunn, Jim Carrey, Sarah Silverman, Tim Conway, Jeffrey Tambor, Jimmy Kimmel, Robert Klein, Ryan Stiles, Rob Reiner, Kevin Dunn, David Arquette, Patricia Arquette, and Rosanna Arquette. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("All of these friends are seen brieﬂy and forgettably. Only Robin Williams is funny. The others seem to be paying courtesy calls. With that much talent on the screen, it’s significant that the funniest moments belong to Winters, seen on old TV shows. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Much is made, in the title and by Winters himself, of his history of bipolar disorder. It’s assumed that today’s audiences will know what’s being referred to. In general, they won’t. It’s sad but true that many younger viewers won’t quite know the range of Winters’s brilliance. What would have been more appropriate: a tour through film and TV archives, memories of friends rather than testimonials, a real documentary instead of a fake one, and Jim Pasternak nowhere to be seen. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a491"
    }
  }, [_vm._v("Certified Copy "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NO MPAA RATING")]), _vm._v(", 106 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Juliette Binoche (Woman), William Shimell (James Miller). Directed by Abbas Kiarostami and produced by Kiarostami, Charles Gillibert, Marin Karmitz, and Nathanael Karmitz. Screenplay by Kiarostami. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_c('em', [_vm._v("Certified Copy ")]), _vm._v("invites us into an intriguing story and then strands us. Yes, we can consider various explanations for what we see, and yes, the film’s mystery is apparently its purpose. For me, it is too clever by half, creating fullbodied characters but inserting them into a story that is thin soup. I enjoy puzzles like Antonioni’s "), _c('em', [_vm._v("Blow-Up ")]), _vm._v("or "), _c('em', [_vm._v("L’Avventura")]), _vm._v(", about characters who don’t understand what has happened, but here there seems to be no underlying reality at all, and Abbas Kiarostami is playing with us. That he does it so well is a consolation. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("A woman (Juliette Binoche) attends a lecture in Italy by an art historian (William Shimell). He speaks on the difference between original art and its copies. Is there, in fact, any difference? The woman would like to meet him. She leaves the address of her antiquities shop. He appears, they engage in talk that is immediately ﬂirtatious, and she offers to drive him to a nearby village in Tuscany. In the course of the drive, and at a café after they get there, their apparent relationship seems to shift. The café owner hears them arguing, assumes they’re married, and then they begin to behave as if they’re married. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Which is the real relationship, and which is the counterfeit? Were they a couple pretending to meet for the first time, or a new couple pretending to be married? I believe that to begin with they are really meeting for the first time, and later they are really an established couple. Perhaps Kiarostami’s intention is to demonstrate how the reality is whatever the artist chooses, and that he can transfer from original art to a copy in midstream. Or perhaps that’s not possible. Perhaps I have no idea what he’s demonstrating. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The woman, who is not named, and the historian, named James Miller, are articulate, playful, and devious. I enjoyed watching them, whatever they were up to. Binoche and Shimell always stay in the moment and never signal us what they’re up to. Binoche seems so attracted to the man in the early scenes that it seems they must have some history. But it’s certainly not the history they later seem to reveal. Throughout "), _c('em', [_vm._v("Certified Copy ")]), _vm._v("there’s the sense of off-screen dimensions or untold side stories. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Kiarostami is rather brilliant in the way he creates off-screen spaces. Consider the opening scene. We clearly see that Binoche has a seat in the front row of the lecture hall, directly in front of the historian. Then the POV changes around to regard her, and we never see him again. Her son is standing at one side, trying to get her attention, eager to leave. She communicates with him using sign language and mouthing words. He comes over to her. She gives the man next to her a note with the address of her shop. She and the boy leave together. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("All this commotion is taking place, distractingly, close in front of the speaker—but we never see him react! Kiarostami creates an implied drama involving what Miller "), _c('em', [_vm._v("must ")]), _vm._v("be experiencing, but refuses to see it. There’s also implied off-screen activity during the long drive they take. The camera regards them through the windshield for extended dialogue passages, sometimes cutting to inside the car. Filming people as they drive is one of Kiarostami’s trademarks, and I wonder why. It is a way to explain why you’re showing two people side by side and looking ahead; if you put them on a park bench that would look odd. It’s also a way to imply off-screen events on the road and involving the passing scenery. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("What it comes down to is this: We assume there’s more going on here than meets the eye, but maybe what meets the eye is "), _c('em', [_vm._v("all ")]), _vm._v("that’s going on, and there is no complete, objective reality. Does that also apply to a copy of a masterpiece of art? Is a skillful copy of the "), _c('em', [_vm._v("Mona Lisa ")]), _vm._v("less valuable than the original painting? What if the original had been lost? Would we treasure the copy? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Such questions are raised by "), _c('em', [_vm._v("Certified Copy ")]), _vm._v("and not answered. Is raising them the point? Does Kiarostami know the answer? Does he care? At least we are engaged, and he does it well. Is that enough? I can explain "), _c('em', [_vm._v("Blow-Up ")]), _vm._v("and "), _c('em', [_vm._v("L’Avventura ")]), _vm._v("to my own satisfaction. This is the best I can do with "), _c('em', [_vm._v("Certified Copy. ")]), _vm._v("Perhaps it was wrong of me even to try. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a492"
    }
  }, [_vm._v("The Change-Up "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 101 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Ryan Reynolds (Mitch Planko), Jason Bateman (Dave Lockwood), Leslie Mann (Jamie Lockwood), Olivia Wilde (Sabrina McArdle), Alan Arkin (Mitch’s Dad). Directed by David Dobkin and produced by Dobkin and Neal H. Moritz. Screenplay by Jon Lucas and Scott Moore. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_c('em', [_vm._v("The Change-Up ")]), _vm._v("is one of the dirtiestminded mainstream releases in history. It has a low opinion of men, a lower opinion of women, and the lowest opinion of the intelligence of its audience. It is obscene, foul-mouthed, scatological, creepy, and perverted. As a bonus, it has the shabbiest low-rent main titles I’ve seen this side of YouTube. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("It is a body switch comedy. You remember those. There must have been dozens. Through some sort of magic, two characters find themselves occupying each other’s bodies, or their own bodies at different ages. This can be charming, as when Tom Hanks did it in "), _c('em', [_vm._v("Big ")]), _vm._v("or Jodie Foster in "), _c('em', [_vm._v("Freaky Friday. ")]), _vm._v("And remember Francis Coppola’s "), _c('em', [_vm._v("Peggy Sue Got Married")]), _vm._v(", with Kathleen Turner becoming herself as a teenager. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("To mention such movies in connection with this one is a sacrilege. Setting aside considerations of the story, "), _c('em', [_vm._v("The Change-Up ")]), _vm._v("sets out to violate and transgress as many standards of civilized conduct as it can. Don’t get me wrong. Faithful readers know I treasure cheerful vulgarity. But readers, I’ve seen "), _c('em', [_vm._v("The Hangover")]), _vm._v(", and this is no "), _c('em', [_vm._v("Hangover. ")])]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Here you will see projectile pooping into faces. Two men exposing themselves and urinating in a “magic fountain” in a shopping mall in the presence of small children. Three tattoo artists closely scrutinizing a woman’s vagina. Women systematically required to bare their breasts. Language in which nondisturbing? Would it leave you capable of perobscene words provide an oasis. Best buddies essentially sharing the same wife. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("OK, OK. In the context of a different movie, I can imagine all of those things working in a comedy. Except the public pissing. I think we can all agree that’s problematical. So let’s get back to the bare breasts. There are a great many of them, frequently and roughly fondled, for one reason only, and it isn’t eroticism. If it were, I would sympathize. It has to do with the systematic exploitation of every actress in a film where God forbid an actor would be asked to display his penis. (We don’t see penises in the urination scene. Only the kids can.) ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Now consider the leading characters. They are Mitch (Ryan Reynolds), a pothead layabout, and Dave (Jason Bateman), an attorney and father of three. They’ve been best friends since grade school. They envy each other’s lives. Through pissing in the fountain, they switch bodies and find out what that would be like. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("This involves Mitch, in Dave’s body, moving in with Dave’s wife, Jamie (Leslie Mann), and Dave involved in Mitch’s budding career as a porn actor. There is also a key role for Sabrina (Olivia Wilde), a legal aide at the law firm, who seduces Dave in the body of Mitch. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Never mind who does what and with which and to whom. The problem is that the movie requires us to accept this premise by making the characters aggressively stupid. Assume for the moment you are Jamie. Two men appearing to be your husband and his buddy Mitch claim their minds are in each other’s bodies. They tell you to ask them something the other guy wouldn’t know. She asks “Mitch” what “his” wedding anniversary is. Of course he doesn’t remember. But asking some men for their wedding anniversary is almost a gotcha! question. For women, a wedding anniversary is as ingrained as New Year’s Day. For men, it is more like Easter, and you can never remember what day it falls on this year. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("A few more questions, and the testing ends. Mitch and Dave give up and reconcile themselves to their fates. Dave moves into Mitch’s bachelor pad. Mitch moves into Dave’s suburban home. Say what? If you found your mind in another body, wouldn’t that be profoundly forming the duties in a movie comedy? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("One problem with the movie is that it requires us to constantly remind ourselves which of these two pleasantlooking thirtysomethings is which. Another problem is that no matter which, they are both low and crude beings with no respect for decency, and their language is foul beyond the call of fictional necessity. The film, in fact, seems to go out of its way to be vulgar and offensive, as if "), _c('em', [_vm._v("adult ")]), _vm._v("audiences crave such an assault. Anyone who enjoys this film cannot fairly be considered an adult. Pity about the R rating. It will keep out those callow enough to enjoy it. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a493"
    }
  }, [_vm._v("The Chaser "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½ ")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NO MPAA RATING")]), _vm._v(", 124 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Kim Yoon-suk (Jungho), Jung-woo Ha (Youngmin), Seo Young-hee (Mijin), Koo Bon-woong (Meathead). Directed by Na Hong-jin and produced by Choi Moonsu. Screenplay by Na Hong-jin, Hong Wonchan, and Lee Shinho. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_c('em', [_vm._v("The Chaser ")]), _vm._v("is an expert serial killer film from South Korea and a poster child for what a well-made thriller looked like in the classic days. Its principal chase scene involves a foot race through the deserted narrow nighttime streets of Seoul. No exploding cars. The climax is the result of everything that has gone before. Not an extended fight scene. This is drama, and it is interesting. Action for its own sake is boring. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The film is a police procedural with a difference: The hero is an excop named Jungho (Kim Yoon-suk), now a pimp, and he is not a nice man. He is angered because a client of his call-girl service has been, he believes, kidnapping his girls and selling them. When another girl disappears, a phone number raises an alarm, and he sets out to track down the client—who didn’t give an address but arranged a street rendezvous. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("What we know is that the client, Youngmin (Ha Jung-woo), is a sadistic murderer. The girl, named Mijin (Seo Young-hee), is driven in his car to an obscure address that she is not intended to ever leave alive. It is a characteristic of South Korean films that they display the grisly details of violence without ﬂinching; the rights to this film have been picked up by Warner Bros., and it’s dead certain the violence and the shocking outcome itself will be greatly toned down. Let me simply note that Youngmin’s tools of choice are a hammer and a chisel, for reasons a police psychiatrist has much to say about. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The film’s structure is relentless in maintaining suspense. We have reason to suspect the prostitute may still be alive, but dying. Both the pimp and the killer are arrested. A ludicrous attack on the mayor of Seoul becomes a media sensation and puts pressure on the cops to charge someone with something to change the headlines. The killer, a calm psychopath, claims first nine murders, then twelve, but changes his story and says he has no idea what he did with the bodies. He’s released on lack of evidence. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The story is an exercise in audience manipulation, especially with the corruption and incompetence of the police. The director, Na Hong-jin, knows exactly what he’s doing. Like the master, Hitchcock, he gives the audience precisely enough information to be frustrated. It is obvious to us what the characters should be doing, but there are excellent reasons why it isn’t obvious to them. If you can contrive that in a screenplay, you have already surpassed the level of the modern thriller. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Another strength of the film is in its attention to characters. The killer is seen as a mental dead zone, a man without conscience to whom good and evil are equally meaningless. The pimp begins as a merchant of sex, goes looking for Youngmin for simple mercenary reasons, and very gradually expands his concerns in response to the presence of the call girl’s young daughter. The daughter follows the Glossary Rule, which instructs us that all children in movies, told to stay put, quickly wander away into danger. Well, can we blame the director? How interesting would it be if she obediently stayed put? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("What I responded to was the streetlevel reality of the film. There are no supermen and no sensational stunts. When the actors run, we see that they are running. These shots extend in time and are not constructed of baffling editing. The spatial realities of the chases are respected; we begin to learn our way around the neighborhood. The cops are not stock characters, but just your average officers. No one in "), _c('em', [_vm._v("The Chaser ")]), _vm._v("seems on autopilot. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("When I see a film like this, it reminds me of what we’re missing. So many recent movies are all smoke and mirrors. A thriller is opening soon in which the star cannot be clearly seen to complete any physical act in an action sequence. We might as well be reading a comic strip, where our minds are expected to fill in the movement between the frames. You sit there and "), _c('em', [_vm._v("The Chaser ")]), _vm._v("unfolds and the director knows what he wants and how to do it without insulting us. In addition to remaking this movie, Hollywood should study it. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a494"
    }
  }, [_vm._v("Chasing Madoff "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NO MPAA RATING")]), _vm._v(", 90 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("A documentary featuring Harry Markopolos, Frank Casey, Neil Chelo, Gaytri Kachroo, and Michael Ocrant. Directed and produced by Jeff Prosserman. Screenplay by Prosserman, based on the book "), _c('em', [_vm._v("No One Would Listen ")]), _vm._v("by Harry Markopolos. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Through the best of times, through the worst of times, year after year, Bernie Madoff’s return on investment remained the same. The line on the graph climbed at a steady twenty-five degrees. It never faltered—until, like Wile E. Coyote, it ran off the edge of a cliff and continued running in thin air. Then came the collapse of a $50 billion Ponzi scheme, the largest in history. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("No one could believe it. In theory it was impossible. Market professionals knew in their guts his returns were impossible. And they all knew about Bernie. No matter where you went in the world of hedge funds, no matter who you spoke to, Bernie was the man everyone knew. They would be asked, “What do you know about Bernie?” They would reply, “What do "), _c('em', [_vm._v("you ")]), _vm._v("know about Bernie?” What they all knew was that nobody, but nobody, could get returns like that. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Chasing Madoff")]), _vm._v(" tells the story of a man named Harry Markopolos, who gathered the facts and figures about Madoff ten years before anyone else did. He had the charts. He had the graphs. It was as obvious as the day was long that Madoff was running a Ponzi scheme. How a Ponzi works: You never buy anything. You simply pay your current investors out of money from new investors. For this to work, you always need new money. For years, Madoff had it. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("“It can’t be a Ponzi,” his investors told each other, “because his fund is closed to new investment!” Yes, but they were able to buy in because they “knew somebody.” Madoff’s investors were rich people, other hedge funds, banks, trusts. You’d think people like that would know (a) there is no free lunch, and (b) you never put all your eggs in one basket. Remarkable numbers of them lost their total investment, however. In enclaves of millionaires, whole families were wiped out. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("My notion is that they were blinded by greed. They knew the numbers were impossible. But since Madoff stayed in business year after year, since he retained such a high profile, they might have told themselves: It can’t last, but I’m willing to clean up on other people’s losses. Then there were the professional managers who bought "), _c('em', [_vm._v("into ")]), _vm._v("Madoff’s funds for competitive reasons. For them it was a way to raise the rate of return on their investments. Many rich people had no idea they were invested in Madoff via “feeder funds.” The function of such funds was to provide outside capital to keep the Ponzi aﬂoat. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("But what about the Securities and Exchange Commission? What about the "), _c('em', [_vm._v("Wall Street Journal")]), _vm._v("? What about the "), _c('em', [_vm._v("New York Times")]), _vm._v("? Bloomberg News? Didn’t they know? Harry Markopolos told them. He was a respected professional. Year after year, he supplied them all with carefully documented evidence of what the scheme was and how it worked. The problem was, they didn’t want to know. Its scope was so vast, Madoff’s webs were so complex, that if it were true, that would make it the largest Ponzi scheme in history. Which it was, as I recall mentioning up above. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Chasing Madoff")]), _vm._v(" is not a very good documentary, but it’s a devastating one. It consists of this entire story told by Markopolos and his fellow Madoff chasers Frank Casey and Neil Chelo. There’s footage from congressional investigations. Staff members of the SEC are called on the carpet. No one from the "), _c('em', [_vm._v("New York Times")]), _vm._v(" or the "), _c('em', [_vm._v("Wall Street Journal")]), _vm._v(" is asked to explain the inaction of their newspapers. We do hear from individual investors who lost their life savings—but not from any of the traders or firms that bought into Madoff. Nor do we hear from Madoff himself. We get many portentous shots of skylines, Wall Street, the SEC headquarters, Madoff’s yacht, and cable news reports. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("There’s precious little, indeed, that we find out here but didn’t already know from the news coverage at the time. The only smoking gun is that Madoff’s guilt was exposed clearly and repeatedly by Markopolos in the decade before his fall. Not only did the system fail, but it failed because of the willful ignorance of those with the responsibility to make it work. What do we learn at the end of it all? There is no free lunch. Never put all your eggs in one basket. One of the many people who forgot those helpful rules was Bernie Madoff. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a495"
    }
  }, [_vm._v("Chicago Heights "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NO MPAA RATING")]), _vm._v(", 90 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("William Gray (Sherwood Anderson/Old Nathan), Keisha Dyson (Elizabeth Walker), Andre Truss (Nathan Walker), Benny Stewart (Dr. Reefy), Jay Johnson (Reverend Curtis Hartman), Ron Jarmon Jr. (Wash Williams), Simone Wilson (Louise Trunnion). Directed by Daniel Nearing and produced by Sanghoon Lee. Screenplay by Nearing and Rudy Thauberger, based on the novel "), _c('em', [_vm._v("Winesburg, Ohio")]), _vm._v(", by Sherwood Anderson. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Sherwood Anderson’s "), _c('em', [_vm._v("Winesburg, Ohio")]), _vm._v(", is sometimes named as a great work of fiction that cannot be filmed. Daniel Nearing demonstrates in "), _c('em', [_vm._v("Chicago Heights ")]), _vm._v("that that’s not necessarily true. The book is a collection of twenty-two short stories connected by the character George Willard, who comes of age in Winesburg and reﬂects on the citizens he has grown to know. Perhaps one could make twenty-two short films. Nearing finds an approach that in ninety minutes accomplishes the uncanny feat of distilling the book’s essence. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Anderson’s Winesburg is a town with roads that can be walked along a short distance into the country. His time frame spans the twentieth century’s first quarter. Nearing’s Chicago Heights is a distant southern suburb of Chicago, bordering on farmland. His time is the present and recent decades. His central character is Nathan Walker (Andre Truss), also played as Old Nathan by William Gray, and at that age is named in the credits as Sherwood Anderson. Anderson’s characters were all white. Nearing’s characters are all African-American. Race is not really a factor. We are concerned with inner selves. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("It’s helpful, maybe essential, to be familiar with the book before seeing the movie. Anderson explains his theory of grotesques, by which he means not sideshow freaks but people who have one aspect of their body or personality exaggerated out of proportion to the whole. Wing Biddlebaum, for example, has hands so expressive they ﬂutter like birds, and these beautiful hands are the cause of his isolation and hatred by the community. All of the characters have some special reason they don’t fit in. This attribute is why their inner thoughts and dreams never become known. They are judged by the uncaring and will be buried never understood. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("What Nearing does, and it is rather brilliant, is show us Nathan in old age, under a blanket on his bed, remembering, dreaming, or hallucinating about the people he has known. A narrator explains his thoughts. Remarkably for a film of average length, Nearing touches on almost every one of Anderson’s characters, and because of his meditative stylistic approach the film never feels rushed or choppy. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The film is mostly in contrasty black and white, sometimes slipping into color. Dialogue slips in and out, too, as it does in the book, but we’re not intended to think it’s being said now. It’s being heard in memory. Chicago Heights is seen as a not particularly lovely place, drowsing near the prairie with the skyline of modern Chicago in the distance. Much of it was shot on location, and Nearing succeeds in establishing it as a place like Winesburg where the countryside is always in walking distance, and one can go there with one’s grotesqueries and feel at peace. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("When I say it helps to have read the book, I don’t mean to frighten you. Perhaps you could read just a few of the stories to begin with. They won’t take long, and once you understand their workings, the whole film will come into focus. Nearing is not the first artist to be drawn to Winesburg"), _c('em', [_vm._v(". ")]), _vm._v("It inspired a made-for-TV film and a Broadway musical, and inﬂuenced authors such as Hemingway, Faulkner, Steinbeck, and Salinger. It is a beautiful book and has inspired this beautiful film. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a496"
    }
  }, [_vm._v("Chico and Rita "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NO MPAA RATING")]), _vm._v(", 93 m., 2012 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Limara Meneses (Rita), Emar Xor Ona (Chico), Mario Guerra (Ramon), Lenny Mandel (Ron). Directed by Fernando Trueba, Javier Mariscal, and Tono Errando and produced by Santi Errando, Cristina Huete, Martin Pope, and Michael Rose. Screenplay by Trueba and Ignacio Martinez de Pison. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_c('em', [_vm._v("Chico and Rita ")]), _vm._v("enjoyed one of   the biggest surprises in the 2012 Oscar nominations by winning a slot as best animated film. That meant this indie production placed ahead of such bigtime entries as Spielberg’s "), _c('em', [_vm._v("Adventures of Tintin. ")]), _vm._v("The reason for that is the story and the music, I suspect, not the animation. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("This is a nearly operatic romantic tragedy, involving a lifelong affair of the heart between two Havana musicians: Chico, a piano player, and Rita, a vocalist. Their mutual problem is that Chico is unfaithful by nature, and although Rita is the woman he loves, when he’s not with the one he loves, he loves the one he’s with. Rita is twotimed once too often, and sets off on her own—a mistake, because when they’re together they have a taste of stardom, and when apart a tendency to selfdestruct. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The film opens in Batista’s Havana, a hotbed of jazz and AfroCuban music, where luxurious clubs, casinos, and hotels have created a Caribbean entertainment mecca, mostly controlled by American gangsters and corporations. It’s a ﬂuid, exciting scene, where in one night Chico can discover Rita singing in an openair club and sweep her along when he’s discovered by Woody Herman in a show in a beachfront hotel. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Herman’s piano man is sick. Chico and Rita walk in, Chico is recruited to fill the empty piano stool, it’s clear how talented he is, and in no time at all he and Rita team up to win a talent contest on a radio station and a lucrative contract. They even have a hit record, masterminded by a breezy con man named Ramon, who dedicates himself to managing them. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Life takes them to New York and a hit record, but the faithless Chico loses Rita to the company of a slickster Yankee named Ron, who gets her a few good bookings before she blows a Vegas gig by being drunk on stage. The story is told in ﬂashback from Chico’s lonely life today and Rita’s equally cheerless existence. The problem we have with their romance is that most of the time it isn’t working. We don’t sense the urgency of their passion so much as the finality of their problems. Apparently, they’re doomed to exist in a permanent state of breakup. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The animation by codirectors Fernando Trueba, Javier Mariscal, and Tono Errando is filled with motion and color, yes, but could have benefited from characters who seemed more like quirky individuals and less like types. Oddly, the backgrounds were the parts of "), _c('em', [_vm._v("Chico and Rita ")]), _vm._v("I liked the most: Havana in its preFidel days of big spenders, New York in the heyday of jazz, Paris when foreign musicians were hot, Vegas in its early golden years. Architecture, neon signs, and big, classic American cars are all done with brio and abandon. It’s entertaining to watch, and I enjoyed the way they slipped in such real-life figures as Dizzy Gillespie beside the fictional leads. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The music is terrific. Idania Valdes dubs Rita’s sensuous, smoky singing voice, and the film is essentially constructed as a musical. There came a point when the sweep of the romantic story caught me up as much as a narrative film might have, and I wasn’t distanced by the animation. After seeing the film, I went online to see if Chico and Rita were inspired by real-life musicians. None in particular, I learned. But probably a great many in general. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a497"
    }
  }, [_vm._v("Chinese Take-Away "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NO MPAA RATING")]), _vm._v(", 93 m., 2012 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Ricardo Darin (Roberto), Ignacio Huang (Jun), Muriel Santa Ana (Mari), Ivan Romanelli (Leonel). Directed by Sebastian Borensztein and produced by Pablo Bossi, Juan Pablo Buscarini, Gerardo Herrero, and Ben Odell. Screenplay by Borensztein. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Here is a movie about a man with a very particular personality, who finds himself sharing his hermitlike existence with another man who has no particular personality at all. They don’t even speak the same language. "), _c('em', [_vm._v("Chinese Take-Away ")]), _vm._v("becomes a bemused study about how they infiltrate each other’s lives. It is a consideration of the life of loneliness, for those who choose it and those who have it forced upon them. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Roberto is the grouchy owner of a small hardware store in Buenos Aires. So small that he is the only employee, and would have it no other way. He considers most people fools and idiots, counts the screws in a box of 500 to see if he is being cheated, and has been known to order a customer out of the store for having the temerity to request a few grams of nails. He lives in an apartment connected to the store, prepares his own meals, and dines alone while scanning newspapers for stories confirming his belief that life has no meaning. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("One day a taxi squeals to a halt and the driver throws out his passenger, a young Chinese man. Roberto is offended. This confirms his belief that all taxi drivers are jerks. The young man speaks no Spanish, but expresses himself in a torrent of anguished Mandarin. He has an address written on his arm. Roberto gives him a lift to that address, but the current tenant says she bought the house a few years ago from a Chinese man. She has no forwarding address. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("That is the most Roberto can be expected to do, and he leaves the young man at a bus stop to find his own way. He goes home, a downpour begins, and he cannot help himself but must drive out to the bus stop, pick up the stranger, and bring him home. This is already an unthinkable breach of his habits. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Roberto is played by the soulful Argentinean actor Ricardo Darin, whom you may remember from "), _c('em', [_vm._v("The Secret in Their Eyes. ")]), _vm._v("He is fiftyish, unassumingly mustached, has weary eyes, is fed up most of the time. His guest, named Jun (Ignacio Huang), is a smoothfaced youth who is baffled to find himself adrift in Argentina, and whose response is cordial passivity. Neither is skilled at communicating without words. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The middle sections of Sebastian Borensztein’s film involve Roberto’s ineffectual warnings that Jun cannot stay, as Jun listens uncomprehendingly. Using a Chinese takeaway deliveryman as a translator, they find Jun is searching for his uncle. Visits to the police station, the Chinese Embassy, and Chinatown are fruitless. The two men share silent meals, and Jun does some odd jobs around the store. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("We meet Mari (Muriel Santa Ana), who is visiting the relative who delivers Roberto’s standing orders for countless newspapers. Roberto and Mari share sort of a history, shown in a brief and startling ﬂashback. Mari makes it no secret that she likes him. Roberto doesn’t want to be liked. As nearly as possible, he wants to be left alone, passing his time counting screws, insulting customers, and scanning the newspapers for items about people dying in ridiculous ways. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("It is hardly possible to suggest how involving this story becomes. One can see how it could have been a comedy, but this is no comedy. Ricardo Darin’s performance evokes the solitary isolation of Roberto and his almost tangible fear of knowing or being known. He isn’t cruel or hostile; he acts out of some deep apprehension. Nor is Jun the sort of man we might imagine, ingratiating and accommodating. He projects no expectations at all, and passively accepts all of Roberto’s actions and decisions. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Chinese Take-Away ")]), _vm._v("insinuates itself. To a degree unusual in most films, I became involved in the fates of these men, perhaps because they make no attempt to be likable. They are consistent with their natures, and the director tells the story with a clean, no-nonsense narrative. If there will be surprises, we can’t guess where they will possibly come from. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Many really good films allow us to empathize with other lives. I became invested in Roberto, and shared his curiosity about the enigmatic Jun. I cared. The film deserved my care. Although one of its revelations is astonishing, it doesn’t come because of trickery, but is consistent with information we already have. It is no easier for Roberto to process than it is for us. At the end, all we know for sure is that perhaps life is not entirely meaningless. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a498"
    }
  }, [_vm._v("Chloe "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 96 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Julianne Moore (Catherine Stewart), Liam Neeson (David Stewart), Amanda Seyfried (Chloe), Max Thieriot (Michael Stewart), R. H. Thomson (Frank), Nina Dobrev (Anna). Directed by Atom Egoyan and produced by Jeffrey Clifford, Joe Medjuck, Ivan Reitman, Simone Urdl, and Jennifer Weiss. Screenplay by Erin Cressida Wilson, based on the motion picture Nathalie"), _c('em', [_vm._v(", ")]), _vm._v("directed by Anne Fontaine. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Looking down from her office window, she sees a young woman who has the manner and routine of a high-priced call girl. This she stores in her memory. When her husband says he missed his ﬂight back to Toronto and she finds a disturbing photo on his iPhone, she goes to the hotel where she saw the girl, makes eye contact with her in a bar, contrives a conversation in the powder room. The girl, with perfect calm, explains that single women are not usually her clients. Couples, maybe. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Atom Egoyan finds intrigue at the edges of conventional sex. "), _c('em', [_vm._v("Chloe, ")]), _vm._v("like his great film "), _c('em', [_vm._v("Exotica ")]), _vm._v("(1994), is about sexual attraction confused by financial arrangements. It centers on a powerfully erotic young woman with personal motives that are hidden. It is not blatant but seductive, depending on the ways that our minds, more than our bodies, can be involved in a sexual relationship. It’s not so much what we’re doing as what I’m thinking about it—and what you’re thinking, which may be more complex than I realize. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Catherine Stewart (Julianne Moore) is a gynecologist, a successful one, judging by the house she inhabits fresh from the cover of "), _c('em', [_vm._v("Architectural Digest")]), _vm._v(". Her husband, David (Liam Neeson), is an expert on opera. The call girl she saw from her window is Chloe (Amanda Seyfried), young, redlipped, intelligent. Catherine explains to Chloe that she suspects her husband of adultery and wants to test if he would try to pick up another woman. She tells Chloe where her husband always has lunch. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Early in the film, talking with a patient uncertain about her sex life, Catherine explains that an orgasm is a simple muscular contraction, quite natural, nothing to be frightened of or make mysterious. Orgasms for Catherine, however, involve a great deal more than muscles, and a great deal depends on whom they are experienced with, and why. Chloe tells her about entering a café, boldly asking David if she can take the sugar from his table, and returning to her own. David understands that Chloe is not interested in sugar. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Chloe meets with Catherine to relate this encounter. Chloe is good at this. She informs us early in the film that she is skilled at what she does. It’s not a matter of renting her body. She uses her intelligence to intuit what a client desires—really desires, no matter what the client might claim. And she knows how to provide this in a way that will provoke curiosity, even fascination. Now she describes details to Catherine that do a great deal more than provoke a wife’s jealousy about her husband. They provoke an erotic curiosity about her husband. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Chloe is perhaps twenty-five years younger than Catherine, but in many ways wiser and more experienced. She is certainly more clear about what it is she really wants. She enjoys the psychological control of her clients, and her own skill in achieving that. She looks so young and innocent, but her life has taught her many lessons. Seyfried plays Chloe as a woman in command of her instrument—her body, which is for sale, and her mind, which works for itself. Moore, that consummate actress, undergoes a change she only believes is under her control. Neeson is an enigma to his wife and in a different way to us. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Egoyan follows his material to an ultimate conclusion. Some will find it difficult to accept. Is it arbitrary? Most of life’s conclusions are arbitrary. I am not sure this particular story should, or can, be wound up in a conventional manner. It’s not the kind of movie that depends on the certainty of an ending. It’s more about how things continue. I have deliberately withheld much of the story, which he leaves for you to understand. His central fascination is with Chloe’s motives. Does she act only for money? Does she do only what is requested? Does she remain emotionally detached? Does she get anything for herself besides money? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("At one point she’s asked how she can relate to some of her clients, who might seem unattractive, even repugnant. A call girl has no idea who will open the door after her knock, and the ground rules are that she will gratify the client’s desires, if he can pay and she doesn’t feel in personal danger. But how can she endure some of them? “I try to find something I can love,” she says. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("After you see the movie, run through it again in your mind. Who wants what? Who gets what? Who decides what? Whose needs are gratified? Atom Egoyan never makes a story with one level. He never reveals all of the motives, especially to his characters. He invites us to be voyeurs of surfaces that may not conceal what they seem. Fundamental shifts can alter all the relationships. All the same, their sexuality compels his characters to make decisions based on their own assumptions. It is a tangled web he weaves. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a499"
    }
  }, [_vm._v("Chronicle "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v("-13, 83 m., 2012 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Dane DeHaan (Andrew), Alex Russell (Matt), Michael B. Jordan (Steve), Michael Kelly (Richard), Ashley Hinshaw (Casey), Bo Petersen (Karen), Anna Wood (Monica). Directed by Josh Trank and produced by John Davis and Adam Schroeder. Screenplay by Max Landis. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Man, you couldn’t get me down into that hole in the ground for all the beans in Boston. It’s perfectly circular, in the middle of a gloomy, grassy field, and Matt and Steve talk Andrew into bringing his new video camera and filming as they disappear into its dark maw. They use the camera’s light and, of course, the screens on their iPhones. They can’t see the bottom. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("It’s spoiling hardly anything to tell you they find some sort of weird, crystalline object. The letters UFO spring to mind. They stare at it and maybe it stares back. Then they discover they can move Lego pieces using only their minds. This is called telekinesis. Matt looks it up in the dictionary. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("From this deceptively ordinary beginning, John Trank’s "), _c('em', [_vm._v("Chronicle ")]), _vm._v("grows into an uncommonly entertaining movie that involves elements of a superhero origin story, a science fiction fantasy, and a drama about a disturbed teenager. Andrew (Dane DeHaan) is a shy and unpopular high school student with a dying mother and a meantempered drunk for a father. Matt (Alex Russell) is his cousin and only friend, a smart kid who quotes Plato as they descend into the hole. Steve (Michael B. Jordan) is cheerful, handsome, and running for class president—all the things Andrew isn’t. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Whatever it is that happened to them in the hole gives them something overwhelming in common: They have new, challenging superpowers. Discovering this, they act like a bunch of kids. Hell, they "), _c('em', [_vm._v("are ")]), _vm._v("a bunch of kids, and the screenplay by Max Landis does a convincing job of making them realistic teenagers. This is a “found footage” movie like "), _c('em', [_vm._v("Blair Witch")]), _vm._v(", allegedly shot on Andrew’s camera. At a dance, Matt meets the friendly Casey (Ashley Hinshaw), who is making a video diary of her own life for her blog. With two cameras, Chronicl"), _c('em', [_vm._v("e ")]), _vm._v("gets around the problem that with found footage you never see the character holding the camera. Later, we’ll see other points of view: surveillance cameras, cell phone movies, and, toward the end, some sensational events on TV news. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The movie is delightful for its first hour or so, and then turns dark and disturbing. The friends test their new powers and decide they’re like muscles—you have to build them up slowly. This they do like mischievous teenagers. If you can lift a leaf blower at a distance, for example, you can use it to blow cheerleaders’skirts above their heads. You can put on an amazing magic show at school. For that matter, you can levitate the camera and get nice “steadicam” shots. Matt, the most responsible one, believes they should keep their powers secret. That will be impossible once Andrew begins to act out the antisocial rage boiling inside him. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Sometimes a movie comes out of the blue that announces the arrival of considerable new talents. Josh Trank is twenty-six and this is his directing debut. Max Landis is twenty-six and has written a couple of shorts. His father is the director John Landis, but connections don’t teach you how to write. Dane DeHaan, Michael B. Jordan, and Alex Russell are in their early or midtwenties, have some experience, and work together easily here as an ensemble. It’s their convincing acting and Landis’s dialogue—not just the late drama, but the early goofing around—that gives the movie a natural authenticity. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Chronicle")]), _vm._v(" seems at first to be all goofing around. It’s Andrew’s tortured personal life that steers it into deep currents, although they have fun getting there. These are teenagers who must think they’ll live forever. Not only do they go down into that hole, but they discover they can ﬂy up into thunderstorms. Even if you could ﬂy to ten thousand feet, would you "), _c('em', [_vm._v("want ")]), _vm._v("to? “It’s cold up here!” one of them shouts. I forget which one. There was some lightning at the time. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a500"
    }
  }, [_vm._v("The Chronicles of Narnia: The Voyage of the Dawn Treader "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v(", 115 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Skandar Keynes (Edmund), Georgie Henley (Lucy), Will Poulter (Eustace), Ben Barnes (King Caspian), Gary Sweet (Ship’s Captain), Tilda Swinton (White Witch). And the voices of Simon Pegg (Reepicheep), Liam Neeson (Aslan the Lion). Directed by Michael Apted and produced by Andrew Adamson, Mark Johnson, and Philip Steuer. Screenplay by Christopher Markus, Stephen McFeely, and Michael Petroni, based on the novel by C. S. Lewis. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("The alarming thing about Narnia is that you might be in the same room with it. It could be inside that old cupboard. Or, this time, inside that painting with the nautical theme. Those waves look so real. In fact, says Lucy, they almost look like they’re moving. The next thing we hear is, “I’m inside the painting!” ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Indeed she is, and the "), _c('em', [_vm._v("Dawn Treader ")]), _vm._v("is approaching over the waves. Her nuisance of a cousin Eustace unwisely pulls the painting from the wall, and seawater rushes out and fills the room until they seem in danger of drowning, but no, they surface and are rescued by sailors from the ship, captained by Caspian (Ben Barnes), who almost seems to have been expecting them. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("The Chronicles of Narnia: The Voyage of the Dawn Treader, ")]), _vm._v("third of the films inspired by the C. S. Lewis tales, once again requires the services of English children to rescue an alternate universe. How a universe is possible that requires participation from a parallel universe I will leave to theoretical physics. If you don’t ask a question, it’s not a question. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("On board the sailing vessel, Lucy (Georgie Henley), her brother Edmund (Skandar Keynes), and young Eustace (Will Poulter) ask no questions. They’re too blissful to be back in Narnia, despite the hairraising adventures they had in the earlier films. Lucy and Edmund, now in their midteens, seem uncommonly calm about being yanked from their everyday lives and put on a strange ship in uncharted seas, but these kids have pluck. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("They’re briefed on the situation: Narnia is threatened by evil forces from the mysterious Dark Island, which no one has seen but everyone has heard about. There is a matter of seven missing magical swords representing the Lords of Telmar, which were given to Narnia by Aslan the Lion and must be brought together again to break a spell that imprisons the lords. Obviously, these kids can do it. Eustace is perhaps seven years old, but, hey, bring the kid along. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("On board the ship is a peppy little swashbuckling rat named Reepicheep (voice of Simon Pegg). He walks upright, speaks assertively, falls squarely into the semiobligatory Cute Little Sidekick role, has a heroic heart, and a cute little sword he is unafraid to brandish. Why the little fella has never been stepped on and squished goes unexplained. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("It’s a rough voyage. There is a tempest. There is a horrifying battle with a sea monster. The monster looks big enough to send the "), _c('em', [_vm._v("Dawn Treader ")]), _vm._v("to the bottom with its tail, but the Narniaites prevail, not least because Reepicheep scampers up the rigging and imparts a nasty ﬂesh wound. As they sail from one Narnian island to another seeking the swords, a series of other challenges confronts them, including an ominous sea fog as alarming as Stephen King’s "), _c('em', [_vm._v("The Mist. ")])]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("A climactic voyage to the Dark Island becomes necessary, and it is fraught with hazards. Halfrations of food and water for all on board! No one knows how far it is. Lucky thing they know in which direction to sail. If they overshoot the island they may sail off the edge of the earth, Columbus having not existed in Narnia. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The island, first glimpsed from a distance, looks ominously like a skull, with the glow of possible volcanoes in its skeleton eyes. Skull Island comes to mind. Here the fate of Narnia will be sealed. The island, we’re told, is the habitation and embodiment of pure Evil; I suppose, since Lewis intended his books as Christian allegory, it is Hell. The kids and the crew of the "), _c('em', [_vm._v("Dawn Treader ")]), _vm._v("are up against it, and Eustace is greatly pleased by being transformed into a firebreathing dragon. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("If I’ve lingered overmuch on the story, it’s because mostly what you have is a series of opportunities for special effects. The characters have characteristics rather than personalities, and little selfconsciousness. They spring to the service of the plot—which, not particularly coherent, boils down to one damn thing after another. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Still, this is a rip-snorting adventure fantasy for families, especially the younger members who are not insistent on continuity. Director Michael Apted may be too good for this material, but he attacks with gusto. Nor are the young actors overly impressed by how nobly archetypal they are; Lucy (who is really the lead) could give lessons to Harry Potter about how to dial down the selfimportance. A universe may hang in the balance, but hey, it’s only a movie. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I’m afraid it’s in 3-D. I will say it has the best rendition of 3-D I’ve seen in one of these action spectaculars; Apted uses it and is not driven by it. The light level is dimmed. It always is in 3-D. I wish I could have seen it in 2D. If you can, try to. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a501"
    }
  }, [_vm._v("Circumstance "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 107 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Nikohl Boosheri (Atafeh), Sarah Kazemy (Shireen), Reza Sixo Safai (Mehran), Soheil Parsa (Firouz), Nasrin Pakkho (Azar), Sina Amedson (Hossein), Keon Mohajeri (Joey). Directed by Maryam Keshavarz and produced by Keshavarz, Karin Chien, and Melissa Lee. Screenplay by Keshavarz. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_c('em', [_vm._v("Circumstance ")]), _vm._v("begins as the story of two teenage Iranian girls in love, and if it had continued to focus on the impossibility of their relationship in everyday modern Tehran, I think it would have been more successful. Unfortunately, it strays into unlikely melodrama and distracting eroticism. Still, it is a bold statement about the treatment of women in general in the modern Islamic state. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("We meet Atafeh (Nikohl Boosheri) and Shireen (Sarah Kazemy), two high school girls who share a big crush. This they keep secret from their families—Atafeh’s, whose professional parents are conformist but not unkind, and Shireen’s, whose uncle is raising her after her dissident parents ran afoul of the clerical authorities. They frequent clandestine stores with Western videos, attend secret parties, smoke, dance, and steal away to their bedrooms to share fantasies of the freedom they could share in nearby Dubai. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Unfortunately, these fantasies are visualized all too sensuously by writer-director Maryam Keshavarz, who uses light, color, and music to suggest escapes that would have been more at home in an American lesbian romance. If the two young women had been more realistic, innocent, and naive, I would have believed in them more. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Then, at about the halfway point, a miscalculation arrives in the form of Atafeh’s brother, Mehran (Reza Sixo Safai). Just returned from drug rehabilitation, he is subjected to enforced urine tests by their father, although Mehran protests he is cured. And so he seems to be, although his cure takes the form of an Islamist dogma that has turned him into much more of an extremist than anyone else in his family. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("That this happened so quickly is a little unlikely. We sense something unwholesome about Mehran, who incredibly hides spy cameras in the family home to keep track of Atafeh and Shireen; his interest is more voyeuristic than liturgical. One senses here a halfrealized ambition by the first-time filmmaker to emulate Hitchcockian motifs, but the film never organizes Mehran’s peculiarities to a particular purpose. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Atafeh’s father, Firouz (Soheil Parsa), and mother, Azar (Nasrin Pakkho), come across as reasonable parents, given their society, who want only a quick and safe marriage for their daughter. One day Firouz takes the family to the beach, where he and Mehran go swimming and he says to the women, “One day we can all go swimming.” The implication is that he regrets the prohibition of women in bathing suits, but observes it. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The strongest message for most Western audiences will be the way subjugation of women saturates every aspect of this society and clearly informs even Mehran’s kinkiness. Yes, but I wish Keshavarz had chosen a more low-key, everyday approach to two ordinary teenagers, and gone slow on the lush eroticism and cinematic voyeurism. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a502"
    }
  }, [_vm._v("City Island "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v("-13, 103 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Andy Garcia (Vince Rizzo), Julianna Margulies (Joyce Rizzo), Steven Strait (Tony Nardella), Alan Arkin (Michael Malakov), Emily Mortimer (Molly Charlesworth), Ezra Miller (Vinnie Rizzo), Dominik Garcia-Lorido (Vivian Rizzo). Directed by Raymond de Felitta and produced by Felitta, Andy Garcia, Zachary Matz, and Lauren Versel. Screenplay by Felitta. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Vince is a man with a dream. Marlon Brando is his god. He would like to become an actor. This is not likely. He’s well into his forties, a prison guard living with his family on City Island, a bucolic outcrop of the Bronx known mostly to its residents. Telling his wife he’s going to a poker game, he attends acting classes in Manhattan. In one class, Vince creates a spot-on imitation, not of Marlon Brando, but of bad Brando imitators. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Vince, played by Andy Garcia with brawny blue-collar dialogue, is married to Joyce (Julianna Margulies), who’s convinced the poker games mean a mistress. His children hide secret lives. His daughter, Vivian (Dominik Garcia-Lorido), has dropped out of college and is working as a stripper in hopes of saving money to reapply. His son, Vinnie (Ezra Miller), is hooked not just on any old Internet porn, but on sites featuring fat women who eat on camera. The younger son in so many movie families is somehow weird. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Two lifechanging experiences happen to Vince. At work, he gets a new prisoner whose name he has reason to recognize. He pulls the kid’s file to confirm it: Tony (Steven Strait) is the son he fathered in a longago affair. Meanwhile, in acting class, his teacher (Alan Arkin) assigns the students to pair up and share their biggest secret in order to prepare for a monologue. He draws Molly (Emily Mortimer), who slowly draws this secret from him. They meet often in the city—not to have an affair, but because they become friends and confidants. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Tony is eligible to be released into the community, but has no family member to sign for him. Vince determines to bring him home for a month. This is the catalyst for upheaval in the longestablished pattern of his life. Cit"), _c('em', [_vm._v("y ")]), _vm._v("Island"), _c('em', [_vm._v(", ")]), _vm._v("written and directed by Raymond de Felitta, has a serious side but is essentially a human comedy, at times almost a gentle farce, as discoveries and revelations drop like explosives. You can imagine this story as the outline for an opera. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Garcia and Margulies, who worked so well together in George Hickenlooper’s "), _c('em', [_vm._v("The Man from Elysian Fields ")]), _vm._v("(2001), show a sure feel for comedy here, especially after he introduces an unexplained stranger into his home: “You just decided to bring a prisoner home to "), _c('em', [_vm._v("live ")]), _vm._v("with us?” Convinced the poker games are a cover-up, she toys with the idea of fooling around with the hunky Tony. Molly, meanwhile, convinces Vince to try his luck at an open audition for a new movie. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("There’s a jolly subplot involving their next-door neighbor on City Island, a fat woman who Vinnie was following on the Web when—OMG!—he sees her on the way to the grocery store, and she asks if he wants to come along. This cheerful woman, played by an actress not listed on IMDb, defuses any awkwardness or discomfort and invites Vinnie and Tony over for some lasagna. Thus Felitta sidesteps a story hazard. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The last scene of the movie could indeed be used in an opera, with all of the leads onstage. It may strike you as a tad coincidental. So it is. Felitta has the good sense not to make it realistic, which it could not be. In the satisfactory tradition of comic melodrama, he tidies up all the loose ends. But don’t get the idea "), _c('em', [_vm._v("City Island ")]), _vm._v("is a laugh riot. For this story about these people, it finds about the right tone. They’re silly and foolish, as are we all, but deserve what happiness they can negotiate. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Note: ")]), _vm._v("City Island "), _c('em', [_vm._v("won the Audience Award at the Tribeca Film Festival 2009. ")])]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a503"
    }
  }, [_vm._v("Clash of the Titans "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v("-13, 106 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Sam Worthington (Perseus), Gemma Arterton (Io), Mads Mikkelsen (Draco), Alexa Davalos (Andromeda), Jason Flemyng (Calibos/King Acrisius), Ralph Fiennes (Hades), Liam Neeson (Zeus). Directed by Louis Leterrier and produced by Kevin De La Noy and Basil Iwanyk. Screenplay by Travis Beacham, Phil Hay, and Matt Manfredi, based on the 1982 screenplay by Beverley Cross. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("There are too many Greek gods for me to keep straight, since as a child I didn’t have action figures as a learning tool. I was prepared to take notes during "), _c('em', [_vm._v("Clash of the Titans, ")]), _vm._v("but only wrote down a single one: “‘Release the Kraken!’—Conan O’Brien.” I know I was intended to be terrified by the release of the Kraken, but all I could think of was O’Brien shouting “Release the bear!” and then some guy in a bear suit runs out and sits on the lap of a guest. In this case, the Kraken is the nuclear option for Zeus, who has been persuaded by Hades to put down a revolt by the upstart mortals of Argos. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The mortals are fed up with the whims of the gods. It would be one thing if they stayed on Olympus and killed time leaning on pillars and addressing one another in thundering ultimatums. Now they meddle in the affairs of men. King Acrisius of Argos declares war and enlists the aid of a demigod who has been found at sea. This is Perseus (Sam Worthington), son of Zeus (Liam Neeson) and a human mother. He didn’t ask to be a savior, but would be happier as a simple fisherman. You know the type. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Zeus, it should be explained, disguised himself as the husband of Perseus’s mother and stole into her bedchamber to father the boy. So he is a rapist. Just sayin.’ Perseus so loved his mother and adoptive father that he will never forgive Poseidon for drowning them, and wants nothing to do with gods. Yet such is his destiny. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The outcome is told in "), _c('em', [_vm._v("Clash of the Titans ")]), _vm._v("with impressive technical mastery and somewhat lesser dramatic command. For its intended audience I suspect this will play as a great entertainment. I enjoyed myself, particularly after they released the Kraken. There’s no particular dramatic conﬂict in the movie: Perseus has to wrestle with his demigod ambiguity; Hades (Ralph Fiennes) nurses a resentment against Zeus; he demands the sacrifice of King Acrisius’s daughter Andromeda (Alexa Davalos) to spare the city, and the citizens seem prepared to get along very nicely without her. That’s about it. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("It’s strange how the sacrifice of one person makes us uneasy. Earlier in the film, the entire ﬂeet of Argos is lost at sea, with the exception of the vessel holding Perseus. The king is philosophical: They were patriots. But the sacrifice of his own daughter—now you’re talkin’ real death. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Most of the film involves terrifying battles between mortals and special effects. After Calibos has a hand chopped off, his fingers grow into claws. Later, his blood drops start growing, creating a crowd of huge lobstermonsters that come crawling over rocks and snapping at everyone. Later in the film, inexplicably, these lobsters appear to be tame and walk obediently across the desert, bearing little houses on their backs for the mortals. What, did they forget they were the blood of Calibos? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("There’s worse to come. Perseus and his comrades must invade the lair of Medusa, one of the three Gorgon girls, whose hair is a writhing mass of snakes and body is a long, lethal snake’s tail. Look at her, and you’ll turn to stone! Maybe this explains the high quality of Greek sculpture. The struggles with Medusa take place on ledges over a ﬂaming lake of lava far below. She must be beheaded, which Perseus does, thoughtfully keeping the head, which he carries around like the head of Alfredo Garcia. Is that a spoiler? The story has been out since 490 B.C. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The climax is classic, with the fair Andromeda hung by her wrists and suspended in a clinging white gown over a ﬂaming pit at the edge of the sea. Meanwhile, Perseus ﬂies to the rescue on the wings of the great ﬂying horse Pegasus. The townspeople clamor for her death, but lose their enthusiasm after the Kraken rears up from the sea. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I like this kind of stuff. I don’t say it’s good cinema, although I recognize the craftsmanship that went into it. I don’t say it’s good acting, when the men have so much facial hair they all look like Liam Neeson. I like the energy, the imagination, the silliness. I even like the one guy who doesn’t have a beard. That’s Perseus. From the first moment we see him as an adult until his last scene in the movie, he has the Standard Regulation MachoLength Stubble on his chin. And in a city where all the men go to Jerry Garcia’s barber, he has a burr cut on the short clipper setting. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("So do I recommend the movie? Yes, if you intuit that this review is affectionate and have the same tolerance for goofy Greek gods as I do. One word of consumer advice, however. Explain to kids that the movie was not filmed in 3-D and is only being shown in 3-D in order to charge you an extra five dollars a ticket. I saw it in 2D, and let me tell you, it looked terrific. Split the difference: “We see it in 2D, I save five bucks, and I increase your allowance by $2.50 this week.” ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a504"
    }
  }, [_vm._v("Cold Weather "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½ ")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NO MPAA RATING")]), _vm._v(", 96 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Cris Lankenau (Doug), Trieste Kelly Dunn (Gail), Raul Castillo (Carlos), Robyn Rikoon (Rachel). Directed by Aaron Katz and produced by Lars Knudsen, Brendan McFadden, and Ben Stambler. Screenplay by Katz. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_c('em', [_vm._v("Cold Weather ")]), _vm._v("is good in so many subtle ways I despair of doing them justice. It’s a thriller involving the personalities of its characters, who we get to know surprisingly well. It remains low-key, even during its final big chase scene, which involves only one car. The acting is so good you may not notice it. Although the characters stumble over the plot at least forty minutes into the film, it’s as ingenious as a high-tech Friday night special. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The tone is established by Doug (Cris Lankenau), a midtwenties guy who was studying forensics in college but dropped out for no reason he ever explains. In an opening scene he tells his parents “it’s a possibility” he may return to school. For now, he’s returned to Portland, Oregon, and is sleeping on the sofa of his sister’s apartment. He finds a job in a factory that makes those plastic bags filled with ice, and spends his time shifting bags from one place to another. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Doug and his sister, Gail (Trieste Kelly Dunn), get along fine. No sibling problems. At work, he makes a friend named Carlos (Raul Castillo) and lends him a book of Sherlock Holmes stories. Carlos likes it. Doug’s former girlfriend Rachel (Robyn Rikoon) comes to town from Chicago and gets a motel room while she trains for a job, she says. The four characters spend some time together. No big deal. Carlos asks Rachel to a Star Trek convention. Doug is fine with that. He remains friends with Rachel but their romance is over with. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Why am I telling you these inconsequential things? Because the movie seems quite willing to spend its running length following the daily lives of nice, low-key, ordinary, even endearing twentysomethings. All four actors, unknown to me, are natural and convincing, like people you would cast with Catherine Keener, if you know what I mean. Cris Lankenau and Raul Castillo as Doug and Carlos do a very difficult thing here, which is to play young male friends without the slightest shadow of Buddy Movie Syndrome. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Carlos grows alarmed. Rachel stood him up on a date. Possibly inﬂamed by Sherlock Holmes and Doug’s studies in forensics, he talks him into an investigation of what he is convinced is a mysterious disappearance. Now at last there is a plot. About the plot I will tell you nothing, except that I could believe in it. I’m not sure Rachel would use the code described here, or that Doug would figure out how to break it, but never mind. Carlos sensibly says, “We need some common sense,” they both enlist Gail, and Doug and Gail find themselves trailing a man in a cowboy hat after having an absolutely realistic sibling conversation about which of them will drive Gail’s car. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("That’s it. Aaron Katz’s direction is just about ﬂawless. It’s a matter of finding the right tone, established by Doug at the outset, and following it through. It’s about a distaste for artificial tensionheightening devices. It’s about love of these characters. It’s about seeing if smoking a pipe, like Sherlock Holmes did, might help. It’s about how an ice factory gets rid of its excess ice. Some people will find this movie boring. That may be because they’ve been deadened by thrillers that don’t pay any more attention than they do. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a505"
    }
  }, [_vm._v("The Company Men "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 115 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Ben Affleck (Bobby Walker), Chris Cooper (Phil Woodward), Kevin Costner (Jack Dolan), Tommy Lee Jones (Gene McClary), Maria Bello (Sally Wilcox), Rosemarie DeWitt (Maggie Walker), Craig T. Nelson (James Salinger). Directed by John Wells and produced by Wells, Claire Rudnick Polstein, and Paula Weinstein. Screenplay by Wells. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("The happiest people I come into contact with seem to be those who have real jobs. In the last few weeks, I’ve talked with a Macintosh tutor, a doctor, a set designer, a stagehand, a heating and airconditioning man, a lawyer, a Web designer, my editor, an animator, and Millie Salmon, the woman who is my caregiver, although that job description makes me sound more decrepit than I am. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("All of these people work hard, know what they’re doing, think it’s worth doing, enjoy it, and take pride in it. There is the same serenity I sensed from my father, who was an electrician and a damned good one. I do not, on the other hand, pick up good feelings from those people I know who are largely involved in “making money for the stockholders.” They focus on moving money around, hiring and firing, cutting costs, serving the bottom line. They are caregivers for corporations, which would be more satisfactory if corporations were not essentially balance sheets. I know the Supreme Court has ruled that corporations are individuals, but when did one ever tell you a good joke? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("The Company Men ")]), _vm._v("follows the stories of characters who have oriented their lives around a corporation named GTX. Years ago this company involved two men who began building ships; small ones at first, and then big ones. Now it’s called General Transportation Systems, which is how we spell Acme these days. Caught in the economic downturn, GTX is downsizing, and some of its employees are discovering their primary occupation was making and spending a lot of money, and that without those jobs there isn’t much they really know how to do. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("We focus at first on Bobby Walker (Ben Affleck), who drives a Porsche and has a nice golf handicap, a big suburban house, and a wife, named Maggie (Rosemarie DeWitt), who is an expert consumer. Bobby loses his job. His severance and “savings cushion” can’t support his overhead. He enters, with great displeasure, the shadow world of the unemployed. His company has paid for temporary office space at a job search center that helps with his résumé. He attends sessions in group therapy where he learns how to present himself and think positively. He loathes them. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Phil Woodward (Chris Cooper), an older man at GTX, is also fired. If there is no great demand for Bobby, there is none for an unemployed executive around sixty. He was literally his job. Without it, in economic terms, he is a man with no buyers and nothing to sell. He was under the impression he had importance and value. He realizes that was a fiction. Employees of corporations are like freeranging scavenger cells. When the corporation inhales in good times, they find themselves in a warm place with good nurture. When it exhales in bad times, they go spinning into the vast, indifferent world. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("GTX was started by Salinger (Craig T. Nelson) and McClary (Tommy Lee Jones). McClary preserves the belief that a corporation owes its employees some loyalty, and that it should serve a useful function. Salinger has outgrown that phase and realizes a corporation survives only by maximizing its profits and producing one primary product: income. As Salinger’s vision prevails over McClary’s oldfashioned idealism, the inexorable task of “working for the shareholder” is reduced to “sacrificing the jobs and lives of others for the bottom line.” ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Although the actors are convincing and the film well crafted, "), _c('em', [_vm._v("The Company Men ")]), _vm._v("delivers few satisfactory character portraits because the movie isn’t really about characters; it’s about economic units. When a corporation fires you, it doesn’t much care whether you’re a good friend, a loving father, a louse, or a liar. You are an investment it carries on its books, or not. The impact of the movie comes when these people realize that, in economic terms, it doesn’t matter who they are. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("There’s one character who really does something. This is Jack Dolan (Kevin Costner), Bobby’s brotherinlaw, who owns a small construction company that builds one house at a time. He and his workers know how to make house siding lie true, how to use materials efficiently, how to—well, how to drive a nail. Bobby has always dismissed Jack as a “working man,” but when you’re out of work, that looks pretty good. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Written and directed by John Wells, Th"), _c('em', [_vm._v("e ")]), _vm._v("Compan"), _c('em', [_vm._v("y ")]), _vm._v("Me"), _c('em', [_vm._v("n ")]), _vm._v("offers no great elation or despair. Its world is what it is. We all live in it. In good times young people go to the movies and dream of becoming Gordon Gekko. In bad times, a housebuilder looks more like a Master of the Universe. It happens I’ve been talking with a few young people who are trying to make career decisions. My advice involves the old cliché, “Find what you really love doing and make that your profession.” I think this is true. If you have to be unemployed, it might seem less bleak if you hated doing the job anyway. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a506"
    }
  }, [_vm._v("Conan O’Brien Can’t Stop "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 89 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Conan O’Brien, Andy Richter, Steve Kroft, Eddie Vedder, Stephen Colbert, Jon Stewart, Jim Carrey, and Jack White. A documentary directed by Rodman Flender and produced by Rachel Griffin and Gavin Polone. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_c('em', [_vm._v("Conan O’Brien Can’t Stop ")]), _vm._v("has a title of piercing accuracy. After NBC and Jay Leno pulled the rug out from under him, O’Brien went overnight from hosting "), _c('em', [_vm._v("The Tonight Show ")]), _vm._v("to being banned from television for six months. To be sure, NBC paid him $40 million in a sendoff package, but the O’Brien we see in the film wasn’t in it for the money. He was in it because he can’t stop. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I appeared many times on his original program, most memorably being attacked by a man in a bear suit. I always liked him. I’ve also been on Carson, Oprah, Letterman, Leno, Regis, Arsenio, Joan Rivers, and a.m. here and a.m. there. You arrive at least an hour early, finish with makeup, leave your dressing room door open, and watch what happens in the corridor. Carson, Conan, and Leno would drop by to say hello. I don’t remember seeing the others before airtime. Letterman in particular seems to build up steam in private. It has nothing to do with who’s nice and who isn’t. It’s showbiz. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Watching this documentary, I realize that when Conan lost Th"), _c('em', [_vm._v("e ")]), _vm._v("Tonigh"), _c('em', [_vm._v("t ")]), _vm._v("Sho"), _c('em', [_vm._v("w ")]), _vm._v("he was like Wile E. Coyote, chasing the Road Runner of his dreams off the edge of a cliff and afraid to look down. Enraged at Leno and NBC, he quickly undertook “The Legally Prohibited from Being Funny on Television Tour,” which covered thirty-two cities, from Radio City Music Hall to the Bonnaroo Music Festival in Tennessee—where inside a tent in onehundreddegree heat he was expected to introduce every act, and did. You get the notion he would have introduced them anyway. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Here is a man driven to assert himself. He waited five years for "), _c('em', [_vm._v("The Tonight Show, ")]), _vm._v("lost it in months, and needed to say to the universe, “Sir! I exist!” The film, directed by Rodman Flender, watches him before and after shows and en route between cities, seeing a man incapable of giving himself a break. Overworked, exhausted, assaulted by demands, he cannot say no to an autograph, patiently hosts waves of visitors in his dressing room, drums up work on his days off, and at times seems on the edge of madness. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Everyone around him pays a price. He relentlessly nibbles away at his support system, picks on his personal assistant, needles his sidekick Andy Richter, and dominates his “writers” so compulsively that I can hardly recall one of them being allowed to say anything at meetings. He seems to consider them more of an audience. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Why these people stay with him is a mystery. My guess is that they know him better than we do and realize he’s undergoing a crisis. He’s driven. After shows, exhausted, he insists on going out to sign autographs and pose for photos with fans. The photos in particular are a version of the Water Torture Test for celebrities. The fan hands a camera to a friend or bystander, who "), _c('em', [_vm._v("inevitably ")]), _vm._v("doesn’t know how to operate it. The celebrity remains in position, his mouth frozen in the rictus of a smile, while the fan explains how the camera operates: “You push this button.” ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("In addition to telling jokes, O’Brien plays guitar and joins a Back-up band and various guest stars to perform countryrock. He’s surprisingly good, for a talk show host. He fantasizes receiving a text message from Jay Leno (“What’s it like to have a soul?”). I can only imagine how well he sleeps. We see his wife in only one brief, early scene, and I suspect she was well advised not to come along. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("This is not to say Conan O’Brien is a bad man. In fact, after the movie, I rather admired him. What we are seeing is a man determined to vindicate himself after a public humiliation. People attend his shows, cheer him, like him. That proves something, doesn’t it? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("What we don’t see are the details of what must have been going on all this time in negotiations to find a new television home after the end of the six-month banishment. He and his agents must have been talking about a lot of possibilities, including TBS, where he ended up. Those would have added a maddening level of frustration to his exhausting existence. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("O’Brien started out as a writer. He must have been driven to become a performer. It is a need in some people. One of the almost unbelievable stories in talk show history is how Johnny Carson was able to retire at the height of his popularity, and mean it, and stick to it. Maybe one of the reasons people liked him so much is that he never seemed to "), _c('em', [_vm._v("need ")]), _vm._v("to perform. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Other people do. I once observed Henny Youngman taping a TV show in the old NBC studios at the Merchandise Mart in Chicago. We got into an elevator together. It stopped at the second ﬂoor, a private club. A wedding was under way. Youngman got off the elevator, asked to meet the father of the bride, and said, “I’m Henny Youngman. I’ll do ten minutes for a hundred dollars.” ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a507"
    }
  }, [_vm._v("Conan the Barbarian "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 102 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Jason Momoa (Conan), Stephen Lang (Khalar Zym), Rachel Nichols (Tamara), Ron Perlman (Corin), Rose McGowan (Marique). Directed by Marcus Nispel and produced by John Baldecchi, Boaz Davidson, Randall Emmett, Joe Gatta, Avi Lerner, Danny Lerner, Fredrik Malmberg, and Les Weldon. Screenplay by Thomas Dean Donnelly, Joshua Oppenheimer, and Sean Hood, based on the character created by Robert E. Howard. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_c('em', [_vm._v("Conan the Barbarian ")]), _vm._v("involves the clash of civilizations whose vocabularies are limited to screams, oaths, grunts, howls, ejaculations, exclamations, vulgarities, screeches, wails, bellows, yelps, and woofs. I’d love to get my hands on the paycheck for subtitling this movie. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The plot involves—oh, never mind. You have your Barbarians and they kill one another in an unending series of battle scenes. I guess Conan is the good guy, but what difference does it make? He has no cause or belief. He’s driven by revenge against the sadistic Khalar Zym (Stephen Lang), who trapped Conan’s father under a vat of molten iron, assigned young Conan to exert his little muscles to try to keep it from tipping, and screamed at the old man: “You will watch your child die trying to save you!” ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Luckily, Conan (the muscular Jason Momoa) survives and grows up with no worse than a photogenic scar on his face, where some wayward molten iron dripped. He and his father, Corin (Ron Perlman), had earlier forged his sword at the steel moltery; earlier still, the infant Conan was delivered on a battlefield by an emergency cesarean performed by Corin’s own sword on his mother, who survives long enough to say, “He shall be named Conan.” She was so weak she lacked the breath to say, “Conan the Barbarian.” ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The movie is a series of violent conﬂicts. People who despair of convincing me to play video games tell me, “Maybe if you could just watch someone else playing one!” I feel as if I now have. Conan carves, beheads, disembowels, and otherwise inconveniences the citizens of several improbable cities, each time in a different fanciful situation. The evil Khalar Zym and his girlfriend Marique (Rose McGowan) turn up regularly, uttering imprecations, with Marique especially focused on Conan’s warrior gal pal Tamara (Rachel Nichols). ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("This Marique, she’s a piece of work. She has white pancake makeup, bloodred lips, cute little facial tattoos, and wickedly sharp metal talons on her fingers. At one point she blows some magic dust at Conan, and the dust turns into a team of warriors made of sand. This is a neat special effect, although it raises the question, if you turn back to sand when Conan slices you, what kind of a life is that? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The film ends with a very long battle involving Conan, Khalar Zym, Tamara, and Marique, a sentence I never thought I’d write. It takes place largely with Tamara strapped to a revolving wheel above a vertiginous drop to ﬂames far below. Mention is made of a volcano, but never further explained. The entire cavern crumbles around them, big chunks of rock falling everywhere except, luckily, upon them. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Conan the Barbarian is a brutal, crude, witless high-tech CGI contrivance, in which no ")]), _vm._v("artificial technique has been overlooked, including 3-D. The third dimension once again illustrates the principle that when a movie largely takes place indoors in dimly lit spaces, the last thing you need is a pair of dark glasses. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a508"
    }
  }, [_vm._v("The Conquest "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NO MPAA RATING")]), _vm._v(", 110 m., 2012 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Denis Podalydes (Nicolas Sarkozy), Florence Pernel (Cecilia Sarkozy), Bernard Le Coq (Jacques Chirac), Hippolyte Girardot (Claude Gueant), Samuel Labarthe (Dominique de Villepin). Directed by Xavier Durringer and produced by Eric Altmeyer and Nicolas Altmeyer. Screenplay by Durringer and Patrick Rotman. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_c('em', [_vm._v("The Conquest ")]), _vm._v("is a feature about recent French politics that makes me yearn for a similar American treatment of our own. Scored with Felliniesque circus music, it shows such figures as Nicolas Sarkozy, Jacques Chirac, and their wives on a merrygoround of vanity, vulgarity, and viciousness. I’m not an expert on French politics, but I gather the director and cowriter, Xavier Durringer, has worked by simply cranking up the energy under what everybody knows really happened. The result at times approaches screwball comedy. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("But no, this isn’t deliberate comedy. It’s essentially realistic. It’s simply that the real lives of these figures are funny. Most of the major players here are in the same political party, we hardly hear about their opponents, the focus is on infighting within the government, and they warmly hate one another. As I follow our own GOP primaries, I would love to see this approach adapted to Newt Gingrich’s real feelings about Mitt Romney and listen in on his language. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The film opens with a problem that would become chronic with current French president Nicolas Sarkozy (Denis Podalydes), who was then a minister angling for higher cabinet posts in the government of Jacques Chirac (Bernard Le Coq). It is an election day, and his wife, Cecilia Sarkozy (Florence Pernel), is nowhere to be found. Sarkozy refuses to be seen voting without his wife at his side, and Cecilia is so mad at him she refuses to appear. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("French political spouses obviously lack the rigorous training on the campaign trail that American partners receive. In our country a spouse is in it for the long haul, and must be prepared to spend eighteen months in an endless series of campaign appearances, smiling and waving, loyal and staunch, every word and gesture under close guard. French campaigns are much shorter and more brutal. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Cecilia occupies an intriguing dual role: (1) She is Sarkozy’s most inﬂuential and trusted adviser; (2) she hates politics, and considers a political campaign to be a sadistic form of reality television. It is also apparently the case that the Sarkozy marriage is being held together with duct tape and bailing wire. At times the two can barely stand to be in the same room together, and yet fate has yoked them to a common goal. They want power, and they want to win. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Sarkozy emerges here as a fascinating figure. Small and hyperactive, a campaigning welterweight, he is nakedly ambitious, but so are they all. After a seemingly cordial meeting with Sarkozy, Chirac tells an adviser: “The little bastard wants my job.” To become president, Sarkozy envisions a series of more and more important cabinet posts, and to keep him in check, Chirac envisions a series of less and less important posts. Since it is clear to everyone that this is the game, it contributes admirably to the amusement level of the French body politic. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("To be a candidate for office is a condition few of us would wish upon ourselves. Even having pleasure at mealtime, a sacred occasion in France, is diminished. Some of the more absorbing scenes in "), _c('em', [_vm._v("The Conquest ")]), _vm._v("involve the major players, sometimes together, often just as twosomes, dining elegantly in ornate rooms of state while smiling pleasantly and cordially insulting each other. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I don’t believe it’s necessary for a nonFrench viewer to know a lot about French politics in order to enjoy this movie. What you need is an appreciation of human nature. The actors, especially Denis Podalydes and Florence Pernel as the Sarkozys, provide in their performances all the personal background you require. We know the film is about politics, we can see how the characters feel about one another, we can apply their behavior to the politicians we’re familiar with. It’s a macabre but not boring process. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a509"
    }
  }, [_vm._v("The Conspirator "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v("-13, 121 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("James McAvoy (Frederick Aiken), Robin Wright (Mary Surratt), Kevin Kline (Edwin M. Stanton), Evan Rachel Wood (Anna Surratt), Danny Huston (Joseph Holt), Justin Long (Nicholas Baker), Colm Meaney (General David Hunter), Alexis Bledel (Sarah), Tom Wilkinson (Reverdy Johnson). Directed by Robert Redford and produced by Redford, Brian Peter Falk, Bill Holderman, Greg Shapiro, Robert Stone, and Webster Stone. Screenplay by James Solomon. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("In the period following the assassination of Abraham Lincoln, those holding together the wounded federal government were desperate to bring charges against the guilty. Their problem was they couldn’t find them. John Wilkes Booth, the gunman, was captured soon after the deed and shot by a Union soldier who was acting against orders. Prosecutors felt he was part of a conspiracy including about eight people. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("The Conspirator")]), _vm._v(", Robert Redford’s new film, takes up the story in a postwar Washington convincingly shot on location in Savannah, Georgia. He approaches it as a legal procedural, concerned not only with the case but also with the legal precedents it established, which we are still dealing with today. Crucially, it tried a civilian in a military tribunal, denying her the right to a jury of peers that is guaranteed in the Constitution. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("This civilian was named Mary Surratt (Robin Wright). She owned a boardinghouse in Washington, where Booth and his fellow plotters met. They were brought there by her son, John. Surratt was charged as a coconspirator. Secretary of War Edwin M. Stanton (Kevin Kline), the de facto power in Washington despite the presence of President Andrew Johnson, wanted her tried and convicted quickly, to placate an enraged population. He gave the assignment to defense attorney Reverdy Johnson (Tom Wilkinson), who passed it to a young Union veteran named Frederick Aiken (James McAvoy). ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Aiken wanted nothing to do with it. He felt Surratt must certainly be guilty. Johnson, a Southerner, felt he couldn’t take the case with passions running so high, and forced the job upon the Northerner Aiken, explaining that Surratt had a right to a competent defense. Surratt is certainly not helpful to her young attorney, because her only thought is to protect her son. Gradually, however, Aiken begins to believe it is possible she was not involved in the meetings of the conspirators. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Redford considers this material in an unusually literate and thoughtful historical film, working from years of research by his screenwriter, James Solomon. I found it absorbing and relevant today. It is useful to reﬂect that it isn’t "), _c('em', [_vm._v("her ")]), _vm._v("constitutional rights that are being violated, but our own, because the Constitution must be seen to work equally for all or it loses its strength for everyone. The language and reasoning of Stanton echo with similar statements by George W. Bush and Dick Cheney in defense of the Patriot Act, and Reverdy Johnson in this reading would represent Barack Obama, more a compromiser than an idealist. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The film depends on Robin Wright and James McAvoy for its human appeal. Wright’s performance is deliberately withdrawn and restrained. Having apparently concluded she is certain to be found guilty, she’s reluctant to cooperate with her attorney. In a sense, because of his ambivalent feelings about her, he’s trying his case against himself. His conversion to her cause is essentially his conversion to the underlying constitutional principles involved. As he argues in the military tribunal, he is arguing about its very presence in a case involving a civilian woman with no role in the military. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Redford could have vulgarized this material. He and Wright certainly have the skills to make Mary Surratt a passionate, heroic victim. They choose not to. They require us to think our own way through the case, and arrive at our own opinions, and that is the value of "), _c('em', [_vm._v("The Conspirator. ")]), _vm._v("In most historical dramas, the opinions are already in and the conclusions already reached. Redford and his producers, the American Film Company of the Ricketts family, show respect in their treatment of a littleknown footnote to a well-known story. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Well, was Mary Surratt a conspirator? I put the question point blank to Redford recently, and he said he thought she must surely have known what her son was discussing with the others under her roof. But her guilt isn’t the issue. The film is about the correct means of determining guilt—or innocence. If the Constitution says you can’t do something, if it guarantees a due process, then it must be obeyed. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("All of this requires a lot of theory, a lot of philosophy, and a lot of dialogue. Those most interested in American history will probably find it most valuable. Those who want a historical romance or a courtroom potboiler will be disappointed. You have to give credit to Redford, Wright and McAvoy, and the other filmmakers. Not many films this smart can be made. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a510"
    }
  }, [_vm._v("Contagion "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v("-13, 105 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Gwyneth Paltrow (Beth Emhoff), Matt Damon (Mitch Emhoff), Laurence Fishburne (Dr. Ellis Cheever), Kate Winslet (Dr. Erin Mears), Marion Cotillard (Dr. Leonora Orantes), John Hawkes (Roger), Jude Law (Alan Krumwiede), Jennifer Ehle (Dr. Ally Hextall), Elliott Gould (Dr. Ian Sussman), Sanaa Lathan (Aubrey Cheever). Directed by Steven Soderbergh and produced by Gregory Jacobs, Michael Shamberg, and Stacey Sher. Screenplay by Scott Z. Burns. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("A black screen. The sound of a harsh cough. We are already alert when, soon after, we see a bartender pick up a customer’s coin and then punch numbers into a cash register. Germs, we’re thinking. "), _c('em', [_vm._v("Contagion ")]), _vm._v("is a realistic, unsensational film about a global epidemic. It’s being marketed as a thriller, a frightening speculation about how a new airborne virus could enter the human species and spread relentlessly in very little time. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("This scenario is already familiar to us through the apparently annual outbreaks of inﬂuenza. Not many of them cause as much alarm as swine ﬂu did. The news chronology is always the same: alarmist maps, global roundups, the struggle to produce a vaccine at the Centers for Disease Control in Atlanta, the manufacture and distribution of supplies of this year’s “ﬂu shot.” ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The virus in Contagio"), _c('em', [_vm._v("n ")]), _vm._v("is a baffling one: defying isolation, rejecting cure. This film by Steven Soderbergh is skillful at telling the story through the lives of several key characters and the casual interactions of many others. It makes it clear that people do not "), _c('em', [_vm._v("give ")]), _vm._v("each other a virus; a virus is a life form evolved to seek out new hosts—as it must to survive, because its carriers die, and it must always stay one jump ahead of death. In a sense it is an alien species, and this is a movie about an invasion from inner space. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The cough we heard at the outset was from Beth Emhoff (Gwyneth Paltrow), a Minneapolis woman who was traveling home from Hong Kong. Soon her son dies. She follows. Her husband, Mitch (Matt Damon), apparently immune, is incredulous that death could so suddenly devastate his family. An investigation uncovers a secret visit Beth made during her stopover in Chicago—but no, she didn’t contract the virus through sexual contact, the way AIDS seemed to spread. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("At the very end of the film Soderbergh adds a brief scenario explaining where the virus may have come from in the first place, and how very few degrees of separation there were between its origin and a woman from Minneapolis. Whether this could happen in the way Soderbergh illustrates is beside the point; all viruses originate somewhere, and in an age of air travel they can reach a new continent in a day. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The movie follows the protocols of technothrillers, with subtitles keeping count: "), _c('em', [_vm._v("Day One, Day Three, Minneapolis, Geneva. . . .")]), _vm._v(" We meet such key players as Dr. Ellis Cheever (Laurence Fishburne) of the CDC in Atlanta; Dr. Erin Mears (Kate Winslet) of the Epidemic Intelligence Service, who tries to track the spread with onthespot visits; Dr. Leonora Orantes (Marion Cotillard), an investigator from the World Health Organization in Geneva. They have worked together before, are skilled, operate urgently. And in a laboratory, there is Dr. Ally Hextall (Jennifer Ehle), trying to perfect a vaccine and impatient with the time being lost before she can test it on humans. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("All of this works as drama. It might have been useful if Soderbergh had explained viruses more clearly as a life form that is not hostile to us, but concerned with other life forms only as its means of survival. Richard Dawkins outlined this process in his remorseless book Th"), _c('em', [_vm._v("e ")]), _vm._v("Selfis"), _c('em', [_vm._v("h ")]), _vm._v("Gene: From the viewpoint of a gene, bodies are merely steppingstones on their journey through time. Still, the movie deserves praise for taking the scientific method seriously, at a time when so much hogwash is ﬂoated about regarding vaccines. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("One aspect of the film is befuddled. Alan Krumwiede (Jude Law) is a popular blogger who has conspiracy theories about the government’s ties with drug companies. His concerns are ominous but unfocused. Does he think drug companies encourage viruses? The blogger subplot doesn’t interact clearly with the main story lines, and functions mostly as an alarming but vague distraction. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Yes, we must often wash our hands. Yes, “hand sanitizers” are all over the place these days. Yes, shaking hands with strangers can be annoying—although they are no more likely to carry viruses than we are. And yes, there is really not much we can do. You might be surprised by how many hospital patients die because of viruses they didn’t walk in with. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a511"
    }
  }, [_vm._v("Contraband "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 110 m., 2012 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Mark Wahlberg (Chris Farraday), Kate Beckinsale (Kate Farraday), Giovanni Ribisi (Tim Briggs), Ben Foster (Sebastian Abney), Caleb Landry Jones (Andy), Lukas Haas (Danny Raymer), Diego Luna (Gonzalo), J. K. Simmons (Captain Redmond Camp). Directed by Baltasar Kormakur and produced by Kormakur, Tim Bevan, Eric Fellner, Stephen Levinson, and Mark Wahlberg. Screenplay by Aaron Guzikowski, based on the film "), _c('em', [_vm._v("Reykjavik-Rotterdam, ")]), _vm._v("written by Arnaldur Indrioason and Oskar Jonasson. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("There are elements in the thriller "), _c('em', [_vm._v("Contraband ")]), _vm._v("that have a nifty novelty, but the movie as a whole is straight from the spare parts shelf. I’m growing particularly weary of the wife/girlfriend of the hero whose life and children are threatened by vicious bad guys. It must be admitted, however, that the threatened means of death in this film makes being tied to railroad tracks seem jolly by comparison. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The movie involves the smuggling of a vast quantity of counterfeit $100 bills from Panama City to New Orleans. Although Chris Farraday, the would-be smuggler, prefers not to deal with drugs, wouldn’t you know several kilos of cocaine get mixed in with the deal. This film is based on an Icelandic thriller named "), _c('em', [_vm._v("Reykjavik-Rotterdam")]), _vm._v(", which leads you to suspect that neither New Orleans nor Panama City is particularly essential to the plot. That film starred Baltasar Kormakur, who is the director of this one, perhaps as a demonstration that many stars believe they could direct this crap themselves if they ever had the chance. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Kormakur uses Mark Wahlberg to play his own former role. Chris is an experienced smuggler who has retired from crime to settle down in married bliss; alas, his wife, Kate (Kate Beckinsale), has a brother who has made a mess of a cocaine delivery, and lives are in danger unless the veteran Chris steps in and performs a makegood job. He has entrusted an old pal named Sebastian (Ben Foster) to protect Kate and the children while he’s on the job. She may require protection because a snaky crime lord named Tim Briggs (Giovanni Ribisi) is the boss of this deal. Let it be said that in this role Ribisi uses the kind of voice that makes you want to smack him, just for talking like that. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Chris and a couple of partners sign as seamen aboard a container ship plying the waves between New Orleans and Panama City. The ship’s skipper is J. K. Simmons. Yes, the instantly likable actor who played the father in "), _c('em', [_vm._v("Juno. ")]), _vm._v("He’s likable here, too, if a little tougher; Chris smuggles rings around him as the ship becomes as active as a FedEx terminal. Now help me out here. Chris shows his pals where he’ll stash the piles of counterfeit bills—in an empty space behind a tool board. One guy steps inside to check it out and just then the skipper approaches, and they have to screw the panel shut and hurry away. Did they ever let that guy out? I kept worrying about him trapped in there. Maybe I missed something. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Man, is this plot complicated. At one point, while Chris and his pals have a “very limited” time ashore in Panama before the ship sails, they find enough time to (1) seek the warehouse where the bills are manufactured, and (2) try to stick up an armored car. It’s not a matter of just going straight to the warehouse. Chris doesn’t recall where it is, “but if we drive around I’ll see something that reminds me.” Panama City has a population of nine hundred thousand. Sticking up the armored car involves driving a van into its path and causing a crash, then shooting it out with the cops. This leads to the theft of a Jackson Pollock painting worth millions, which nobody ever explains to the thieves. At one point it’s described as “a cloth with oil smears.” Well, fair enough. More like dribbles. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Meanwhile, snakyvoiced Ribisi and his men are causing great distress to the Beckinsale character—so much that the preview audience recoiled at one point. The means of her apparent doom is so heartless you can hardly believe your eyes. Toward the end, Chris sets a trap for the bad guys that is admirably ingenious, although it involves a lot of planning ahead and good luck, and it’s one of those deals requiring everyone to be in precisely the right place at the right time. Don’t you suppose these schemes usually go wrong? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Contraband ")]), _vm._v("involves a lot of energy, but I’m getting tired of violent retreads of these heist elements. It wanted to terrify me for two hours, but what mostly scared me was the challenge of getting back to street level on the theater’s steep escalator. Man, they should slow that baby down. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a512"
    }
  }, [_vm._v("Conviction "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 96 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Hilary Swank (Betty Anne Waters), Sam Rockwell (Kenny Waters), Minnie Driver (Abra Rice), Melissa Leo (Nancy Taylor), Peter Gallagher (Barry Scheck), Juliette Lewis (Roseanne Perry). Directed by Tony Goldwyn and produced by Goldwyn, Andrew S. Karsch, and Andrew Sugerman. Screenplay by Pamela Gray. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Kenny Waters might not have been a very nice man, but he was an innocent one. By considering his innocence and not his personality, "), _c('em', [_vm._v("Conviction ")]), _vm._v("puts the focus where it belongs: on the sister who reshaped her entire life to win his freedom. Her determination is fierce, her rebirth is inspiring, and in Hilary Swank the film finds the right actress to embody gritty tenacity. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("You can hardly imagine anyone else playing Betty Anne Waters. She’s a working-class woman from a hard childhood. She and her brother Kenny (Sam Rockwell) had an absent father and a mother who might as well have been absent, and were shuffled through a series of dismal foster homes. But they stuck together and helped each other, almost as Dickensian survivors. Her gratitude to him is boundless. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The movie doesn’t avoid the fact that Kenny gets wild when he gets drunk. He displays the personality changes of an alcoholic. He can be mean, and everybody knows it. In many circles this is seen as a trait and not a symptom. A local woman is murdered; he’s arrested on suspicion and makes the mistake of behaving insultingly to a cop (Melissa Leo, from "), _c('em', [_vm._v("Frozen River")]), _vm._v("). He will pay for that. A couple of local women, including a ditzy witness (Juliette Lewis), sorta are kinda sure they musta seen him at the crime scene, and the vengeful cop railroads him into jail. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("(Some spoilers ahead.) ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Swank dedicates her life to proving her brother’s innocence. This involves reinventing herself. She gets a high school diploma and a college degree and enrolls in law school. One cost of this is her marriage. It’s an intriguing possibility, untouched by the movie, that after a certain point in her reeducation she simply outgrew her earlier life, and carried on for her own sake as well as her brother’s. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("In law school she bonds with another student named Abra (Minnie Driver), who also dedicates her life to the case. The movie never really explains why; is it just the goodness of her heart? Driver is very good, in any event, and the two women involve us in their investigation. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Courtroom scenes just about always work for me. It must be built into the situation. "), _c('em', [_vm._v("Conviction ")]), _vm._v("has good ones, especially when the Juliette Lewis character comes back into play. It is good to see Melissa Leo again, not so good that her vengeful cop has one dimension, but she’s effective at how well she evokes it. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("This is all based on a true story, including the lucky break when DNA testing is introduced and proves Kenny innocent. The story generates the kind of urgency we feel when a character is obviously right and is up against stupidity and meanness. It delivers. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("What it doesn’t reveal during the “where are they now?” crawl at the end is that six months after his release, according to The Associated Press, Kenny was killed when he “fractured his skull when he fell from a 15foot wall while taking a shortcut to his brother’s house after a dinner with his mother.” Tragic. But Betty Anne Waters is still working for wrongfully convicted prisoners. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a513"
    }
  }, [_vm._v("Cop Out "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 110 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Bruce Willis (Jimmy Monroe), Tracy Morgan (Paul Hodges), Adam Brody (Barry Mangold), Kevin Pollak (Hunsaker), Ana de la Reguera (Gabriela), Guillermo Diaz (Poh Boy), Michelle Trachtenberg (Ava), Seann William Scott (Dave). Directed by Kevin Smith and produced by Polly Cohen Johnsen, Marc Platt, and Michael Tadross. Screenplay by Robb Cullen and Mark Cullen. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Jimmy and Paul are cops hunkered down across the street from a stakeout when they see a mysterious figure run across rooftops and break into a house. Seconds later, he can clearly be seen in an upper window, sitting on a toilet and reading a magazine. “What kindofa guy breaks into a house and takes a crap?” asks Paul, or words to that effect. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Paul explains he always delays this elementary function until he gets home. He’s not relaxed until then. But once he’s home—ooohhh boy! Then he lets loose. He describes the results in great detail. The walls, the ceilings. All right! I’m thinking, all right, already! I got it! Mudslide! Paul isn’t finished. Now he’s talking about the reaction of the neighbors. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("How do you know this is a scene from a Kevin Smith film? The imitation of a nine-year-old describing bodily functions might be a clue. But the clincher is when that mysterious guy runs across the rooftops. Paul (Tracy Morgan) explains to his partner Jimmy (Bruce Willis): “That’s known as ‘parkour.’ It’s a new martial art.” Well, thanks, Paul. I didn’t know that until yesterday, when it was explained in "), _c('em', [_vm._v("District 13: Ultimatum. ")]), _vm._v("What synchronicity. That other movie costars the man who gave “parkour” its name. The movie is filled with it. I suspect its presence as a brief walkon in "), _c('em', [_vm._v("Cop Out ")]), _vm._v("can be explained this way: Kevin found out about it, thought it was cool, and slipped in a little quick “parkour” for fun. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("If you combine the enthusiasms of a geek with the toilet humor of a thirdgrader, you’ll be pretty close to defining the art of Kevin Smith. Hey, I’m not complaining. If we lose our inner thirdgrader, we begin to die. When the muse visits him, Smith gets inspired and makes fun movies like "), _c('em', [_vm._v("Zack and Miri Make a Porno. ")]), _vm._v("Alas, "), _c('em', [_vm._v("Cop Out ")]), _vm._v("is not one of those movies. Tracy Morgan is forced to go way over the top; Bruce Willis seems eager to have a long, sad talk with his agent; and Kevin Pollak, who gets costar billing, does at least appear for longer than a quark at Fermilab. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Cop Out ")]), _vm._v("tells your standard idiotic story about buddy cops who screw up, get suspended by the captain, and redeem themselves by overthrowing a drug operation while searching for the valuable baseball card Jimmy wants to sell to pay for his daughter’s wedding. Paul spends an unreasonable amount of time dressed as a cell phone, considering there is nothing to prevent him from taking it off. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("A lot of the dialogue is intended to be funny, but man, is it lame. Many of the gags possibly looked good on paper, but watching Willis and Morgan struggle with them is like watching thirdgraders do Noel Coward, if Noel Coward had been rewritten by Kevin Smith. At St. Joseph’s Boys’ Camp there was this Chicago kid named Bob Calvano who was naturally hilarious around the campfire every night. Then I’d get up and ﬂop with my memorized bits from Buddy Hackett records. “Ebert,” he advised me kindly, “it isn’t funny if you act like it’s supposedto be funny. Act likeyou don’t know.” All I can do is pass along Calvano’s advice. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a514"
    }
  }, [_vm._v("Coriolanus "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 122 m., 2012 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Ralph Fiennes (Caius Martius Coriolanus), Gerard Butler (Tullus Aufidius), Brian Cox (Menenius), Vanessa Redgrave (Volumnia), Jessica Chastain (Virgilia), John Kani (General Cominius), James Nesbitt (Sicinius), Paul Jesson (Brutus). Directed by Ralph Fiennes and produced by Fiennes, John Logan, Gabrielle Tana, Julia Taylor-Stanley, and Colin Vaines. Screenplay by John Logan, based on the play by William Shakespeare. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("The point with Shakespeare is the language. Moderndress productions of his plays are common and can inspire intriguing viewpoints. Who is to say that "), _c('em', [_vm._v("Coriolanus ")]), _vm._v("might not as well be set in the Middle East as in Rome—neither a place Shakespeare had ever seen? Modern associations can even find parallels, as in the 1995 "), _c('em', [_vm._v("Richard III")]), _vm._v(", which cast Ian McKellen as a fascist dictator. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Now we have Ralph Fiennes directing and starring in "), _c('em', [_vm._v("Coriolanus")]), _vm._v(", one of the Roman tragedies, where the feral and discontented general is at war in “a place calling itself Rome.” The walls are covered with graffiti, grenade launchers replace swords, and we get the obligatory shot of warriors being blown toward us with an explosion blossoming behind. The costumes, art direction, and props could be used for an action film about most modern wars, including the Bosnian, and indeed the film was shot on location in Belgrade. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Apart from the infinite varieties of the human face, there are no sights in "), _c('em', [_vm._v("Coriolanus ")]), _vm._v("I’m not familiar with. Fiennes, an actor who can remake himself, is here lean and muscular, his head shaven, his neck a muscular trunk displaying a dragon tattoo. He carries an AK-47. Is this Shakespeare’s hero? Did Shakespeare envision Coriolanus in GrecoRoman draperies? I imagine Shakespeare alone in a room, writing by candlelight, intoxicated by language. For him, Coriolanus was the name of the speaker of his words. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("One of the pleasures of Fiennes’s film is that the screenplay by John Logan ("), _c('em', [_vm._v("Hugo, Gladiator")]), _vm._v(") makes room for as much of Shakespeare’s language as possible. I would have enjoyed more, because such speakers as Fiennes, Vanessa Redgrave, and Brian Cox let the words roll trippingly off the tongue. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I realize I savor Shakespeare in a different way than the typical Friday night action fan—who, lured by the violence and ferocity of the hard-boiled trailer and TV ads, will perhaps wonder why everyone is talking so strangely. There is a reason why most of the sentences in action dialogue are not more than a few words long. More than half the boxoffice revenue will come from overseas, where the film will be dubbed, and longer speeches are trickier to dub. "), _c('em', [_vm._v("Coriolanus ")]), _vm._v("will ideally be seen in English. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Shakespeare’s story involves a Roman who cares more about battle than about politics. This is Caius Martius (Fiennes), a general who has led Rome against its nearby Volscian enemies. Warfare has cut off Rome’s food supplies, there’s rioting in the streets, and he leaves to join the siege of the enemy city Corioles. When he prevails, he’s given the honorary title “Coriolanus,” returns home, and at the urging of his strongwilled mother, Volumnia (Vanessa Redgrave), runs for consul. He is, alas, not a diplomatic politician (it’s unwise to hold the people in contempt). Banished from Rome, he joins forces with his former Volscian enemy, Tullus Aufidius (Gerard Butler), and they attack the city. Only his mother can persuade him to lay down his arms. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Transfer this story to “a place calling itself Rome,” add the trappings and the suits of modern warfare, supply updates from cable news, and you have a movie that is not so much about the private, patrician scorn of Coriolanus as about the motivation of most action heroes, which is to strut in macho display, inspire slaughter and mayhem, and provide reaction shots when things blow up real good. This is all done well by Fiennes, but as a man who starred in this play ten years ago in London, he has deeper feelings for it, and the key scenes are those between Coriolanus and his mother, Volumnia, to whom he seems more romantically attached than to his wife, Virgilia (Jessica Chastain). ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I admired the movie even though I found it neither fish nor fowl. As Shakespeare, it has too much action footage (Coriolanus’s face seems permanently streaked with blood), and as action, it has too much Shakespeare. I suppose the action is the price Fiennes had to pay to do the Shakespeare, because a film this expensive must appeal to the masses. What’s the question Shakespeare has Coriolanus ask about public opinion? “What’s the matter, you dissentious rogues, that, rubbing the poor itch of your opinion, make yourselves scabs?” ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a515"
    }
  }, [_vm._v("Country Strong "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v("-13, 116 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Gwyneth Paltrow (Kelly Canter), Tim McGraw (James Canter), Garrett Hedlund (Beau Hutton), Leighton Meester (Chiles Stanton). Directed by Shana Feste and produced by Tobey Maguire and Jenno Topping. Written by Feste. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_c('em', [_vm._v("Country Strong ")]), _vm._v("is one of the best movies of 1957, and I mean that sincerely as a compliment. Lee Remick would have been terrific in this movie—as good as Gwyneth Paltrow is. We live now in more fraught times, with Natalie Portman mentally disemboweling herself for her art while slipping into madness. And I admire her and she deserves her Oscar. But "), _c('em', [_vm._v("Country Strong ")]), _vm._v("is a throwback, a pure, heartfelt exercise in ’50s social melodrama, using such stock elements as a depressed heroine, her manipulating husband, an ambivalent Other Man, and, tapping her toe impatiently in the wings, young Eve Harrington eager to swoop in and gnaw the heroine’s courage from her bones. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("This is filmed in a straightforward meatandpotatoes style, beautifully photographed by John Bailey. It takes place in what could be the Texas of "), _c('em', [_vm._v("The Last Picture Show")]), _vm._v(", except for some performances in a modern arena. It stars Paltrow as Kelly Canter, a troubled country singer who has been released from alcohol rehab too soon. Tim McGraw plays James, the man she married when they were in love and who now stays on as her controlling manager. Garrett Hedlund is Beau Hutton, a singer who “just likes to play music for people” and doesn’t care about money. And Leighton Meester is Chiles Stanton, a former Miss Dallas who dreams of stardom. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Beau and Chiles. Man, are those ’50s names. The plot does not neglect the tragic loss of Kelly’s child, when while pregnant and drunk she fell from a stage. Nor Beau and James, who "), _c('em', [_vm._v("both ")]), _vm._v("fool around with Chiles, and "), _c('em', [_vm._v("both ")]), _vm._v("are probably in love with Kelly. After Beau (apparently) resigns his day job as an orderly at Kelly’s rehab institution, these people move in unison across Texas on a tour route scattered with emotional land mines. Kelly is in the big customized bus. The rest bring up the rear in an old van. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("It is a given that Kelly is a great star. Beau is a damn fine country singer, too good to play in bars that can’t even afford enough extras to make up a crowd. Chiles is a promising singer but an emotional basket case because of deep insecurities from childhood. She’s got herself one of those pinchedup fearful faces with her red lips all forced into a perfect bow and her hair too stiff. She’s like a caricature of mama’s little beauty pageant contestant until at the end, wow, she scrubs off the makeup and shampoos that hair spray off her head, and we realize Leighton Meester is a beauty and not a victim of a cosmetics counter makeover. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Now it may seem from this that I am finding fault with "), _c('em', [_vm._v("Country Strong. ")]), _vm._v("Quite the opposite. We must see a movie for what it is, not for what we think another film might have been. This is a movie into which Lee Remick and Rock Hudson and Sandra Dee would have slipped without shoehorns, and Douglas Sirk would have known where to march them. Its emotions are strong and visible. Its motives are clear. Its music performances are so good we wish they lasted longer. Gwyneth Paltrow is so beautiful and just really nice that she brings enormous sympathy to her role. And Garrett Hedlund’s Beau would do anything for a woman—or two women, in this case. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I eat this stuff up. Don’t get all on your high horse. Here are big emotions sprayed across the somewhat crowded quarters of a limited number of small sets, punctuated by secondunit drivebys and grizzly good ol’ boys filling out the frame. The only truly realistic character in the movie has hardly a line. That would be the tall middle-age woman who is apparently Kelly Canter’s wardrobe woman, and follows her everywhere like those well-paid and not indifferent support people in the lives of stars. She sees everything and knows everything and keeps her mouth shut, which is what you want. She’s got your back. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Another thing that places this movie in the 1950s milieu is its understanding of alcoholism. It thinks being drunk comes on people in sudden spurts, like a sneezing fit, and goes away when the plot needs it to. Kelly will be waving a vodka bottle at one moment and morosely pondering at the next. Paltrow has a lovely scene where she coaches young Chiles on what she needs to know about sweat stains, high heels, and love. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Beau tells James his mistake was to take Kelly out of rehab before the rehab was finished. James is not a man of deep insights into drinking or sobriety. Three days after Kelly gets out of rehab, Beau catches her choking down pills in the dressing room. He confronts James about this. “I know!” says James. “I put them in her pillbox myself! They’re not dangerous unless she drinks!” I know I didn’t hear you say that, James. Tell me you didn’t. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a516"
    }
  }, [_vm._v("Cowboys & Aliens "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v("-13, 118 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Daniel Craig (Jake Lonergan), Harrison Ford (Colonel Woodrow Dolarhyde), Olivia Wilde (Ella Swenson), Sam Rockwell (Doc), Adam Beach (Nat Colorado), Paul Dano (Percy Dolarhyde), Noah Ringer (Emmett Taggart), Keith Carradine (Sheriff John Taggart). Directed by Jon Favreau and produced by Johnny Dodge, Ron Howard, Alex Kurtzman, Damon Lindelof, Roberto Orci, and Scott Mitchell Rosenberg. Screenplay by Kurtzman, Lindelof, Orci, Mark Fergus, and Hawk Ostby, based on Platinum Studios’ "), _c('em', [_vm._v("Cowboys and Aliens ")]), _vm._v("by Rosenberg. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_c('em', [_vm._v("Cowboys & Aliens ")]), _vm._v("has without any doubt the most cockamamie plot I’ve witnessed in many a moon. Here is a movie with cowboys, aliens, Apaches, horses, spaceships, a murdering stagecoach robber, a preacher, bugeyed monsters, a bartender named Doc, a tyrannical rancher who lives outside of a town named Absolution, his worthless son, two sexy women (one not from around these parts), bandits, a magic bracelet, an ancient Indian cure for amnesia, a symbolic hummingbird, a brave kid with a spyglass, and a plucky dog who follows the good guys for miles and miles through the barren waste and must be plumb tuckered out. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("This is not a satire. Nor is it a comedy. Humanity is in danger, and it’s up to the roughhewn cowboys of the Old West to save us. Daniel Craig plays Lonergan, the stagecoach killer, Harrison Ford plays the not enigmatically named Woodrow Dolarhyde, and Keith Carradine is Sheriff Taggart, who has his work cut out for him. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The aliens, as usual, show limited signs of intelligence. Oh, they arrive in a spaceship that’s taller than a skyscraper, and they must have designed it. But mostly they strafe the town, drop explosive charges behind characters but rarely upon them, and reel up human victims into their smaller ﬂying ships in order (need we be told) to study them. Their other purpose in journeying unimaginable distances across the void is to use mysterious forces to suck up gold—coins, watches, rings, whatever. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I call these monsters bugeyed not to be unkind, but to trace their lineage back to the mother lode of BEMs on the covers of such pulp mags as "), _c('em', [_vm._v("Thrilling Wonder Stories")]), _vm._v(". It’s almost too good to be true to learn, via a trade review, that the movie was inspired not by a comic book but by its cover. That’s the spirit. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The movie will no doubt be popular and deserves success. As preposterous moneymakers go, it’s ambitious and well-made. The acting from the large cast is of a high standard, Craig and Ford were more or less born into their roles, and director Jon Favreau actually develops his characters and gives them things to do, instead of posing them in front of special effects. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Yet I feel a certain small sadness. I wish this "), _c('em', [_vm._v("had ")]), _vm._v("been a Western. You know, the oldfashioned kind, without spaceships. Daniel Craig, coldeyed and lean, plays a character familiar in the genre; think of the Ringo Kid or Doc Holliday, bad guys who rise to goodness. Harrison Ford, as the rancher, embodies the kind of man who comes riding into town at the head of his private posse and issues orders to everyone. Sam Rockwell’s Doc is the kind of smallbusiness man who has come west seeking his fortune among hard men. All the elements are here. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("We are told, however, that the Western is a dead genre. The last one kids liked was "), _c('em', [_vm._v("Rango")]), _vm._v(", an animated cartoon. "), _c('em', [_vm._v("True Grit")]), _vm._v(", "), _c('em', [_vm._v("Appaloosa")]), _vm._v(", and "), _c('em', [_vm._v("3:10 to Yuma ")]), _vm._v("were good, but limited in their demographic appeal. A competent director—Favreau, say—could have ditched the ridiculous aliens and made a straight Western with the same cast, but today there’s small chance of that. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Yet I suspect the big audiences drawn to this concept will find themselves more deeply drawn into the conventional Western material in the opening scenes, before the aliens attack. There is more genuine suspense when the rancher’s loopy son (Paul Dano) starts shooting up the town than when countless aliens appear, resembling a fusion of gorillas and lobsters. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("One alien element has become almost traditional. Ever since "), _c('em', [_vm._v("Alien ")]), _vm._v("we’ve had the phenomenon of aliens who unfold to reveal wicked inner parts. The aliens here have chest cavities that open to extrude threefingered hands, slimy with mucus. One shudders to envision the use of these limbs during sex. On their home world, there must be fortunes to be made in opening manicure shops. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a517"
    }
  }, [_vm._v("The Crazies "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 101 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Timothy Olyphant (David Dutton), Radha Mitchell (Judy Dutton), Joe Anderson (Russell Clank), Danielle Panabaker (Becca Darling), Christie Lynn Smith (Deardra Farnum), Brett Rickaby (Bill Farnum), Preston Bailey (Nicholas), John Aylward (Mayor Hobbs). Directed by Breck Eisner and produced by Michael Aguilar, Rob Cowan, and Dean Georgaris. Screenplay by Scott Kosar and Ray Wright. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_c('em', [_vm._v("The Crazies ")]), _vm._v("is a perfectly competent genre film in a genre that has exhausted its interest for me, the zombie film. It provides such a convenient storytelling device: Large numbers of mindless zombies lurch toward the camera and the hero, wreaking savage destruction, and can be quickly blown away, although not without risk and occasional loss of life. When sufficient zombies have been run through, it’s time for a new dawn. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I know there can be good zombie films. I’ve seen some: "), _c('em', [_vm._v("Dawn of the Dead, 28 Days Later, Shaun of the Dead, ")]), _vm._v("and so on. If I saw another one, I’d like it. But all depends on good living characters and a director with something new to say about zombies, who are a subject easily exhausted. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Are the zombies in Th"), _c('em', [_vm._v("e ")]), _vm._v("Crazie"), _c('em', [_vm._v("s ")]), _vm._v("real zombies? Maybe, maybe not. Is there an agreed definition of what is a zombie, and how they get that way? Not that I know of. I think zombies are defined by behavior and can be “explained” by many handy shortcuts: the supernatural, radiation, a virus, space visitors, secret weapons, a Harvard education, and so on. I suppose it would be a “spoiler” if I revealed why the Crazies are lurching, but come on, does it matter? What if I revealed they got that way because of, oh, say, eating Pringles? Would that spoil things for you? What difference does it make? All that matters is that they got to be zombies "), _c('em', [_vm._v("somehow")]), _vm._v(". Before that, they were your friends and neighbors. Then they started in on the damn Pringles. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The protagonists, of course, have to be healthy. I cannot imagine a zombie as a leading character. Vampires, now, I grant you. Werewolves. But a zombie doesn’t bring much to the party. So we start in sweet little Ogden Marsh, Iowa, described on its Web site as “the friendliest place on Earth,” and no wonder. Its sheriff is so good-looking he could be the star of this movie. Must be a quiet place. The sheriff’s office is open only from eight to five Monday through Friday. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("One day after work Sheriff David Dutton (Timothy Olyphant) and his deputy, Russell Clank (Joe Anderson), are watching a local school baseball game when the town drunk comes lurching into the outfield holding a shotgun. When the autopsy shows he had a 0.0 blood alcohol level, that’s the first signal something is wrong in Ogden Marsh. For one thing, their town drunk is a slacker. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The sheriff’s wife, Judy (Radha Mitchell), is the local doctor. She starts treating some strange cases. I don’t want to spoil anything, so I’ll simply say the sheriff and Deputy Russell discover the probable origin of this plague, but of course can’t get the mayor to declare an emergency, because he learned the mayoring trade from "), _c('em', [_vm._v("Jaws. ")]), _vm._v("Meanwhile, it’s up to Dave, Judy, and Russell to defend themselves from zombies and survive after the town is isolated and quarantined and the cure seems worse than the disease. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("That requires many scenes involving people and objects that jump out from the sides of the screen with loud noises and alarming musical chords. I’m thinking, so what? The last thing I need is another jump out/loud noise/alarming chord movie. Even a well-made one—like this one, directed by Breck Eisner. It was inspired by George Romero’s 1973 movie of the same name, although I can’t tell you if the zombies match because that would be a spoiler. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Here is what I can say to aspiring young screenwriters: Movies like this are fairly simple to write. You need zombies. You need heroes. At first there’s a mystery, and then the horror. You describe lots of jump/noise/chord situations. When you figure you’re up to around ninety minutes, the sun can rise. You’ll get an R rating, so throw in a little nudity. Not too much, because if there’s a combination that gives me the creeps, it’s zombies and nudity. Especially when—but never mind. That’s enough for today. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a518"
    }
  }, [_vm._v("Crazy, Stupid, Love. "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v("-13, 117 m., 2011 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Steve Carell (Cal), Ryan Gosling (Jacob), Julianne Moore (Emily), Emma Stone (Hannah), John Carroll Lynch (Bernie), Marisa Tomei (Kate), Kevin Bacon (David Lindhagen), Jonah Bobo (Robbie), Analeigh Tipton (Jessica). Directed by Glenn Ficarra and John Requa and produced by Steve Carell and Denise Di Novi. Screenplay by Dan Fogelman. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_c('em', [_vm._v("Crazy, Stupid, Love. ")]), _vm._v("is a sweet romantic comedy about good-hearted people. Imagine that. No snark. No raunch. It has a lot of cynicism, but that’s employed only to be corrected. Nobody here wishes anybody ill, and the movie comes out foursquare in favor of marriage. Yes, the characters commit adultery, but they learn to their relief they were mistaken. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Much of the movie’s appeal is generated by the actors. Steve Carell has been growing on me. Emma Stone is a sweetheart. Julianne Moore’s character seems cold and distant, but that’s a stage she’s going through. A teenage couple are cutiepies. Marisa Tomei enters the movie as a tornado of warm comic energy. All that woman has to do is smile and I’m there. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("But the surprise is Ryan Gosling. I consider him a superb actor, and I’ve seen him play everything from an antiSemite ("), _c('em', [_vm._v("The Believer")]), _vm._v(") to a child killer ("), _c('em', [_vm._v("Murder by Numbers")]), _vm._v(") to a man in love with a love doll ("), _c('em', [_vm._v("Lars and the Real Girl")]), _vm._v("). In last year’s "), _c('em', [_vm._v("Blue Valentine ")]), _vm._v("he plays a notideal husband. But I didn’t see him as a lounge lizard and pickup artist, and in "), _c('em', [_vm._v("Crazy, Stupid, Love. ")]), _vm._v("he has as much bulls#!t as if he’d been Zach Galifianakis all of his life. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The movie opens with a bombshell. Cal (Steve Carell) asks his wife, Emily (Julianne Moore), what she wants for dessert. “A divorce,” she says. Cal, who has grown complacent in his marriage, is stunned. So are his kids, especially thirteen-year-old Robbie (Jonah Bobo), who has a crush on Jessica (Analeigh Tipton), his seventeen-year-old babysitter. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Cal seeks to assuage his sorrow in an upscale cocktail lounge with an improbable variety of babes, and finds himself noticing the smooth moves of a ladykiller named Jacob (Ryan Gosling). This guy seems to leave every night with the woman of his choice. Jacob observes Cal’s morose presence at the bar, overhears his bitter monologues, and insists on giving him some tips. This leads to lectures on pickup techniques and one of those makeover montages in which Cal acquires the correct shoes, shirts, suits, and a haircut. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Emily, I neglected to say, has been fooling around with a guy at work (Kevin Bacon in his slightly snaky mode). Not much is made of this; we’re spared the sight of Emily being tender with him, because that would throw off the gradually developing logic of the movie. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("So OK. We have two generations seeking success in love. Jonah Bobo does a winsomely good job of pining hopelessly for Analeigh Tipton, who has set her sights a little higher. Cal, meanwhile, takes advantage of Jacob’s coaching to score sensationally with Kate (Marisa Tomei), an energetic recovering alcoholic who is a sexual virtuoso. And then something happens that Jacob did not anticipate: In the bar one night, he meets the lovely Hannah (Emma Stone), and does something he didn’t think he was capable of. He falls in love. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("These many strands are woven together in a clever screenplay by Dan Fogelman, which establishes what is needed, conceals what is required, supplies Carell with a oneliner about Tomei that brings down the house, and springs some “OMG!” moments. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("All of that is the mechanism. What is also nice is the feeling. No one is hateful in this movie. Even Kevin Bacon, as the ominous marriage wrecker David Lindhagen, wishes no ill. Emily was apparently seducible, so how much can we blame him? The major characters all persevere in the faith that for every person there is One True Love, and when you meet that person, your quest is at an end—always assuming, of course, that your love is returned. Sometimes babysitters four years older than you are don’t get in the spirit. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The strength of the movie, however formulaic its structure, is that it is slightly more thoughtful about its characters. It’s not deep, mind you, but it considers their problems as more than fodder for comedy. It allows them to have real feelings, even some that surprise them, and it leaves them some room for growth. At the end, after as many strands have been brought together as seems possible, I felt an undeniable satisfaction. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a519"
    }
  }, [_vm._v("Creation "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PG")]), _vm._v("-13, 108 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Paul Bettany (Charles Darwin), Jennifer Connelly (Emma Darwin), Jeremy Northam (Rev. Innes), Toby Jones (Thomas Huxley), Benedict Cumberbatch (Joseph Hooker), Martha West (Annie Darwin). Directed by Jon Amiel and produced by Jeremy Thomas. Screenplay by John Collee, based on the book "), _c('em', [_vm._v("Annie’s Box ")]), _vm._v("by Randal Keynes. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Darwin, it is generally agreed, had the most important idea in the history of science. Thinkers had been feeling their way toward it for decades, but it took Darwin to begin with an evident truth and arrive at its evident conclusion: Over the passage of many years, more successful organisms survive better than less successful. The result is the improvement of future generations. This process he called “natural selection.” ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("It worked for bugs, birds, and bees. It worked for plants, fish, and trees. In 1859, when he published "), _c('em', [_vm._v("On the Origin of Species, ")]), _vm._v("it explained a great many things. Later, we would discover it even explained the workings of the cosmos. But—and here was the question even Darwin himself hesitated to ask—did it explain Man? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Emma Darwin didn’t think so. Darwin’s wife was a committed Christian who believed with her church that God alone was the author of Man. And for her it wasn’t God as a general concept, but the specific God of Genesis, and he created Man exactly as the Old Testament said he did. He did it fairly recently, too, no matter that Darwin’s fossils seemed to indicate otherwise. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Creation ")]), _vm._v("is a film about the way this disagreement played out in Darwin’s marriage. Charles and Emma were married from 1830 until his death in 1882. They had ten children, seven of whom survived to beget descendants who even today have reunions. They loved each other greatly. Darwin at first avoided spelling out the implications for Man of the theory of evolution so as not to disturb her. But his readers could draw the obvious conclusion, and so could Emma: If God created Man, he did it in the way Darwin discovered, and not in the way a four-thousand-year-old legend prescribed. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The problems this created in the Darwin marriage were of interest primarily to Emma and Charles, probably their children, and few others except in the movie business, which seldom encounters an idea it can’t dramatize in terms of romance. It helps to know that going in. "), _c('em', [_vm._v("Creation ")]), _vm._v("will give you an idea of the lives and times of the Darwins, but unless you bring a knowledge of evolution to the movie you may not leave with much of one. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The film stars the real-life couple Paul Bettany and Jennifer Connelly, as Charles and Emma, who a few years before the publication of "), _c('em', [_vm._v("Origins ")]), _vm._v("are grieving the death of their ten-year-old, Annie (Martha West). This loss has destroyed Darwin’s remaining faith in God and reinforced his wife’s. But it is to Charles that Annie reappears throughout the film, in visions, memories, and perhaps hallucinations. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The film suggests that Darwin was forced almost helplessly toward the implications of his theory. He had no particular desire to stir up religious turmoil, especially with himself as its target. He famously delayed publication of his theories as long as he could. Two close friends tell him he owes it to himself to publish, and Thomas Huxley, who called himself “Darwin’s bulldog,” tells him: “Congratulations, sir! You’ve killed God!” ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Not every believer in evolution, including the pope, would agree. But Huxley’s words are precisely those Darwin feared the most. Consider that he had no idea in the 1850s how irrefutably correct his theory was, and how useful it would be in virtually every hard science. Emma and their clergyman, Rev. Innes (Jeremy Northam), try to dissuade him from publishing, but his wife finally tells him to go ahead because he must. If he hadn’t, someone would have: The theory of evolution was a fruit hanging ripe from the tree. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The director Jon Amiel tells his story with respect and some restraint, showing how sad and weakened Charles is and yet not ratcheting up his grief into unseemly melodrama. One beautiful device Amiel uses is a series of digressions into the natural world, in which we observe everyday applications of the survival of the fittest. What’s often misunderstood is that Darwin was essentially speaking of the survival of the fittest genes, not the individual members of a species. This process took millions of years, and wasn’t a case of humans slugging it out with dinosaurs. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Both Darwins understood and agreed about the role that inheritance (later to be known as genetics) played in health. As first cousins, they wondered if Annie’s life expectancy had been compromised. She died of complications from scarlet fever, which wasn’t their fault—but did they know and believe that? ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I have a feeling that the loss of their child and the state of their marriage were what most interested the backers of this film. They must have wanted to make a film about Darwin the man, not Darwin the scientist. The filmmakers do their best to keep Darwin’s theory in the picture, but it sadly isn’t fit enough to struggle against the dominant species of Hollywood executives. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a520"
    }
  }, [_vm._v("Cropsey "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NO MPAA RATING")]), _vm._v(", 84 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("Donna Cutugno, Karen Schweiger, David Novarro, and Ralph Aquino. A documentary directed by Joshua Zeman and Barbara Brancaccio and produced by Zeman, Brancaccio, and Zachary Mortensen. Screenplay by Zeman. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_c('em', [_vm._v("Cropsey")]), _vm._v(" is a creepy documentary with all the elements of a horror film about a demented serial killer, and an extra ingredient: This one is real, and you see him handcuffed in the film, not merely empty-eyed, shabby, and stooped, but actually drooling. “I’ve never seen a perp walk like that,” says a TV newsman. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The killer’s name is Andre Rand, and he’s currently doing time in a New York penitentiary. He was the real-life embodiment of  “Cropsey,” a bogeyman who figured in the campfire stories and nightmares of many children in Pennsylvania, New Jersey, and along the Eastern Seaboard. In the legends, he lived in the woods and ventured out to abduct children. In the early 1980s, Rand was convicted for the kidnapping and murder of two young girls and suspected in the disappearance of three more. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The man fit the legend. Andre Rand was a worker in the Willowbrook State School for the mentally handicapped on Staten Island, a New York borough isolated from the city for many years before a bridge was constructed. Willowbrook, one of the largest mental institutions in the world, was also one of the worst; Geraldo Rivera won fame for a TV special with footage of its half-naked children scattered on the ﬂoor, rocking back and forth in misery. Sanitary facilities were pitiful, filth was everywhere, abuse was common. Willowbrook was shut down, but some of its staff and inmates returned, living in a forgotten network of tunnels under the grounds. Among these was Andre Rand. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Already convicted of sexual abuse against a minor, he attracted the attention of searchers after the disappearance of Jennifer Schweiger, a young girl with Down syndrome. Rand was then living in a campsite on the heavily forested grounds of Willowbrook, and was arrested on suspicion. The charges were expanded to include the disappearance of little Holly Ann Hughes. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("He made an ideal suspect. Rumors spread of Satan worship in the tunnels. Staten Island was convinced. He was a bogeyman from central casting. There were only a few problems. There was no physical evidence. Jennifer Schweiger’s body was found, but here’s the funny thing: The grounds of Willowbrook were combed by hundreds of police and volunteers who found nothing, and then a later search found a grave so shallow a hand was sticking out of the earth. It was near Rand’s campsite. It wasn’t found on the earlier search, and he’d been in jail ever since. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Was he framed? Did he have a partner in murder? Was some eyewitness testimony suspect because he’d already been convicted in the public eye? "), _c('em', [_vm._v("Cropsey ")]), _vm._v("raises these questions in a doc that interviews the original detectives on the case, Jennifer’s parents, Rand’s defense attorneys, and members of the public. It surrounds this footage with the sparse available video of Rand, and uses many letters Rand wrote to the filmmakers claiming his innocence and suggesting unanswered questions. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("The people of Staten Island heard in the film seem unconcerned by the possibility of Rand’s innocence. They ask, Would you feel safe knowing that man was roaming free? No, but that alone is not the best reason for locking someone away. At the end I was prepared to agree that Rand seemed like an awfully convincing suspect if he happened to be innocent. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I was reminded of the continuing outrage of the West Memphis Three. Three teenagers were arrested, tried, and convicted amid hysterical rumors they were Satanists who sacrificed young boys. This in the face of their alibis and actual physical evidence suggesting the identity of another possible killer, who makes self-incriminating statements in two famous documentaries about the case, "), _c('em', [_vm._v("Paradise Lost ")]), _vm._v("and "), _c('em', [_vm._v("Paradise Lost 2: Revelations. ")]), _vm._v("Sometimes a perfect suspect is not guilty. ")]), _vm._v(" "), _c('p', {
    staticClass: "title1",
    attrs: {
      "id": "a521"
    }
  }, [_vm._v("Cyrus "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/img1.jpg"
    }
  }), _vm._v(" ½")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(", 91 m., 2010 ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("John C. Reilly (John), Jonah Hill (Cyrus), Marisa Tomei (Molly), Catherine Keener (Jamie), Matt Walsh (Tim). Directed by Mark Duplass and Jay Duplass and produced by Michael Costigan. Screenplay by Mark Duplass and Jay Duplass. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #000",
      "line-height": "10px",
      "margin-top": "4px"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-in1"
  }, [_vm._v("Marisa Tomei plays warm and friendly as well as anyone, and those qualities are essential to "), _c('em', [_vm._v("Cyrus, ")]), _vm._v("a film about her grown son and her new boyfriend waging what amounts to war over the possession of her body. There’s no incest, but a photo in her bedroom suggests the son was still getting to second base well into his adolescence. The boyfriend is pathetically happy to get on base at all, and this creates a comedy of awkwardness, private thoughts, passive aggression, and veiled hostility. All Molly (Tomei) wants is for everybody to like shoes disappear. If Cyrus took them, he could one another and get along. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Her boyfriend, John (John C. Reilly), is fine with that goal, but her son, Cyrus (Jonah Hill), is jealous and possessive, and very intelligent about how to use his feelings in a sneaky way, so it’s not always obvious what he’s up to. Not obvious to Molly, anyway, because she doesn’t really want to know. More obvious to John, who’s on such thin ice he’s slow to admit how unpleasant the situation has become. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("I can imagine how a sex comedy could spring from this premise, or even an Oedipal drama. What’s intriguing about "), _c('em', [_vm._v("Cyrus ")]), _vm._v("is the way it sort of sits back and observes an emotional train wreck as it develops. The movie doesn’t eagerly jump from one payoff to another, but attunes itself to nuance, body language, and the habitual politeness with which we try to overlook social embarrassment. With only three people, however, it’s a problem when one is deliberately creating embarrassment. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Jonah Hill, who is a fairly large man, is able to morph himself somehow into a big baby here; he cleverly uses immature conduct to excuse inappropriate behavior. When he hugs his mommy, for example, there’s the notsoslight suggestion that he does so not as her son but as her smoocher. There’s no suggestion that actual sex has ever been involved, but to poor John (and to us), he’s over the top. Molly seems oblivious. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Cyrus pretends to welcome and like John. His very welcome outreaches the bounds of propriety. Then little things happen. John’s easily throw them away. But whoeve"), _c('em', [_vm._v("r ")]), _vm._v("took them, they’re left where they will eventually be found, a ticking time bomb. Little things like that. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_vm._v("Marisa Tomei has the trickiest role here. She’s lonely, she’s been single too long, and she likes John, the big lug. She befriends him at a party where he’s desperately unhappy. She discovers him peeing in the shrubbery and says what, under these circumstances, is a remarkably tactful thing to relieve the embarrassment: “Nice penis.” He needs a woman like this. He’s apart from his first wife (Catherine Keener), who was maybe too smart for him. Molly isn’t dumb, but she’s—well, sometimes she’s improbably clueless. She is also very sexy, so you can understand that a boy the age of Cyrus (but not her son) would be attracted. That avoids possible Eww Moments. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-text"
  }, [_c('em', [_vm._v("Cyrus ")]), _vm._v("was written and directed by the Duplass brothers, Mark and Jay, who up until now have been identified with “mumblecore,” a term I hope I never have to use again. Let’s put it this way: If a movie is mumblecore, it probably doesn’t much want to be enjoyed, and if it isn’t, why call it failed mumblecore? Their previous film, "), _c('em', [_vm._v("Baghead ")]), _vm._v("(2008), was not beloved by me. Now here is a film that uses very good actors and gives them a lot of improvisational freedom to talk their way into, around, and out of social discomfort. And it’s not snarky. It doesn’t mock these characters. It understands they have their difficulties and hopes they find a way to work things out. There’s your suspense: How can they?")])])])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(87),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(90),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(93),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(96),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(99),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(102),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(105),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(108),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(111),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(114),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(117),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(120),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(123),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(126),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(129),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(132),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(135),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(138),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(141),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(144),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(147),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(150),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(153),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(156),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(159),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(162),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(165),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(168),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(171),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(174),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(177),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(180),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(183),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(186),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(189),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(192),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 192 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(195),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 195 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(198),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 198 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample. Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9781449423117',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(202)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(204);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 204 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.c4f4364145fa6a98e848.js